export interface ImCodes{
    [key: string]: string[];
}

export const IM_CODES:ImCodes={
  "0": ["Dc9","Dc8"],
  "1": ["Dbs","Dbo"],
  "2": ["Dc6","Dc4"],
  "3": ["Dcn","Dcl"],
  "4": ["DbS","DbQ"],
  "5": ["DbC","DbA"],
  "6": ["DcE","DcC"],
  "7": ["Dbw","Dbu"],
  "8": ["Daf","Dab"],
  "9": ["DbY","DbW"],
  "10": ["DcV","DcU"],
  "11": ["Dau","Dat"],
  "12": ["Dcr","Dcp"],
  "13": ["DcY","DcX"],
  "14": ["DbU","DbT"],
  "15": ["Daw","Dav"],
  "16": ["DcG","DcF"],
  "17": ["Dby","Dbx"],
  "18": ["Dad","Dac"],
  "19": ["Dba","DbZ"],
  "20": ["Dcy","Dcs"],
  "21": ["Dcx"],
  "22": ["Dc3"],
  "23": ["Dc2"],
  "24": ["Dcv"],
  "25": ["Dcu"],
  "26": ["Dc0"],
  "27": ["Dcz"],
  "28": ["Dct"],
  "29": ["Dcw"],
  "30": ["Dcf","DcZ"],
  "31": ["Dce"],
  "32": ["Dck"],
  "33": ["Dcj"],
  "34": ["Dcc"],
  "35": ["Dcb"],
  "36": ["Dch"],
  "37": ["Dcg"],
  "38": ["Dca"],
  "39": ["Dcd"],
  "40": ["DbK","DbE"],
  "41": ["DbJ"],
  "42": ["DbP"],
  "43": ["DbO"],
  "44": ["DbH"],
  "45": ["DbG"],
  "46": ["DbM"],
  "47": ["DbL"],
  "48": ["DbF"],
  "49": ["DbI"],
  "50": ["Da4","Day"],
  "51": ["Da3"],
  "52": ["Da9"],
  "53": ["Da8"],
  "54": ["Da1"],
  "55": ["Da0"],
  "56": ["Da6"],
  "57": ["Da5"],
  "58": ["Daz"],
  "59": ["Da2"],
  "60": ["DcO","DcI"],
  "61": ["DcN"],
  "62": ["DcT"],
  "63": ["DcS"],
  "64": ["DcL"],
  "65": ["DcK"],
  "66": ["DcQ"],
  "67": ["DcP"],
  "68": ["DcJ"],
  "69": ["DcM"],
  "70": ["Db6","Db0"],
  "71": ["Db5"],
  "72": ["DcB"],
  "73": ["DcA"],
  "74": ["Db3"],
  "75": ["Db2"],
  "76": ["Db8"],
  "77": ["Db7"],
  "78": ["Db1"],
  "79": ["Db4"],
  "80": ["Dan","Dah"],
  "81": ["Dam"],
  "82": ["Das"],
  "83": ["Dar"],
  "84": ["Dak"],
  "85": ["Daj"],
  "86": ["Dap"],
  "87": ["Dao"],
  "88": ["Dai"],
  "89": ["Dal"],
  "90": ["Dbi","Dbc"],
  "91": ["Dbh"],
  "92": ["Dbn"],
  "93": ["Dbm"],
  "94": ["Dbf"],
  "95": ["Dbe"],
  "96": ["Dbk"],
  "97": ["Dbj"],
  "98": ["Dbd"],
  "99": ["Dbg"],
  "100": ["Dbp"],
  "200": ["Dc5"],
  "300": ["Dcm"],
  "400": ["DbR"],
  "500": ["DbB"],
  "600": ["DcD"],
  "700": ["Dbv"],
  "800": ["Dae"],
  "900": ["DbX"],
  "1000": ["Dbt"],
  "1200": ["Dcq"],
  "2000": ["Dc7"],
  "3000": ["Dco"],
  "4000": ["DbV"],
  "5000": ["DbD"],
  "6000": ["DcH"],
  "7000": ["Dbz"],
  "8000": ["Dag"],
  "9000": ["Dbb"],
  "10000": ["DcW"],
  "15000": ["Dax"],
  "20000": ["Dc1"],
  "30000": ["Dci"],
  "40000": ["DbN"],
  "50000": ["Da7"],
  "60000": ["DcR"],
  "70000": ["Db9"],
  "80000": ["Daq"],
  "90000": ["Dbl"],
  "100000": ["Dbq"],
  "1000000": ["Dbr"],
  "10 o'clock": ["DeW"],
  "10 past 8": ["DeX"],
  "10 to 5": ["DeY"],
  "11 minutes past 5": ["Dd9"],
  "2 o'clock": ["Deg"],
  "20 past 2": ["Dee"],
  "20 to 4": ["Def"],
  "25 past 10": ["Dec"],
  "25 past 11": ["Dea"],
  "25 past 6": ["Deb"],
  "25 to 10": ["Ded"],
  "3 o'clock": ["DeZ"],
  "5 o'clock": ["DeA"],
  "5 past 12": ["DeC"],
  "5 past 6": ["DeB"],
  "5 to 12": ["DeD"],
  "6 o'clock": ["DeV"],
  "7 o'clock": ["DeU"],
  "8'clock": ["Dd8"],
  "9 o'clock": ["DeJ"],
  "a": ["DZm","DZl"],
  "a bad apple": ["D8A","D8B","D8C"],
  "a bookworm": ["D8D","D8E","D8F"],
  "a couch potato": ["D8I","D8J","D8K"],
  "a fish out of water": ["D8M","D8N","D8O"],
  "a night owl": ["D8W","D8X","D8Y"],
  "abdicate": ["AAA"],
  "abe": ["AAB"],
  "aboard": ["DRR"],
  "aboriginal": ["AAD","AAC"],
  "about": ["AAE"],
  "above": ["DdC","AAF"],
  "abroad": ["Dob"],
  "abstract": ["AAI","AAG","AAH"],
  "Abu dhabi": ["AAJ","AAK","AAL"],
  "abuse": ["AAN","AAM"],
  "acacia tree": ["AAO","AAP"],
  "academy": ["DRS","AAQ"],
  "accelerate": ["DRT","AAS","AAR"],
  "acceleration": ["AAT"],
  "accept": ["DRU","AAX","AAU","AAV","AAW"],
  "accident": ["DRV","AAa","AAY","AAZ"],
  "accommodation": ["AAe","AAb","AAc","AAd"],
  "accomodation": ["DRW"],
  "accomplish": ["AAh","AAf","AAg"],
  "accordian": ["C4b","DwH","AAl","AAj","AAk"],
  "according to": ["AAi"],
  "accordion": ["C4b","DwH","AAl","AAj","AAk"],
  "account": ["AAr","AAm","AAn"],
  "accountant": ["D8G","D8H","C4d","C4c","AAq","AAo","AAp"],
  "accumulate": ["DRX","AAt","AAs"],
  "accurate": ["DRY","AAw","AAu","AAv"],
  "accuse": ["DRZ","AAz","AAx","AAy"],
  "achieve": ["AA5","AA0","AA1","AA2"],
  "achievement": ["AA4","AA3"],
  "acid rain": ["AA6"],
  "acorn": ["DRa","ABA","AA7","AA8","AA9"],
  "acorns": ["ABB"],
  "acoustics": ["ABD","ABC"],
  "acrobat": ["DRb","ABK","ABE","ABF","ABG","ABH"],
  "acrobatics": ["ABJ","ABI"],
  "across": ["ABL"],
  "action": ["ABQ","ABM"],
  "action figure": ["ABN"],
  "action film": ["ABO","ABP"],
  "activate": ["ABR"],
  "active": ["ABT","ABS"],
  "actor": ["ABX","ABU","ABV","ABW"],
  "actress": ["ABb","ABY","ABZ","ABa"],
  "acute": ["DRc"],
  "add": ["Eaa","Dei","Dej"],
  "add added": ["ESW","Dei","Dej"],
  "add sugar": ["Eaa","Dej"],
  "added": ["ESW"],
  "added sugar": ["ESW"],
  "addiction": ["DRd","ABf","ABc","ABd","ABe"],
  "addictive": ["ABh","ABg"],
  "adding": ["Eaa","Dei","Dej"],
  "adding sugar": ["Eaa","Dej"],
  "addition": ["ABk","ABi","ABj"],
  "address": ["DRe","ABn","ABl","ABm"],
  "adjectives": ["ABo"],
  "administrative": ["ABr","ABp","ABq"],
  "admire": ["ABt","ABs"],
  "adopt": ["ABx","ABu","ABv","ABw"],
  "adult": ["DRf","AB0","ABy","ABz"],
  "advance": ["AB2","AB1"],
  "adventure": ["DRg","AB5","AB3","AB4"],
  "advertise": ["Dek"],
  "advertise advertised": ["EUm","Dek"],
  "advertise burgers": ["Dek"],
  "advertised": ["EUm"],
  "advertised hamburgers": ["EUm"],
  "advertisement": ["AB8","AB6","AB7"],
  "advertising": ["Dek"],
  "advertising burgers": ["Dek"],
  "aerobics": ["AB9"],
  "aeroplane": ["ACE","ACA","ACB","ACC","ACD"],
  "aerospace engineer": ["C4e","C4f"],
  "affect": ["ACK","ACF","ACG"],
  "affection": ["DRh","ACJ","ACH","ACI"],
  "afford": ["DRi","ACL"],
  "Afghanistan": ["D8L","ACO","ACM","ACN"],
  "afraid": ["ACR","ACP","ACQ"],
  "Africa": ["ACV","ACS","ACT","ACU"],
  "afternoon": ["ACW"],
  "again": ["ACY","ACX"],
  "against": ["DRj","ACa","ACZ"],
  "age": ["DRk","ACc","ACb"],
  "aggravated": ["DRl","ACd"],
  "agony": ["DRm","ACf","ACe"],
  "agree": ["DRo","ACm","ACg","ACh","ACi"],
  "agreement": ["DRn","ACl","ACj","ACk"],
  "aim": ["DRp","ACq","ACn","ACo","ACp"],
  "air": ["EdE","AC3","ACr","ACs"],
  "air conditioner": ["DwI","C4g","ACt","ACu","ACv","ACw","ACx"],
  "air pollution": ["C4h","C4i","AC4","AC5","AC6","AC7","AC8"],
  "airplane": ["AC2","ACy","ACz","AC0","AC1"],
  "airport": ["DwJ","C4j","ADF","AC9","ADA","ADB","ADC","ADD","ADE"],
  "airport terminal": ["ADG","ADH"],
  "aisle": ["ADJ","ADI"],
  "aladdin": ["ADM","ADK","ADL"],
  "alarm": ["ADT","ADN","ADO","ADP"],
  "alarm clock": ["DwK","C4k","ADQ","ADR","ADS"],
  "Albania": ["D8P"],
  "albatross": ["ADW","ADU","ADV"],
  "albert einstein": ["ADX","ADY"],
  "alcohol": ["DRq","ADc","ADZ","ADa","ADb"],
  "Algeria": ["D8Q"],
  "alien": ["DRr","ADg","ADd","ADe","ADf"],
  "aliens": ["DRs"],
  "all": ["ADx","ADh"],
  "allergic": ["DRt","ADj","ADi"],
  "allergies": ["DRu","ADl","ADk"],
  "allergy": ["ADn","ADm"],
  "alligator": ["ADr","ADo","ADp","ADq"],
  "allow": ["ADw","ADs","ADt","ADu","ADv"],
  "alone": ["DRv","ADz","ADy"],
  "along": ["DRw"],
  "aloud": ["DRx","AD1","AD0"],
  "alpaca": ["AD4","AD2","AD3"],
  "alpha": ["Doc"],
  "alphabet": ["DRy","AD6","AD5"],
  "alternative energy": ["DRz","AD7","AD8","AD9"],
  "altitude": ["DR0","AEB","AEA"],
  "always": ["AEC"],
  "amaze": ["DR1","AED"],
  "amazing": ["DR2","AEF","AEE"],
  "amazon": ["AEJ","AEG","AEH","AEI"],
  "ambassador": ["AEK"],
  "amber": ["C4l","AEN","AEL","AEM"],
  "ambitious": ["AEO"],
  "ambulance": ["DwL","C4m","AES","AEP","AEQ","AER"],
  "ambush": ["AEU","AET"],
  "America": ["EPk","DwN","C4p","AEp","AEV","AEW","AEX","AEY","AEZ"],
  "American": ["EeD","C4o","AEo","AEa","AEb"],
  "American flag": ["AEc"],
  "American football": ["DwM","C4n","AEd","AEe","AEf","AEg","AEh","AEi"],
  "americano": ["EgS","AEn","AEj","AEk"],
  "americano iced": ["AEl","AEm"],
  "among": ["AEq"],
  "among us": ["AEr"],
  "amphibian": ["C4q"],
  "amplitude": ["AEs"],
  "Amsterdam": ["AEw","AEt","AEu","AEv"],
  "amusement": ["DR4","AE3","AEx","AEy","AEz"],
  "amusement park": ["DR3","AE0","AE1","AE2"],
  "amusing": ["DR5","AE4"],
  "an apple a day keeps the doctor away": ["D8R","D8S","D8T"],
  "an earache": ["Dod"],
  "anaconda": ["AE9","AE5","AE6","AE7","AE8"],
  "analogy": ["AFA"],
  "ancestor": ["AFD","AFB","AFC"],
  "anchor": ["AFG","AFE","AFF"],
  "ancient": ["AFJ","AFH","AFI"],
  "Andorra": ["AFL","AFK"],
  "angel": ["DR7","DR6","AFQ","AFM","AFN","AFO","AFP"],
  "anger": ["DR8","AFS","AFR"],
  "Angola": ["D8U"],
  "angrily": ["ERR"],
  "angry": ["D8V","C4r","DR9","AFX","AFT","AFU","AFV"],
  "angry girl": ["AFW"],
  "animal": ["AFa"],
  "animal crossing": ["AFY","AFZ"],
  "animal shelter": ["AFd","AFe"],
  "animals": ["AFf","AFb","AFc"],
  "animation": ["AFh","AFg"],
  "anime": ["AFj","AFi"],
  "ankle": ["DwO","C4s","AFk"],
  "anklet": ["AFl"],
  "announcer": ["DSA","AFo","AFm","AFn"],
  "annoy": ["DSC","AFt"],
  "annoyed": ["D8Z","C4t","DSB","AFs","AFp","AFq","AFr"],
  "another": ["AFu"],
  "answer": ["AFz","AFv","AFw","AFx","AFy"],
  "ant": ["DwP","C4u","AGO","AF0","AF1","AF2","AF3"],
  "Antarctica": ["AF7","AF4","AF5","AF6"],
  "antelope": ["AGA","AF8","AF9"],
  "antenna": ["AGD","AGB","AGC"],
  "anthem": ["AGF","AGE"],
  "antique shop": ["AGG","AGH","AGI"],
  "antisocial": ["AGJ"],
  "antlers": ["AGN","AGK","AGL","AGM"],
  "ants": ["AGR","AGP","AGQ"],
  "anxious": ["AGT","AGS"],
  "apartment": ["AGW","AGU","AGV"],
  "apartment block": ["DwQ","C4v"],
  "ape": ["AGb","AGX","AGY","AGZ","AGa"],
  "app": ["AHC","AGc","AGd"],
  "apparition": ["AGf","AGe"],
  "appear": ["Doe"],
  "appendix": ["AGg"],
  "appetizers": ["AGj","AGh","AGi"],
  "apple": ["DwS","C4x","AGx","AGk","AGl","AGm","AGn","AGo","AGp"],
  "apple juice": ["DwR","C4w","AGq","AGr","AGs"],
  "apple pie": ["AGt","AGu","AGv","AGw"],
  "apple tea": ["AG4"],
  "apples": ["EgT","C4y","AG3","AGy","AGz","AG0"],
  "applesauce": ["AG2","AG1"],
  "appliance": ["AG7","AG5","AG6"],
  "application": ["AHB","AG8","AG9","AHA"],
  "appreciate": ["DSD","AHD"],
  "apprentice": ["DSE","AHG","AHE","AHF"],
  "approach": ["AHH"],
  "apricot": ["AHK","AHI","AHJ"],
  "April": ["Dof"],
  "apron": ["DwT","C4z","AHM","AHL"],
  "aquamarine": ["AHN"],
  "aquarium": ["AHP","AHO"],
  "Arab": ["AHT","AHQ"],
  "arabesque": ["AHS","AHR"],
  "arcade game": ["DSF","AHU"],
  "archaeologist": ["DSG","AHY","AHV","AHW","AHX"],
  "archeologist": ["DSH"],
  "archery": ["DwU","C40","DSI","AHb","AHZ","AHa"],
  "architect": ["D8a","D8b","C42","C41","AHf","AHc","AHd","AHe"],
  "arctic": ["AHk","AHg","AHh"],
  "arctic fox": ["AHi","AHj"],
  "are you a student": ["D8d"],
  "are you angry": ["D8c"],
  "are you bored": ["D8e"],
  "are you cold": ["D8f"],
  "are you tired": ["D8g"],
  "Argentina": ["D8h","DwV","C44","AHo","AHl","AHm","AHn"],
  "Argentina flag": ["C43"],
  "Argentinean": ["AHp"],
  "Argentinian": ["EeE","C45"],
  "argue": ["EdK","EWW","Dem","Del"],
  "argue argued": ["EUu","Del","Dem"],
  "argue in a courtroom": ["D8i"],
  "argue with someone": ["EWW"],
  "argued": ["EUu"],
  "arguing": ["EdK","Dem","Del"],
  "argument": ["AHt","AHq","AHr","AHs"],
  "arm": ["DwY","C48","AH4","AHu","AHv"],
  "arm chair": ["AHx","AHy","AHz"],
  "armbands": ["AHw"],
  "armchair": ["DwW","C46"],
  "Armenia": ["AH3","AH0","AH1","AH2"],
  "armpit": ["DwX","C47"],
  "arms": ["C5A","C49","AH5"],
  "army": ["AH9","AH6","AH7","AH8"],
  "aroma": ["DSJ","AID","AIA","AIB","AIC"],
  "around": ["AIF","AIE"],
  "arrange": ["EWX","Den","AIK","AIG","AIH"],
  "arrange arranged": ["Den"],
  "arrange flowers": ["D8j","Den"],
  "arrange some flowers": ["EWX"],
  "arrangement": ["AIJ","AII"],
  "arranging": ["Den"],
  "arranging flowers": ["Den"],
  "arrest": ["EWY","Deo","AIO","AIL"],
  "arrest arrested": ["Deo"],
  "arrest criminals": ["D8k"],
  "arrest someone": ["EWY","Deo"],
  "arrested": ["AIN","AIM"],
  "arresting": ["Deo"],
  "arresting someone": ["Deo"],
  "arrival": ["AIP"],
  "arrive": ["EWZ","Deq","Dep"],
  "arrive arrived": ["EWH","EUp","Dep","Deq"],
  "arrive at the station": ["EWZ","Dep"],
  "arrived": ["EWH","EUp","DSK"],
  "arriving": ["Deq","Dep"],
  "arriving at the station": ["Dep"],
  "arrogance": ["DSL","AIR","AIQ"],
  "arrogant": ["DSM","AIT","AIS"],
  "arrow": ["DSN","AIY","AIU","AIV","AIW","AIX"],
  "art": ["Dwa","C5D","AIu","AIZ","AIa","AIb"],
  "art gallery": ["AIe","AIf","AIg"],
  "art room": ["Dog"],
  "artery": ["AId","AIc"],
  "artichoke": ["AIj","AIh","AIi"],
  "article": ["AIm","AIk","AIl"],
  "articles": ["AIn"],
  "artist": ["D8l","D8m","DwZ","C5C","C5B","DSP","AIt","AIo","AIp","AIq"],
  "artistic": ["DSO","AIs","AIr"],
  "artwork": ["AIx","AIv","AIw"],
  "as hard as nails": ["D8n","D8o","D8p"],
  "as old as the hills": ["D8q","D8r","D8s"],
  "as usual": ["AKK","AKL"],
  "as white as snow": ["D8w","D8x","D8y"],
  "ashamed": ["AI2","AIy","AIz","AI0","AI1"],
  "ashma": ["DSQ"],
  "Asia": ["AI9","AI3","AI4","AI5","AI6","AI7","AI8"],
  "asiatic lion": ["AJA"],
  "ask": ["Ebw","EWa","Des","Der","AJF","AJB","AJC"],
  "ask a question": ["Ebw","EWa","Der"],
  "ask asked": ["ETj","Der","Des"],
  "ask for help": ["AJE"],
  "asked": ["ETj","AJD"],
  "asked a question": ["ETj"],
  "asking": ["Ebw","Des","Der"],
  "asking a question": ["Ebw","Der"],
  "asleep": ["AJJ","AJG","AJH","AJI"],
  "asparagus": ["AJM","AJK","AJL"],
  "aspirin": ["AJP","AJN","AJO"],
  "assemble": ["AJU","AJQ","AJR","AJS","AJT"],
  "assets": ["AJX","AJV","AJW"],
  "assign": ["AJa"],
  "assignment": ["AJZ","AJY"],
  "assist the boss": ["D8t"],
  "assistance": ["AJd","AJb","AJc"],
  "assistant": ["AJi","AJe","AJf","AJg","AJh"],
  "asteroid": ["AJo","AJj","AJk","AJl","AJm","AJn"],
  "asthma": ["DSR","AJs","AJp","AJq","AJr"],
  "astonish": ["DST","AJ2","AJt","AJu","AJv"],
  "astonished": ["DSS","AJ0","AJw","AJx","AJy","AJz"],
  "astonishment": ["AJ1"],
  "astound": ["AJ4","AJ3"],
  "astronaut": ["D8u","D8v","C5F","C5E","AKC","AJ5","AJ6","AJ7","AJ8","AJ9","AKA","AKB"],
  "astronomer": ["AKE","AKD"],
  "astronomy": ["DSU","AKJ","AKF","AKG","AKH","AKI"],
  "at": ["AKz","AKM"],
  "at home": ["AKa","AKb","AKc"],
  "at night": ["AKt","AKu","AKv","AKw","AKx","AKy"],
  "at risk": ["AK0","AK1"],
  "at school": ["AK2","AK3","AK4","AK5","AK6","AK7"],
  "at the back": ["Edp","DdD"],
  "at the back of the queue": ["Edp"],
  "at the beach": ["ALO","ALP","ALQ"],
  "at the front": ["Edq","DdE"],
  "at the front of the plane": ["Edq"],
  "at the mall": ["ALR"],
  "at the museum": ["ALS"],
  "at your wits end": ["D82","D83","D84"],
  "ate": ["ETk"],
  "ate pizza": ["ETk"],
  "athlete": ["D8z","D80","C5H","C5G","AKT","AKN","AKO","AKP","AKQ","AKR","AKS"],
  "athletic": ["D81","DSV","AKX","AKU","AKV","AKW"],
  "athletics": ["AKZ","AKY"],
  "atlas": ["AKh","AKd","AKe","AKf","AKg"],
  "atm": ["Dwb","C5I","AKs","AKi","AKj","AKk","AKl","AKm"],
  "atmosphere": ["AKr","AKn","AKo","AKp","AKq"],
  "attach": ["ALE","AK8","AK9"],
  "attachment": ["ALD","ALA","ALB","ALC"],
  "attack": ["ALI","ALF","ALG","ALH"],
  "attend": ["ALK"],
  "attendance": ["ALJ"],
  "attention": ["ALN","ALL","ALM"],
  "attic": ["ALX","ALT","ALU","ALV","ALW"],
  "attitude": ["ALZ","ALY"],
  "attract": ["ALj","ALa","ALb","ALc"],
  "attractive": ["ALi","ALd","ALe","ALf","ALg","ALh"],
  "au pair": ["DSY"],
  "auction": ["ALm","ALk","ALl"],
  "audience": ["ALp","ALn","ALo"],
  "auditorium": ["Doh"],
  "August": ["Doi"],
  "aunt": ["D85","DZK","DSX","ALr","ALq"],
  "auntie": ["DSW"],
  "aurora": ["ALv","ALs","ALt","ALu"],
  "Australia": ["D86","Dwc","C5L","AL4","ALw","ALx","ALy","ALz","AL0","AL1","AL2"],
  "Australia and Oceania": ["AL3"],
  "Australia flag": ["C5J"],
  "Australian": ["EeF","C5K"],
  "Austria": ["D87","AL9","AL5","AL6","AL7","AL8"],
  "author": ["D88","D89","C5N","C5M","AMH","AMA","AMB","AMC","AMD"],
  "authority": ["AMG","AME","AMF"],
  "automatically": ["AMK","AMI","AMJ"],
  "automobile": ["AMN","AML","AMM"],
  "autumn": ["AMU","AMO","AMP","AMQ","AMR","AMS","AMT"],
  "avalanche": ["AMZ","AMV","AMW","AMX","AMY"],
  "avocado": ["Dwd","C5O","AMd","AMa","AMb","AMc"],
  "avocado smoothie": ["AMe","AMf"],
  "avocados": ["EgU"],
  "avoid": ["DSZ"],
  "awake": ["DSa"],
  "aware": ["DSb"],
  "awe inspiring": ["DSc","AMg","AMh"],
  "awesome": ["DSd","AMj","AMi"],
  "awful": ["DSe","AMm","AMk","AMl"],
  "awkward": ["AMp","AMn","AMo"],
  "axe": ["Dwe","C5P","AMu","AMq","AMr","AMs","AMt"],
  "axis": ["AMy","AMv","AMw","AMx"],
  "Azerbaijan": ["AM2","AMz","AM0","AM1"],
  "b": ["DZo","DZn"],
  "babies": ["Doj"],
  "baboon": ["DSf","AM5","AM3","AM4"],
  "baby": ["DSg","ANG","AM6","AM7","AM8","AM9"],
  "baby bottle": ["ANA","ANB","ANC","AND"],
  "baby brother": ["Dok"],
  "baby cat": ["ANE"],
  "baby dog": ["ANF"],
  "baby sister": ["Dol"],
  "babysitter": ["ANI","ANH"],
  "back": ["ANb","ANJ","ANK"],
  "back to school": ["DSj","ANg","ANh"],
  "backache": ["DSh","ANO","ANL","ANM","ANN"],
  "background": ["DSi","ANS","ANP","ANQ","ANR"],
  "backpack": ["Dwf","Dwg","C5R","C5Q","ANa","ANT","ANU","ANV","ANW","ANX","ANY","ANZ"],
  "backstage": ["ANf","ANc","ANd","ANe"],
  "backwards": ["ANl","ANi","ANj","ANk"],
  "backyard": ["ANp","ANm","ANn","ANo"],
  "bacon": ["Dwh","C5S","ANt","ANq","ANr","ANs"],
  "bacteria": ["ANx","ANu","ANv","ANw"],
  "bad": ["D9A","AOM","ANy","ANz","AN0","AN1","AN2","AN3"],
  "bad news": ["AOK","AOL"],
  "bad temper": ["AON"],
  "badge": ["AN9","AN4","AN5","AN6","AN7","AN8"],
  "badges": ["AOC","AOA","AOB"],
  "badly": ["ERL"],
  "badminton": ["Dwi","C5T","AOJ","AOD","AOE","AOF","AOG","AOH","AOI"],
  "bag": ["Dwj","C5Y","C5U","AOk","AOO","AOP","AOQ","AOR","AOS","AOT","AOU"],
  "bag of chips": ["AOh"],
  "bag of flour": ["AOi","AOj"],
  "bagel": ["C5V","AOZ","AOV","AOW","AOX","AOY"],
  "bagels": ["AOb","AOa"],
  "baggage": ["AOg","AOc","AOd","AOe"],
  "baggage claim": ["AOf"],
  "baggage handler": ["D9C","D9B","C5W","C5X"],
  "baguette": ["Dwk","C5Z"],
  "Bahrain": ["AOo","AOl","AOm","AOn"],
  "bake": ["AOv","AOp"],
  "bake cookies": ["AOq","AOr"],
  "baked potato": ["AOs","AOt","AOu"],
  "baker": ["D9D","D9E","Dwl","C5b","C5a","AO1","AOw","AOx","AOy","AOz","AO0"],
  "baker's": ["AO7","C5c","AO2"],
  "bakery": ["C5c","AO7","AO3","AO4","AO5","AO6"],
  "baking cookies": ["AO8"],
  "balance": ["APD","AO9","APA","APB","APC"],
  "balcony": ["APK","APE","APF","APG","APH","API","APJ"],
  "bald": ["APP","APL","APM","APN","APO"],
  "ball": ["Dwn","C5e","APt","APQ","APR","APS","APT","APU","APV"],
  "ballerina": ["APb","APW","APX","APY","APZ","APa"],
  "ballet": ["APi","APc","APd","APe","APf"],
  "ballet classes": ["APg","APh"],
  "balloon": ["Dwm","C5d","APo","APj","APk","APl","APm","APn"],
  "balloons": ["APs","APp","APq","APr"],
  "balls": ["APv","APu"],
  "bambi": ["AP0","APw","APx","APy","APz"],
  "ban": ["ARB","AP1","AP2","AP3","AP4","AP5"],
  "banana": ["EgV","C5g","AQB","AP6","AP7","AP8","AP9","AQA"],
  "banana milkshake": ["C5f"],
  "bananas": ["Dwo","C5h","AQH","AQC","AQD","AQE","AQF","AQG"],
  "band": ["AQS","AQI","AQJ","AQK","AQL","AQM"],
  "band aid": ["Dwq","C5j"],
  "bandage": ["Dwp","C5i","AQR","AQN","AQO","AQP","AQQ"],
  "bangers and mash": ["AQT"],
  "Bangladesh": ["D9F","AQZ","AQU","AQV","AQW","AQX","AQY"],
  "bangle": ["AQd","AQa","AQb","AQc"],
  "bangles": ["AQf","AQe"],
  "banjo": ["Dwr","C5k","AQk","AQg","AQh","AQi","AQj"],
  "bank": ["AQ4","AQl","AQm","AQn","AQo","AQp","AQq","AQr"],
  "bank account": ["DSk","AQs","AQt","AQu","AQv","AQw","AQx","AQy"],
  "bank robbers": ["DSm"],
  "banknote": ["DSl","AQ3","AQz","AQ0","AQ1","AQ2"],
  "bankrupt": ["DSn","AQ7","AQ5","AQ6"],
  "banner": ["ARA","AQ8","AQ9"],
  "baozi": ["ARD","ARC"],
  "bar": ["Dom"],
  "barbecue": ["Dws","C5l","ARM","ARE","ARF","ARG","ARH","ARI","ARJ","ARK","ARL"],
  "barbeque": ["Dws","C5l","ARM","ARE","ARF","ARG","ARH","ARI","ARJ","ARK","ARL"],
  "barber": ["ARP","ARN","ARO"],
  "barbers": ["ARU","ARQ","ARR","ARS"],
  "barbershop": ["ART"],
  "barcode": ["ARX","ARV","ARW"],
  "barefooted": ["ARb","ARY","ARZ","ARa"],
  "bargain": ["ARe","ARc","ARd"],
  "barista": ["D9G","D9H","C5n","C5m"],
  "bark": ["ARk","ARf","ARg","ARh"],
  "barking": ["ARj","ARi"],
  "barley": ["ARo","ARl","ARm","ARn"],
  "barman": ["Dwt"],
  "barn": ["ARu","ARp","ARq","ARr","ARs","ARt"],
  "barrel": ["AR0","ARv","ARw","ARx","ARy","ARz"],
  "barren": ["AR4","AR1","AR2","AR3"],
  "barrister": ["AR8","AR5","AR6","AR7"],
  "bartender": ["D9I","D9J","C5p","C5o","ASE","AR9","ASA","ASB","ASC","ASD"],
  "base": ["ASa"],
  "baseball": ["Dwu","C5q","ASS","ASF","ASG","ASH","ASI","ASJ"],
  "baseball cap": ["ASK","ASL","ASM","ASN","ASO","ASP"],
  "baseball field": ["ASQ","ASR"],
  "baseball stadium": ["AST","ASU"],
  "basement": ["ASZ","ASV","ASW","ASX","ASY"],
  "basil": ["ASg","ASb","ASc","ASd","ASe","ASf"],
  "basket": ["Dww","C5s","ASv","ASh","ASi","ASj","ASk","ASl","ASm"],
  "basketball": ["Dwv","C5r","ASu","ASn","ASo","ASp","ASq","ASr","ASs","ASt"],
  "bass": ["ASz"],
  "bassoon": ["ASy","ASw","ASx"],
  "bat": ["Dwx","C5v","ATQ","AS0","AS1","AS2","AS3","AS4","AS5","AS6"],
  "bath": ["C5t","ATF","AS7","AS8","AS9","ATA"],
  "bathe": ["ATE","ATB","ATC","ATD"],
  "bathroom": ["C5u","ATM","ATG","ATH","ATI","ATJ","ATK","ATL"],
  "bathtub": ["ATP","ATN","ATO"],
  "batman": ["Don"],
  "bats": ["D9K"],
  "batteries": ["ATT","ATR","ATS"],
  "battery": ["Dwy","C5w","ATY","ATU","ATV","ATW","ATX"],
  "battle": ["ATc","ATZ","ATa","ATb"],
  "baubles": ["ATh","ATd","ATe","ATf","ATg"],
  "bay": ["ATl","ATi","ATj","ATk"],
  "bbq": ["Dws","C5l","ARM","ARE","ARF","ARG","ARH","ARI","ARJ","ARK","ARL"],
  "be a dinosaur": ["D9L","D9M","D9N"],
  "be a pig": ["D9R","D9S","D9T"],
  "be a superstar": ["D9U","D9V","D9W"],
  "be all ears": ["D9O","D9P","D9Q"],
  "be been": ["EVP","EVQ"],
  "be happy": ["Det"],
  "be in charge of a sports match": ["D9Y"],
  "be on time": ["AW4"],
  "be quiet": ["Ehy","AW5","AW6","AW7"],
  "be the boss of a company": ["D9a"],
  "be unhappy": ["Deu"],
  "be was": ["EUW","Det"],
  "be were": ["EVF"],
  "beach": ["C5x","DvN","AT2","ATm","ATn","ATo","ATp","ATq"],
  "beach ball": ["ATr","ATs","ATt","ATu","ATv"],
  "beach bucket": ["ATw"],
  "beach chair": ["ATx","ATy","ATz","AT0"],
  "beach mat": ["AT1"],
  "beach towel": ["AT3","AT4","AT5"],
  "beach umbrella": ["AT6","AT7","AT8","AT9","AUA"],
  "beads": ["AUF","AUB","AUC","AUD","AUE"],
  "beagle": ["AUH","AUG"],
  "beak": ["C5y","AUL","AUI","AUJ","AUK"],
  "bean": ["Doo"],
  "bean sprouts": ["AUY","AUZ","AUa","AUb"],
  "beanbag": ["AUN","AUM"],
  "beanie": ["AUQ","AUO","AUP"],
  "beans": ["C50","AUX","AUR","AUS","AUT","AUU","AUV","AUW"],
  "beans on toast": ["C5z"],
  "bear": ["Dw0","C52","AUn","AUc","AUd","AUe","AUf","AUg","AUh"],
  "beard": ["Dwz","C51","AUm","AUi","AUj","AUk","AUl"],
  "bears": ["AUp","AUo"],
  "beast": ["AUs","AUq","AUr"],
  "beat": ["AUx","AUt","AUu","AUv","AUw"],
  "beautiful": ["D9X","C53","AU4","AUy","AUz","AU0","AU1","AU2"],
  "beautifully": ["ERD","AU3"],
  "beauty": ["AU8","AU5","AU6"],
  "beauty contest": ["AU7"],
  "beauty salon": ["AU9","AVA","AVB"],
  "beaver": ["AVI","AVC","AVD","AVE","AVF","AVG","AVH"],
  "become": ["AVJ"],
  "bed": ["Dw1","C54","AVS","AVK","AVL","AVM","AVN","AVO","AVP"],
  "bed and breakfast": ["AVQ","AVR"],
  "bedroom": ["C55","AVW","AVT","AVU","AVV"],
  "bedside table": ["AVX","AVY","AVZ","AVa"],
  "bedtime": ["AVe","AVb","AVc","AVd"],
  "bee": ["Dw3","C57","AVt","AVf","AVg","AVh","AVi","AVj","AVk","AVl"],
  "beef": ["EgW","Dw2","C56","AVs","AVm","AVn","AVo","AVp","AVq","AVr"],
  "been": ["EVP","EVm","EVQ","EVR"],
  "been a policeman": ["EVP"],
  "been scuba diving": ["EVm"],
  "been sick": ["EVQ"],
  "been to america": ["EVR"],
  "beer": ["AVz","AVu","AVv","AVw","AVx","AVy"],
  "bees": ["AV2","AV0","AV1"],
  "beetle": ["Dw4","C58","AV7","AV3","AV4","AV5","AV6"],
  "beetroot": ["AV8"],
  "beetroots": ["AWB","AV9","AWA"],
  "beggar": ["AWG","AWC","AWD","AWE","AWF"],
  "begin": ["AWI","AWH"],
  "behind": ["Eds","Edr","DdH","DdF","DdG","AWJ"],
  "behind the bush": ["Edr"],
  "behind the tree": ["Eds"],
  "beige": ["C59","AWM","AWK","AWL"],
  "beijing": ["AWP","AWN","AWO"],
  "being happy": ["Det"],
  "being polite": ["Dop"],
  "being unhappy": ["Deu"],
  "Belgium": ["D9Z","AWT","AWQ","AWR","AWS"],
  "believe": ["AWV","AWU"],
  "bell": ["AWb","AWW","AWX","AWY","AWZ"],
  "bell pepper": ["Egz"],
  "bell peppers": ["D3y","C6A"],
  "bellboy": ["AWa"],
  "bells": ["AWc"],
  "belly": ["Dw6","C6C","AWf","AWd","AWe"],
  "belly button": ["Dw5","C6B"],
  "below": ["AWj","AWg","AWh","AWi"],
  "belt": ["Dw7","C6D","AWn","AWk","AWl","AWm"],
  "beluga": ["AWq","AWo","AWp"],
  "bench": ["Dw8","C6E","AWx","AWr","AWs","AWt","AWu","AWv","AWw"],
  "bend": ["Doq"],
  "benefit": ["AWy"],
  "benefits": ["AWz"],
  "bengal fox": ["AW0","AW1"],
  "bengal tiger": ["AW2","AW3"],
  "berries": ["AXB","AW8","AW9","AXA"],
  "berry": ["AXD","AXC"],
  "best": ["AXM","AXE","AXF"],
  "best friend": ["AXG","AXH"],
  "best friends": ["AXI","AXJ","AXK","AXL"],
  "bet": ["AXQ","AXN","AXO","AXP"],
  "betray": ["AXR"],
  "better": ["ERw","C6F","AXS"],
  "between": ["Edt","DdJ","DdI"],
  "between the earth and the sun": ["Edt"],
  "beverage": ["AXV","AXT","AXU"],
  "beverages": ["DSo","AXW"],
  "Bhutan": ["AXb","AXX","AXY","AXZ","AXa"],
  "bib": ["Dor"],
  "bicycle": ["AXf","AXc","AXd","AXe"],
  "big": ["EhE","EhF","D9b","C6K","C6G","AXv"],
  "big ben": ["Dos"],
  "big brother": ["AXg","AXh"],
  "big buddha": ["AXi","AXj"],
  "big dog": ["AXk","AXl"],
  "big ears": ["AXm","AXn","AXo"],
  "big elephant": ["AXp","AXq","AXr"],
  "big eyes": ["AXs","AXt","AXu"],
  "big sister": ["AXw"],
  "big teeth": ["AXx"],
  "big toe": ["C6L"],
  "big wheel": ["AXy","AXz"],
  "bigger": ["EgP","EgO","ERb","C6J","C6H","C6I"],
  "bike": ["Dw9","C6M","AYD","AX0","AX1","AX2","AX3","AX4"],
  "bike lock": ["AX5","AX6","AX7","AX8"],
  "bike path": ["AX9","AYA","AYB","AYC"],
  "bike rack": ["AYE","AYF","AYG"],
  "bike rides": ["AYH"],
  "bikini": ["AYN","AYI","AYJ","AYK","AYL","AYM"],
  "bill": ["Dot"],
  "billboard": ["DxA","C6N"],
  "bin": ["DxB","C6O","AYY","AYO","AYP","AYQ","AYR"],
  "bin bag": ["AYS","AYT"],
  "binoculars": ["AYX","AYU","AYV","AYW"],
  "biodiversity": ["AYa","AYZ"],
  "biography": ["Dou"],
  "biology": ["DxC","C6P","AYd","AYb","AYc"],
  "bionic": ["AYg","AYe","AYf"],
  "birch": ["AYh"],
  "bird": ["DxD","C6R","C6Q","AYu","AYi","AYj","AYk","AYl","AYm","AYn"],
  "bird bath": ["AYo","AYp"],
  "bird house": ["AYq","AYr","AYs","AYt"],
  "bird table": ["AYy"],
  "birds": ["D9c","AYx","AYv","AYw"],
  "birth": ["AY8"],
  "birthday": ["AY7","AYz","AY0","AY1","AY2","AY3"],
  "birthday cake": ["Dov"],
  "birthday card": ["AY4","AY5"],
  "birthday hat": ["AY6"],
  "birthday party": ["C6S"],
  "biscuit": ["AY9","AZA","AZB"],
  "biscuits": ["C6T","AZE","AZC","AZD"],
  "bison": ["AZJ","AZF","AZG","AZH","AZI"],
  "bit": ["ESX"],
  "bit me": ["ESX"],
  "bitcoin": ["AZK"],
  "bite": ["EdC","Dev","Dew","AZO","AZL","AZM","AZN"],
  "bite bit": ["ESX","Dev","Dew"],
  "bite someone": ["EdC","Dew"],
  "bite someones head off": ["D9d","D9e","D9f"],
  "biting": ["EdC","Dev","Dew"],
  "biting someone": ["Dew"],
  "bitter": ["AZR","AZP","AZQ"],
  "black": ["C6f","AZl","AZS"],
  "black and blue": ["C6U"],
  "black and orange": ["C6V"],
  "black and pink": ["C6W"],
  "black and red": ["C6X"],
  "black and white": ["C6Y"],
  "black and yellow": ["C6Z"],
  "black bird": ["AZX","AZY","AZZ"],
  "black cat": ["D9g","AZc"],
  "black coffee": ["C6b"],
  "black currant": ["AZd","AZe","AZf","AZg"],
  "black dress": ["Ef4","C6c"],
  "black eye": ["DxF","C6d"],
  "black gloves": ["EgE","C6e"],
  "black hair": ["AZh"],
  "black panther": ["AZi","AZj","AZk"],
  "black widow": ["AZm","AZn","AZo"],
  "blackbeard": ["AZT"],
  "blackberry": ["AZW","AZU","AZV"],
  "blackboard": ["DxE","C6a","AZb","AZa"],
  "blade": ["AZr","AZp","AZq"],
  "blame": ["AZv","AZs","AZt","AZu"],
  "blanket": ["AZy","AZw","AZx"],
  "blast": ["AZ2","AZz","AZ0","AZ1"],
  "blaze": ["AZ5","AZ3","AZ4"],
  "blazer": ["DxG","C6g"],
  "blender": ["AaA","AZ6","AZ7","AZ8","AZ9"],
  "blew": ["EUj"],
  "blew air": ["EUj"],
  "blind": ["AaF","AaB","AaC","AaD","AaE"],
  "blink": ["AaH","AaG"],
  "blizzard": ["C6i","C6h","AaL","AaI","AaJ","AaK"],
  "block": ["EWc","Dex","AaR","AaM","AaN","AaO","AaP"],
  "block blocked": ["Dex"],
  "block of flats": ["AaQ"],
  "block the sun": ["EWc","Dex"],
  "blocking": ["Dex"],
  "blocking the sun": ["Dex"],
  "blocks": ["AaT","AaS"],
  "blog": ["AaW","AaU","AaV"],
  "blond": ["AaZ","AaX","AaY","Dow"],
  "blood": ["Aad","Aaa","Aab","Aac"],
  "blood pressure": ["Aae","Aaf"],
  "blood test": ["Aag"],
  "bloom": ["Aaj","Aah","Aai"],
  "blossom": ["Aal","Aak"],
  "blouse": ["DxH","C6j","Aao","Aam","Aan"],
  "blow": ["Ebx","EWe","EWd","Dey","Dez"],
  "blow air": ["EWd","Dey"],
  "blow blew": ["EUj","Dey","Dez"],
  "blow bubbles": ["Aap","Aaq"],
  "blow nose": ["Ebx"],
  "blow your nose": ["EWe","Dez"],
  "blowfish": ["Aat","Aar","Aas"],
  "blowing": ["Ebx","Dez","Dey"],
  "blowing air": ["Dey"],
  "blowing your nose": ["Dez"],
  "blue": ["EhG","EhH","C6q","Aa4","Aau"],
  "blue and green": ["C6k"],
  "blue and white": ["C6l"],
  "blue bird": ["Aa0"],
  "blue coats": ["EgF","C6n"],
  "blue eyes": ["Aa1","Aa2","Aa3"],
  "blue hair": ["EhG","EhH"],
  "blue hat": ["Ef5","C6o"],
  "blue pants": ["EgG","C6p"],
  "blue whale": ["Aa5","Aa6","Aa7","Aa8","Aa9"],
  "blueberries": ["C6m","Aay","Aav","Aaw","Aax"],
  "blueberry": ["Aaz"],
  "blurred": ["AbB","AbA"],
  "blushing": ["AbE","AbC","AbD"],
  "boar": ["AbW","AbF","AbG","AbH"],
  "board": ["AbV","AbI","AbJ","AbK","AbL","AbM"],
  "board game": ["C6r","AbN","AbO","AbP","AbQ"],
  "boarding pass": ["DSp","AbR","AbS","AbT"],
  "boarding school": ["DSq","AbU"],
  "boat": ["DxI","C6s","Abd","AbX","AbY","AbZ","Aba","Abb","Abc"],
  "bobble hat": ["Abe","Abf","Abg","Abh","Abi"],
  "body": ["C6t"],
  "body language": ["Abl"],
  "bodyguard": ["Abk","Abj"],
  "boil": ["EdJ","EWf","De0","Abt","Abm"],
  "boil boiled": ["EUr","De0"],
  "boil water": ["EWf","De0"],
  "boiled": ["EUr"],
  "boiled egg": ["Abn","Abo","Abp","Abq","Abr"],
  "boiled eggs": ["DxJ","C6u"],
  "boiling": ["EdJ","De0","C6w","C6v","Abs"],
  "boiling water": ["De0"],
  "bolt": ["DxK","C6x","Abx","Abu","Abv","Abw"],
  "bone": ["Ab0","Aby","Abz"],
  "bones": ["DxL","C6y","Ab2","Ab1"],
  "bonfire": ["Ab5","Ab3","Ab4"],
  "book": ["DxN","C60","AcJ","Ab6","Ab7","Ab8","Ab9","AcA","AcB"],
  "book bag": ["AcC"],
  "book shelf": ["AcM","AcN","AcO","AcP"],
  "book shelves": ["AcQ","AcR","AcS"],
  "bookcase": ["DxM","C6z","AcI","AcD","AcE","AcF","AcG","AcH"],
  "books": ["DxO","C61","AcY","AcK","AcL"],
  "bookshelf": ["Dox"],
  "bookshop": ["AcX","AcT","AcU","AcV","AcW"],
  "bookstore": ["Acc","AcZ","Aca","Acb"],
  "boom": ["Ach","Acd"],
  "boomerang": ["Acg","Ace","Acf"],
  "boot": ["Acr","Aci","Acj","Ack","Acl","Acm"],
  "booth": ["Acq","Acn","Aco","Acp"],
  "boots": ["DxP","C62","Acy","Acs","Act","Acu","Acv","Acw","Acx"],
  "bored": ["D9h","C63","Ac3","Acz","Ac0","Ac1","Ac2"],
  "boring": ["D9i","Ac6","Ac4","Ac5"],
  "born": ["Ac8","Ac7"],
  "borrow": ["EWg","De1","De2","AdC","Ac9","AdA","AdB"],
  "borrow a book": ["EWg","D9j","De1"],
  "borrow a pen": ["De2"],
  "borrow borrowed": ["De1","De2"],
  "borrowing": ["De2","De1"],
  "borrowing a book": ["De1"],
  "borrowing a pen": ["De2"],
  "Bosnia": ["AdF","AdD","AdE"],
  "Bosnia and Herzegovina": ["D9k"],
  "boss": ["Doy"],
  "both": ["AdG"],
  "bottle": ["DxR","C65","AdO","AdH","AdI","AdJ","AdK"],
  "bottle of ketchup": ["AdL"],
  "bottle of water": ["AdM","AdN"],
  "bottle opener": ["DxQ","C64"],
  "bottles": ["AdS","AdP","AdQ","AdR"],
  "bottom": ["DdK"],
  "bought": ["EWL","ESf"],
  "bought a tv": ["EWL"],
  "bought some groceries": ["ESf"],
  "boulder": ["AdW","AdT","AdU","AdV"],
  "bounce": ["AdY","AdX"],
  "bouquet": ["DSr","Adb","AdZ","Ada"],
  "boutique": ["Adc"],
  "bow": ["Adv","Add","Ade","Adf"],
  "bow tie": ["DxU","C68"],
  "bowl": ["Eab","DxT","De3","C67","Adu","Adg","Adh","Adi","Adj","Adk","Adl"],
  "bowl bowled": ["De3"],
  "bowl of soup": ["Adr","Ads"],
  "bowl of strawberries": ["Adt"],
  "bowling": ["Eab","DxS","De3","C66","Adq","Adm","Adn"],
  "bowling alley": ["Ado","Adp"],
  "box": ["DxW","C7A","Ad5","Adw","Adx","Ady","Adz"],
  "boxer": ["Ad1","Ad0"],
  "boxes": ["Doz"],
  "boxing": ["DxV","C69","Ad4","Ad2","Ad3"],
  "boy": ["AeE","Ad6","Ad7","Ad8"],
  "boy scout": ["AeG","AeH"],
  "boyfriend": ["D9l","DZL","AeD","Ad9","AeA","AeB","AeC"],
  "boys": ["AeI","AeF"],
  "bracelet": ["DxX","C7C","C7B","AeN","AeJ","AeK","AeL","AeM"],
  "bragging": ["DSs","AeO"],
  "braids": ["DSt","AeQ","AeP"],
  "brain": ["DSu","AeW","AeR","AeS","AeT","AeU","AeV"],
  "brake": ["Aea","AeX","AeY","AeZ"],
  "branch": ["DSv","Aej","Aeb","Aec","Aed","Aee","Aef","Aeg"],
  "branches": ["Aei","Aeh"],
  "brave": ["Aeq","Aek","Ael","Aem"],
  "bravely": ["Aep","Aen","Aeo"],
  "Brazil": ["D9m","DxY","C7F","Aeu","Aer","Aes","Aet"],
  "Brazil flag": ["C7D"],
  "Brazilian": ["EeG","C7E"],
  "bread": ["DxZ","C7H","C7G","Aez","Aev","Aew","Aex","Aey"],
  "bread roll": ["EgX","Ae0"],
  "bread rolls": ["Dxa","C7I"],
  "break": ["De7","De4","De5","AfK","Ae1","Ae2","Ae3","Ae4","Ae5"],
  "break a cup": ["De4"],
  "break a window": ["De5"],
  "break broke": ["ESg","De4","De5","De7"],
  "break broken": ["EVd","EVV"],
  "break down": ["D9n","De6","Ae6"],
  "break down broke down": ["De6"],
  "break into": ["AfI","AfJ"],
  "break up": ["D9o","De8"],
  "break up broke up": ["De8"],
  "breaker": ["Ae7"],
  "breakfast": ["AfF","Ae8","Ae9","AfA","AfB","AfC","AfD","AfE"],
  "breaking": ["De7","De4","De5"],
  "breaking a cup": ["De4"],
  "breaking a window": ["De5"],
  "breaking down": ["De6"],
  "breaking news": ["AfG","AfH"],
  "breaking up": ["De8"],
  "breath": ["DSx"],
  "breathe": ["DSw","AfO","AfL","AfM","AfN"],
  "breathtaking": ["DSy","AfR","AfP","AfQ"],
  "breed": ["AfT","AfS"],
  "breeze": ["AfW","AfU","AfV"],
  "brick": ["Afa","AfX","AfY","AfZ"],
  "bricks": ["Afc","Afb"],
  "bride": ["Do0"],
  "bridge": ["Dxb","C7J","Afi","Afd","Afe","Aff","Afg","Afh"],
  "briefcase": ["Dxc","C7L","C7K","Afn","Afj","Afk","Afl","Afm"],
  "bright": ["EhI","D9p","C7N","Afp","Afo"],
  "brighter": ["ERd","C7M"],
  "Britain": ["D9q","Afu","Afq","Afr","Afs","Aft"],
  "British": ["Afw","Afv"],
  "British pound": ["Afx","Afy"],
  "brittle": ["Af0","Afz"],
  "broadband": ["Af2","Af1"],
  "broccoli": ["Dxd","C7O","Af9","Af3","Af4","Af5","Af6","Af7","Af8"],
  "brochure": ["AgC","AgA","AgB"],
  "broke": ["ESg","AgM","AgD","AgE"],
  "broke a mug": ["ESg"],
  "broken": ["EhJ","EhK","EVV","EVd","C7R","AgL","AgF","AgG"],
  "broken arm": ["EhK","Dxe","C7P","AgH","AgI"],
  "broken his arm": ["EVd"],
  "broken leg": ["Dxf","C7Q","AgJ","AgK"],
  "broken the window": ["EVV"],
  "brontosaurus": ["AgO","AgN"],
  "bronze": ["C7S","AgS","AgP","AgQ","AgR"],
  "broom": ["Dxg","C7T","AgX","AgT","AgU","AgV","AgW"],
  "broomstick": ["AgZ","AgY"],
  "brother": ["D9r","D9s","DZM","Agd","Aga","Agb","Agc"],
  "brothers": ["Agg","Age","Agf"],
  "brow": ["Agq","Agh","Agi","Agj"],
  "brown": ["C7Y","Agp"],
  "brown belt": ["Ef6","C7U"],
  "brown coat": ["Ef7","C7V"],
  "brown eyes": ["Agk","Agl","Agm"],
  "brown hair": ["Agn","Ago"],
  "brown pants": ["EgH","C7X"],
  "brownies": ["EgY","C7W"],
  "browse": ["EWi","De9","Ags","Agr"],
  "browse browsed": ["De9"],
  "browse the Internet": ["EWi","De9"],
  "browsing": ["De9"],
  "browsing the Internet": ["De9"],
  "bruise": ["Agt"],
  "Brunei": ["Agx","Agu","Agv","Agw"],
  "brush": ["Eby","Eac","EWj","DfA","DfB","DfC","Ag2","Agy","Agz"],
  "brush brushed": ["EVl","ETl","DfA","DfB","DfC"],
  "brush hair": ["Eby","Ag0","Ag1"],
  "brush my teeth": ["Do1"],
  "brush teeth": ["Eac","Ag3","Ag4","Ag5","Ag6","Ag7"],
  "brush your hair": ["DfB"],
  "brush your teeth": ["EWj","D9t","DfC"],
  "brushed": ["EVl","ETl"],
  "brushed her hair": ["ETl"],
  "brushed her teeth": ["EVl"],
  "brushing": ["Eby","Eac","DfA","DfB","DfC"],
  "brushing your hair": ["DfB"],
  "brushing your teeth": ["DfC"],
  "bubble": ["AhA","Ag8","Ag9"],
  "bubble tea": ["AhF","AhG","AhH","AhI"],
  "bubbles": ["AhE","AhB","AhC","AhD"],
  "bucket": ["Dxh","C7Z","AhN","AhJ","AhK","AhL"],
  "bucket and spade": ["AhM"],
  "buddhism": ["AhR","AhO","AhP","AhQ"],
  "budget": ["AhU","AhS","AhT"],
  "budgie": ["AhX","AhV","AhW"],
  "buffalo": ["Ahb","AhY","AhZ","Aha"],
  "buffalo wings": ["Ahc","Ahd"],
  "bug": ["Ahg","Ahe","Ahf"],
  "bug spray": ["Ahh","Ahi"],
  "build": ["Ead","EWl","EWk","DfD","DfE","DfF","DfG","Ahs","Ahj","Ahk"],
  "build a building": ["D9u"],
  "build a nest": ["EWk","DfD"],
  "build a robot": ["EWl","D9v","DfE"],
  "build a snowman": ["DfF"],
  "build a wall": ["Ead","DfG"],
  "build built": ["ESh","DfD","DfE","DfF","DfG"],
  "builder": ["Dxi","Aho","Ahl","Ahm","Ahn"],
  "building": ["Ead","DfG","DfD","DfE","DfF","Ahr","Ahp","Ahq"],
  "building a nest": ["DfD"],
  "building a robot": ["DfE"],
  "building a snowman": ["DfF"],
  "building a wall": ["Ead","DfG"],
  "built": ["ESh","Do2"],
  "built a wall": ["ESh"],
  "Bulgaria": ["D9w"],
  "bull": ["D9x","Dxj","C7a","Ahx","Aht","Ahu","Ahv"],
  "bulldog": ["Ahw"],
  "bump": ["Ah3","Ahy","Ahz","Ah0"],
  "bumper cars": ["Ah1","Ah2"],
  "bun": ["AiJ","Ah4","Ah5"],
  "bunch": ["Ah9","Ah6","Ah7"],
  "bunch of bananas": ["Ah8"],
  "bungee jumping": ["AiA","AiB","AiC"],
  "bunnies": ["AiD"],
  "bunny": ["AiI","AiE","AiF","AiG","AiH"],
  "buns": ["AiL","AiK"],
  "buoyant": ["AiO","AiM","AiN"],
  "burden": ["AiQ","AiP"],
  "burger": ["C7c","AiZ","AiR","AiS","AiT"],
  "burger and chips": ["AiU","AiV","AiW"],
  "burger and fries": ["C7b","AiX","AiY"],
  "burgers": ["Aic","Aia","Aib"],
  "burial tomb": ["Aid"],
  "burn": ["DfH","Aih","Aie","Aif","Aig"],
  "burn burnt": ["DfH"],
  "burn the midnight oil": ["D9y","D9z","D90"],
  "burning": ["Ehv","Ehu","DfH"],
  "burrito": ["Dxk","C7d","Ail","Aii","Aij","Aik"],
  "burrow": ["Aim"],
  "bury": ["Do3"],
  "bus": ["Dxm","C7i","Ai7","Ain","Aio","Aip"],
  "bus driver": ["Aiq","Air","Ais"],
  "bus station": ["Ai8","Ai9","AjA"],
  "bus stop": ["C7j","AjB","AjC","AjD","AjE","AjF","Do4"],
  "bush": ["Dxl","C7e","Aiy","Ait","Aiu","Aiv"],
  "bushes": ["Aix","Aiw"],
  "busier": ["ERe","C7f"],
  "business": ["DS0","Ai3"],
  "businessman": ["D91","D92","C7h","C7g","DSz","Ai2","Aiz","Ai0","Ai1"],
  "businesswoman": ["DS1","Ai6","Ai4","Ai5"],
  "busy": ["D93","AjI","AjG","AjH"],
  "butcher": ["AjL","AjJ","AjK"],
  "butcher's": ["Do5","AjP","AjM","AjN","AjO"],
  "butchers": ["AjP","AjM","AjN","AjO"],
  "butchery": ["AjR","AjQ","Do5","AjP","AjM"],
  "butter": ["Dxo","C7l","Aja","AjS","AjT","AjU"],
  "butterflies in your stomach": ["D94","D95","D96"],
  "butterfly": ["Dxn","C7k","AjZ","AjV","AjW","AjX","AjY"],
  "button": ["Dxp","C7m","Ajd","Ajb","Ajc"],
  "buttons": ["Aje"],
  "buy": ["Eaf","Eae","EWn","DfL","DfI","DfJ","DfK","Ajf"],
  "buy a coffee": ["Eae"],
  "buy a TV": ["DfI"],
  "buy bought": ["EWL","ESf","DfI","DfJ","DfK","DfL"],
  "buy coffee": ["DfJ"],
  "buy groceries": ["Eaf","DfK"],
  "buy some food": ["EWn"],
  "buying": ["Eaf","Eae","DfL","DfI","DfJ","DfK"],
  "buying a TV": ["DfI"],
  "buying coffee": ["DfJ"],
  "buying groceries": ["Eaf","DfK"],
  "buzz": ["Ajg"],
  "by the lake": ["Ajj","Ajk"],
  "by the river": ["Ajl"],
  "by the sea": ["Ajm"],
  "bye": ["Aji","Ajh"],
  "c": ["DZq","DZp"],
  "cab": ["Aj5","Ajn","Ajo","Ajp"],
  "cabbage": ["Dxq","C7n","Ajr","Ajq"],
  "cabbages": ["Ajs"],
  "cabin": ["Aj0","Ajt","Aju","Ajv","Ajw"],
  "cabinet": ["Ajz","Ajx","Ajy"],
  "cable": ["Aj4","Aj1"],
  "cable car": ["Aj2","Aj3"],
  "cactus": ["Aj8","Aj6","Aj7"],
  "cafe": ["C7p","AkD","Aj9","AkA","AkB","AkC"],
  "cafe latte": ["Egp","C7o"],
  "cafeteria": ["AkF","AkE"],
  "cage": ["AkJ","AkG","AkH","AkI"],
  "cake": ["Dxr","C7q","AkQ","AkK","AkL","AkM","AkN","AkO","AkP"],
  "cakes": ["AkR"],
  "calculate": ["AkU","AkS","AkT"],
  "calculator": ["Dxs","Dxt","C7s","C7r","Aka","AkV","AkW","AkX","AkY","AkZ"],
  "calendar": ["Akf","Akb","Akc","Akd","Ake"],
  "calf": ["Akh","Akg"],
  "California": ["D97"],
  "call": ["EWo","DfN","DfM","Akl","Aki","Akj","Akk"],
  "call a friend": ["DfM"],
  "call called": ["ESi","DfM","DfN"],
  "call his grandma": ["D98"],
  "call someone on the phone": ["EWo"],
  "called": ["ESi"],
  "called her": ["ESi"],
  "calling": ["DfN","DfM"],
  "calling a friend": ["DfM"],
  "calm": ["Ako","Akm","Akn"],
  "Cambodia": ["D99","Akt","Akp","Akq","Akr","Aks"],
  "camel": ["Dxu","C7t","Aky","Aku","Akv","Akw","Akx"],
  "camera": ["Dxv","C7w"],
  "cameraman": ["EAA","EAB","C7v","C7u"],
  "Cameroon": ["EAC"],
  "camouflage": ["Ak1","Akz","Ak0"],
  "camp": ["AlB","Ak2","Ak3"],
  "camper": ["Ak6","Ak4","Ak5"],
  "campfire": ["Do6"],
  "camping": ["Ak8","Ak7"],
  "camping tent": ["Ak9","AlA"],
  "campsite": ["C7x","AlE","AlC","AlD"],
  "can": ["Ed3","Ed2","Ed1","Ed0","Edz","Edy","Edx","Edw","Edv","Edu","Dx0","C8A","Al5","AlF","AlG","AlH","AlI"],
  "can climb a tree": ["Edu","C71"],
  "can drive": ["C73"],
  "can drive a car": ["Edv"],
  "can i borrow a book": ["EAF"],
  "can i borrow a pen": ["EAG"],
  "can jump": ["Edw","C75"],
  "can opener": ["Dxz","C76"],
  "can play the piano": ["Edx","C77"],
  "can play the trumpet": ["Edy","C78"],
  "can play the violin": ["Edz","C79"],
  "can speak": ["C8D"],
  "can speak Chinese": ["Ed0","C8B"],
  "can speak English": ["Ed1","C8C"],
  "can swim": ["Ed2","C8E","C8F"],
  "can talk": ["Ed3"],
  "can you speak french": ["EAK"],
  "can you swim": ["EAL"],
  "can you type": ["EAM"],
  "can't": ["Ed4","Ed5","Ed6","Ed7","Ed8","Ed9","EeA","EeB","EeC"],
  "can't climb a tree": ["Ed4","C8G"],
  "can't drive": ["C8H"],
  "can't drive a car": ["Ed5"],
  "can't play the guitar": ["Ed6","C8I"],
  "can't read": ["C8J"],
  "can't read a book": ["Ed7"],
  "can't ride a bike": ["Ed8","C8K"],
  "can't swim": ["Ed9","C8L"],
  "can't take a bus": ["EeA","C8M"],
  "can't understand": ["C8N"],
  "can't understand Chinese": ["EeB"],
  "can't use a computer": ["EeC","C8O"],
  "Canada": ["EAD","Dxw","C7z","AlO","AlJ","AlK","AlL","AlM","AlN"],
  "Canada flag": ["C7y"],
  "Canadian": ["EeH","C70"],
  "canary": ["AlR","AlP","AlQ"],
  "candies": ["AlT","AlS"],
  "candle": ["Dxx","C72","AlY","AlU","AlV","AlW","AlX"],
  "candles": ["EAE","Alc","AlZ","Ala","Alb"],
  "candy": ["Dxy","C74","Alk","Ald","Ale","Alf","Alg"],
  "candy bar": ["Alh"],
  "candy cane": ["Ali","Alj"],
  "candy store": ["All","Alm","Aln","Alo"],
  "cane": ["Als","Alp","Alq","Alr"],
  "canned food": ["Alt","Alu"],
  "cannon": ["Aly","Alv","Alw","Alx"],
  "canoe": ["Al4","Alz","Al0","Al1"],
  "canoeing": ["Al3","Al2"],
  "cant teach an old dog new tricks": ["EAH","EAI","EAJ"],
  "cantaloupe": ["AmB","Al6","Al7","Al8","Al9","AmA"],
  "canteen": ["AmE","AmC","AmD"],
  "canvas": ["AmH","AmF","AmG"],
  "cap": ["Dx1","C8P","AmR","AmI","AmJ","AmK","AmL"],
  "cape": ["AmO","AmM","AmN"],
  "capital": ["AmQ","AmP"],
  "capital a": ["DZl"],
  "capital b": ["DZn"],
  "capital c": ["DZp"],
  "capital d": ["DZr"],
  "capital e": ["DZt"],
  "capital f": ["DZv"],
  "capital g": ["DZx"],
  "capital h": ["DZz"],
  "capital i": ["DZ"],
  "capital j": ["DZ3"],
  "capital k": ["DZ5"],
  "capital l": ["DZ7"],
  "capital m": ["DZ9"],
  "capital n": ["DaB"],
  "capital o": ["DaD"],
  "capital p": ["DaF"],
  "capital q": ["DaH"],
  "capital r": ["DaJ"],
  "capital s": ["DaL"],
  "capital t": ["DaN"],
  "capital u": ["DaP"],
  "capital v": ["DaR"],
  "capital w": ["DaT"],
  "capital x": ["DaV"],
  "capital y": ["DaX"],
  "capital z": ["DaZ"],
  "cappuccino": ["C8Q"],
  "captain": ["AmV","AmS","AmT","AmU"],
  "capture": ["AmX","AmW"],
  "car": ["Dx7","C8Y","And","AmY","AmZ","Ama","Amb"],
  "car crash": ["Amo","Amp","Amq"],
  "car park": ["Dx5","C8V","AnP","AnQ","AnS"],
  "car parking": ["AnR"],
  "car racing": ["Ane"],
  "car salesman": ["EAR","EAQ","Dx9","C8a","C8b"],
  "car wash": ["An9","AoA","AoB"],
  "caravan": ["Ame","Amc","Amd"],
  "carbohydrates": ["Ami","Amf","Amg","Amh"],
  "carbon dioxide": ["Aml","Amm","Amn"],
  "carbonated": ["Amj"],
  "carbonated water": ["Amk"],
  "card": ["Am3","Amr","Ams","Amt"],
  "card machine": ["Am1","Am2"],
  "cardboard": ["Amw","Amu","Amv"],
  "cardigan": ["Dx2","C8R","Am0","Amx","Amy","Amz"],
  "cards": ["Dx3","C8T","C8S","Am5","Am4"],
  "care": ["DS5","AnC","Am6"],
  "career": ["DS2","Am7"],
  "careful": ["DS4","AnB","Am8"],
  "carefully": ["ERB","DS3","AnA","Am9"],
  "careless": ["Do7"],
  "cargo": ["DS6","AnF","AnD","AnE"],
  "cargo shorts": ["Dx4","C8U"],
  "caring": ["Do8"],
  "carnation": ["AnI","AnG","AnH"],
  "carnivore": ["AnL","AnJ","AnK"],
  "carol singers": ["EAN"],
  "carousel": ["AnO","AnM","AnN"],
  "carpenter": ["EAO","EAP","Dx6","C8X","C8W","AnX","AnT","AnU","AnV","AnW"],
  "carpet": ["Anc","AnY","AnZ","Ana","Anb"],
  "carriage": ["Ang","Anf"],
  "carried": ["ESj"],
  "carried a bag": ["ESj"],
  "carrot": ["EgZ","Ann","Anh","Ani","Anj","Ank"],
  "carrot cake": ["Anl","Anm"],
  "carrots": ["Dx8","C8Z","Anp","Ano"],
  "carry": ["Ebz","Eag","EWp","DfQ","DfO","DfP","Anu","Anq","Anr","Ans","Ant"],
  "carry a bag": ["Eag","EWp","DfO"],
  "carry a box": ["Ebz","DfP"],
  "carry carried": ["ESj","DfO","DfP","DfQ"],
  "carrying": ["Ebz","Eag","DfQ","DfO","DfP"],
  "carrying a bag": ["Eag","DfO"],
  "carrying a box": ["Ebz","DfP"],
  "cart": ["An6","Anv","Anw","Anx"],
  "carton": ["An3","Any","Anz","An0"],
  "carton of milk": ["An1","An2"],
  "cartoon": ["An5","An4"],
  "carve": ["An8","An7"],
  "case": ["AoE","AoC","AoD"],
  "cash": ["AoK","AoF","AoG","AoH"],
  "cash register": ["AoL","AoM"],
  "cashier": ["EAS","EAT","DyA","C8d","C8c","AoJ","AoI"],
  "cask": ["AoN"],
  "cast": ["AoS"],
  "castle": ["DyB","C8e","AoR","AoO","AoP","AoQ"],
  "casual": ["AoW","AoT","AoU","AoV"],
  "cat": ["EAV","DyD","C8g","Aoz","AoX","AoY","AoZ","Aoa","Aob"],
  "cat and mouse": ["Aoc","Aod","Aoe","Aof"],
  "catapult": ["Aoj","Aog","Aoh","Aoi"],
  "catch": ["Eah","EWq","DfT","DfR","DfS","Aor","Aok","Aol","Aom"],
  "catch a ball": ["Eah","DfR","Aon"],
  "catch a cold": ["DS7","Aoo","Aop"],
  "catch a fish": ["EWq","DfS","Aoq"],
  "catch caught": ["EVL","ESk","DfR","DfS","DfT"],
  "catch fish": ["EAU"],
  "catching": ["Eah","DfT","DfR","DfS"],
  "catching a ball": ["Eah","DfR"],
  "catching a fish": ["DfS"],
  "caterpillar": ["DyC","C8f","Aow","Aos","Aot","Aou","Aov"],
  "catfish": ["Aoy","Aox"],
  "cathedral": ["Do9"],
  "cats": ["Ao0"],
  "cattle": ["Ao2","Ao1"],
  "caught": ["EVL","ESk","Ao4","Ao3"],
  "caught a fish": ["EVL","ESk"],
  "caught red handed": ["EAW","EAX","EAY"],
  "cauldron": ["EAZ","Ao7","Ao5","Ao6"],
  "cauliflower": ["DyE","C8h","ApD","Ao8","Ao9","ApA","ApB"],
  "cauliflower cheese": ["ApC"],
  "caution": ["ApF","ApE"],
  "cautious": ["ApG"],
  "cave": ["ApJ","ApH","ApI"],
  "cavern": ["ApM","ApK","ApL"],
  "cd": ["ApP","ApN"],
  "cd player": ["ApO"],
  "cds": ["ApQ"],
  "cease": ["ApR"],
  "cedar": ["ApT","ApS"],
  "ceiling": ["ApX","ApU","ApV","ApW"],
  "celebrate": ["EWr","DfW","DfU","DfV","ApZ","ApY"],
  "celebrate a birthday": ["EAa"],
  "celebrate celebrated": ["DfU","DfV","DfW"],
  "celebrate Christmas": ["EhM","EhL","EWr","EAc","EAb","DfU"],
  "celebrate Halloween": ["EAd"],
  "celebrate New Year": ["DfV","EAe"],
  "celebrating": ["DfW","DfU","DfV","Apb","Apa"],
  "celebrating Christmas": ["DfU"],
  "celebrating New Year": ["DfV","EAe"],
  "celebration": ["Apc"],
  "celery": ["DyF","C8i","Apg","Apd","Ape","Apf"],
  "celestial": ["DS8","Api","Aph"],
  "cell": ["Apu"],
  "cell phone": ["Apq","Apr","Aps","Apt"],
  "cellar": ["Apl","Apj","Apk"],
  "cello": ["App","Apm","Apn","Apo"],
  "cells": ["Apw","Apv"],
  "cement": ["Apx"],
  "cemetery": ["Ap1","Apy","Apz","Ap0"],
  "center": ["DpA"],
  "centipede": ["Ap6","Ap2","Ap3","Ap4","Ap5"],
  "centre": ["DpA"],
  "CEO": ["EAf","EAg","C8k","C8j"],
  "ceramic": ["Ap9","Ap7","Ap8"],
  "cereal": ["DyG","C8l","AqF","AqA","AqB","AqC","AqD"],
  "cereal bar": ["AqE"],
  "ceremony": ["AqH","AqG"],
  "chain": ["DyH","C8m","AqL","AqI","AqJ","AqK"],
  "chair": ["DyI","C8n","AqQ","AqM","AqN","AqO","AqP"],
  "chairs": ["AqV","AqR","AqS","AqT","AqU"],
  "chalet": ["AqY","AqW","AqX"],
  "chalk": ["Aqd","AqZ","Aqa","Aqb","Aqc"],
  "challenge": ["Aqg","Aqe","Aqf"],
  "challenging": ["Aqh"],
  "chameleon": ["Aqm","Aqi","Aqj","Aqk","Aql"],
  "chance": ["Aqo","Aqn"],
  "change": ["EWs","DfX","DfY","Aqr","Aqp","Aqq"],
  "change a lightbulb": ["DfX"],
  "change changed": ["DfX","DfY"],
  "change into a butterfly": ["EWs","DfY"],
  "changing": ["DfY","DfX"],
  "changing a lightbulb": ["DfX"],
  "changing into a butterfly": ["DfY"],
  "chaos": ["Aqw","Aqs","Aqt","Aqu","Aqv"],
  "charge": ["EdG","EWt","DfZ","Dfa","Aqz","Aqx","Aqy"],
  "charge a phone": ["EWt","DfZ","Dfa"],
  "charge charged": ["ESY","Dfa","DfZ"],
  "charge your phone": ["EAh"],
  "charged": ["ESY"],
  "charged my phone": ["ESY"],
  "charger": ["Aq2","Aq0","Aq1"],
  "charging": ["EdG","Dfa","DfZ"],
  "charging a phone": ["DfZ","Dfa"],
  "charity": ["Aq6","Aq3","Aq4","Aq5"],
  "charity shop": ["Aq7"],
  "Charles darwin": ["Aq8"],
  "chase": ["EWu","Dfb","ArC","Aq9","ArA","ArB"],
  "chase a mouse": ["EWu","Dfb"],
  "chase chased": ["Dfb"],
  "chasing": ["Dfb"],
  "chasing a mouse": ["Dfb"],
  "chat": ["DpB"],
  "chauffeur": ["EAi","EAj","DyJ","C8p","C8o"],
  "cheap": ["EAk","C8s","ArE","ArD"],
  "cheaper": ["EgQ","ERg","C8r","C8q"],
  "cheat": ["DS9"],
  "check": ["EWv","Dfc","DTC"],
  "check checked": ["Dfc"],
  "check electricity": ["EAl"],
  "check in": ["DTB"],
  "check teeth": ["EAm"],
  "check the bill": ["DTD"],
  "check the dog": ["EWv","Dfc"],
  "checked": ["DTA"],
  "checking": ["Dfc"],
  "checking the dog": ["Dfc"],
  "cheek": ["ArF"],
  "cheeks": ["DTE"],
  "cheer": ["DTH","ArM"],
  "cheerful": ["EAn","DTF","ArG"],
  "cheerleader": ["DTG","ArL","ArH","ArI","ArJ","ArK"],
  "cheese": ["DyL","C8u","Are","ArN","ArO","ArP","ArQ","ArR"],
  "cheese and tomato": ["ArS","ArT"],
  "cheese burger": ["C8t"],
  "cheese sandwich": ["Arf","Arg"],
  "cheese toastie": ["Ega","C8v"],
  "cheeseburger": ["DyK","ArY","ArU","ArV","ArW","ArX"],
  "cheesecake": ["Ard","ArZ","Ara","Arb","Arc"],
  "cheetah": ["Arj","Arh","Ari"],
  "chef": ["EAo","EAp","DyM","C8x","C8w","Arp","Ark","Arl","Arm","Arn","Aro"],
  "chemical engineer": ["C8y","C8z"],
  "chemical fertilizer": ["Arq"],
  "chemist": ["DpC"],
  "chemistry": ["DyN","C80","DTI","Aru","Arr","Ars","Art"],
  "cherish": ["Arw","Arv"],
  "cherries": ["DyO","C81","Arz","Arx","Ary"],
  "cherry": ["Egb","Ar2"],
  "cherry pie": ["Ar0","Ar1"],
  "chess": ["DyP","C82","Ar6","Ar3","Ar4","Ar5"],
  "chest": ["AsB","Ar7"],
  "chest of drawers": ["Ar8","Ar9","AsA"],
  "chest x ray": ["AsC","AsD"],
  "chewing gum": ["AsE"],
  "chichen itza": ["AsF"],
  "chick": ["Asb","AsG","AsH"],
  "chicken": ["Egc","DyQ","DyR","C87","C83","AsT","AsI","AsJ","AsK","AsL","AsM"],
  "chicken and rice": ["C84"],
  "chicken leg": ["C85","AsN","AsO"],
  "chicken nugget": ["AsP","AsQ","AsR"],
  "chicken nuggets": ["C86","AsS"],
  "chicken wing": ["C88","AsU"],
  "chicken wings": ["AsV","AsW","AsX"],
  "chickpeas": ["Asa","AsY","AsZ"],
  "child": ["EAq","Asf","Asc","Asd","Ase"],
  "children": ["Asj","Asg","Ash","Asi"],
  "Chile": ["EAr"],
  "chili": ["Egd","Asn","Ask","Asl","Asm"],
  "chili peppers": ["Asp","Asq","Asr","Ass"],
  "chilies": ["DyS","C89"],
  "chill": ["Ast","Aso"],
  "chilli": ["Asn","Ask","Asl","Asm"],
  "chilli peppers": ["Asp","Asq","Asr","Ass"],
  "chillies": ["DyS","C89"],
  "chilly": ["Asu"],
  "chimney": ["DyT","C9A","Asy","Asv","Asw","Asx"],
  "chimp": ["As3","Asz"],
  "chimpanzee": ["As2","As0","As1"],
  "chin": ["DyW","C9F","AtF","As4","As5"],
  "China": ["EAs","DyU","C9C","AtA","As6","As7","As8","As9"],
  "China flag": ["C9B"],
  "Chinese": ["EeI","DyV","C9E","C9D","AtE","AtB","AtC"],
  "Chinese new year": ["AtD"],
  "chips": ["DyX","AtL","AtG","AtH","AtI","AtJ","AtK"],
  "chips and dip": ["C9G"],
  "chirp": ["AtN","AtM"],
  "chisel": ["AtR","AtO","AtP","AtQ"],
  "chocolate": ["DyY","C9I","Atg","AtS","AtT","AtU","AtV"],
  "chocolate bar": ["AtW","AtX","AtY","AtZ"],
  "chocolate cake": ["Ata","Atb","Atc","Atd","Ate"],
  "chocolate milk": ["Atf"],
  "chocolate milkshake": ["C9H"],
  "choice": ["Atj","Ath","Ati"],
  "choir": ["Atl","Atk"],
  "choke": ["Atm"],
  "choose": ["Ato","Atn"],
  "chop": ["Eai","Dfd","Atr","Atp","Atq"],
  "chop an onion": ["Eai","Dfd"],
  "chop chopped": ["Dfd"],
  "chopping": ["Eai","Dfd"],
  "chopping an onion": ["Eai","Dfd"],
  "chopping board": ["DyZ","C9J"],
  "chopsticks": ["Dya","C9K","Atx","Ats","Att","Atu","Atv","Atw"],
  "Christ": ["AuF"],
  "Christ the redeemer": ["AuG"],
  "Christmas": ["EhM","EhL","EhN","C9L","At7","Aty","Atz"],
  "Christmas candle": ["EAt","At0","At1","At2"],
  "Christmas decorations": ["EhX"],
  "Christmas dinner": ["EhL","At3","At4","At5","At6"],
  "Christmas elf": ["Ehb"],
  "Christmas gift": ["Ehg"],
  "Christmas gifts": ["Ehh"],
  "Christmas morning": ["EhM"],
  "Christmas present": ["Ehg"],
  "Christmas presents": ["Ehh"],
  "Christmas reindeer": ["Eh0"],
  "Christmas sleigh": ["Eh4"],
  "Christmas snowman": ["Eh8"],
  "Christmas stocking": ["Eh9","At8","At9","AuA","AuB"],
  "Christmas tree": ["EiG","EAu","C9M","AuC","AuD","AuE"],
  "Christmas turkey": ["EiH"],
  "Christmas wreath": ["EiK"],
  "chrysanthemum": ["AuI","AuH"],
  "chubby": ["AuM","AuJ","AuK","AuL"],
  "church": ["Dyb","C9N","AuQ","AuN","AuO","AuP"],
  "churro": ["AuT","AuR","AuS"],
  "Cinderella": ["AuW","AuU","AuV"],
  "cinema": ["AuZ","AuX","AuY"],
  "circle": ["Auc","Aua","Aub"],
  "circular saw": ["Aud","Aue","Auf","Aug","Auh"],
  "circus": ["Aul","Aui","Auj","Auk"],
  "citadel": ["Aum"],
  "city": ["Aut","Aun","Auo","Aup","Auq"],
  "city hall": ["Aur","Aus"],
  "civil engineer": ["EAw","EAv","C9O","C9P"],
  "civilization": ["Auv","Auu"],
  "clam": ["Aux","Auw"],
  "clams": ["Au0","Auy","Auz"],
  "clap": ["Au5","Au1","Au2","Au3","Au4"],
  "clarinet": ["Dyc","C9Q","Au9","Au6","Au7","Au8"],
  "clasp": ["AvA"],
  "class": ["AvL","AvB"],
  "classic": ["AvI","AvC","AvD"],
  "classical": ["AvH","AvE"],
  "classical music": ["AvF","AvG"],
  "classmate": ["AvJ"],
  "classmates": ["AvK"],
  "classroom": ["C9R","AvO","AvM","AvN"],
  "claw": ["AvQ","AvP"],
  "claws": ["AvR"],
  "clay": ["DpD"],
  "clean": ["EWw","EA3","Dfe","Dff","C9W","Ava","AvS"],
  "clean as a whistle": ["EAx","EAy","EAz"],
  "clean cleaned": ["ETm","Dfe","Dff"],
  "clean dishes": ["EA0"],
  "clean teeth": ["Avb"],
  "clean the floor": ["EA4","Dfe"],
  "clean the house": ["Avc","Avd"],
  "clean the window": ["Dff"],
  "clean up": ["Ave","Avf"],
  "clean windows": ["EWw","EA5"],
  "cleaned": ["ETm"],
  "cleaned the floor": ["ETm"],
  "cleaner": ["EgR","ERh","EA1","EA2","Dyd","C9V","C9S","C9T","C9U","AvX","AvT","AvU","AvV","AvW"],
  "cleaning": ["Dfe","Dff","AvZ","AvY"],
  "cleaning the floor": ["Dfe"],
  "cleaning the window": ["Dff"],
  "cleanup": ["Avg"],
  "clear": ["Avi","Avh"],
  "clear sky": ["Avj","Avk"],
  "cleaver": ["Dye","C9X","Avo","Avl","Avm","Avn"],
  "clerk": ["Avq","Avp"],
  "clever": ["Avt","Avr","Avs"],
  "click": ["Dfg","Avw","Avu","Avv"],
  "click clicked": ["ESZ","Dfg"],
  "click on": ["DpE"],
  "click the mouse": ["Dfg"],
  "clicked": ["ESZ"],
  "clicked the mouse": ["ESZ"],
  "clicking": ["Dfg"],
  "clicking the mouse": ["Dfg"],
  "cliff": ["Avz","Avx","Avy"],
  "cliffs": ["Dyf","C9Y","Av1","Av0"],
  "climate": ["Av7","Av2","Av3","Av4"],
  "climate change": ["Av5","Av6"],
  "climb": ["EdL","EWy","EWx","Dfk","Dfh","Dfi","Dfj","AwD","Av8"],
  "climb a mountain": ["EdL","EWx","Dfi"],
  "climb a tree": ["EWy","Dfj"],
  "climb climbed": ["EWO","ESl","Dfh","Dfi","Dfj","Dfk"],
  "climbed": ["EWO","ESl"],
  "climbed a tree": ["ESl"],
  "climbed the mountain": ["EWO"],
  "climber": ["AwA","Av9"],
  "climbing": ["EdL","Dfk","Dfh","Dfi","Dfj","AwC","AwB"],
  "climbing a mountain": ["EdL","Dfi"],
  "climbing a tree": ["Dfj"],
  "clinic": ["AwF","AwE"],
  "clip": ["AwG"],
  "clipboard": ["Dyg","C9Z"],
  "clock": ["Dyh","C9a","AwL","AwH","AwI","AwJ","AwK"],
  "clocks": ["AwM"],
  "close": ["Eb0","Eak","EW0","EWz","Dfo","Dfl","Dfm","Dfn","Dfp"],
  "close a laptop": ["Dfm"],
  "close a window": ["Dfn"],
  "close closed": ["ESa","Dfm","Dfl","Dfn","Dfo","Dfp"],
  "close in the evening": ["EWz"],
  "close laptop": ["Eb0"],
  "close the window": ["Eak","EW0","Dfp"],
  "closed": ["ESa","DpF"],
  "closed my laptop": ["ESa"],
  "closely": ["ERJ"],
  "closet": ["Dyi","C9b","AwN"],
  "closing": ["Eb0","Eak","Dfo","Dfl","Dfm","Dfn","Dfp"],
  "closing a laptop": ["Dfm"],
  "closing a window": ["Dfn"],
  "closing the window": ["Eak","Dfp"],
  "cloth": ["Awc"],
  "clothes": ["AwT","AwO","AwP"],
  "clothes line": ["Dyj","AwQ","AwR","AwS"],
  "clothes lines": ["C9c"],
  "clothes rack": ["AwU","AwV","AwW"],
  "clothes shop": ["AwX","AwY","AwZ","Awa","Awb"],
  "clothing store": ["DpG"],
  "cloud": ["Awi","Awd","Awe","Awf","Awg","Awh"],
  "clouds": ["Dyk","C9d","Awo","Awj","Awk","Awl","Awm","Awn"],
  "cloudy": ["EhO","EA6","C9f","C9e","Awr","Awp","Awq"],
  "clown": ["EA7","EA8","Dyl","C9h","C9g","Awx","Aws","Awt","Awu","Awv"],
  "clown mask": ["Aww"],
  "club": ["Awz","Awy"],
  "clue": ["Aw1","Aw0"],
  "cluster": ["Aw2"],
  "coach": ["EA9","EBA","C9j","C9i","Aw6","Aw3","Aw4","Aw5","DpH"],
  "coal": ["AxB","Aw7","Aw8","Aw9","AxA"],
  "coal miner": ["EBC","EBB","C9k","C9l"],
  "coast": ["AxE","AxC","AxD"],
  "coat": ["Dyo","C9o","AxK","AxF","AxG","AxH","AxI"],
  "coat hangar": ["C9m"],
  "coat hanger": ["Dym"],
  "coat hook": ["Dyn","C9n"],
  "coat rack": ["Dyp","C9p","AxL","AxM","AxN"],
  "coathook": ["AxJ"],
  "cobbler": ["AxQ","AxO","AxP"],
  "cobblestone": ["AxS","AxR"],
  "cobra": ["AxU","AxT"],
  "cobweb": ["EBD","Axa","AxV","AxW","AxX","AxY","AxZ"],
  "coca cola": ["Axb","Axc","Axd"],
  "cockerel": ["Axg","Axe","Axf"],
  "cockroach": ["Axo","Axh","Axi","Axj","Axk"],
  "cockroaches": ["Axn","Axl","Axm"],
  "cocoa": ["Axs","Axp","Axq","Axr"],
  "coconut": ["Ege","Egf","Ax4","Axt","Axu","Axv","Axw","Axx"],
  "coconut juice": ["Axy","Axz"],
  "coconut milk": ["Ax0","Ax1","Ax2","Ax3"],
  "coconuts": ["Dyq","Ax9","Ax5","Ax6","Ax7","Ax8"],
  "coding": ["AyC","AyA","AyB"],
  "coffee": ["Dys","C9r","AyJ","AyD","AyE","AyF","AyG","AyH","AyI"],
  "coffee machine": ["Dyr","C9q"],
  "coffee shop": ["AyK","AyL","AyM","AyN","AyO","AyP"],
  "coffee table": ["AyQ","AyR","AyS","AyT"],
  "coffin": ["DpI"],
  "coin": ["AyX","AyU","AyV","AyW"],
  "coins": ["Dyt","C9s","Ayd","AyY","AyZ","Aya","Ayb","Ayc"],
  "coke": ["DpJ"],
  "cola": ["Dyu","C9t","Ayi","Aye","Ayf","Ayg","Ayh"],
  "cold": ["EhP","EhQ","EBE","C9x","C9u","C9v","Aym","Ayj","Ayk","Ayl"],
  "colder": ["ERi","C9w"],
  "collapse": ["Dfq","Ayp","Ayn","Ayo"],
  "collapse collapsed": ["EUg","Dfq"],
  "collapsed": ["EUg"],
  "collapsing": ["Dfq"],
  "collar": ["DpK"],
  "collect": ["EW1","Dfr","Ays","Ayq"],
  "collect collected": ["Dfr"],
  "collect garbage": ["Dfr"],
  "collect stamps": ["DpL"],
  "collect trash": ["EW1","EBF"],
  "collecting": ["Dfr"],
  "collecting garbage": ["Dfr"],
  "collection": ["Ayr"],
  "college": ["Ayz","Ayt","Ayu","Ayv","Ayw","Ayx","Ayy"],
  "Colombia": ["EBG"],
  "colonel": ["Ay0"],
  "colony": ["Ay1"],
  "color": ["AzI","Ay2","Ay3"],
  "color pen": ["AzH"],
  "colored pencil": ["Ay5","Ay4","Ay6","Ay7"],
  "colored pencils": ["Ay5","Ay4","Ay6","Ay7"],
  "colorful": ["EhR","EhS","EBH","C9y","AzB","Ay8","Ay9","AzA"],
  "coloring book": ["AzC","AzD","AzE"],
  "coloring picture": ["AzF","AzG"],
  "colors": ["AzL","DpN","AzJ","AzK"],
  "colosseum": ["AzQ","AzM","AzN","AzO","AzP"],
  "colour": ["AzI","Ay2","Ay3"],
  "colour pen": ["AzH"],
  "coloured pencil": ["Ay5","Ay4","Ay6","Ay7"],
  "coloured pencils": ["DpM"],
  "colourful": ["EBH","C9y","AzB","Ay8","Ay9","AzA"],
  "colouring book": ["AzC","AzD","AzE"],
  "colouring picture": ["AzF","AzG"],
  "colours": ["AzL","DpN","AzJ","AzK"],
  "column": ["AzW","AzR","AzS","AzT","AzU","AzV"],
  "comb": ["Eb1","EW2","Dyv","Dfs","Dft","C9z","Azc","AzX","AzY","AzZ"],
  "comb combed": ["Dfs","Dft"],
  "comb hair": ["Eb1","Aza"],
  "comb her hair": ["Dfs"],
  "comb your hair": ["EW2","Dft"],
  "combine": ["Azb"],
  "combing": ["Eb1","Dft","Dfs"],
  "combing her hair": ["Dfs"],
  "combing your hair": ["Dft"],
  "come": ["Dfu"],
  "come came": ["Dfu"],
  "come from": ["EW3"],
  "come from America": ["EW3","EeD","Dfu"],
  "come from Argentina": ["EeE"],
  "come from Australia": ["EeF"],
  "come from Brazil": ["EeG"],
  "come from Canada": ["EeH"],
  "come from China": ["EeI"],
  "come from Egypt": ["EeJ"],
  "come from England": ["EeK"],
  "come from France": ["EeL"],
  "come from Germany": ["EeM"],
  "come from India": ["EeN"],
  "come from Ireland": ["EeO"],
  "come from Italy": ["EeP"],
  "come from Japan": ["EeQ"],
  "come from Mexico": ["EeR"],
  "come from Russia": ["EeS"],
  "come from South Africa": ["EeT"],
  "come from Spain": ["EeU"],
  "come from Thailand": ["EeV"],
  "come from Turkey": ["EeW"],
  "come here": ["DpQ"],
  "come in": ["Azd"],
  "comedian": ["DpO"],
  "comedy": ["DpP"],
  "comet": ["Azh","Aze","Azf","Azg"],
  "comfort": ["DTK","Azr","Azi","Azj","Azk"],
  "comfortable": ["DTJ","Azo","Azl","Azm","Azn"],
  "comfortably": ["ERS"],
  "comforter": ["Azq","Azp"],
  "comic book": ["Azs"],
  "coming": ["Dfu"],
  "coming from America": ["Dfu"],
  "common": ["DpR"],
  "communal": ["DTM"],
  "communal house": ["DTL"],
  "communicate": ["DpS"],
  "communication": ["DpT"],
  "community": ["DTN","Azt"],
  "companion": ["DTO","Azx","Azu","Azv","Azw"],
  "company": ["DTP"],
  "compare": ["Azz","Azy"],
  "comparison": ["DTQ","Az0"],
  "compass": ["DTS","Az3","Az1","Az2"],
  "compassion": ["DTR"],
  "compatible": ["Az4"],
  "competition": ["Az5"],
  "competitive": ["Az6"],
  "complete": ["Az8","Az7"],
  "complex": ["DTT","A0B","Az9","A0A"],
  "complicated": ["A0D","A0C"],
  "comply": ["DTU"],
  "compose": ["DTV"],
  "composer": ["DpU"],
  "comprehend": ["A0E"],
  "comprehension": ["DTW"],
  "computer": ["Dyw","C90","A0Q","A0F","A0G","A0H"],
  "computer game": ["A0I","A0J","A0K"],
  "computer games": ["DpV"],
  "computer lab": ["A0L","A0M"],
  "computer mouse": ["A0N","A0O","A0P"],
  "computer problem": ["A0R"],
  "computer programmer": ["A0S","A0T"],
  "computer room": ["A0U"],
  "computer technician": ["EBJ","EBI","Dyx","C91","C92","A0V","A0W"],
  "computing": ["Dyy","C93"],
  "concentrate": ["Eb2","Dfv"],
  "concentrate concentrated": ["ETn","Dfv"],
  "concentrated": ["ETn"],
  "concentrating": ["Eb2","Dfv"],
  "concentration": ["DTX","A0X"],
  "concept": ["DTY"],
  "concerned": ["DTa","DTZ","A0Y"],
  "concert": ["A0d","A0Z","A0a"],
  "concert hall": ["A0b","A0c"],
  "condor": ["A0f","A0e"],
  "conduct": ["A0i"],
  "conductor": ["DTb","A0h","A0g"],
  "cone": ["DTc","A0l","A0j","A0k"],
  "confident": ["DTd","A0m"],
  "confirm": ["DTe","A0q","A0n","A0o"],
  "confirmation": ["A0p"],
  "confused": ["EBK","C94","A0s","A0r"],
  "confusing": ["DTf","A0u","A0t"],
  "conga": ["A0v"],
  "connect": ["EW4","Dfw","A0x","A0w"],
  "connect a phone": ["Dfw"],
  "connect a phone to a computer": ["EW4"],
  "connect connected": ["Dfw"],
  "connecting": ["Dfw"],
  "connecting a phone": ["Dfw"],
  "conservation": ["DTg","A0z","A0y"],
  "console": ["DTh","A00"],
  "conspicuous": ["DTi"],
  "constellation": ["DTj","A02","A01"],
  "constitutional": ["A03"],
  "constitutionalist": ["DTk"],
  "construct": ["Dfx"],
  "construct a building": ["Dfx"],
  "construct constructed": ["EUv","Dfx"],
  "constructed": ["EUv"],
  "constructed a building": ["EUv"],
  "constructing": ["Dfx"],
  "constructing a building": ["Dfx"],
  "construction area": ["A04","A05","A06"],
  "construction site": ["Dyz","C95"],
  "construction worker": ["EBM","EBL","C96","C97","A07","A08","A09"],
  "consumers": ["DTl"],
  "consumption": ["DTm"],
  "container": ["A1B","A1A"],
  "containers": ["DTn"],
  "contest": ["A1C"],
  "contract": ["DTo","A1G","A1D","A1E","A1F"],
  "contrail": ["DTp","A1J","A1H","A1I"],
  "contribute": ["DTq"],
  "control": ["Eal","Dfy"],
  "control a drone": ["Eal","Dfy"],
  "control controlled": ["ESb","Dfy"],
  "controling": ["Dfy"],
  "controling a drone": ["Dfy"],
  "controlled": ["ESb"],
  "controlled the drone": ["ESb"],
  "controller": ["Dy0","C98"],
  "controlling": ["Eal"],
  "convenience store": ["Dy1","C99"],
  "conversation": ["DTr","A1N","A1K","A1L","A1M"],
  "cook": ["Eb3","EW5","Df1","Dfz","Df0","A1T","A1O"],
  "cook cooked": ["ESm","Df0","Dfz","Df1"],
  "cook dinner": ["EBN"],
  "cook food": ["EW5","EBO","Df0"],
  "cooked": ["ESm","DpW"],
  "cooked some food": ["ESm"],
  "cooker": ["DpX"],
  "cookie": ["Dy2","DAA","A1Q","A1P"],
  "cookies": ["A1S","A1R"],
  "cooking": ["Eb3","Df1","Dfz","Df0"],
  "cooking food": ["Df0"],
  "cool": ["EBP","Df2"],
  "cool cooled": ["ESV","Df2"],
  "cool the room": ["Df2"],
  "cooled": ["ESV"],
  "cooled the room": ["ESV"],
  "cooling": ["Df2"],
  "cooling the room": ["Df2"],
  "copper": ["DAB","A1W","A1U","A1V"],
  "coral": ["DTs","A1Z","A1X","A1Y"],
  "coral reef": ["A1a"],
  "cord": ["A1b"],
  "core": ["A1d","A1c"],
  "corgi": ["A1f","A1e"],
  "coriander": ["A1i","A1g","A1h"],
  "corkscrew": ["Dy3","DAC"],
  "corn": ["Dy4","DAD","A17","A1j","A1k","A1l","A1m","A1n","A1o"],
  "corn dog": ["A1p","A1q"],
  "corn field": ["A1w","A1x"],
  "cornbread": ["DTt"],
  "corner": ["DTu","A1u","A1r","A1s","A1t"],
  "corner shop": ["DTv","A1v"],
  "cornflakes": ["A13","A1y","A1z","A10","A11","A12"],
  "cornflower": ["A14"],
  "cornish pasty": ["A15","A16"],
  "corridor": ["DAE","DTw","A2A","A18","A19"],
  "corruption": ["DTx"],
  "cosmos": ["A2B"],
  "cost": ["EW6","Df3","A2C"],
  "cost an arm and a leg": ["EBQ","EBR","EBS"],
  "cost cost": ["Df3"],
  "cost one dollar": ["EW6","Df3"],
  "Costa Rica": ["EBT"],
  "costing": ["Df3"],
  "costume": ["A2F","A2D","A2E"],
  "cosy": ["EBU","A2J","A2G","A2H","A2I"],
  "cot": ["A2O","A2K","A2L","A2M","A2N"],
  "cottage": ["A2S","A2P","A2Q","A2R"],
  "cotton": ["A2W","A2T","A2U","A2V"],
  "couch": ["A2b","A2X","A2Y","A2Z","A2a"],
  "cough": ["Eb4","Dy5","Df4","DAF","A2c"],
  "cough coughed": ["ETo","Df4"],
  "cough syrup": ["A2d"],
  "coughed": ["ETo"],
  "coughing": ["Eb4","Df4"],
  "counter": ["DpY"],
  "counting": ["A2g","A2e","A2f"],
  "country": ["A2k"],
  "country house": ["A2h","A2i","A2j"],
  "countryside": ["A2m","A2l"],
  "couple": ["A2p","A2n","A2o"],
  "coupons": ["A2q"],
  "courage": ["A2r"],
  "courthouse": ["A2t","A2s"],
  "courtyard": ["A2w","A2u","A2v"],
  "cousin": ["EBV","EBW","DZN"],
  "cousins": ["DZO","A2y","A2x"],
  "cow": ["EBX","Dy6","DAG","A25","A2z","A20"],
  "coward": ["A21"],
  "cowboy": ["A24","A22","A23"],
  "cows": ["A28","A26","A27"],
  "crab": ["Dy7","DAH","A3E","A29","A3A","A3B","A3C","A3D"],
  "crack": ["Df5","A3M","A3F","A3G","A3H"],
  "crack cracked": ["Df5"],
  "crack the screen": ["Df5"],
  "cracked": ["EhT","EBY","DAI"],
  "cracked screen": ["EhT"],
  "cracker": ["A3L","A3I","A3J","A3K"],
  "crackers": ["DpZ"],
  "cracking": ["Df5"],
  "cracking the screen": ["Df5"],
  "crane": ["A3Q","A3N","A3O","A3P"],
  "cranky": ["A3R"],
  "crash": ["Df6","A3U","A3S","A3T"],
  "crash a car": ["Df6"],
  "crash crashed": ["EVW","ESn","Df6"],
  "crashed": ["EVW","ESn"],
  "crashed his car": ["EVW","ESn"],
  "crashing": ["Df6"],
  "crashing a car": ["Df6"],
  "crater": ["A3W","A3V"],
  "crawl": ["A3Y","A3X"],
  "crayon": ["A3Z"],
  "crayons": ["Dy8","DAJ","A3e","A3a","A3b","A3c","A3d"],
  "crazy": ["DTy","A3i","A3f","A3g","A3h"],
  "cream": ["A3j"],
  "create graphics": ["EBZ"],
  "creative": ["A3k"],
  "creativity": ["DTz","A3l"],
  "creature": ["DT0","A3m"],
  "credit card": ["Dy9","DAK","A3n","A3o","A3p","A3q","A3r"],
  "creepy": ["DT1","A3v","A3s"],
  "creepy clown": ["A3t"],
  "creepy house": ["A3u"],
  "crepe": ["A3y","A3w","A3x"],
  "crescent": ["A31","A3z","A30"],
  "crest": ["A32"],
  "crew": ["A34","A33"],
  "crib": ["Dpa"],
  "cricket": ["DzA","DAL","A4B","A35","A36","A37","A38","A39","A4A"],
  "cried": ["ETp","Dpb"],
  "crime": ["A4D","A4C"],
  "criminal": ["A4E"],
  "cripple": ["A4F"],
  "crisps": ["A4H","A4G"],
  "Croatia": ["EBa"],
  "crocodile": ["DzB","DAM","A4N","A4I","A4J","A4K","A4L","A4M"],
  "croissant": ["DzC","DAN","A4T","A4O","A4P","A4Q","A4R","A4S"],
  "croissants": ["A4W","A4U","A4V"],
  "crops": ["A4Y","A4X"],
  "croquet": ["A4c","A4Z","A4a","A4b"],
  "cross": ["Eam","Df7","A4i","A4d","A4e"],
  "cross crossed": ["ESo","Df7"],
  "cross the river": ["EBb"],
  "cross the river carefully": ["ERB"],
  "cross the road": ["Eam","Df7"],
  "cross walk": ["A4m","A4n","A4o","A4p"],
  "crossed": ["ESo"],
  "crossed the road": ["ESo"],
  "crossing": ["Eam","Df7","A4h"],
  "crossing guard": ["A4f","A4g"],
  "crossing the road": ["Eam","Df7"],
  "crossroad": ["A4l","A4j","A4k"],
  "crosswalk": ["Dpc"],
  "crossword": ["A4r","A4q"],
  "crow": ["A47","A4s","A4t","A4u","A4v"],
  "crowd": ["A42","A4w","A4x"],
  "crowded": ["EBc","A41","A4y","A4z","A40"],
  "crown": ["DzD","DAO","A46","A43","A44","A45"],
  "crude oil": ["A48","A49"],
  "cruise": ["A5C","A5A","A5B"],
  "crunches": ["A5D"],
  "crush": ["A5E"],
  "crust": ["A5G"],
  "crustacean": ["A5F"],
  "crutches": ["DzE","DAP"],
  "cry": ["Eb5","Df8","A5J"],
  "cry cried": ["ETp","Df8"],
  "cry like a baby": ["EBd","EBe","EBf"],
  "crying": ["Eb5","Df8","A5I","A5H"],
  "crystals": ["A5L","A5K"],
  "cub": ["A5T"],
  "Cuba": ["EBg","A5P","A5M","A5N","A5O"],
  "cube": ["A5R","A5Q"],
  "cuboid": ["A5S"],
  "cucumber": ["DzF","DAQ","A5X","A5U","A5V","A5W"],
  "cucumbers": ["A5Y"],
  "cue": ["A5Z"],
  "cultivate": ["DT2","A5b","A5a"],
  "cultivation": ["DT3","A5c"],
  "culture": ["Dpd"],
  "cumbersom": ["DT4"],
  "cunning": ["DT5","A5d"],
  "cup": ["DzH","DAT","A55","A5e","A5f","A5g","A5h"],
  "cup cake": ["DAS"],
  "cup of coffee": ["A5x","A5y","A5z"],
  "cup of hot chocolate": ["A50"],
  "cup of tea": ["A51","A52","A53","A54"],
  "cupboard": ["DzG","DAR","A5m","A5i","A5j","A5k","A5l"],
  "cupcake": ["A5q","A5n","A5o","A5p"],
  "cupcakes": ["A5t","A5r","A5s"],
  "cupid": ["A5w","A5u","A5v"],
  "cups": ["A56"],
  "cure": ["DT6"],
  "curfew": ["DT7"],
  "curious": ["DT8","A57"],
  "curly": ["A6A"],
  "curly hair": ["A58","A59"],
  "currency": ["A6D","A6B","A6C"],
  "curry": ["A6G","A6E","A6F"],
  "curry and rice": ["DAU"],
  "curtain": ["A6I","A6H"],
  "curtains": ["DzI","DAV","A6M","A6J","A6K","A6L"],
  "cushion": ["DzJ","DAW","A6Q","A6N","A6O","A6P"],
  "cushions": ["A6T","A6R","A6S"],
  "custard apple": ["A6U","A6V"],
  "custody": ["DT9"],
  "customer": ["Dpe"],
  "customers": ["DUA"],
  "customize": ["DUB"],
  "customs": ["DUC"],
  "cut": ["Eb6","EW8","ESp","DzK","DgC","Df9","DgA","DgB","DAX"],
  "cut cut": ["ESp","Df9","DgA","DgB","DgC"],
  "cut down": ["EW7","EBh"],
  "cut down a tree": ["EW7","Df9"],
  "cut down trees": ["EBi"],
  "cut hair": ["EBj"],
  "cut paper": ["Eb6","EW8","ESp","DgA","DgB"],
  "cute": ["A6W"],
  "cutlery": ["A6Y","A6X"],
  "cutting": ["Eb6","DgC","Df9","DgA","DgB"],
  "cutting down a tree": ["Df9"],
  "cutting paper": ["Eb6","DgA","DgB"],
  "cyan": ["DAY"],
  "cyberbullying": ["DUD"],
  "cycle": ["DgD"],
  "cycle cycled": ["DgD"],
  "cycle in the park": ["EBk"],
  "cycle lane": ["A6Z","A6a","A6b","A6c"],
  "cycle quickly": ["ERC"],
  "cycling": ["DzL","DgD","DAZ","A6f","A6d","A6e"],
  "cylinder": ["A6h","A6g"],
  "cypress tree": ["A6i"],
  "Cyprus": ["EBl"],
  "czar": ["A6j"],
  "Czech flag": ["DAa"],
  "Czech republic": ["EBm","A6k","A6l","A6m"],
  "d": ["DZs","DZr"],
  "dachshund": ["A6n"],
  "dad": ["EBn","EBo","A6t","A6o","A6p","A6q"],
  "daddy": ["A6s","A6r"],
  "daffodil": ["A6u"],
  "dahlia": ["A6v"],
  "dairy": ["A6x","A6w"],
  "daisy": ["A60","A6y","A6z"],
  "dam": ["DUF","A65","A61","A62"],
  "damage": ["DUE","A64","A63"],
  "damp": ["A66"],
  "dance": ["EdM","EXA","EBp","DgF","DgE","A69","A67","A68"],
  "dance beautifully": ["ERD"],
  "dance danced": ["EUw","DgF","DgE"],
  "dance with a friend": ["EXA"],
  "danced": ["EUw","Dpf"],
  "dancer": ["EBq","EBr","DzM","DAc","DAb","A7B","A7A"],
  "dancing": ["EdM","DgF","DgE","A7C"],
  "danger": ["A7G","A7D","A7E"],
  "dangerous": ["EhU","EBs","DAd","A7F"],
  "dangerously": ["ERO"],
  "dark": ["A7K","A7H"],
  "dark blue": ["DAe"],
  "dark brown": ["DAf"],
  "dark green": ["DAh"],
  "dark hair": ["A7I"],
  "dark red": ["DAi"],
  "darker": ["ERl","DAg"],
  "darkness": ["A7J"],
  "darts": ["DzN","DAj","A7Q","A7L","A7M","A7N","A7O","A7P"],
  "date": ["A7S","A7R"],
  "daughter": ["EBt","EBv","DZQ","A7V","A7T","A7U"],
  "daughter in law": ["EBu","DZP"],
  "daughterinlaw": ["EBu"],
  "dawn": ["A7Y","A7W","A7X"],
  "daydream": ["A7b","A7Z","A7a"],
  "dazzling": ["A7c"],
  "dead": ["EhV","EhW","EBw","DAk"],
  "deal": ["A7d"],
  "death": ["Dpg"],
  "debate": ["EdN","DgG"],
  "debate debated": ["EUx","DgG"],
  "debated": ["EUx"],
  "debating": ["EdN","DgG"],
  "decay": ["A7e"],
  "December": ["Dph"],
  "decide": ["Dpi"],
  "deck": ["A7i"],
  "deck chair": ["A7f","A7g","A7h"],
  "deckchair": ["DzO","DAl"],
  "declare": ["DUG"],
  "decline": ["DUH","A7l","A7j","A7k"],
  "decompose": ["DUI","A7m"],
  "decorate": ["DUJ"],
  "decorations": ["EhX","EBx","A7n"],
  "decorator": ["EBy","EBz","DzP","DAn","DAm"],
  "decrease": ["DgH","A7q","A7o","A7p"],
  "decrease decreased": ["ETg","DgH"],
  "decreased": ["ETg"],
  "decreasing": ["DgH"],
  "deep": ["A7r"],
  "deeper": ["ERm","DAo"],
  "deer": ["DzQ","DAp","A7v","A7s","A7t","A7u"],
  "defeat": ["A7w"],
  "defend": ["A7x"],
  "deforestation": ["DUK","A70","A7y","A7z"],
  "degree": ["DUL","A71"],
  "dejected": ["DUM","A72"],
  "delete": ["DUN","A73"],
  "delicious": ["DUO"],
  "delighted": ["EB0","Dpj"],
  "deliver": ["Ean","EXB","DgJ","DgI","A76","A74","A75"],
  "deliver a package": ["Ean","DgI"],
  "deliver delivered": ["ESq","DgI","DgJ"],
  "deliver letters": ["EB1"],
  "deliver packages": ["EXB","EB2"],
  "delivered": ["ESq"],
  "delivered a package": ["ESq"],
  "delivering": ["Ean","DgJ","DgI"],
  "delivering a package": ["Ean","DgI"],
  "delivery": ["A77"],
  "delivery man": ["EB4","EB3","DAq","DAr"],
  "deliveryman": ["DzR"],
  "delta": ["A78"],
  "Democratic Republic of Congo": ["EB5"],
  "denim": ["A8B","A79","A8A"],
  "Denmark": ["EB6","A8F","A8C","A8D","A8E"],
  "Denmark flag": ["DAs"],
  "dental floss": ["DzS","DAt"],
  "dentist": ["EB7","EB8","DzT","DAv","DAu","A8H","A8G"],
  "dentistry": ["A8I"],
  "depart": ["EXC","DgK"],
  "depart departed": ["DgK"],
  "depart the station": ["EXC","DgK"],
  "departing": ["DgK"],
  "departing the station": ["DgK"],
  "department store": ["DUP","A8J"],
  "departure": ["Dpk"],
  "deposit": ["Eao","DgL"],
  "deposit deposited": ["ESr","DgL"],
  "deposit money": ["Eao","DgL"],
  "deposited": ["ESr"],
  "deposited money": ["ESr"],
  "depositing": ["Eao","DgL"],
  "depositing money": ["Eao","DgL"],
  "depressed": ["EB9","A8M","A8K","A8L"],
  "desert": ["DzU","DAw","A8P","A8N","A8O"],
  "design": ["Eb7","EXE","EXD","DgO","DgM","DgN","DUQ","A8Q"],
  "design a building": ["DgM"],
  "design buildings": ["EXD","ECA"],
  "design clothes": ["Eb7","EXE","ECB","DgN"],
  "design designed": ["ETq","DgM","DgN","DgO"],
  "design electricity": ["ECC"],
  "design machines": ["ECD"],
  "design nuclear power": ["ECE"],
  "design software": ["ECF"],
  "designed": ["ETq"],
  "designed clothes": ["ETq"],
  "designer": ["Dpl"],
  "designing": ["Eb7","DgO","DgM","DgN"],
  "designing a building": ["DgM"],
  "designing clothes": ["Eb7","DgN"],
  "desk": ["DzV","DAx","A8T","A8R","A8S"],
  "desktop computer": ["DzW","DAy"],
  "desolate": ["DUR"],
  "desperate": ["DUS","A8U"],
  "dessert": ["A8X","A8V","A8W"],
  "desserts": ["Dpm"],
  "destination": ["Dpn"],
  "destroy": ["A8Y"],
  "destruction": ["DUT","A8a","A8Z"],
  "destructive": ["DUU"],
  "detective": ["A8d","A8b","A8c"],
  "determined": ["Dpo"],
  "devils": ["ECG"],
  "devoted": ["DUV"],
  "dew": ["A8g","A8e","A8f"],
  "diabetes": ["DUW","A8j","A8h","A8i"],
  "dial": ["A8k"],
  "diamond": ["A8o","A8l","A8m","A8n"],
  "diary": ["A8q","A8p"],
  "dice": ["DzX","DAz","A8u","A8r","A8s","A8t"],
  "dictionary": ["A8x","A8v","A8w"],
  "did": ["ETr"],
  "did homework": ["ETr"],
  "die": ["DgP","A8z"],
  "die died": ["EUk","DgP"],
  "die out": ["DUX","A8y"],
  "died": ["EUk"],
  "diet": ["DUZ","DUY","A81","A80"],
  "different": ["DUa","A86","A82","A83","A84","A85"],
  "difficult": ["DUb","A88","A87"],
  "dig": ["Eap","DgQ","DgR","A9C"],
  "dig a hole": ["DgQ","DgR"],
  "dig dug": ["ETx","DgQ","DgR"],
  "dig up coal": ["ECH"],
  "digging": ["Eap","DgR","DgQ","A89"],
  "digging a hole": ["DgQ","DgR"],
  "digital": ["A9B","A9A"],
  "digital camera": ["Dpp"],
  "dimples": ["A9D"],
  "dimsum": ["A9H","A9E","A9F","A9G"],
  "dine": ["A9I"],
  "diner": ["A9M","A9J","A9K","A9L"],
  "dingy": ["A9N"],
  "dining room": ["A9O","A9P","A9Q"],
  "dining table": ["A9R","A9S"],
  "dinner": ["A9Y","A9T","A9U","A9V","A9W","A9X"],
  "dinosaur": ["ECI","DA0","A9e","A9Z","A9a","A9b","A9c","A9d"],
  "dinosaurs": ["A9h","A9f","A9g"],
  "dip": ["A9m","A9i","A9j","A9k","A9l"],
  "director": ["A9n"],
  "dirt": ["A9p","A9o"],
  "dirtier": ["ERo","DA2","DA1"],
  "dirty": ["EhZ","EhY","Eha","ECJ","DA5","DA3","DA4","A9u","A9q","A9r","A9s","A9t"],
  "dirty dishes": ["EhZ"],
  "disagreement": ["DUd","DUc","A9y","A9v","A9w","A9x"],
  "disappear": ["DUe","A91","A9z","A90"],
  "disappointed": ["ECK","DUf","A95","A92","A93","A94"],
  "disappointing": ["DUg","A97","A96"],
  "disappointment": ["DUh"],
  "disc": ["DzY","DA6"],
  "disco": ["BAB","A98","A99","BAA"],
  "discount": ["DgS","DUi","BAE","BAC","BAD"],
  "discount discounted": ["EUy","DgS"],
  "discounted": ["EUy"],
  "discounted the price": ["EUy"],
  "discounting": ["DgS"],
  "discover": ["Dpq"],
  "discovery": ["DUj"],
  "discuss": ["DUl"],
  "discussion": ["DUk","BAG","BAF"],
  "disgust": ["BAM"],
  "disgusted": ["DA7","BAK","BAH","BAI","BAJ"],
  "disgusting": ["ECL","BAL"],
  "dish": ["BAS","BAN","BAO","BAP","BAQ"],
  "dishcloth": ["DzZ","DA8"],
  "dishes": ["BAR"],
  "dishwasher": ["ECM","ECN","Dza","DBA","DA9","BAV","BAT","BAU"],
  "dislike": ["EXF","DgT","BAZ","BAW","BAX","BAY"],
  "dislike disliked": ["DgT"],
  "dislike ice cream": ["EXF"],
  "dislike icecream": ["DgT"],
  "disliking": ["DgT"],
  "dismal": ["DUm"],
  "dismay": ["DUn"],
  "disneyland": ["BAe","BAa","BAb","BAc","BAd"],
  "display": ["DgU","BAf"],
  "display clothes": ["DgU"],
  "display displayed": ["EUn","DgU"],
  "displayed": ["EUn"],
  "displayed tshirts": ["EUn"],
  "displaying": ["DgU"],
  "displaying clothes": ["DgU"],
  "disposable": ["DUo","BAh","BAg"],
  "dissolve": ["DUp","BAi"],
  "distance": ["BAl","BAj","BAk"],
  "distant": ["BAo","BAm","BAn"],
  "distillation": ["BAq","BAp"],
  "distract": ["DUq","BAr"],
  "distress": ["BAt","BAs"],
  "dive": ["Eb8","DgV","BAw","BAu","BAv"],
  "dive dived": ["ETs"],
  "dive dove": ["DgV"],
  "dive into the water": ["DgV"],
  "dive into water": ["Eb8"],
  "dived": ["ETs"],
  "dived into water": ["ETs"],
  "diver": ["BAy","BAx"],
  "diverse": ["BA0","BAz"],
  "diversity": ["DUr"],
  "divide": ["DUt"],
  "divided": ["DUs","BA1"],
  "diving": ["Eb8","Dzb","DgV","DBB","BA2"],
  "diving into the water": ["DgV"],
  "dizzy": ["Dpr"],
  "dj": ["BA6","BA3","BA4","BA5"],
  "dna": ["BA9","BA7","BA8"],
  "do": ["Eb9","EXM","EXL","EXK","EXJ","EXI","EXH","EXG","DgW","DgX","DgY"],
  "do a jigsaw": ["EXG","ECO","DgW"],
  "do business": ["ECP"],
  "do did": ["ETr","DgW","DgX","DgY","DgZ","Dga","Dgc"],
  "do done": ["EVy","EVe","EWJ"],
  "do exercise": ["ECU","ECV"],
  "do experiments": ["DgX"],
  "do homework": ["Eb9","EXH","ECX","ECW","DgY","DgZ","Dga"],
  "do homework well": ["ERE"],
  "do housework": ["Dpt"],
  "do karate": ["EXI","Dgb"],
  "do laundry": ["EXJ","Dgc"],
  "do magic": ["ECY","Dgd"],
  "do magic tricks": ["EXK","ECZ"],
  "do maths": ["Dge"],
  "do my homework": ["Dpu"],
  "do operations": ["ECd"],
  "do push ups": ["Dgf","EXL"],
  "do pushups": ["EXL"],
  "do research": ["ECe","Dgg"],
  "do some research": ["EXM"],
  "do the dishes": ["Dpv"],
  "do up": ["ECf","Dgh"],
  "do up didup": ["Dgh"],
  "do yoga": ["ECg","Dpz"],
  "do you drink coffee": ["ECh"],
  "do you have a cat": ["ECi"],
  "do you have an umbrella": ["ECj"],
  "do you know how to drive": ["ECk"],
  "do you like cats": ["ECl"],
  "do you like ice cream": ["ECm"],
  "do you like indian food": ["ECn"],
  "do you like spicy food": ["ECo"],
  "do your homework": ["Dp0"],
  "dock": ["BBF","BBA","BBB","BBC","BBD","BBE"],
  "doctor": ["ECQ","ECR","Dzc","DBD","DBC","BBJ","BBG","BBH","BBI"],
  "document": ["DUu","BBM","BBK","BBL"],
  "documentary": ["Dps"],
  "dodo": ["BBP","BBN","BBO"],
  "does your friend have long hair": ["ECS"],
  "does your friend like chocolate": ["ECT"],
  "dog": ["Dzd","DBE","BBa","BBQ","BBR","BBS","BBT","BBU"],
  "dog bed": ["BBV"],
  "dog house": ["BBW","BBX","BBY","BBZ"],
  "dogs": ["BBb"],
  "doing": ["Eb9","DgY","DgW","DgX"],
  "doing a jigsaw": ["DgW"],
  "doing exercise": ["BBc"],
  "doing experiments": ["DgX"],
  "doing homework": ["Eb9","DgY","DgZ","Dga"],
  "doing karate": ["Dgb"],
  "doing laundry": ["Dgc"],
  "doing magic": ["Dgd"],
  "doing maths": ["Dge"],
  "doing push ups": ["Dgf"],
  "doing research": ["Dgg"],
  "doing up": ["Dgh"],
  "doll": ["BBj","BBd","BBe","BBf","BBg"],
  "doll house": ["BBh","BBi"],
  "dolls": ["BBk"],
  "dolphin": ["Dze","DBF","BBt","BBl","BBm","BBn","BBo","BBp","BBq","BBr","BBs"],
  "dolphins": ["BBv","BBu"],
  "dome": ["BBx","BBw"],
  "Dominican republic": ["BBy","BBz","BB0"],
  "domino": ["BB6"],
  "dominoes": ["BB5","BB1","BB2","BB3","BB4"],
  "don't have a beard": ["EeX"],
  "don't have a moustache": ["EeY"],
  "don't have a shell": ["Eea"],
  "don't have a tail": ["Eeb"],
  "don't have arms": ["EeZ"],
  "don't have feathers": ["Eec"],
  "don't have hair": ["Eed"],
  "don't have legs": ["Eee"],
  "don't have long hair": ["Eef"],
  "don't have wings": ["Eeg"],
  "don't like cake": ["Eeh"],
  "don't like doing yoga": ["Eei"],
  "don't like drinking coffee": ["Eej"],
  "don't like hamburgers": ["Eek"],
  "don't like maths": ["Eel"],
  "don't like paying money": ["Eem"],
  "don't like playing cards": ["Een"],
  "don't like playing the trumpet": ["Eeo"],
  "don't like table tennis": ["Eep"],
  "don't like taking exams": ["Eeq"],
  "don't like wine": ["Eer"],
  "donate": ["BB7"],
  "done": ["EVy","EVe","EWJ"],
  "done her homework": ["EVy"],
  "done laundry": ["EVe"],
  "done yoga": ["EWJ"],
  "donkey": ["Dzf","DBG","BCD","BB8","BB9","BCA","BCB","BCC"],
  "dont cry over spilt milk": ["ECa","ECb","ECc"],
  "donut": ["Egg","DBH","BCI","BCE","BCF","BCG","BCH"],
  "donuts": ["Dzg","DBI","BCM","BCJ","BCK","BCL"],
  "door": ["Dzj","DBL","BCW","BCN","BCO","BCP","BCQ","BCR"],
  "door handle": ["Dzh","DBJ"],
  "doorbell": ["BCV","BCS","BCT","BCU"],
  "doormat": ["Dzi","DBK"],
  "doors": ["BCX"],
  "dormintory": ["DUv"],
  "dormitory": ["BCY"],
  "dormouse": ["BCZ"],
  "dots": ["BCa"],
  "double bass": ["BCb","BCc","BCd","BCe"],
  "double bed": ["BCf","BCg","BCh"],
  "double decker bus": ["BCi","BCj","BCk","BCl","BCm"],
  "dough": ["BCr","BCn","BCo"],
  "doughnut": ["BCq","BCp"],
  "dove": ["BCw","BCs","BCt","BCu","BCv"],
  "down": ["Dpy","Dpw"],
  "download": ["BC0","BCx","BCy","BCz","Dpx"],
  "downpour": ["BC1"],
  "downstairs": ["BC2"],
  "downtown": ["BC3"],
  "doze": ["BC7","BC4","BC5"],
  "dozen": ["BC6"],
  "dracula": ["ECp","ECq","BC9","BC8"],
  "dragon": ["Dzk","DBN","BDO","BDA","BDB","BDC"],
  "dragon boat festival": ["BDD","BDE"],
  "dragon fruit": ["Egh","DBM","BDK","BDL","BDM","BDN"],
  "dragonfly": ["BDJ","BDF","BDG","BDH","BDI"],
  "drain": ["Dzl","DBO"],
  "drama": ["BDP"],
  "drank": ["ETt"],
  "drank water": ["ETt"],
  "draw": ["EcA","EXO","EXN","Dgl","Dgi","Dgj","Dgk","BDX","BDQ"],
  "draw a line": ["EXN","Dgi"],
  "draw a picture": ["BDR"],
  "draw drawn": ["EVz"],
  "draw drew": ["ETv","Dgi","Dgj","Dgk","Dgl"],
  "draw images": ["EXO"],
  "draw on the board": ["EcA","Dgj","Dgk"],
  "draw pictures": ["ECr","Dp1"],
  "drawer": ["BDT","BDS"],
  "drawers": ["Dzm","DBP","BDV","BDU"],
  "drawing": ["EcA","Dgl","Dgi","Dgj","Dgk","BDW"],
  "drawing a line": ["Dgi"],
  "drawing on the board": ["EcA","Dgj","Dgk"],
  "drawn": ["EVz"],
  "drawn on the board": ["EVz"],
  "dream": ["Eaq","EXP","Dgo","Dgm","Dgn","BDa","BDY","BDZ"],
  "dream about basketball": ["EXP","Dgn"],
  "dream dreamed": ["ETu","Dgn","Dgm","Dgo"],
  "dreamed": ["ETu"],
  "dreaming": ["Eaq","Dgo","Dgm","Dgn"],
  "dreaming about basketball": ["Dgn"],
  "dress": ["Dzp","DBS","BDk","BDb","BDc","BDd","BDe","BDf","BDg","BDh"],
  "dress up": ["EXQ","ECs","Dgp","Dgq"],
  "dress up dressed up": ["Dgp","Dgq"],
  "dress up for halloween": ["EXQ"],
  "dresser": ["Dzn","DBQ","BDj","BDi"],
  "dressing gown": ["Dzo","DBR"],
  "dressing up": ["Dgp","Dgq"],
  "drew": ["ETv"],
  "drew on the board": ["ETv"],
  "dried": ["EUi"],
  "drier": ["ERp","DBT"],
  "drill": ["Dzq","DBU","BDp","BDl","BDm","BDn","BDo"],
  "drink": ["EdO","EcB","EXS","EXR","Dgu","Dgr","Dgs","Dgt","Dgv","BDu","BDq","BDr"],
  "drink coffee": ["EdO","EXR","Dgr","Dgs","Dgt"],
  "drink drank": ["ETt","Dgr","Dgs","Dgt","Dgu","Dgv"],
  "drink drunk": ["EV0"],
  "drink water": ["EcB","EXS","Dgv"],
  "drinking": ["EdO","EcB","Dgu","Dgr","Dgs","Dgt","Dgv","BDt","BDs"],
  "drinking coffee": ["EdO","Dgr","Dgs","Dgt"],
  "drinking water": ["EcB","Dgv"],
  "drinks": ["BDv"],
  "drip": ["BDw"],
  "drive": ["EcC","EXT","Dgy","Dgw","Dgx","BD0","BDx","BDy"],
  "drive a bus": ["BDz"],
  "drive a car": ["EcC","EXT","ECt","Dgw","Dgx"],
  "drive a limo": ["ECu"],
  "drive a truck": ["ECv"],
  "drive driven": ["EVS"],
  "drive drove": ["ESs","Dgx","Dgw","Dgy"],
  "driven": ["EVS"],
  "driven his car": ["EVS"],
  "driver": ["ECw","ECx","Dzr","DBW","DBV","BD3","BD1","BD2"],
  "driving": ["EcC","Dgy","Dgw","Dgx","BD5","BD4"],
  "driving a car": ["EcC","Dgw","Dgx"],
  "drizzle": ["DBY","DBX"],
  "drone": ["Dzs","DBZ","BEA","BD6","BD7","BD8","BD9"],
  "drop": ["EcD","Dgz","BEE","BEB","BEC","BED"],
  "drop a ball": ["EcD","Dgz"],
  "drop dropped": ["ETw","Dgz"],
  "dropped": ["ETw"],
  "dropped a ball": ["ETw"],
  "dropping": ["EcD","Dgz"],
  "dropping a ball": ["EcD","Dgz"],
  "drought": ["BEI","BEF","BEG","BEH"],
  "drove": ["ESs"],
  "drowsy": ["BEK","BEJ"],
  "drugstore": ["BEL"],
  "drum": ["BEP","BEM","BEN","BEO"],
  "drums": ["Dzt","DBa","BEU","BEQ","BER","BES","BET"],
  "drunk": ["EV0","BEW","BEV"],
  "drunk coffee": ["EV0"],
  "dry": ["EdD","EXU","ECy","Dg0","BEa","BEX"],
  "dry clothes": ["Dg0"],
  "dry dried": ["EUi","Dg0"],
  "dry in the sun": ["EXU"],
  "dry the dishes": ["Dp2"],
  "dryer": ["BEZ","BEY"],
  "drying": ["EdD","Dg0"],
  "drying clothes": ["Dg0"],
  "Dublin": ["BEb"],
  "duck": ["Dzu","DBb","BEl","BEc","BEd","BEe","BEf"],
  "duckling": ["BEi","BEg","BEh"],
  "ducklings": ["BEk","BEj"],
  "ducks": ["BEm"],
  "duct tape": ["BEn","BEo"],
  "dug": ["ETx"],
  "dug a hole": ["ETx"],
  "dull": ["Dp3"],
  "dump": ["BEu","BEp"],
  "dumpling": ["BEq"],
  "dumplings": ["DBc","BEt","BEr","BEs"],
  "dune": ["BEw","BEv"],
  "dung beetle": ["BEz","BE0","BE1","BE2"],
  "dungarees": ["BEy","BEx"],
  "duration": ["DUw","BE3"],
  "durian": ["BE7","BE4","BE5","BE6"],
  "dust": ["BE9"],
  "dustpan and brush": ["Dzv","DBd","BE8"],
  "dusty": ["DUx","BFA"],
  "dvd player": ["Dp4"],
  "dwarf": ["BFB"],
  "dye": ["BFC"],
  "dying": ["DgP"],
  "dynamo": ["BFD"],
  "e": ["DZu","DZt"],
  "eager": ["BFF","BFE"],
  "eagle": ["Dzw","DBe","BFJ","BFG","BFH","BFI"],
  "ear": ["DBj","BFU","BFK","BFL"],
  "ear buds": ["Dzx","DBf"],
  "ear lobe": ["DBg"],
  "ear piercing": ["BFS","BFT"],
  "early": ["DUy","BFM"],
  "earmuffs": ["DBh"],
  "earn": ["BFN"],
  "earphones": ["Dzy","DBi","BFR","BFO","BFP","BFQ"],
  "earring": ["Dzz","DBk"],
  "earrings": ["DBl"],
  "ears": ["Dz0","DBm"],
  "earth": ["D6q","BFW","BFV","DOi"],
  "earthquake": ["BFZ","BFX","BFY"],
  "earthworm": ["BFc","BFa","BFb"],
  "easier": ["ERq","DBn"],
  "easily": ["ERH"],
  "easter": ["BFh","BFd"],
  "easter bunny": ["BFe"],
  "easter egg": ["BFf","BFg"],
  "easy": ["ECz","BFi"],
  "easygoing": ["DUz"],
  "eat": ["EdP","EcE","EXY","EXX","EXW","EXV","EC0","EC6","Dg8","Dg1","Dg2","Dg3","Dg4","Dg5","Dg6","Dg7","Dg9","BFn","BFj","BFk","BFl"],
  "eat a burger": ["EXV","Dg2"],
  "eat a spider": ["EXW","Dg4"],
  "eat an apple": ["EC1","Dg3"],
  "eat ate": ["ETk","Dg2","Dg1","Dg3","Dg4","Dg5","Dg6","Dg7","Dg8","Dg9"],
  "eat breakfast": ["Dp5","Dp6"],
  "eat cake": ["EdP","Dg5"],
  "eat carrots": ["EXX"],
  "eat dinner": ["Dp7"],
  "eat eaten": ["EVu","EVM","EVn","EV1"],
  "eat hastily": ["ERF"],
  "eat like a horse": ["EC2","EC3","EC4"],
  "eat lunch": ["EC5","Dg6"],
  "eat messily": ["ERG"],
  "eat out": ["Dp8"],
  "eat pizza": ["EcE","Dg7"],
  "eat popcorn": ["Dg9"],
  "eat soup": ["EXY"],
  "eaten": ["EVu","EVM","EVn","EV1"],
  "eaten a spider": ["EVu"],
  "eaten an apple": ["EVM"],
  "eaten lunch": ["EVn"],
  "eaten the banana": ["EV1"],
  "eating": ["EdP","EcE","Dg8","Dg1","Dg2","Dg3","Dg4","Dg5","Dg6","Dg7","Dg9","BFm"],
  "eating a burger": ["Dg2"],
  "eating a spider": ["Dg4"],
  "eating an apple": ["Dg3"],
  "eating cake": ["EdP","Dg5"],
  "eating lunch": ["Dg6"],
  "eating pizza": ["EcE","Dg7"],
  "eating popcorn": ["Dg9"],
  "ebook": ["BFs","BFo","BFp","BFq","BFr"],
  "ecommerce": ["BFu","BFt"],
  "economy": ["BFv"],
  "ecosystem": ["BFx","BFw"],
  "edgy": ["BFy"],
  "education": ["DU0","BF1","BFz","BF0"],
  "eel": ["BF4","BF2","BF3"],
  "egg": ["D0o","DBp","BGJ","BF5","BF6","BF7","BF8","BF9"],
  "egg cup": ["BGA","BGB","BGC"],
  "egg tarts": ["BGP","BGQ"],
  "eggplant": ["Dz1","DBo","BGI","BGD","BGE","BGF","BGG","BGH"],
  "eggs": ["DxJ","Dz2","BGO","BGK","BGL","BGM","BGN"],
  "Egypt": ["EC7","Dz3","DBs","BGV","BGR","BGS","BGT","BGU"],
  "Egypt flag": ["DBq"],
  "Egyptian": ["EeJ","DBr"],
  "Eid": ["BGW"],
  "eight": ["Daf","Dab"],
  "eight hundred": ["Dae"],
  "eight o'clock": ["Dd8"],
  "eight thousand": ["Dag"],
  "eighteen": ["Dad","Dac"],
  "eighty": ["Dan","Dah"],
  "eighty eight": ["Dai"],
  "eighty five": ["Daj"],
  "eighty four": ["Dak"],
  "eighty nine": ["Dal"],
  "eighty one": ["Dam"],
  "eighty seven": ["Dao"],
  "eighty six": ["Dap"],
  "eighty thousand": ["Daq"],
  "eighty three": ["Dar"],
  "eighty two": ["Das"],
  "El Salvador": ["EDE"],
  "elbow": ["Dz4","DBt"],
  "elder": ["BGY","BGX"],
  "elderly": ["Ehs","EC8"],
  "electric drill": ["BGZ","BGa"],
  "electric guitar": ["BGb","BGc","BGd","BGe","BGf","BGg"],
  "electric piano": ["BGo"],
  "electric toothbrush": ["BGp"],
  "electrical engineer": ["EDA","EC9","DBu","DBv"],
  "electrician": ["EDB","EDC","Dz5","DBx","DBw","DU1","BGl","BGh","BGi","BGj","BGk"],
  "electricity": ["DU2","BGn","BGm"],
  "elegant": ["BGr","BGq"],
  "elephant": ["Dz6","DBy","BGx","BGs","BGt","BGu","BGv","BGw"],
  "elephants": ["BGy"],
  "elevator": ["Dz7","DBz","BG1","BGz","BG0"],
  "eleven": ["Dau","Dat"],
  "eleven minutes past five": ["Dd9"],
  "elf": ["Ehb","EDD","BG6","BG2","BG3","BG4","BG5"],
  "elm tree": ["BG7"],
  "email": ["BHB","BG8","BG9","BHA"],
  "embarrased": ["DU3"],
  "embarrassed": ["DB0","BHE","BHC","BHD"],
  "embarrassing": ["BHF"],
  "emerald": ["BHH","BHG"],
  "emergency": ["Dp9"],
  "emergency exit": ["BHI","BHJ","BHK","BHL"],
  "emission": ["DU4","BHM"],
  "emo": ["BHO","BHN"],
  "emotions": ["BHP"],
  "emperor": ["BHQ"],
  "employment": ["BHS","BHR"],
  "emptied": ["ESt"],
  "emptied a bin": ["ESt"],
  "empty": ["Ear","EDF","DhA","BHW","BHT","BHU","BHV"],
  "empty emptied": ["ESt"],
  "empty emptyed": ["DhA"],
  "empty the bin": ["Ear","DhA"],
  "emptying": ["Ear","DhA"],
  "emptying the bin": ["Ear","DhA"],
  "encounter": ["DU5","BHX"],
  "encourage": ["Eas","DhB","DU6","BHY"],
  "encourage a friend": ["DhB"],
  "encourage encouraged": ["ESu","DhB"],
  "encourage someone": ["Eas"],
  "encouraged": ["ESu"],
  "encouraged his friend": ["ESu"],
  "encouraging": ["Eas","DhB"],
  "encouraging a friend": ["DhB"],
  "end": ["BHa","BHZ"],
  "endangered": ["DU7"],
  "endurance": ["DU8","BHb"],
  "energentic": ["DU9"],
  "energetic": ["BHc"],
  "energy": ["DqA"],
  "energy source": ["BHd"],
  "engine": ["BHh","BHe","BHf","BHg"],
  "engineer": ["Dz8"],
  "England": ["EDG","Dz9","DB2","BHm","BHi","BHj","BHk","BHl"],
  "England flag": ["DB1"],
  "English": ["EeK","D0A","DB5","DB3","BHo"],
  "English breakfast": ["DB4"],
  "English class": ["BHn"],
  "enhance": ["DVA"],
  "enjoy": ["EXZ","DhC","DVB","BHs","BHp","BHq"],
  "enjoy enjoyed": ["ETy","DhC"],
  "enjoy reading": ["EXZ","DhC"],
  "enjoyed": ["ETy"],
  "enjoyed reading a book": ["ETy"],
  "enjoying": ["DhC","BHr"],
  "enjoying reading": ["DhC"],
  "enormous": ["BHv","BHt","BHu"],
  "entertain": ["BHw"],
  "entertain children": ["EDH"],
  "entertainment": ["DVC"],
  "enthusiam": ["DVD"],
  "enthusiasm": ["BHx"],
  "Enthusiastically": ["DVE"],
  "entrance": ["BH0","BHy","BHz"],
  "envelope": ["D0B","DB6","BH4","BH1","BH2","BH3"],
  "environment": ["BH9","BH5","BH6","BH7"],
  "environmentalist": ["DVF","BH8"],
  "environmentally friendly": ["DVG"],
  "equality": ["DVH","BIB","BIA"],
  "equation": ["DVI","BID","BIC"],
  "equator": ["DVJ"],
  "equipment": ["BIF","BIE"],
  "equivalent": ["DVK"],
  "eraser": ["D0C","DB7","BII","BIG","BIH"],
  "erode": ["DVL","BIK","BIJ"],
  "erosion": ["DVM","BIN","BIL","BIM"],
  "error message": ["BIO"],
  "erupt": ["DhD"],
  "erupt erupted": ["DhD"],
  "erupting": ["DhD"],
  "eruption": ["BIR","BIP","BIQ"],
  "escalate": ["DVN"],
  "escalator": ["D0D","DB8","BIV","BIS","BIT","BIU"],
  "escape": ["DVO","BIX","BIW"],
  "espresso": ["Egi","DB9"],
  "esteemed": ["DVP"],
  "estimate": ["DVQ"],
  "Estonia": ["EDI"],
  "Ethiopia": ["EDJ"],
  "ethnic minorities": ["DVR"],
  "ethnic minority": ["DqB"],
  "Europe": ["BId","BIY","BIZ","BIa","BIb"],
  "European union": ["BIc"],
  "evaporate": ["DVS"],
  "evaporation": ["DVT"],
  "evening": ["BIe"],
  "event": ["BIf"],
  "Everest": ["BIi","BIg","BIh"],
  "everyone": ["BIj"],
  "evil": ["BIm","BIk","BIl"],
  "evolution": ["BIo","BIn"],
  "evolve": ["DVU"],
  "exaggerate": ["DVV"],
  "exam": ["BIr","BIp"],
  "examine": ["EXb","DhE","BIq"],
  "examine a patient": ["DhE"],
  "examine examined": ["DhE"],
  "examine eyes": ["EDK"],
  "examine someone": ["EXb"],
  "examining": ["DhE"],
  "examining a patient": ["DhE"],
  "example": ["DqC"],
  "excavate": ["DVW"],
  "excavation": ["BIs"],
  "exceed": ["DVX","BIt"],
  "exchange": ["EdQ","DhF","DhG","DVY","BIu"],
  "exchange exchanged": ["ESd","DhF","DhG"],
  "exchange money": ["EdQ","DhF","DhG"],
  "exchanged": ["ESd"],
  "exchanged money": ["ESd"],
  "exchanging": ["DhF","DhG"],
  "exchanging money": ["EdQ","DhF","DhG"],
  "excited": ["EDL","DCA","DVZ","BIw","BIv"],
  "exciting": ["DCB","BIy","BIx"],
  "executioner": ["BI0","BIz"],
  "exercise": ["EdR","DhH","BI4","BI1","BI2","BI3"],
  "exercise exercised": ["EUz","DhH"],
  "exercised": ["EUz"],
  "exercising": ["EdR","DhH","BI6","BI5"],
  "exhausted": ["EDM","DCC","BI7"],
  "exhibit": ["DVb"],
  "exhibition": ["DVa","BJB","BI8","BI9","BJA"],
  "exhilarate": ["DVd"],
  "exhilarated": ["DVc"],
  "exile": ["DVe"],
  "exit": ["DqD"],
  "exotic": ["BJF","BJC","BJD","BJE"],
  "expand": ["DVf","BJG"],
  "expel": ["DVg"],
  "expenditure": ["DVh"],
  "expensive": ["Ehc","EDN","DCD","DVi","BJJ","BJH","BJI"],
  "experience": ["DqE"],
  "expired": ["DVj"],
  "explain": ["EXc","DhI","DVk","BJO","BJK","BJL","BJM","BJN"],
  "explain explained": ["DhI"],
  "explain some science": ["EXc"],
  "explaining": ["DhI"],
  "explore": ["BJQ","BJP"],
  "explorer": ["DVl","BJR"],
  "explosion": ["BJU","BJS","BJT"],
  "expunge": ["DVm"],
  "extension cord": ["BJV","BJW"],
  "exterior": ["DVn"],
  "extinct": ["DVo"],
  "extract": ["DVp","BJX"],
  "extraordinary": ["DVq"],
  "eye": ["DCI","BJj","BJY","BJZ","BJa"],
  "eyebrow": ["D0E","DCE","BJd","BJb","BJc"],
  "eyebrows": ["DCF"],
  "eyelash": ["DCH","BJi","BJe","BJf","BJg"],
  "eyelashes": ["DCG","BJh"],
  "eyes": ["D0F","DCJ","BJm","BJk","BJl"],
  "f": ["DZw","DZv"],
  "fabric": ["BJo","BJn"],
  "face": ["DCK","DVr","BJs","BJp","BJq","BJr"],
  "face to face": ["DVs"],
  "facebook": ["DqF"],
  "facial expression": ["BJt","BJu","BJv"],
  "facility": ["BJw"],
  "factory": ["D0G","DCL","BJz","BJx","BJy"],
  "fail": ["DhJ"],
  "fail a test": ["DhJ"],
  "fail an exam": ["DVt"],
  "fail failed": ["EVT","ESv","DhJ"],
  "failed": ["EVT","ESv"],
  "failed a test": ["ESv"],
  "failed the test": ["EVT"],
  "failing": ["DhJ"],
  "failing a test": ["DhJ"],
  "fair hair": ["BJ0"],
  "fairy": ["BJ4","BJ1","BJ2","BJ3"],
  "fairy tales": ["DVu"],
  "falcon": ["BJ8","BJ5","BJ6","BJ7"],
  "fall": ["EXe","DhN","DhK","DhL","DhM","BKH","BJ9","BKA","BKB","BKC","BKD"],
  "fall asleep": ["DhL"],
  "fall asleep fell asleep": ["DhL"],
  "fall down": ["EDO"],
  "fall fell": ["EUq","DhN","DhK"],
  "fall from a tree": ["EXe"],
  "fall in love": ["DVv","BKG"],
  "fall out": ["DVw"],
  "fall over": ["Eat","EDP","DhM"],
  "fall over fell over": ["DhM"],
  "falling": ["DhN","DhK","DhL","DhM"],
  "falling asleep": ["DhL"],
  "falling over": ["Eat","DhM"],
  "falling rocks": ["BKE","BKF"],
  "fallorautumn": ["DqG"],
  "family": ["DZR","BKK","BKI","BKJ"],
  "famine": ["DVx"],
  "famished": ["DVy"],
  "famous": ["DVz"],
  "fan": ["D0H","DCM","BKR","BKL","BKM","BKN","BKO"],
  "fancy": ["DqH"],
  "fangs": ["BKQ","BKP"],
  "fans": ["DqI"],
  "fantastic": ["DV0","BKS"],
  "fantasy": ["BKT"],
  "far": ["BKh","BKU"],
  "faraway": ["EDQ"],
  "farm": ["BKg","BKV","BKW","BKX","BKY","BKZ"],
  "farm house": ["BKf"],
  "farmer": ["EDR","EDS","D0I","DCO","DCN","BKe","BKa","BKb","BKc","BKd"],
  "fascinating": ["DV1"],
  "fashion": ["BKl"],
  "fashion designer": ["EDU","EDT","D0J","DCP","DCQ","DV2"],
  "fashionable": ["BKk","BKi","BKj"],
  "fast": ["Ehd","EDY","DCT","BKp","BKm","BKn"],
  "fast as lightning": ["EDV","EDW","EDX"],
  "fast horse": ["BKo"],
  "faster": ["ERt","DCS","DCR"],
  "fat": ["Ehe","EDc","DCU","BKw","BKq","BKr","BKs"],
  "fatal": ["BKt"],
  "father": ["EDb","DZT","BKv","BKu"],
  "father christmas": ["EDZ"],
  "Father Christmas": ["Eh3"],
  "father in law": ["EDa","DZS"],
  "fatherinlaw": ["EDa"],
  "fatter": ["ERu","DCV"],
  "faucet": ["D0K","DCW","BK0","BKx","BKy","BKz"],
  "fawn": ["BK2","BK1"],
  "fax  machine": ["BK3"],
  "fear": ["BK6","BK4"],
  "fearful": ["BK5"],
  "fearless": ["DV3"],
  "feast": ["DV4","BK7"],
  "feather": ["BLA","BK8"],
  "feather duster": ["BK9"],
  "feathers": ["D0L","DCX","BLB"],
  "February": ["DqJ"],
  "fed": ["ETz"],
  "fed the dog": ["ETz"],
  "fed up": ["EDd","EDe","EDf"],
  "feeble": ["DV5"],
  "feed": ["EcF","EXf","DhP","DhO","BLG","BLC","BLD"],
  "feed a cat": ["EXf","DhO"],
  "feed a dog": ["EcF"],
  "feed fed": ["ETz","DhO","DhP"],
  "feed the cat": ["DqK"],
  "feed the dog": ["DhP","BLH"],
  "feedback": ["BLF","BLE"],
  "feeding": ["EcF","DhP","DhO"],
  "feeding a cat": ["DhO"],
  "feeding the dog": ["DhP"],
  "feel": ["EXg","DhR","DhQ"],
  "feel anxious": ["DV6"],
  "feel blue": ["EDg","EDh","EDi"],
  "feel bored": ["DhQ"],
  "feel dizzy": ["DV7"],
  "feel felt": ["ET0","DhQ","DhR"],
  "feel sick": ["EXg","DhR","DV8"],
  "feel tired": ["DV9"],
  "feeling": ["DhR","DhQ"],
  "feeling bored": ["DhQ"],
  "feeling sick": ["DhR"],
  "feet": ["DCY","BLK","BLI","BLJ"],
  "fell": ["EUq"],
  "felt": ["ET0"],
  "felt bored": ["ET0"],
  "felt tip": ["BLL"],
  "female": ["BLN","BLM"],
  "femur": ["DWA","BLO"],
  "fence": ["D0M","DCZ","BLQ","BLP"],
  "fencing": ["DqL"],
  "fern": ["BLS","BLR"],
  "ferocious": ["BLT"],
  "Ferrari": ["DqM"],
  "ferret": ["BLU"],
  "ferris wheel": ["BLV","BLW"],
  "ferry": ["BLX"],
  "fertile": ["DWB","BLY"],
  "festival": ["DWC","BLZ"],
  "fetch": ["BLa"],
  "fever": ["BLc","BLb"],
  "fidget toy": ["BLd","BLe"],
  "field": ["BLj","BLf","BLg","BLh","BLi"],
  "fierce": ["BLk"],
  "fifteen": ["Daw","Dav"],
  "fifteen thousand": ["Dax"],
  "fifty": ["Da4","Day"],
  "fifty eight": ["Daz"],
  "fifty five": ["Da0"],
  "fifty four": ["Da1"],
  "fifty nine": ["Da2"],
  "fifty one": ["Da3"],
  "fifty seven": ["Da5"],
  "fifty six": ["Da6"],
  "fifty thousand": ["Da7"],
  "fifty three": ["Da8"],
  "fifty two": ["Da9"],
  "fig": ["BLq","BLl","BLm","BLn"],
  "fight": ["EdS","DhS","BLp","BLo"],
  "fight fought": ["EU0","DhS"],
  "fighting": ["EdS","DhS"],
  "figs": ["BLu","BLr","BLs","BLt"],
  "Fiji": ["EDj"],
  "file": ["BLx","BLv","BLw"],
  "fill": ["EcG","DhU","DhT","DWD","BLy"],
  "fill a glass": ["EcG","DhT","DhU"],
  "fill filled": ["ESe","DhT","DhU"],
  "fill out": ["EcH","EDk","DhW","DhV"],
  "fill out a form": ["EcH","DhV"],
  "fill out filled out": ["DhV","DhW"],
  "fill up": ["EDl","DhX"],
  "fill up filled up": ["DhX"],
  "filled": ["ESe"],
  "filled a glass": ["ESe"],
  "filling": ["EcG","DhU","DhT"],
  "filling a glass": ["EcG","DhT","DhU"],
  "filling out": ["EcH","DhW","DhV"],
  "filling out a form": ["EcH","DhV"],
  "filling up": ["DhX"],
  "film": ["BLz"],
  "film movies": ["EDm"],
  "film star": ["DWE","BL0"],
  "filtered coffee": ["BL1"],
  "fin": ["DCd","BMN","BL2","BL3","BL4"],
  "find": ["BL6","BL5"],
  "find out": ["DWF"],
  "finger": ["D0N","DCb","BL9","BL7","BL8"],
  "finger nail": ["DCa"],
  "fingerprint": ["BMB","BMA"],
  "fingerprint scan": ["BMC"],
  "fingers": ["DCc","BMD","BME"],
  "finish": ["EXh","DhY","DWH","BMH","BMF","BMG"],
  "finish class": ["DWG"],
  "finish finished": ["EV3","EV2","DhY"],
  "finish school": ["EXh","DhY"],
  "finish work": ["DWI"],
  "finished": ["EV2","EV3"],
  "finished her homework": ["EV2"],
  "finished the painting": ["EV3"],
  "finishing": ["DhY"],
  "finishing school": ["DhY"],
  "Finland": ["EDn","BMM","BMI","BMJ","BMK","BML"],
  "fins": ["BMO"],
  "fire": ["BMj","BMP","BMQ","BMR"],
  "fire engine": ["D0O","DCe","BMW","BMX","BMY"],
  "fire extinguisher": ["D0P","DCf"],
  "fire station": ["BMk"],
  "fire truck": ["BMl"],
  "fireball": ["BMV","BMS","BMT","BMU"],
  "fired": ["DWJ"],
  "firefighter": ["EDo","EDp","D0Q","DCh","DCg","BMd","BMZ","BMa","BMb","BMc"],
  "firefighters": ["DqN"],
  "fireman": ["BMf","BMe"],
  "fireplace": ["D0R","DCi","BMi","BMg","BMh"],
  "fireworks": ["D0S","DCj","BMo","BMm","BMn"],
  "first": ["DqO"],
  "first aid kit": ["BMp","BMq"],
  "fish": ["Eau","D0T","D0V","DhZ","DCp","DCk","DCl","BNH","BMr","BMs","BMt","BMu","BMv"],
  "fish and chips": ["Egj","DCm","BMw","BMx","BMy"],
  "fish bowl": ["BMz","BM0","BM1","BM2","BM3"],
  "fish fished": ["DhZ"],
  "fisherman": ["EDq","EDr","D0U","DCo","DCn","BM7","BM4","BM5","BM6"],
  "fishing": ["Eau","DhZ","BNA","BM8","BM9"],
  "fishing rod": ["BNB","BNC","BND","BNE"],
  "fishmonger": ["BNG","BNF"],
  "fist": ["BNK","BNI","BNJ"],
  "fit": ["EDy","BNP","BNL"],
  "fit as a fiddle": ["EDs","EDt","EDu"],
  "fit like a glove": ["EDv","EDw","EDx"],
  "fitness": ["BNO"],
  "fitness center": ["BNM","BNN"],
  "fitness centre": ["BNM","BNN"],
  "five": ["DbC","DbA"],
  "five hundred": ["DbB"],
  "five o'clock": ["DeA"],
  "five past six": ["EfR","DeB"],
  "five past twelve": ["DeC"],
  "five thousand": ["DbD"],
  "five to twelve": ["EfS","DeD"],
  "fix": ["Eav","EXj","EXi","Dhc","Dha","Dhb","BNS","BNQ","BNR"],
  "fix a car": ["Eav","Dha"],
  "fix a computer": ["Dhb"],
  "fix cars": ["EDz"],
  "fix computers": ["ED0"],
  "fix fixed": ["Dha","Dhb","Dhc"],
  "fix the computer": ["EXi"],
  "fix the water": ["Dhc"],
  "fix the water pipes": ["EXj"],
  "fix water pipes": ["ED1"],
  "fixing": ["Eav","Dhc","Dha","Dhb"],
  "fixing a car": ["Eav","Dha"],
  "fixing a computer": ["Dhb"],
  "fixing the water": ["Dhc"],
  "fizzy drink": ["BNT"],
  "flag": ["D0W","DCq","BNW","BNU","BNV"],
  "flags": ["BNY","BNX"],
  "flame": ["BNd","BNZ","BNa","BNb","BNc"],
  "flamingo": ["BNh","BNe","BNf","BNg"],
  "flap": ["BNi"],
  "flashlight": ["D0X","DCr","BNm","BNj","BNk","BNl"],
  "flat": ["Ehf","ED2","DCs"],
  "flat tire": ["BNn","BNo"],
  "flat tires": ["Ehf"],
  "flat tyre": ["BNn","BNo"],
  "flat tyres": ["Ehf"],
  "flavor": ["BNp"],
  "flavors": ["DWK","BNq"],
  "flavour": ["BNp"],
  "flavours": ["DWK","BNq"],
  "flax": ["BNr"],
  "flew": ["EUf"],
  "flexible": ["DWL","BNt","BNs"],
  "flies": ["DqP"],
  "flight": ["BNw"],
  "flight attendant": ["ED4","ED3","DCt","DCu","DWM","BNu","BNv"],
  "flip chart": ["D0Y","DCv","BNx","BNy"],
  "flip flops": ["D0Z","DCw","BNz","BN0","BN1","BN2","BN3"],
  "flippers": ["BN5","BN4"],
  "float": ["DWO","DWN"],
  "flood": ["DCy","DCx","BOB","BN6","BN7","BN8","BN9","BOA"],
  "floor": ["BOF","BOC","BOD","BOE"],
  "Florida": ["ED5"],
  "florist": ["ED6","ED7","D0a","D0b","DC1","DCz","DC0","BOH","BOG"],
  "flour": ["BOK","BOI","BOJ"],
  "flow": ["BOW"],
  "flower": ["D0c","D0d","DC3","DC2","BON","BOL","BOM"],
  "flower pot": ["BOO","BOP","BOQ"],
  "flowerpot": ["BOR"],
  "flowers": ["BOV","BOS","BOT","BOU"],
  "flu": ["BOY","BOX"],
  "fluctuate": ["DWP"],
  "fluent": ["DWQ"],
  "flute": ["BOb","BOZ","BOa"],
  "fly": ["Eaw","EXk","D0e","Dhf","Dhd","DC4","BOd","BOc"],
  "fly a kite": ["Eaw","Dhd"],
  "fly a plane": ["ED8","DqQ"],
  "fly flew": ["EUf","Dhd","Dhe","Dhf"],
  "fly in the sky": ["EXk"],
  "fly over": ["Dhe"],
  "fly over the mountains": ["Dhe"],
  "flying": ["Eaw","Dhf","Dhd"],
  "flying a kite": ["Eaw","Dhd"],
  "flying over": ["Dhe"],
  "flying over the mountains": ["Dhe"],
  "foal": ["BOf","BOe"],
  "fog": ["BOk","BOg","BOh","BOi"],
  "foggy": ["BOj"],
  "fold": ["DqR"],
  "folder": ["D0f","DC5","BOp","BOl","BOm","BOn","BOo"],
  "follow": ["EXl","Dhg","BOq"],
  "follow followed": ["ESc","Dhg"],
  "follow mother": ["EXl","Dhg"],
  "followed": ["ESc"],
  "followed mother": ["ESc"],
  "following": ["Dhg"],
  "following mother": ["Dhg"],
  "fond of": ["DWR"],
  "fondu": ["BOr"],
  "fondue": ["BOr"],
  "food": ["DqT","DqS"],
  "food pyramid": ["BOs"],
  "foods": ["BOt"],
  "fool": ["BOw","BOu","BOv"],
  "foot": ["D0g","DC6","BO9","BOx","BOy"],
  "football": ["BO3","BOz","BO0","BO1"],
  "football player": ["BO2"],
  "footballer": ["DqU"],
  "footpath": ["BO8","BO4","BO5","BO6","BO7"],
  "footprints": ["BPD","BPA","BPB","BPC"],
  "forager": ["DWS"],
  "forbid": ["DWT","BPE"],
  "force": ["DWU","BPF"],
  "forearm": ["BPH","BPG"],
  "forecast": ["BPI"],
  "forehead": ["BPJ"],
  "forest": ["D0h","DC9","BPP","BPK","BPL"],
  "forest fire": ["DC7","DC8","BPM","BPN","BPO"],
  "forever": ["DWV","BPQ"],
  "forget": ["EXm","Dhh","DWW"],
  "forget forgot": ["ESw","Dhh"],
  "forget forgotten": ["EVU"],
  "forget me not": ["BPR"],
  "forget your car key": ["EXm"],
  "forget your key": ["Dhh"],
  "forgeting": ["Dhh"],
  "forgot": ["ESw","DqV"],
  "forgot his key": ["ESw"],
  "forgotten": ["EVU"],
  "forgotten his keys": ["EVU"],
  "fork": ["D0i","DDA","BPT","BPS"],
  "formal": ["DWX","BPV","BPU"],
  "fortress": ["DWY","BPW"],
  "fortune": ["DWZ","BPX"],
  "forty": ["DbK","DbE"],
  "forty eight": ["DbF"],
  "forty five": ["DbG"],
  "forty four": ["DbH"],
  "forty nine": ["DbI"],
  "forty one": ["DbJ"],
  "forty seven": ["DbL"],
  "forty six": ["DbM"],
  "forty thousand": ["DbN"],
  "forty three": ["DbO"],
  "forty two": ["DbP"],
  "forward": ["DWa","BPZ","BPY"],
  "fossil": ["BPb","BPa"],
  "fossil fuels": ["DWb"],
  "fought": ["EU0"],
  "fountain": ["D0k","DDC","BPe","BPc","BPd"],
  "fountain pen": ["D0j","DDB"],
  "four": ["DbS","DbQ"],
  "four hundred": ["DbR"],
  "four thousand": ["DbV"],
  "fourteen": ["DbU","DbT"],
  "fourth": ["DqW"],
  "fox": ["D0l","DDD","BPj","BPf","BPg","BPh","BPi"],
  "fracture": ["DWc","BPk"],
  "frame": ["DWd","BPl"],
  "France": ["ED9","D0m","DDF","BPp","BPm","BPn","BPo"],
  "France flag": ["DDE"],
  "frankenstein": ["EEA","EEB","BPt","BPq","BPr","BPs"],
  "freckles": ["BPx","BPu","BPv","BPw"],
  "freeze": ["BP0","BPy","BPz"],
  "freezer": ["BP1"],
  "freezing": ["DDH","DDG","BP2"],
  "French": ["EeL","DDI"],
  "french fries": ["BP3","BP4","BP5"],
  "french horn": ["BP6","BP7","BP8"],
  "frequency": ["BP9"],
  "Frequently": ["DWe"],
  "fresh": ["DqX"],
  "Friday": ["DDL","DDJ","DDK"],
  "fridge": ["D0n","DDM","BQD","BQA","BQB","BQC"],
  "fried chicken": ["DDN","BQE","BQF","BQG"],
  "fried egg": ["D0o","BQH","BQI","BQJ","BQK","BQL"],
  "fried eggs": ["BQM","BQN","BQO"],
  "fried food": ["BQP"],
  "fried rice": ["DDO","BQQ","BQR","BQS","BQT"],
  "friend": ["BQX","BQU","BQV"],
  "friendly": ["BQW"],
  "friends": ["DWf","BQe","BQY","BQZ","BQa","BQb"],
  "friendship": ["BQd","BQc"],
  "fries": ["D0p","DDP","DWg","BQg","BQf"],
  "frighten": ["DWi"],
  "frightened": ["EEC","DWh","BQj","BQh","BQi"],
  "frightening": ["BQm","BQk","BQl"],
  "frisbee": ["BQp","BQn","BQo"],
  "frisk": ["DWj"],
  "frog": ["EED","D0q","DDQ","BQs","BQq","BQr"],
  "frogs": ["DqY"],
  "front door": ["BQt","BQu","BQv","BQw","BQx","BQy"],
  "frost": ["BQ0","BQz"],
  "frosty": ["DWk","BQ2","BQ1"],
  "frown": ["Dhi","BQ5","BQ3","BQ4"],
  "frown frowned": ["Dhi"],
  "frowning": ["Dhi"],
  "frozen": ["BQ8","BQ6","BQ7"],
  "fruit": ["EEE","DDR","BRF","BQ9","BRA","DqZ"],
  "fruit juice": ["BRB","BRC","BRD","BRE"],
  "fruit salad": ["BRG","BRH","BRI"],
  "fruit smoothie": ["DDS"],
  "fruit stall": ["BRJ","BRK","BRL","BRM"],
  "fruit stand": ["BRN"],
  "frustrated": ["BRP","BRO"],
  "fry": ["Dhj","BRU","BRQ","BRR"],
  "fry fried": ["Dhj"],
  "frying": ["Dhj","BRT","BRS"],
  "frying pan": ["D0r","DDT"],
  "fuchsia": ["BRW","BRV"],
  "fuel": ["DWl","BRX"],
  "full moon": ["BRY","BRZ","BRa","BRb"],
  "fume": ["BRf","BRc","BRd","BRe"],
  "fun": ["Dqd","Dqa","Dqb"],
  "funfair": ["BRi","BRg","BRh"],
  "fungi": ["BRl","BRj","BRk"],
  "funnel": ["Dqc"],
  "funny": ["EEF","DWm","BRp","BRm","BRn","BRo"],
  "fur": ["DDU"],
  "furious": ["DWn","BRs","BRq","BRr"],
  "furnace": ["DWo","BRu","BRt"],
  "furniture": ["BRv"],
  "furry": ["BRw"],
  "fuses": ["BRx"],
  "futsal": ["BRy"],
  "g": ["DZy","DZx"],
  "galaxy": ["BR2","BRz","BR0","BR1"],
  "gallery": ["BR5","BR3","BR4"],
  "game": ["BR9","BR6","BR7","BR8"],
  "game console": ["Dqe"],
  "game designer": ["DWp"],
  "game show": ["DWq"],
  "games": ["Dqf"],
  "games console": ["D0s","DDV","BSA","BSB","BSC"],
  "garage": ["D0t","DDW","BSD"],
  "garbage": ["BSP","BSE","BSF","BSG","BSH","BSI"],
  "garbage can": ["BSJ","BSK","BSL","BSM","BSN"],
  "garbage truck": ["BSQ","BSR"],
  "garbageman": ["EEG","EEH","DDY","DDX","BSO"],
  "garden": ["DDb","BSW","BSS","BST"],
  "gardener": ["EEI","EEJ","D0u","DDa","DDZ","BSU"],
  "gardening": ["BSV"],
  "gargoyle": ["BSZ","BSX","BSY"],
  "garlic": ["D0v","DDc","BSe","BSa","BSb","BSc","BSd"],
  "gas": ["BSf"],
  "gas station": ["D0w","DDd","BSg","BSh","BSi"],
  "gate": ["D0x","DDe","BSp","BSj","BSk","BSl","BSm","BSn","BSo"],
  "gather": ["DWr","BSq"],
  "gathering": ["Dqg"],
  "gave": ["ESx"],
  "gave her a gift": ["ESx"],
  "gaze": ["DWs","BSv","BSr"],
  "gazelle": ["BSu","BSs","BSt"],
  "gecko": ["BSy","BSw","BSx"],
  "geese": ["BS1","BSz","BS0"],
  "gem": ["BS6","BS2","BS3","BS4","BS5"],
  "generous": ["DWt"],
  "gentlemen": ["BS7"],
  "geography": ["D0y","DDf","BTB","BS8","BS9","BTA"],
  "Georgia": ["EEK"],
  "German": ["EeM","DDg"],
  "German shepherd": ["BTC"],
  "Germany": ["EEL","D0z","DDi","BTH","BTD","BTE","BTF","BTG"],
  "Germany flag": ["DDh"],
  "germs": ["BTK","BTI","BTJ"],
  "get": ["EcJ","EcI","EXu","EXs","EXr","EXq","EXp","EXo","Dhk","Dhl"],
  "get a book": ["EcI","Dhk"],
  "get a burger": ["EEM"],
  "get a drink": ["Dhl"],
  "get a haircut": ["EcJ","EXo","Dhm","Dhn"],
  "get a massage": ["EEN"],
  "get an injection": ["EXp","Dho"],
  "get dressed": ["EXq","EEO","Dhp"],
  "get dressed got dressed": ["Dhp"],
  "get eyes checked": ["Dhq"],
  "get got": ["EVp","ET1","Dhk","Dhl"],
  "get his phone fixed": ["EEP"],
  "get home": ["Dqh"],
  "get juice from the fridge": ["EXr"],
  "get married": ["EEQ","Dhr"],
  "get married got married": ["Dhr"],
  "get on": ["Eax","EES","EER","Dhs","Dhu","Dht"],
  "get on a bus": ["EER","Eax","Dht"],
  "get on got on": ["Dhs","Dhu"],
  "get to": ["Dhv"],
  "get to got to": ["Dhv"],
  "get to work": ["EXs","Dhv"],
  "get up": ["Eay","EXt","EEU","EET","Dhw","Dhx"],
  "get up early": ["EXt"],
  "get up got up": ["Dhw","Dhx"],
  "get your eyes checked": ["EXu"],
  "get your nails painted": ["Dhy"],
  "getting": ["EcJ","EcI","Dhl","Dhk"],
  "getting a book": ["EcI","Dhk"],
  "getting a drink": ["Dhl"],
  "getting a haircut": ["EcJ","Dhm","Dhn"],
  "getting an injection": ["Dho"],
  "getting dressed": ["Dhp"],
  "getting eyes checked": ["Dhq"],
  "getting married": ["Dhr"],
  "getting on": ["Eax","Dhs","Dhu","Dht"],
  "getting on a bus": ["Eax","Dht"],
  "getting to": ["Dhv"],
  "getting to work": ["Dhv"],
  "getting up": ["Eay","Dhw","Dhx"],
  "getting your nails painted": ["Dhy"],
  "Ghana": ["EEV"],
  "gherkin": ["BTL"],
  "gherkins": ["BTN","BTM"],
  "ghost": ["EEW","BTR","BTO","BTP","BTQ"],
  "ghosts": ["EEX"],
  "giant": ["BTS"],
  "gift": ["Ehg","EEY","D00","DDj","BTV","BTT","BTU"],
  "gift shop": ["Dqi"],
  "gifts": ["Ehh","BTY","BTW","BTX"],
  "gigantic": ["BTa","BTZ"],
  "gills": ["Dqj"],
  "ginger": ["D01","DDk","BTp","BTb","BTc","BTd"],
  "ginger hair": ["BTm","BTn","BTo"],
  "gingerbread": ["BTl","BTe"],
  "gingerbread house": ["BTf","BTg","BTh"],
  "gingerbread man": ["Ehi","EEZ","BTi","BTj","BTk"],
  "giraffe": ["D02","DDl","BTu","BTq","BTr","BTs","BTt"],
  "girder": ["BTx","BTv","BTw"],
  "girl": ["BT1","BTy","BTz","BT0"],
  "give": ["Eaz","EXv","Dhz","Dh0","Dh1","BT8","BT2","BT3","BT4"],
  "give a gift": ["Eaz","EXv","EEa","Dhz","Dh0"],
  "give a hand": ["BT5","BT6"],
  "give a presentation": ["EEb","Dh1"],
  "give flowers": ["BT7"],
  "give gave": ["ESx","Dhz","Dh0","Dh1"],
  "give given": ["EVo"],
  "give out": ["EXw","Dh2"],
  "give out gave out": ["Dh2"],
  "give out money": ["EXw","Dh2"],
  "give someone a hand": ["EEc","EEd","EEe"],
  "give someone the cold shoulder": ["EEf","EEg","EEh"],
  "given": ["EVo"],
  "given a presentation": ["EVo"],
  "giving": ["Eaz","Dh1","Dhz","Dh0"],
  "giving a gift": ["Eaz","Dhz","Dh0"],
  "giving a presentation": ["Dh1"],
  "giving out": ["Dh2"],
  "giving out money": ["Dh2"],
  "glacier": ["BUB","BT9","BUA"],
  "glad": ["BUI","BUC","BUD"],
  "gladiator": ["BUH","BUE","BUF","BUG"],
  "glass": ["D05","DDo","BUW","BUJ","BUK","BUL","BUM","BUN"],
  "glass of milk": ["BUS","BUT","BUU","BUV"],
  "glass water": ["BUX","BUY","BUZ"],
  "glasses": ["Ehz","D03","D04","DDn","DDm","BUR","BUO","BUP","BUQ"],
  "glitch": ["DWu"],
  "global": ["DWv","BUd","BUa","BUb","BUc"],
  "global warming": ["BUe"],
  "globe": ["D06","DDp","BUg","BUf"],
  "gloomy": ["BUi","BUh"],
  "glove": ["BUk","BUj"],
  "gloves": ["D07","DDq","BUo","BUl","BUm","BUn"],
  "glue": ["DWw","BUq","BUp"],
  "glue stick": ["BUr"],
  "gluten free": ["DWx"],
  "go": ["EdT","EX1","EX0","EXz","EXy","EXx","Dh9","Dh8"],
  "go back": ["Dqk"],
  "go been": ["EVm","EVR"],
  "go camping": ["EEi"],
  "go cycling": ["Dql"],
  "go diving": ["Dh3"],
  "go fishing": ["EEj","Dqm"],
  "go for a walk": ["Dqn"],
  "go hiking": ["Dh4"],
  "go hiking in the mountains": ["EXx"],
  "go home": ["Dqo"],
  "go into space": ["EEk"],
  "go jogging": ["Dqp"],
  "go rock climbing": ["EEm"],
  "go scuba diving": ["EXy"],
  "go shopping": ["Dh5"],
  "go shopping went shopping": ["Dh5"],
  "go sightseeing": ["Dqv"],
  "go skating": ["Dqw"],
  "go skiing": ["EEo","EEn","Dqx"],
  "go swimming": ["Dqy"],
  "go to": ["Dh6","Dh7"],
  "go to a cafe": ["EXz","Dh6"],
  "go to bed": ["EX0","EEp","Dh7"],
  "go to school": ["EdT","Dh8"],
  "go to the cinema": ["Dqz"],
  "go to the WC": ["EX1","Dh9"],
  "go to the zoo": ["Dq0"],
  "go to went to": ["Dh7"],
  "go to work": ["Dq1"],
  "go viral": ["DW0"],
  "go went": ["EVE","Dh8","Dh3","Dh4"],
  "goal": ["BUt","BUs"],
  "goat": ["D08","DDr","BUy","BUu","BUv","BUw","BUx"],
  "goats": ["BU0","BUz"],
  "god": ["BU1"],
  "goggles": ["D09","DDs","BU5","BU2","BU3","BU4"],
  "going": ["EdT","Dh9","Dh8"],
  "going diving": ["Dh3"],
  "going hiking": ["Dh4"],
  "going shopping": ["Dh5"],
  "going to": ["Dh6","Dh7"],
  "going to a cafe": ["Dh6"],
  "going to bed": ["Dh7"],
  "going to buy a tv": ["Ees"],
  "going to clean the windows": ["Eet"],
  "going to cut down the tree": ["Eeu"],
  "going to do laundry": ["Eev"],
  "going to drink coffee": ["Eew"],
  "going to eat a banana": ["Eex"],
  "going to fly a kite": ["Eey"],
  "going to have a picnic": ["Eez"],
  "going to jump into the water": ["Ee0"],
  "going to land": ["Ee1"],
  "going to play football": ["Ee2"],
  "going to play tennis": ["Ee3"],
  "going to school": ["EdT","Dh8"],
  "going to shave his beard": ["Ee4"],
  "going to sleep": ["Ee5"],
  "going to swim": ["Ee6"],
  "going to take a bath": ["Ee7"],
  "going to take a photo": ["Ee8"],
  "going to take a train": ["Ee9"],
  "going to the WC": ["Dh9"],
  "going to walk the dog": ["EfA"],
  "going to watch a movie": ["EfB"],
  "gold": ["DDt","BVJ","BU6","BU7","BU8"],
  "golden eagle": ["BU9","BVA","BVB","BVC"],
  "goldfish": ["BVI","BVD","BVE","BVF","BVG"],
  "goldfish bowl": ["BVH"],
  "golf": ["D1A","DDu","BVN","BVK","BVL","BVM"],
  "good": ["EEl","DWz","BVT"],
  "good bye": ["Dqq"],
  "good evening": ["Dqr"],
  "good idea": ["BVR","BVS"],
  "good morning": ["Dqs"],
  "good night": ["Dqt","Dqu"],
  "goodbye": ["DWy","BVQ","BVO","BVP"],
  "google": ["BVU"],
  "goose": ["BVa","BVV","BVW","BVX"],
  "gooseberry": ["BVZ","BVY"],
  "gorilla": ["D1B","DDv","BVf","BVb","BVc","BVd","BVe"],
  "gosling": ["BVi","BVg","BVh"],
  "got": ["EVp","ET1"],
  "got a book": ["ET1"],
  "got an injection": ["EVp"],
  "government": ["BVk","BVj"],
  "gown": ["BVl"],
  "gps": ["BVo","BVm","BVn"],
  "grab": ["Dq2"],
  "graceful": ["DW1","BVq","BVp"],
  "gradually": ["BVs","BVr"],
  "graduate": ["DiA","DW2","BVw","BVt","BVu","BVv"],
  "graduate college": ["DiA"],
  "graduate from college": ["EEq"],
  "graduate graduated": ["EWP","DiA"],
  "graduated": ["EWP"],
  "graduated from college": ["EWP"],
  "graduating": ["DiA"],
  "graduating college": ["DiA"],
  "graduation": ["BVy"],
  "graduation ceremony": ["BVx"],
  "grain": ["BV1","BVz","BV0"],
  "grains": ["Dq3"],
  "grandad": ["DW4","DW3"],
  "granddaughter": ["EEr","DZU","DW6","DW5","BV3","BV2"],
  "grandfather": ["EEs","DZV","DW8","DW7","BV6","BV4","BV5"],
  "grandma": ["DXA","DW9","BV9","BV7","BV8"],
  "grandmother": ["EEt","DZW","DXB","BWA"],
  "grandpa": ["DXC","BWC","BWB"],
  "grandparents": ["DXD","BWE","BWD"],
  "grandson": ["EEu","DZX","DXE","BWH","BWF","BWG"],
  "granite": ["DXF","BWL","BWI","BWJ","BWK"],
  "granny": ["DXG","BWN","BWM"],
  "grape juice": ["BWT","BWU"],
  "grapefruit": ["Egk","D1C","DDw","BWS","BWO","BWP","BWQ","BWR"],
  "grapes": ["D1D","DDx","BWZ","BWV","BWW","BWX","BWY"],
  "graphic designer": ["EEw","EEv","D1E","DDy","DDz","BWa"],
  "grasp": ["BWb"],
  "grass": ["BWj","BWc","BWd","BWe"],
  "grasshopper": ["D1F","DD0","BWi","BWf","BWg","BWh"],
  "grassland": ["Dq4"],
  "grate": ["BWl","BWk"],
  "grater": ["D1G","DD1"],
  "gravel": ["BWq","BWm","BWn","BWo","BWp"],
  "graveyard": ["EEx","BWv","BWr","BWs","BWt","BWu"],
  "gravity": ["DXH"],
  "gravy": ["BWx","BWw"],
  "gray": ["BWy","DD6"],
  "graze": ["BW1","BWz","BW0"],
  "grazing": ["BW3","BW2"],
  "great grandfather": ["DXI","BW4"],
  "great grandmother": ["DXJ"],
  "great wall of china": ["BW5","BW6","BW7"],
  "great white shark": ["BW8"],
  "Greece": ["EEy","BXC","BW9","BXA","BXB"],
  "Greece flag": ["DD2"],
  "greedy": ["Dq5"],
  "Greek": ["Dq6"],
  "green": ["DD3","BXX"],
  "green bean": ["BXD","BXE","BXF","BXG"],
  "green beans": ["Dq7"],
  "green eyes": ["BXH"],
  "green frog": ["BXI"],
  "green pepper": ["BXT"],
  "green peppers": ["BXU","BXV","BXW"],
  "green salad": ["BXY","BXZ"],
  "green scarf": ["Ef8","DD4"],
  "green shorts": ["EgI","DD5"],
  "green tea": ["BXa","BXb"],
  "greengrocer": ["BXM","BXJ","BXK","BXL"],
  "greengrocers": ["Dq8"],
  "greenhouse": ["BXS","BXN","BXO","BXP","BXQ"],
  "greenhouse effect": ["BXR"],
  "greet": ["EX2","DiB"],
  "greet greeted": ["ET2","DiB"],
  "greet people": ["EX2","EEz"],
  "greeted": ["ET2"],
  "greeted guests": ["ET2"],
  "greeting": ["DiB"],
  "greetings": ["DXK"],
  "grew": ["EUl"],
  "grey": ["BWy","DD6"],
  "grill": ["BXc"],
  "grim": ["BXd"],
  "grim reaper": ["EE0","EE1"],
  "grin": ["BXf","BXe"],
  "grip": ["BXh","BXg"],
  "grocery": ["BXi"],
  "grocery store": ["BXj"],
  "groom": ["BXk","Dq9"],
  "ground": ["BXl"],
  "ground floor": ["DXL"],
  "groundwater": ["DXM","BXm"],
  "group": ["BXp","BXn","BXo"],
  "grow": ["DiC","BXs"],
  "grow food": ["EE2","BXq"],
  "grow grew": ["EUl","DiC"],
  "growing": ["DiC"],
  "growling": ["BXr"],
  "grumpy": ["EE3","BXu","BXt"],
  "guacamole": ["DD7"],
  "guard": ["EdU","EX3","DiD","DiE"],
  "guard a building": ["EE4"],
  "guard guarded": ["EU1","DiD","DiE"],
  "guard the door": ["EdU","EX3","DiE"],
  "guarded": ["EU1"],
  "guarded a door": ["EU1"],
  "guarding": ["EdU","DiD","DiE"],
  "guarding the door": ["EdU","DiE"],
  "Guatemala": ["EE5"],
  "guava": ["BXy","BXv","BXw","BXx"],
  "guest": ["DXN"],
  "guests": ["DXO"],
  "guide": ["EX4","DiF","BX0"],
  "guide book": ["BXz"],
  "guide guided": ["DiF"],
  "guide tourists": ["EX4","EE6","DiF"],
  "guiding": ["DiF"],
  "guiding tourists": ["DiF"],
  "guinea pig": ["BX1","BX2","BX3","BX4"],
  "guitar": ["D1H","DD8","BX9","BX5","BX6","BX7","BX8"],
  "gull": ["BYD","BYA","BYB","BYC"],
  "gum": ["BYJ","BYE","BYF","BYG"],
  "gummybears": ["BYI","BYH"],
  "guy": ["BYK"],
  "gym": ["DD9","BYR","BYL","BYM","BYN"],
  "gymnasium": ["BYO"],
  "gymnastics": ["BYQ","BYP"],
  "h": ["DZ0","DZz"],
  "habitable": ["DXP"],
  "habitat": ["BYS"],
  "hack": ["BYU","BYT"],
  "hacksaw": ["BYY","BYV","BYW","BYX"],
  "had": ["EWK","EVr","EV4","EVq","ET3"],
  "had a cat": ["EVq"],
  "had a haircut": ["EV4"],
  "had a job interview": ["EVr"],
  "had breakfast": ["EWK"],
  "had two pens": ["ET3"],
  "hail": ["DEB","DEA","BYa","BYZ"],
  "hair": ["D1L","DEG","BYl","BYb"],
  "hair dryer": ["D1K","DEF","BYh","BYi","BYj"],
  "hair salon": ["DEH","BYm","BYn","BYo"],
  "hair stylist": ["BYp","BYq"],
  "hairbrush": ["D1I","DEC","BYe","BYc","BYd"],
  "hairdresser": ["EE7","EE8","D1J","DEE","DED","BYg","BYf"],
  "hairline": ["BYk"],
  "Haiti": ["EE9"],
  "half": ["BYr"],
  "half past 12": ["DeH"],
  "half past 2": ["DeI"],
  "half past 5": ["DeF"],
  "half past 7": ["DeG"],
  "half past five": ["DeF"],
  "half past seven": ["EfT","DeG"],
  "half past twelve": ["EfU","DeH"],
  "half past two": ["EfV","DeI"],
  "hall": ["BY1","BYs","BYt","BYu"],
  "halloween": ["BY0","BYv","BYw","BYx"],
  "halloween candy": ["BYy","BYz"],
  "hallway": ["BY4","BY2","BY3"],
  "halt": ["BY6","BY5"],
  "ham": ["DEK","BZR","BY7","BY8","BY9"],
  "hamburger": ["D1M","BZF","BZA","BZB","BZC","BZD","BZE"],
  "hamburgers": ["BZG"],
  "hamlet": ["BZH"],
  "hammer": ["D1N","DiG","DEI","BZM","BZI","BZJ","BZK","BZL"],
  "hammer a nail": ["DiG"],
  "hammer hammered": ["DiG"],
  "hammering": ["DiG"],
  "hammering a nail": ["DiG"],
  "hammock": ["D1O","DEJ","BZQ","BZN","BZO","BZP"],
  "hamster": ["BZY","BZS","BZT","BZU","BZV"],
  "hamster cage": ["BZW","BZX"],
  "hand": ["D1R","DEN","BZl","BZZ","BZa"],
  "hand drill": ["BZh"],
  "hand dryer": ["D1Q","DEM"],
  "hand in": ["Ea0","EFA","DiH"],
  "hand in handed in": ["DiH"],
  "hand in homework": ["Ea0","DiH"],
  "hand out": ["EcK","EFB","DiI"],
  "hand out fliers": ["EcK","DiI"],
  "hand out handed out": ["DiI"],
  "handbag": ["D1P","DEL","BZf","BZb","BZc","BZd","BZe"],
  "handball": ["BZg"],
  "handing in": ["Ea0","DiH"],
  "handing in homework": ["Ea0","DiH"],
  "handing out": ["EcK","DiI"],
  "handing out fliers": ["EcK","DiI"],
  "handlebars": ["BZk","BZi","BZj"],
  "handrail": ["D1S","DEO"],
  "hands": ["DEP","BZu","BZm","BZn","BZo"],
  "hands up": ["BZv"],
  "handsaw": ["BZq","BZp"],
  "handsome": ["BZt","BZr","BZs"],
  "handyman": ["EFC","EFD","DER","DEQ"],
  "hang": ["BZ2","BZw","BZx"],
  "hang out": ["EX5","EFE","DiJ","DiK"],
  "hang out hung out": ["DiJ","DiK"],
  "hang out with friends": ["EX5","EFF","DiK"],
  "hang up": ["EcL","Ea1","EFG","DiM","DiL"],
  "hang up a coat": ["Ea1"],
  "hang up clothes": ["EcL","DiL"],
  "hang up hung up": ["DiL","DiM"],
  "hanger": ["BZ0","BZy","BZz"],
  "hangers": ["BZ1"],
  "hanging out": ["DiJ","DiK"],
  "hanging out with friends": ["DiK"],
  "hanging up": ["EcL","Ea1","DiM","DiL"],
  "hanging up clothes": ["EcL","DiL"],
  "happier": ["ERx","DES"],
  "happily": ["ERW"],
  "happiness": ["DXQ","BZ3"],
  "happy": ["Ehj","Ehk","EFH","DET","DXR","BZ7","BZ4","BZ5","BZ6"],
  "harbor": ["BaC","BZ8","BZ9","BaA","BaB"],
  "harbour": ["BaC","BZ8","BZ9","BaA","BaB"],
  "hard": ["ERU","EFI","BaD"],
  "hard working": ["DrA"],
  "hardwood": ["BaE"],
  "hardworking": ["DXS","BaF"],
  "hare": ["BaI","BaG","BaH"],
  "harmful gas": ["DXT"],
  "harmless": ["DXU"],
  "harmonica": ["D1T","DEU","BaM","BaJ","BaK","BaL"],
  "harp": ["D1U","DEV","BaR","BaN","BaO","BaP","BaQ"],
  "harvest": ["BaT","BaS"],
  "hastily": ["ERF"],
  "hat": ["D1V","DEY","DEW","DEX","BaX","BaU","BaV","BaW"],
  "haunted house": ["BaY","BaZ","Baa","Bab"],
  "have": ["EYB","EYA","EX9","EX8","EX7","EX6","Dif","Die"],
  "have a baby": ["DiN"],
  "have a barbecue": ["EFJ","DrB"],
  "have a bbq": ["DiO"],
  "have a birthday party": ["EFK"],
  "have a campfire": ["EFL","DiP"],
  "have a cat": ["EX6","DiQ"],
  "have a chip on your shoulder": ["EFM","EFN","EFO"],
  "have a dog": ["EX7","DiR"],
  "have a fin": ["EfC"],
  "have a heart of gold": ["EFP","EFQ","EFR"],
  "have a meeting": ["EX8","EFS","DiS"],
  "have a music lesson": ["DrC"],
  "have a party": ["DiU"],
  "have a photo taken": ["EX9","DiV"],
  "have a picnic": ["DrD"],
  "have a shell": ["EfD"],
  "have a snowball fight": ["EFT","DiW"],
  "have a sweet tooth": ["EFU","EFV","EFW"],
  "have a tail": ["EfE"],
  "have an online meeting": ["DiT"],
  "have bad breath": ["DiX"],
  "have breakfast": ["EYA","EFY","EFX","DiY","DiZ"],
  "have class": ["EFZ","Dia"],
  "have coffee": ["Dib"],
  "have coffee with friends": ["EFa"],
  "have cooking class": ["Dic"],
  "have dinner": ["DrE"],
  "have eight legs": ["EfF"],
  "have four legs": ["EfG"],
  "have fun": ["DrF"],
  "have had": ["EWK","EVr","EV4","EVq","ET3","DiO","DiP","DiQ","Die"],
  "have her photo taken": ["EFb"],
  "have his eyes checked": ["EFc"],
  "have long ears": ["EfH"],
  "have long hair": ["EfI"],
  "have lunch": ["Did"],
  "have money to burn": ["EFd","EFe","EFf"],
  "have the time of your life": ["EFg","EFh","EFi"],
  "have two arms": ["EfJ"],
  "have two ears": ["EfK"],
  "have two eyes": ["EfL"],
  "have two pens": ["Die"],
  "have two phones": ["EYB","Dif"],
  "have your ducks in a row": ["EFj","EFk","EFl"],
  "having": ["Dif","Die"],
  "having a baby": ["DiN"],
  "having a bbq": ["DiO"],
  "having a campfire": ["DiP"],
  "having a cat": ["DiQ"],
  "having a dog": ["DiR"],
  "having a meeting": ["DiS"],
  "having a party": ["DiU"],
  "having a photo taken": ["DiV"],
  "having a snowball fight": ["DiW"],
  "having an online meeting": ["DiT"],
  "having bad breath": ["DiX"],
  "having breakfast": ["DiY","DiZ"],
  "having class": ["Dia"],
  "having coffee": ["Dib"],
  "having cooking class": ["Dic"],
  "having lunch": ["Did"],
  "having two pens": ["Die"],
  "having two phones": ["Dif"],
  "hawk": ["Bag","Bac","Bad","Bae","Baf"],
  "hay": ["Bal","Bah","Bai","Baj","Bak"],
  "hay fever": ["DXV"],
  "hazel": ["Bao"],
  "hazelnuts": ["Ban","Bam"],
  "he adds sugar to his coffee": ["Eaa"],
  "he bowls": ["Eab"],
  "he brushes his teeth": ["Eac"],
  "he builds a wall": ["Ead"],
  "he buys a coffee": ["Eae"],
  "he buys groceries": ["Eaf"],
  "he carries a bag": ["Eag"],
  "he catches a ball": ["Eah"],
  "he chops an onion": ["Eai"],
  "he climbs": ["Eaj"],
  "he closes the window": ["Eak"],
  "he controls a drone": ["Eal"],
  "he crosses the road": ["Eam"],
  "he delivers a package": ["Ean"],
  "he deposits money at a bank": ["Eao"],
  "he digs": ["Eap"],
  "he dreams": ["Eaq"],
  "he empties the bin": ["Ear"],
  "he encourages his friend": ["Eas"],
  "he falls over": ["Eat"],
  "he fishes": ["Eau"],
  "he fixes a car": ["Eav"],
  "he flies a kite": ["Eaw"],
  "he gets on a bus": ["Eax"],
  "he gets up": ["Eay"],
  "he gives her a gift": ["Eaz"],
  "he hands in his homework": ["Ea0"],
  "he hangs up his coat": ["Ea1"],
  "he has already caught a fish": ["EFs"],
  "he has already eaten an apple": ["EFt"],
  "he has already washed his car": ["EFu"],
  "he has already washed the dishes": ["EFv"],
  "he has been a policeman since he was ": ["EFw"],
  "he has been sick since yesterday": ["EFx"],
  "he has been to america": ["EFy"],
  "he has driven his car since o'clock": ["EFz"],
  "he has failed the test times": ["EF0"],
  "he has forgotten his keys times": ["EF1"],
  "he has just broken the window": ["EF2"],
  "he has just crashed his car": ["EF3"],
  "he has just lost the game": ["EF4"],
  "he has just scored a goal": ["EF5"],
  "he has made a sandwich": ["EF6"],
  "he has made a speech times": ["EF7"],
  "he has never planted a tree": ["EF8"],
  "he has never shaved his head": ["EF9"],
  "he has read the book": ["EGF"],
  "he has seen an elephant": ["EGG"],
  "he has supported liverpool since ": ["EGH"],
  "he hasn't broken his arm": ["EGA"],
  "he hasn't done laundry for weeks": ["EGB"],
  "he hasn't ordered a pizza": ["EGC"],
  "he hasn't slept for days": ["EGD"],
  "he hasn't watched tv for one year": ["EGE"],
  "he hides behind the tree": ["Ea2"],
  "he holds up a sign": ["Ea3"],
  "he is adding sugar to his coffee": ["Eaa"],
  "he is bowling": ["Eab"],
  "he is brushing his teeth": ["Eac"],
  "he is building a wall": ["Ead"],
  "he is buying a coffee": ["Eae"],
  "he is buying groceries": ["Eaf"],
  "he is carrying a bag": ["Eag"],
  "he is catching a ball": ["Eah"],
  "he is chicken": ["EGI","EGJ","EGK"],
  "he is chopping an onion": ["Eai"],
  "he is climbing": ["Eaj"],
  "he is closing the window": ["Eak"],
  "he is cold": ["EhQ"],
  "he is controlling a drone": ["Eal"],
  "he is crossing the road": ["Eam"],
  "he is delivering a package": ["Ean"],
  "he is depositing money at a bank": ["Eao"],
  "he is digging": ["Eap"],
  "he is dreaming": ["Eaq"],
  "he is emptying the bin": ["Ear"],
  "he is encouraging his friend": ["Eas"],
  "he is falling over": ["Eat"],
  "he is fat": ["Ehe"],
  "he is fishing": ["Eau"],
  "he is fixing a car": ["Eav"],
  "he is flying a kite": ["Eaw"],
  "he is getting on a bus": ["Eax"],
  "he is getting up": ["Eay"],
  "he is giving her a gift": ["Eaz"],
  "he is handing in his homework": ["Ea0"],
  "he is hanging up his coat": ["Ea1"],
  "he is happy": ["Ehk"],
  "he is hiding behind the tree": ["Ea2"],
  "he is holding up a sign": ["Ea3"],
  "he is jumping over a puddle": ["Ea4"],
  "he is kicking a ball": ["Ea5"],
  "he is kneeling down": ["Ea6"],
  "he is laying out the table": ["Ea7"],
  "he is leaving": ["Ea8"],
  "he is lifting weights": ["Ea9"],
  "he is locking the door": ["EbA"],
  "he is looking at the clock": ["EbB"],
  "he is lying down": ["EbC"],
  "he is making a sandwich": ["EbD"],
  "he is making coffee": ["EbE"],
  "he is old": ["Eht"],
  "he is ordering food": ["EbF"],
  "he is painting a picture": ["EbG"],
  "he is picking apples": ["EbH"],
  "he is picking up litter": ["EbI"],
  "he is playing chess": ["EbJ"],
  "he is playing pool": ["EbK"],
  "he is playing the guitar": ["EbL"],
  "he is pointing at the clock": ["EbM"],
  "he is pulling a rope": ["EbN"],
  "he is pushing a car": ["EbO"],
  "he is putting his books in his bag": ["EbP"],
  "he is putting on a coat": ["EbQ"],
  "he is putting on shoes": ["EbR"],
  "he is putting out a fire": ["EbS"],
  "he is reading a newspaper": ["EbU"],
  "he is reading aloud": ["EbT"],
  "he is refusing money": ["EbV"],
  "he is relaxing": ["EbW"],
  "he is repairing a phone": ["EbX"],
  "he is rescuing someone": ["EbY"],
  "he is riding a bike": ["EbZ"],
  "he is riding a motorbike": ["Eba"],
  "he is sad": ["Eh1"],
  "he is shaving": ["Ebb"],
  "he is shutting the door": ["Ebc"],
  "he is signing his name": ["Ebd"],
  "he is squeezing an orange": ["Ebe"],
  "he is stealing a wallet": ["Ebf"],
  "he is strong": ["EiA"],
  "he is sweeping the floor": ["Ebg"],
  "he is swimming": ["Ebh"],
  "he is taking off his coat": ["Ebi"],
  "he is taking out the trash": ["Ebj"],
  "he is telling her a secret": ["Ebk"],
  "he is throwing a ball": ["Ebl"],
  "he is throwing away a bottle": ["Ebm"],
  "he is turning on the tv": ["Ebn"],
  "he is typing": ["Ebo"],
  "he is unhappy": ["Eh1"],
  "he is using a tablet": ["Ebp"],
  "he is using his phone": ["Ebq"],
  "he is washing his face": ["Ebr"],
  "he is washing his hands": ["Ebs"],
  "he is washing the dishes": ["Ebt"],
  "he is writing": ["Ebu"],
  "he is yawning": ["Ebv"],
  "he jumps over a puddle": ["Ea4"],
  "he kicks a ball": ["Ea5"],
  "he kneels down": ["Ea6"],
  "he lays out the table": ["Ea7"],
  "he leaves": ["Ea8"],
  "he lies down": ["EbC"],
  "he lifts weights": ["Ea9"],
  "he locks the door": ["EbA"],
  "he looks at the clock": ["EbB"],
  "he makes a sandwich": ["EbD"],
  "he makes coffee": ["EbE"],
  "he orders food": ["EbF"],
  "he paints a picture": ["EbG"],
  "he picks apples": ["EbH"],
  "he picks up litter": ["EbI"],
  "he plays chess": ["EbJ"],
  "he plays pool": ["EbK"],
  "he plays the guitar": ["EbL"],
  "he points at the clock": ["EbM"],
  "he pulls a rope": ["EbN"],
  "he pushes a car": ["EbO"],
  "he puts his books in his bag": ["EbP"],
  "he puts on a coat": ["EbQ"],
  "he puts on shoes": ["EbR"],
  "he puts out a fire": ["EbS"],
  "he reads a newspaper": ["EbU"],
  "he reads aloud": ["EbT"],
  "he refuses money": ["EbV"],
  "he relaxes": ["EbW"],
  "he repairs a phone": ["EbX"],
  "he rescues someone": ["EbY"],
  "he rides a bike": ["EbZ"],
  "he rides a motorbike": ["Eba"],
  "he shaves": ["Ebb"],
  "he shuts the door": ["Ebc"],
  "he signs his name": ["Ebd"],
  "he squeezes an orange": ["Ebe"],
  "he steals a wallet": ["Ebf"],
  "he sweeps the floor": ["Ebg"],
  "he swims": ["Ebh"],
  "he takes off his coat": ["Ebi"],
  "he takes out the trash": ["Ebj"],
  "he tells her a secret": ["Ebk"],
  "he throws a ball": ["Ebl"],
  "he throws away a bottle": ["Ebm"],
  "he turns on the tv": ["Ebn"],
  "he types": ["Ebo"],
  "he uses a tablet": ["Ebp"],
  "he uses his phone": ["Ebq"],
  "he washes his face": ["Ebr"],
  "he washes his hands": ["Ebs"],
  "he washes the dishes": ["Ebt"],
  "he writes": ["Ebu"],
  "he yawns": ["Ebv"],
  "head": ["D1Z","DEd","DEZ","Ba0","Bap"],
  "head of lettuce": ["Bat","Bau"],
  "head over heels in love": ["EFm","EFn","EFo"],
  "headache": ["D1W","DEa","DXW","Bar","Baq"],
  "headband": ["Bas"],
  "headphones": ["D1X","D1Y","DEc","DEb","Baz","Bav","Baw","Bax","Bay"],
  "headset": ["D1a","DEe","Ba4","Ba1","Ba2","Ba3"],
  "health": ["Ba5"],
  "healthier": ["ERy","DEf"],
  "healthy": ["EFp","Ba6"],
  "hear": ["Dig","Ba8"],
  "hear a noise": ["Dig"],
  "hear heard": ["ESy","Dig"],
  "heard": ["ESy"],
  "heard a noise": ["ESy"],
  "hearing": ["Dig","Ba7"],
  "hearing a noise": ["Dig"],
  "heart": ["BbI","Ba9","BbA","BbB","BbC","BbD"],
  "heart attack": ["BbE","BbF","BbG","BbH"],
  "heartbroken": ["EFq"],
  "heat": ["BbN","BbJ","BbK"],
  "heater": ["D1b","DEg"],
  "heating": ["BbM","BbL"],
  "heavier": ["ERz","DEi","DEh"],
  "heavy": ["Ehl","EFr","DEk","DEj","BbS","BbO","BbP","BbQ","BbR"],
  "hedge": ["Bbb","BbT","BbU","BbV"],
  "hedgehog": ["Bba","BbW","BbX","BbY","BbZ"],
  "heel": ["D1c","DEl"],
  "height": ["DXX","Bbd","Bbc"],
  "held": ["ET4"],
  "held a baby": ["ET4"],
  "helicopter": ["D1d","DEm","Bbj","Bbe","Bbf","Bbg","Bbh","Bbi"],
  "hell": ["Bbl","Bbk"],
  "helmet": ["D1e","DEn","Bbp","Bbm","Bbn","Bbo"],
  "help": ["Bbr","Bbq"],
  "help sick people": ["EGL"],
  "helpful": ["DXY"],
  "hen": ["Bbt","Bbs"],
  "her bag is heavy": ["Ehl"],
  "her hair is long": ["Ehn"],
  "her shirt is dirty": ["EhY"],
  "her sweater is big": ["EhE"],
  "herbal": ["Bbx","Bbu","Bbv","Bbw"],
  "herbivore": ["DXZ"],
  "hero": ["DrG"],
  "heron": ["Bb0","Bby","Bbz"],
  "hesitate": ["DXa"],
  "hexagon": ["Bb2","Bb1"],
  "hibernate": ["DXb","Bb4","Bb3"],
  "hibernation": ["DXc"],
  "hiccup": ["Bb5"],
  "hid": ["ESz"],
  "hidden": ["BcA","Bb6","Bb7","Bb8","Bb9"],
  "hide": ["Ea2","Dih","BcD","BcB","BcC"],
  "hide and seek": ["DrH"],
  "hide behind the tree": ["Dih"],
  "hide hid": ["ESz","Dih"],
  "hideing": ["Dih"],
  "hiding": ["Ea2"],
  "hiding behind the tree": ["Dih"],
  "hieroglyphics": ["BcH","BcE","BcF","BcG"],
  "high": ["EiC","DEr","BcT","BcI","BcJ"],
  "high heels": ["D1f","DEp"],
  "high jump": ["D1g","DEq","BcK","BcL"],
  "higher": ["ER0","DEo"],
  "highlands": ["BcP","BcM","BcN","BcO"],
  "highlight": ["EcM","Dii"],
  "highlight highlighted": ["ET5","Dii"],
  "highlight lines": ["EcM","Dii"],
  "highlighted": ["ET5"],
  "highlighted some lines": ["ET5"],
  "highlighter": ["BcS","BcQ","BcR"],
  "highlighting": ["EcM","Dii"],
  "highlighting lines": ["EcM","Dii"],
  "hike": ["BcW","BcU","BcV"],
  "hike hiked": ["EWN"],
  "hiked": ["EWN"],
  "hiked in the mountains": ["EWN"],
  "hiking": ["Bcd","BcX"],
  "hiking boots": ["BcY","BcZ","Bca","Bcb","Bcc"],
  "hiking trail": ["Bce","Bcf","Bcg","Bch"],
  "hilarious": ["DXd"],
  "hill": ["Bcl","Bci","Bcj","Bck"],
  "hills": ["Bco","Bcm","Bcn"],
  "himalaya": ["Bcq","Bcp"],
  "hippo": ["D1h","DEs","Bcu","Bcr","Bcs","Bct"],
  "hippopotamus": ["DrI"],
  "hippos": ["Bcw","Bcv"],
  "hips": ["DXe"],
  "hired": ["Bcx"],
  "his arm is broken": ["EhK"],
  "his hair is blue": ["EhH"],
  "his shirt is colorful": ["EhR"],
  "his sweater is small": ["Eh6"],
  "historic": ["Bc1","Bcy","Bcz","Bc0"],
  "history": ["D1i","DEt","Bc4","Bc2"],
  "history book": ["Bc3"],
  "hit": ["EYC","ES0","Dik","Dij","Bc6","Bc5"],
  "hit a ball": ["ES0","Dij"],
  "hit a nail": ["EYC","Dik"],
  "hit hit": ["ES0","Dij","Dik"],
  "hit the sack": ["EGM","EGN","EGO"],
  "hitting": ["Dik","Dij"],
  "hitting a ball": ["Dij"],
  "hitting a nail": ["Dik"],
  "hive": ["BdA","Bc7","Bc8","Bc9"],
  "hobby": ["DXf","BdB"],
  "hockey": ["D1j","DEu","BdG","BdC","BdD","BdE","BdF"],
  "hoe": ["BdI","BdH"],
  "hold": ["EcN","EYD","Din","Dil","Dim","BdL","BdJ"],
  "hold a baby": ["EcN","Dil"],
  "hold a ball": ["EYD","Dim"],
  "hold hands": ["EdV","Din","BdK"],
  "hold held": ["ET4","Dil","Dim","Din"],
  "hold on": ["EGP","Dio"],
  "hold on held on": ["Dio"],
  "hold out": ["EGQ","Dip"],
  "hold out held out": ["Dip"],
  "hold up": ["Ea3","Diq"],
  "hold up a sign": ["Ea3","Diq"],
  "hold up held up": ["Diq"],
  "holding": ["EcN","Din","Dil","Dim"],
  "holding a baby": ["EcN","Dil"],
  "holding a ball": ["Dim"],
  "holding hands": ["EdV","Din"],
  "holding on": ["Dio"],
  "holding out": ["Dip"],
  "holding up": ["Ea3","Diq"],
  "holding up a sign": ["Ea3","Diq"],
  "hole": ["BdQ","BdM","BdN","BdO","BdP"],
  "hole punch": ["BdR","BdS","BdT"],
  "holiday": ["BdV","BdU"],
  "hollow": ["BdW"],
  "holly": ["BdX"],
  "home": ["Bdf","BdY","BdZ","Bda"],
  "homeland": ["Bdb"],
  "homeless": ["Bde","Bdc","Bdd"],
  "hometown": ["DXg"],
  "homework": ["Bdi","Bdg","Bdh"],
  "Honduras": ["EGR"],
  "honey": ["DEv","Bdm","Bdj","Bdk","Bdl"],
  "Hong Kong flag": ["DEw"],
  "hoodie": ["D1k","DEx","Bds","Bdn","Bdo","Bdp","Bdq","Bdr"],
  "hook": ["Bdv","Bdt","Bdu"],
  "hooves": ["Bdx","Bdw"],
  "hop": ["DXj"],
  "hope": ["DXi","Bdz"],
  "hopeful": ["DXh","Bdy"],
  "horizon": ["DXk","Bd1","Bd0"],
  "hormone": ["DXl"],
  "horns": ["Bd4","Bd2","Bd3"],
  "horror": ["Bd5"],
  "horse": ["D1l","DEy","Bd9","Bd6","Bd7","Bd8"],
  "horse racing": ["BeA","BeB","BeC"],
  "horse riding": ["D1m","DEz","BeD","BeE","BeF"],
  "horses": ["BeJ","BeG","BeH","BeI"],
  "hose": ["BeN","BeK","BeL","BeM"],
  "hospital": ["D1n","DE0","BeR","BeO","BeP","BeQ"],
  "hostel": ["DXm","BeS"],
  "hostile": ["DXn"],
  "hot": ["Ehm","EGU","DE7","DE1","DE2","Bep","BeT"],
  "hot air balloon": ["BeU","BeV","BeW"],
  "hot and spicy": ["BeX","BeY","BeZ"],
  "hot chocolate": ["D1o","DE3","Bea","Beb","Bec","Bed"],
  "hot cross buns": ["Bee","Bef","Beg"],
  "hot dog": ["D1p","DE4","Beh","Bei","Bej","Bek","Bel"],
  "hot dogs": ["Bem"],
  "hot soup": ["Beq","Ber"],
  "hotel": ["Beo","Ben"],
  "hotel manager": ["EGT","EGS","DE5","DE6"],
  "hotter": ["ER1","DE8"],
  "hound": ["Bev","Bes","Bet","Beu"],
  "hounds": ["Bey","Bew","Bex"],
  "hour": ["DrJ"],
  "house": ["D1q","DE9","Be5","Bez","Be0","Be1","Be2"],
  "household chores": ["DXo"],
  "housekeeper": ["Be4","Be3"],
  "housewife": ["Be9","Be6","Be7","Be8"],
  "how": ["Ddk"],
  "how are you": ["DrK"],
  "how do you go to school": ["EGV","Ddk"],
  "how do you spell your name": ["EGW"],
  "how expensive is the book": ["EGX"],
  "how far": ["Ddl"],
  "how far is London": ["EGY","Ddl"],
  "how heavy": ["Ddm"],
  "how heavy are you": ["Ddm"],
  "how heavy is he": ["EGZ"],
  "how many apples do you want": ["EGa"],
  "how much": ["Ddn"],
  "how much is the book": ["Ddn"],
  "how much is the skateboard": ["EGb"],
  "how old": ["Ddo"],
  "how old are you": ["EGc","Ddo"],
  "how old is he": ["EGd"],
  "how tall": ["Ddp"],
  "how tall are you": ["Ddp"],
  "huddle": ["BfB","BfA"],
  "hug": ["EdW","EYE","Dir","Dis","BfF","BfC","BfD","BfE"],
  "hug a friend": ["EYE"],
  "hug hugged": ["EU2","Dir","Dis"],
  "hug someone": ["Dis"],
  "huge": ["EGe"],
  "hugged": ["EU2"],
  "hugging": ["EdW","Dir","Dis"],
  "hugging someone": ["Dis"],
  "hulk": ["DXp"],
  "humid": ["DrL"],
  "hummingbird": ["BfI","BfG","BfH"],
  "hump": ["BfJ"],
  "hundred": ["DrM"],
  "hung up": ["ET6"],
  "hung up clothes": ["ET6"],
  "Hungary": ["EGf"],
  "hungry": ["EGg","BfK"],
  "hunt": ["BfQ","BfL"],
  "hunter": ["BfP","BfM","BfN","BfO"],
  "hurricane": ["DFB","DFA","BfT","BfR","BfS"],
  "hurt": ["EGh","DFC","BfU"],
  "husband": ["EGi","DZY","BfY","BfV","BfW","BfX"],
  "hut": ["Bfd","BfZ","Bfa","Bfb","Bfc"],
  "hyacinth": ["Bff","Bfe"],
  "hyena": ["Bfj","Bfg","Bfh","Bfi"],
  "i": ["DZ2","DZ1"],
  "I am happy": ["DrN"],
  "ice": ["D1s","DFG","BgL","Bfk","Bfl","Bfm"],
  "ice age": ["Bfn","Bfo"],
  "ice coffee": ["Egl","DFD"],
  "ice cream": ["D1r","DFE","DFF","Bfq","Bfr","Bfs","Bft","Bfu"],
  "ice cream stand": ["Bfv"],
  "ice cream van": ["Bfw","Bfx","Bfy"],
  "ice cube": ["Bfz"],
  "ice cubes": ["Bf0","Bf1"],
  "ice giant": ["BgA"],
  "ice hockey": ["BgB","BgC","BgD"],
  "ice lolly": ["BgJ","BgK"],
  "ice rink": ["BgM","BgN"],
  "ice skate": ["BgO","BgP","BgQ"],
  "ice skates": ["BgR","BgS","BgT"],
  "ice skating": ["BgU","BgV","BgW"],
  "ice tea": ["Egm","DFH"],
  "iceberg": ["Bfp"],
  "iced coffee": ["Bf2","Bf3","Bf4","Bf5"],
  "iced tea": ["Bf6","Bf7","Bf8","Bf9"],
  "Iceland": ["EGj","BgI","BgE","BgF","BgG","BgH"],
  "icicle": ["BgY","BgX"],
  "icicles": ["Bgd","BgZ","Bga","Bgb","Bgc"],
  "icy": ["Bgh","Bge","Bgf","Bgg"],
  "id": ["Bgn","Bgi","Bgj","Bgk"],
  "ID card": ["D1t","DFI"],
  "idea": ["Bgl"],
  "identify": ["Bgm"],
  "igloo": ["Bgr","Bgo","Bgp","Bgq"],
  "igneous": ["Bgs"],
  "ignore": ["EcO","Dit"],
  "ignore ignored": ["ET7","Dit"],
  "ignore someone": ["EcO","Dit"],
  "ignored": ["ET7"],
  "ignored him": ["ET7"],
  "ignoring": ["EcO","Dit"],
  "ignoring someone": ["EcO","Dit"],
  "iguana": ["Bgv","Bgt","Bgu"],
  "ill": ["Bgx","Bgw"],
  "Illinois": ["EHW"],
  "illiterate": ["DXq"],
  "illuminated": ["Bg0","Bgy","Bgz"],
  "illustration": ["Bg3","Bg1","Bg2"],
  "illustrator": ["EHX","EHY","D1u","DFK","DFJ","DXr"],
  "image": ["Bg4"],
  "imagine": ["Bg5"],
  "impact": ["DXs"],
  "impatient": ["DXt"],
  "imperative": ["DXu"],
  "implant": ["DXv"],
  "important": ["Bg7","Bg6"],
  "imposter": ["DXw"],
  "impractical": ["DXx"],
  "impure": ["Bg8"],
  "in": ["EfP","EfO","DdQ","DdL","DdM","Bho"],
  "in charge": ["DXy"],
  "in front": ["DdP","DX5"],
  "in front of": ["EfN","EfM","DdN","DdO"],
  "in front of the coffee shop": ["EfM"],
  "in front of the tv": ["EfN"],
  "in love": ["Bhl","Bhm","Bhn"],
  "in the bag": ["EfO"],
  "in the fridge": ["EfP"],
  "in the middle": ["EfQ","DdR"],
  "in the middle of the line": ["EfQ"],
  "inappropriate": ["Bg9"],
  "income": ["DXz"],
  "inconvenient": ["DX0"],
  "increase": ["BhB","BhA"],
  "India": ["EHe","D1v","DFN","BhG","BhC","BhD","BhE"],
  "India flag": ["DFL"],
  "Indian": ["EeN","DFM"],
  "Indian elephant": ["BhF"],
  "indicate": ["DX1"],
  "indignant": ["DX2"],
  "indigo": ["DFO"],
  "individual": ["BhI","BhH"],
  "Indonesia": ["EHf","BhM","BhJ","BhK","BhL"],
  "Indonesia flag": ["DFP"],
  "industry": ["BhQ","BhN","BhO","BhP"],
  "inexpensive": ["DX3"],
  "infant": ["BhT","BhR","BhS"],
  "infection": ["BhU"],
  "inflict": ["DX4"],
  "information": ["BhX","BhV"],
  "information board": ["BhW"],
  "ingredients": ["Bha","BhY","BhZ"],
  "inhaling": ["DX6"],
  "inherit": ["DX7"],
  "initial": ["DX8"],
  "initiative": ["DX9"],
  "injection": ["Bhb"],
  "injure": ["DYA"],
  "injury": ["Bhf","Bhc","Bhd","Bhe"],
  "ink": ["Bhi","Bhg","Bhh"],
  "inline skates": ["Bhj","Bhk"],
  "inner core": ["DYB"],
  "innovation": ["DYC"],
  "insect": ["DFQ","Bhp"],
  "insects": ["EHj","DrO"],
  "insert": ["Diu"],
  "insert inserted": ["ETY","Diu"],
  "inserted": ["ETY"],
  "inserted a usb stick": ["ETY"],
  "inserting": ["Diu"],
  "inside": ["Bhq"],
  "inspirational": ["Bhr"],
  "instant coffee": ["DFR"],
  "instant noodles": ["D1w","DFS","Bhs","Bht","Bhu","Bhv","Bhw"],
  "instruments": ["DrP"],
  "insurance": ["DYD","Bhx"],
  "integration": ["DYE"],
  "intelligent": ["Bh0","Bhy","Bhz"],
  "interactive whiteboard": ["Bh1","Bh2"],
  "interested": ["Bh3"],
  "interesting": ["EHm","DYF"],
  "interior": ["Bh4"],
  "internet": ["Bh6","Bh5"],
  "interpret": ["EYF","Div"],
  "interpret chinese to english": ["EYF"],
  "interpret interpreted": ["Div"],
  "interpreter": ["EHn","EHo","DFU","DFT"],
  "interpreting": ["Div"],
  "interview": ["EYG","Diw","Dix","Bh8","Bh7"],
  "interview interviewed": ["EU3","Diw","Dix"],
  "interview people": ["EHp"],
  "interview someone": ["EYG","Dix"],
  "interviewed": ["EU3"],
  "interviewed her": ["EU3"],
  "interviewing": ["Diw","Dix"],
  "interviewing someone": ["Dix"],
  "intestines": ["BiA","Bh9"],
  "introduce": ["DrQ"],
  "intuition": ["BiB"],
  "invent": ["BiC"],
  "invention": ["DrR"],
  "inventor": ["DYG","BiD"],
  "investment": ["BiE"],
  "invisible": ["DrS"],
  "invitation": ["DYH"],
  "invite": ["DYI"],
  "iphone": ["BiG","BiF"],
  "Iran": ["EHr","BiK","BiH","BiI","BiJ"],
  "Ireland": ["EHs","D1x","DFW","BiQ","BiL","BiM","BiN","BiO","BiP"],
  "Ireland flag": ["DFV"],
  "Irish": ["EeO","DFX"],
  "iron": ["EcP","Diy","BiR"],
  "iron a shirt": ["EcP","Diy"],
  "iron ironed": ["Diy"],
  "ironing": ["EcP","Diy"],
  "ironing a shirt": ["EcP","Diy"],
  "irritated": ["DYJ"],
  "irritating": ["DYK"],
  "is it hot today": ["EHt"],
  "is it raining": ["EHu"],
  "is the music loud": ["EHv"],
  "is was": ["Deu"],
  "is your bag heavy": ["EHw"],
  "is your dog dangerous": ["EHx"],
  "is your friend beautiful": ["EHy"],
  "island": ["D1y","DFY","BiU","BiS","BiT"],
  "isolated": ["DYL"],
  "it is cloudy": ["EhO"],
  "it is sunny": ["EiB"],
  "it's five past six": ["EfR"],
  "it's five to twelve": ["EfS"],
  "it's half past seven": ["EfT"],
  "it's half past twelve": ["EfU"],
  "it's half past two": ["EfV"],
  "it's nine o'clock": ["EfW"],
  "it's quarter past eleven": ["EfX"],
  "it's quarter past one": ["EfY"],
  "it's quarter past six": ["EfZ"],
  "it's quarter past twelve": ["Efa"],
  "it's quarter to eight": ["Efb"],
  "it's quarter to five": ["Efc"],
  "it's quarter to four": ["Efd"],
  "it's ten past eight": ["Efe"],
  "it's ten to five": ["Eff"],
  "it's three o'clock": ["Efg"],
  "it's twenty five past eleven": ["Efh"],
  "it's twenty five to ten": ["Efi"],
  "it's twenty past two": ["Efj"],
  "it's twenty to four": ["Efk"],
  "Italian": ["EeP","DFZ"],
  "Italy": ["EHz","D1z","DFb","Bia","BiV","BiW","BiX","BiY","BiZ"],
  "Italy flag": ["DFa"],
  "itch": ["Bib"],
  "itchy": ["DrT"],
  "itinerary": ["DYM"],
  "its cold": ["DrU"],
  "its sunny": ["DrV"],
  "j": ["DZ4","DZ3"],
  "jack fruit": ["Big","Bih"],
  "jack in the box": ["Bii"],
  "jack o lantern": ["DrX"],
  "jacket": ["D10","DFc","Bif","Bic","Bid","Bie"],
  "jackfruit": ["DrW"],
  "jackolantern": ["EH0"],
  "jade": ["Bik","Bij"],
  "jaguar": ["Bio","Bil","Bim","Bin"],
  "jailbreak": ["DYN"],
  "jam": ["Biw","Bip","Biq","Bir"],
  "Jamaica": ["EH1","Biv","Bis","Bit","Biu"],
  "janitor": ["EH2","EH3","DFe","DFd"],
  "January": ["DrY"],
  "Japan": ["EH4","D11","DFh","Bi2","Bix","Biy","Biz","Bi0","Bi1"],
  "Japan flag": ["DFg"],
  "Japanese": ["EeQ","DFf"],
  "jar": ["Bi7","Bi3","Bi4","Bi5","Bi6"],
  "jasmine": ["Bi9","Bi8"],
  "javelin": ["D12","DFi"],
  "jaw": ["BjA"],
  "jazz": ["BjC","BjB"],
  "jealous": ["EH5","DFj","DYO"],
  "jeans": ["D13","DFk","BjI","BjD","BjE","BjF","BjG","BjH"],
  "jeep": ["BjM","BjJ","BjK","BjL"],
  "jello": ["BjO","BjN"],
  "jelly": ["BjU","BjP"],
  "jellybeans": ["BjR","BjQ"],
  "jellyfish": ["BjT","BjS"],
  "jester": ["BjY","BjV","BjW","BjX"],
  "jet": ["Bjb","BjZ","Bja"],
  "jewel": ["Bje","Bjc","Bjd"],
  "jewelry": ["DrZ"],
  "jewelry store": ["Bjf","Bjg"],
  "jigsaw": ["DFl","Bjj","Bjh","Bji"],
  "jingle bells": ["Bjk","Bjl","Bjm","Bjn"],
  "job": ["Bjo"],
  "jockey": ["Bjr","Bjp","Bjq"],
  "jog": ["Diz","Bj1","Bjs","Bjt","Bju","Bjv","Bjw"],
  "jog jogged": ["Diz"],
  "jogging": ["Diz","Bj0","Bjx","Bjy","Bjz"],
  "join": ["Di0","Bj2"],
  "join a book club": ["Di0"],
  "join joined": ["Di0"],
  "joining": ["Di0"],
  "joining a book club": ["Di0"],
  "joints": ["Bj3"],
  "joke": ["DYP"],
  "jolly": ["DYQ"],
  "journalist": ["EH6","EH7","DFn","DFm","Bj4"],
  "journey": ["Bj8","Bj5","Bj6","Bj7"],
  "joy": ["BkB","Bj9","BkA"],
  "judge": ["BkF","BkC","BkD","BkE"],
  "judo": ["BkK","BkG","BkH","BkI","BkJ"],
  "jug": ["D14","DFo","BkS","BkL","BkM","BkN"],
  "juggle": ["BkP","BkO"],
  "juggler": ["BkR","BkQ"],
  "juice": ["BkV","BkT","BkU"],
  "July": ["Dra"],
  "jump": ["EdX","EYJ","EYI","Di4","Di1","Di2","Di3","Bkg","BkW","BkX","BkY"],
  "jump jumped": ["EVv","ES1","Di3","Di1","Di2","Di4"],
  "jump on a trampoline": ["EYI"],
  "jump out of the water": ["EYJ"],
  "jump over": ["Ea4"],
  "jump over a puddle": ["Ea4","Di3"],
  "jump rope": ["Bkh","Bki","Bkj","Bkk"],
  "jumped": ["EVv","ES1"],
  "jumped on a trampoline": ["EVv"],
  "jumped over a puddle": ["ES1"],
  "jumper": ["Bkd","BkZ","Bka","Bkb","Bkc"],
  "jumping": ["EdX","Di4","Di1","Di2","Di3","Bkf","Bke"],
  "jumping over": ["Ea4"],
  "jumping over a puddle": ["Ea4","Di3"],
  "June": ["Drb"],
  "jungle": ["Bko","Bkl","Bkm","Bkn"],
  "junk food": ["Bkp","Bkq","Bkr"],
  "jupiter": ["Bkt","Bks"],
  "k": ["DZ6","DZ5"],
  "kangaroo": ["D15","DFp","Bkz","Bku","Bkv","Bkw","Bkx","Bky"],
  "karate": ["D16","DFq","Bk3","Bk0","Bk1","Bk2"],
  "kayak": ["Bk9","Bk4","Bk5"],
  "kayaking": ["Bk8","Bk6","Bk7"],
  "kebab": ["Egn"],
  "kebabs": ["D17"],
  "keep": ["BlA"],
  "keep track of money": ["EH8"],
  "Kenya": ["EH9","BlF","BlB","BlC","BlD","BlE"],
  "ketchup": ["D18","DFr","BlI","BlG","BlH"],
  "kettle": ["D19","DFs","BlM","BlJ","BlK","BlL"],
  "key": ["BlV","BlN","BlO","BlP"],
  "keyboard": ["D2A","D2B","DFu","DFt","BlU","BlQ","BlR","BlS","BlT"],
  "keyring": ["BlZ","BlW","BlX","BlY"],
  "keys": ["D2C","DFv","Blb","Bla"],
  "khaki": ["DFw"],
  "kick": ["Ea5","Di5","Blh","Blc","Bld","Ble","Blf","Blg"],
  "kick a ball": ["Ea5","Di5"],
  "kick kicked": ["ES2","Di5"],
  "kicked": ["ES2"],
  "kicked the ball": ["ES2"],
  "kicking": ["Ea5","Di5"],
  "kicking a ball": ["Ea5","Di5"],
  "kid": ["Bll"],
  "kidney": ["Blj","Bli"],
  "kidneys": ["Blk"],
  "kids": ["Blm"],
  "killer whale": ["Bln","Blo","Blp","Blq"],
  "kilogram": ["Bls","Blr"],
  "kind": ["Blt"],
  "king": ["Bl0","Blu","Blv"],
  "king cobra": ["Blw"],
  "kingfisher": ["Blz","Blx","Bly"],
  "kiss": ["Bl4","Bl1","Bl2","Bl3"],
  "kit": ["BmF"],
  "kitchen": ["DFx","Bl8","Bl5","Bl6","Bl7"],
  "kite": ["D2D","DFy","BmE","Bl9","BmA","BmB","BmC"],
  "kite flying": ["BmD"],
  "kites": ["Drc"],
  "kitten": ["BmK","BmG","BmH","BmI","BmJ"],
  "kittens": ["BmM","BmL"],
  "kiwi": ["BmR","BmN","BmO"],
  "kiwi fruit": ["DFz","BmP","BmQ"],
  "kiwifruit": ["D2E"],
  "knead": ["Di6","BmT","BmS"],
  "knead dough": ["Di6"],
  "knead kneaded": ["Di6"],
  "kneading": ["Di6"],
  "kneading dough": ["Di6"],
  "knee": ["D2F","DF0","BmU"],
  "kneel": ["Di7"],
  "kneel down": ["Ea6","Di7"],
  "kneel knelt": ["Di7"],
  "kneeling": ["Di7"],
  "kneeling down": ["Ea6","Di7"],
  "knees": ["Drd"],
  "knife": ["D2G","DF1","BmX","BmV","BmW"],
  "knight": ["Bmb","BmY","BmZ","Bma"],
  "knit": ["EYK","Di8"],
  "knit a scarf": ["EYK"],
  "knit knitted": ["Di8"],
  "knitting": ["Di8","Bme","Bmc","Bmd"],
  "knives": ["Bmf"],
  "know": ["EYL","Di9"],
  "know knew": ["Di9"],
  "know the answer": ["EYL","Di9"],
  "knowing": ["Di9"],
  "knowing the answer": ["Di9"],
  "knowledge": ["Bmg"],
  "knuckle": ["DF2"],
  "knuckles": ["DF3"],
  "koala": ["Bml","Bmh","Bmi","Bmj","Bmk"],
  "Korea": ["EIA","Bmp","Bmm","Bmn","Bmo"],
  "Korea flag": ["DF4"],
  "kumquat": ["Bmt","Bmq","Bmr","Bms"],
  "kung fu": ["Bmu","Bmv","Bmw","Bmx"],
  "l": ["DZ8","DZ7"],
  "lab technician": ["Bm5","Bm6"],
  "laboratory": ["Bm1","Bmy","Bmz","Bm0"],
  "labrador": ["Bm4","Bm2","Bm3"],
  "lace": ["Bm8","Bm7"],
  "laces": ["Bm9"],
  "ladder": ["D2H","DF5","BnD","BnA","BnB","BnC"],
  "ladies": ["BnF","BnE"],
  "ladle": ["Dre"],
  "lady": ["BnS","BnG","BnH","BnI"],
  "ladybird": ["BnN","BnJ","BnK","BnL","BnM"],
  "ladybug": ["BnP","BnO"],
  "ladybugs": ["BnR","BnQ"],
  "lake": ["D2I","DF6","BnY","BnT","BnU","BnV","BnW","BnX"],
  "lamb": ["Ego","D2J","DF7","Bnc","BnZ","Bna","Bnb"],
  "lamp": ["D2K","DF9","DF8","Bnf","Bnd","Bne"],
  "land": ["Bnr","Bng","Bnh","Bni","Bnj"],
  "landfill": ["Bno","Bnk","Bnl","Bnm","Bnn"],
  "landmark": ["Bnq","Bnp"],
  "landscape": ["Drf"],
  "landslide": ["Bnv","Bns","Bnt","Bnu"],
  "lane": ["Bny","Bnw","Bnx"],
  "language": ["Bnz"],
  "languages": ["Bn0"],
  "lantern": ["Bn3","Bn1","Bn2"],
  "lanterns": ["Bn6","Bn4","Bn5"],
  "laptop": ["D2L","D2M","DGB","DGA","BoB","Bn7","Bn8","Bn9","BoA"],
  "large": ["EhE","EhF","EIB","BoD","BoC"],
  "late": ["EIC","BoE"],
  "latte": ["Egp","BoL","BoF","BoG","BoH","BoI","BoJ","BoK"],
  "Latvia": ["EID"],
  "laugh": ["DjA","BoS","BoM","BoN"],
  "laugh laughed": ["DjA"],
  "laughing": ["DjA","BoR","BoO","BoP","BoQ"],
  "laughter": ["BoW","BoT","BoU","BoV"],
  "laundromat": ["BoZ","BoX","BoY"],
  "laundry": ["Bod","Boa","Bob","Boc"],
  "laundry room": ["Drg"],
  "lava": ["Bog","Boe","Bof"],
  "lavender": ["Boi","Boh"],
  "lawn": ["Bou","Boj","Bok","Bol","Bom","Bon"],
  "lawn mower": ["D2N","DGC","Boo","Bop","Boq","Bor","Bos","Bot"],
  "lawyer": ["EIE","EIF","DGE","DGD","Boy","Bov","Bow","Box"],
  "lay": ["EYN","ES3","DjB"],
  "lay down": ["ES3"],
  "lay eggs": ["EYN","DjB"],
  "lay laid": ["DjB"],
  "lay out": ["Ea7","DjC"],
  "lay out a table": ["DjC"],
  "lay out laid out": ["DjC"],
  "lay out the table": ["Ea7"],
  "layers": ["Boz"],
  "laying": ["DjB"],
  "laying eggs": ["DjB"],
  "laying out": ["Ea7","DjC"],
  "laying out a table": ["DjC"],
  "lazy": ["Bo3","Bo0","Bo1","Bo2"],
  "leaf": ["D2O","DGF","Bo7","Bo4","Bo5","Bo6"],
  "learn": ["EYO","DjE","DjD","Bo9","Bo8"],
  "learn Japanese": ["EYO","DjD"],
  "learn learned": ["ET8","DjD"],
  "learn learnt": ["DjE"],
  "learn maths": ["DjE"],
  "learn to drive": ["EIG"],
  "learned": ["ET8"],
  "learned maths": ["ET8"],
  "learning": ["DjE","DjD"],
  "learning Japanese": ["DjD"],
  "learning maths": ["DjE"],
  "leash": ["BpD","BpA","BpB","BpC"],
  "leather": ["BpF","BpE"],
  "leave": ["Ea8","EYP","DjF","DjG","DjH"],
  "leave left": ["ES4","DjF","DjG","DjH"],
  "leave school": ["EIH","DjG"],
  "leave work": ["EYP","DjH"],
  "leaves": ["BpK","BpG","BpH","BpI","BpJ"],
  "leaving": ["Ea8","DjF","DjG","DjH"],
  "leaving school": ["DjG"],
  "leaving work": ["DjH"],
  "lecturer": ["BpM","BpL"],
  "leek": ["BpO","BpN"],
  "left": ["ES4"],
  "leg": ["D2P","DGH","BpU","BpP"],
  "leggings": ["DGG"],
  "lego": ["BpT","BpQ","BpR","BpS"],
  "legs": ["DGJ","DGI","BpX","BpV","BpW"],
  "lemon": ["D2R","DGL","Bpg","BpY","BpZ","Bpa"],
  "lemon juice": ["Bpe","Bpf"],
  "lemon tea": ["DGN","Bpm","Bpn","Bpo","Bpp"],
  "lemonade": ["D2Q","DGK","Bpd","Bpb","Bpc"],
  "lemons": ["Egq","DGM","Bpl","Bph","Bpi","Bpj","Bpk"],
  "lend": ["EYQ","Bpr","Bpq"],
  "lend a book": ["EYQ","DjI"],
  "lend lent": ["DjI"],
  "lending a book": ["DjI"],
  "length": ["Bps"],
  "lentils": ["Bpx","Bpt","Bpu","Bpv","Bpw"],
  "leopard": ["Bp2","Bpy","Bpz","Bp0","Bp1"],
  "let go": ["Drh"],
  "letter": ["D2S","DGO"],
  "letter a": ["DZm"],
  "letter b": ["DZo"],
  "letter c": ["DZq"],
  "letter d": ["DZs"],
  "letter e": ["DZu"],
  "letter f": ["DZw"],
  "letter g": ["DZy"],
  "letter h": ["DZ0"],
  "letter i": ["DZ2"],
  "letter j": ["DZ4"],
  "letter k": ["DZ6"],
  "letter l": ["DZ8"],
  "letter m": ["DaA"],
  "letter n": ["DaC"],
  "letter o": ["DaE"],
  "letter p": ["DaG"],
  "letter q": ["DaI"],
  "letter r": ["DaK"],
  "letter s": ["DaM"],
  "letter t": ["DaO"],
  "letter u": ["DaQ"],
  "letter v": ["DaS"],
  "letter w": ["DaU"],
  "letter x": ["DaW"],
  "letter y": ["DaY"],
  "letter z": ["Daa"],
  "letters": ["Bp6","Bp3","Bp4","Bp5"],
  "lettuce": ["D2T","DGP","BqA","Bp7","Bp8","Bp9"],
  "level": ["BqB"],
  "librarian": ["BqC"],
  "library": ["DGQ","BqF","BqD","BqE"],
  "Libya": ["EII"],
  "licence": ["BqG"],
  "license": ["BqG"],
  "lick": ["BqI","BqH"],
  "lid": ["BqN","BqJ","BqK","BqL","BqM"],
  "lie": ["BqP","BqO"],
  "lie down": ["EbC","EYR","EIJ","DjJ","DjK"],
  "lie down lay down": ["DjK"],
  "lie down on the sofa": ["EYR"],
  "lie lay": ["ES3","DjJ"],
  "life jacket": ["BqZ","Bqa"],
  "lifebelt": ["BqS","BqQ","BqR"],
  "lifeboat": ["BqV","BqT","BqU"],
  "lifeguard": ["EIK","EIL","DGS","DGR","BqY","BqW","BqX"],
  "lift": ["Ea9","EYS","DjL","DjM","Bqd","Bqb","Bqc"],
  "lift lifted": ["ES5","DjL","DjM"],
  "lift weights": ["Ea9","EYS","EIN","EIM","DjM","Bqe","Bqf"],
  "lift weights easily": ["ERH"],
  "lifted": ["ES5"],
  "lifted weights": ["ES5"],
  "lifting": ["Ea9","DjL","DjM"],
  "lifting weights": ["Ea9","DjM"],
  "light": ["EIO","D2Y","DjN","DGc","Bqv","Bqg","Bqh","Bqi"],
  "light a candle": ["DjN"],
  "light blue": ["DGT"],
  "light brown": ["DGU"],
  "light bulb": ["D2U","DGV","Bqj","Bqk"],
  "light bulbs": ["Bql","Bqm"],
  "light green": ["DGY"],
  "light lighted": ["ETb","DjN"],
  "light red": ["DGd"],
  "lighted": ["ETb"],
  "lighted a candle": ["ETb"],
  "lighter": ["ER2","D2V","DGX","DGW"],
  "lighthouse": ["D2W","DGZ","Bqr","Bqn","Bqo","Bqp","Bqq"],
  "lighting": ["DjN"],
  "lighting a candle": ["DjN"],
  "lightning": ["D2X","DGb","DGa","Bqu","Bqs","Bqt"],
  "lights": ["Bqz","Bqw","Bqx","Bqy"],
  "like": ["EYU","EYT","DjQ","DjO","DjP","Bq1","Bq0"],
  "like apples": ["EYT","DjO"],
  "like chocolate": ["Efl"],
  "like doing exercise": ["Efm"],
  "like football": ["EYU","DjP"],
  "like giving gifts": ["Efn"],
  "like icecream": ["DjQ"],
  "like liked": ["ET9","DjO","DjP","DjQ"],
  "like listening to music": ["Efo"],
  "like milk": ["Efp"],
  "like pizza": ["Efq"],
  "like playing the drums": ["Efr"],
  "like reading books": ["Efs"],
  "like surfing": ["Eft"],
  "liked": ["ET9"],
  "liked ice cream": ["ET9"],
  "liking": ["DjQ","DjO","DjP"],
  "lily": ["Bq4","Bq2","Bq3"],
  "lime": ["Egr","D2Z","DGe","BrB","Bq5","Bq6","Bq7"],
  "lime juice": ["Bq8","Bq9","BrA"],
  "limes": ["DGf","BrD","BrC"],
  "limo": ["D2a","DGg"],
  "line": ["D2b","DGh"],
  "line up": ["Dri"],
  "link": ["BrE"],
  "lion": ["D2c","DGi","BrJ","BrF","BrG","BrH","BrI"],
  "lions": ["BrN","BrK","BrL","BrM"],
  "lip": ["Drj"],
  "lip stick": ["DGj"],
  "lips": ["BrS","BrO","BrP","BrQ","BrR"],
  "lipstick": ["D2d","BrW","BrT","BrU","BrV"],
  "liquid": ["BrZ","BrX","BrY"],
  "list": ["Drl"],
  "listen": ["EdY","EYV","EIP","DjR","DjS","Brd","Bra","Brb"],
  "listen carefully": ["ERI"],
  "listen listened": ["EWM","EU4","DjR","DjS"],
  "listen to": ["Drk"],
  "listen to music": ["EdY","EYV","DjS","Bre","Brf","Brg"],
  "listen to people's problems": ["EIQ"],
  "listened": ["EWM","EU4"],
  "listened to music": ["EWM","EU4"],
  "listening": ["EdY","DjR","DjS"],
  "listening to music": ["EdY","DjS","Brc"],
  "literature": ["Brk","Brh","Bri","Brj"],
  "Lithuania": ["EIR","Bro","Brl","Brm","Brn"],
  "litter": ["Brs","Brp","Brq","Brr"],
  "little": ["EIS"],
  "little brother": ["Brt"],
  "little sister": ["Bru"],
  "live": ["EYW","DjT"],
  "live in London": ["EYW","DjT"],
  "live lived": ["EVt","DjT"],
  "lived": ["EVt"],
  "lived in London": ["EVt"],
  "liver": ["Brw","Brv"],
  "Liverpool": ["Drm"],
  "living": ["DjT"],
  "living in London": ["DjT"],
  "living room": ["DGk","Brx","Bry","Brz","Br0","Br1","Br2"],
  "lizard": ["D2e","DGl","Br7","Br3","Br4","Br5","Br6"],
  "llama": ["Drn"],
  "loaf": ["Dro"],
  "loaf of bread": ["Br8","Br9","BsA","BsB"],
  "loaves": ["BsF","BsC","BsD","BsE"],
  "lobby": ["BsJ","BsG","BsH","BsI"],
  "lobster": ["D2f","DGm","BsP","BsK","BsL","BsM","BsN","BsO"],
  "lock": ["EbA","EYX","DjV","DjU","Bsb","BsQ","BsR","BsS"],
  "lock a door": ["DjU"],
  "lock locked": ["ETc","DjU","DjV"],
  "lock the door": ["EbA","EYX","DjV"],
  "locked": ["ETc"],
  "locked the door": ["ETc"],
  "locker": ["BsW","BsT","BsU","BsV"],
  "lockers": ["D2g","DGn"],
  "locket": ["Bsa","BsX","BsY","BsZ"],
  "locking": ["EbA","DjV","DjU"],
  "locking a door": ["DjU"],
  "locking the door": ["EbA","DjV"],
  "locust": ["Bsc"],
  "lodge": ["Bsf","Bsd","Bse"],
  "log": ["Bsh","Bsg"],
  "logo": ["Drp"],
  "logs": ["Bsj","Bsi"],
  "lollipop": ["D2h","Bso","Bsk","Bsl","Bsm","Bsn"],
  "lollipops": ["Drq"],
  "London": ["Drr"],
  "lonely": ["Bss","Bsp","Bsq","Bsr"],
  "long": ["Ehn","Eho","EIT","DGr","Bsy"],
  "long hair": ["Eho","Ehn","Bst","Bsu","Bsv","Bsw"],
  "long jump": ["D2i","DGq"],
  "long neck": ["Bsx"],
  "longer": ["ER3","DGp","DGo"],
  "look": ["EYZ","EYY","Dja","DjX","Bs4","Bsz"],
  "look after": ["EcQ","EIX","DjW","Bs0"],
  "look after animals": ["EIU"],
  "look after children": ["EcQ","EIV"],
  "look after looked after": ["DjW"],
  "look after passengers": ["EIW"],
  "look after sick people": ["EIY"],
  "look at": ["EdZ","EbB","EIa","DjY","DjZ","Bs1","Bs2","Bs3"],
  "look at a clock": ["DjY"],
  "look at a picture": ["EIZ"],
  "look at art": ["EYY"],
  "look at each other": ["EdZ","DjZ"],
  "look at looked at": ["DjX"],
  "look at pictures": ["DjX"],
  "look at the clock": ["EbB"],
  "look closely": ["ERJ"],
  "look in the mirror": ["EYZ","Dja"],
  "look looked": ["EU5","DjY","DjZ","Dja"],
  "look through": ["Djb"],
  "look through a telescope": ["Djb"],
  "looked": ["EU5"],
  "looked at each other": ["EU5"],
  "looking": ["Dja","DjX"],
  "looking after": ["EcQ","DjW"],
  "looking at": ["EdZ","EbB","DjY","DjZ"],
  "looking at a clock": ["DjY"],
  "looking at each other": ["EdZ","DjZ"],
  "looking at pictures": ["DjX"],
  "looking in the mirror": ["Dja"],
  "looking through": ["Djb"],
  "looking through a telescope": ["Djb"],
  "lorry": ["Bs9","Bs5","Bs6","Bs7","Bs8"],
  "lose": ["Djc"],
  "lose lost": ["EVX","ES6","Djc"],
  "lose the game": ["Djc"],
  "losing": ["Djc"],
  "losing the game": ["Djc"],
  "lost": ["EVX","ES6"],
  "lost the game": ["EVX","ES6"],
  "lotus": ["BtB","BtA"],
  "loud": ["DGs","BtF","BtC","BtD","BtE"],
  "love": ["EYa","Djd","BtJ","BtG","BtH","BtI"],
  "love cats": ["EYa"],
  "love loved": ["Djd"],
  "love the cat": ["Djd"],
  "lovely": ["Drs"],
  "loving": ["Djd"],
  "lower": ["ER4","DGt"],
  "loyal": ["BtK"],
  "luck": ["BtL"],
  "lucky": ["BtM"],
  "lucky money": ["Drt"],
  "luggage": ["D2j","DGu","BtS","BtN","BtO","BtP","BtQ","BtR"],
  "lumberjack": ["EIb","EIc","D2k","DGw","DGv"],
  "lunch": ["BtW","BtT"],
  "lunch box": ["BtU","BtV"],
  "lunchbox": ["Dru"],
  "lungs": ["BtZ","BtX","BtY"],
  "Luxembourg": ["Btc","Bta","Btb"],
  "luxury": ["Btf","Btd","Bte"],
  "lychee": ["Btj","Btg","Bth","Bti"],
  "lying down": ["EbC","DjJ","DjK"],
  "m": ["DaA","DZ9"],
  "machine": ["Btn","Btk","Btl","Btm"],
  "machu picchu": ["Bto"],
  "mad": ["Btt","Btp"],
  "mad as hell": ["EIe","EIf","EIg"],
  "Madagascar": ["EId","Bts","Btq","Btr"],
  "made": ["EVa","EWI","EVZ","ES7"],
  "made a sandwich": ["EVZ"],
  "made a snowman": ["EWI"],
  "made a speech": ["EVa"],
  "made coffee": ["ES7"],
  "magazine": ["Btx","Btu","Btv","Btw"],
  "magazines": ["Bty"],
  "magenta": ["DGx"],
  "magic": ["Bt5","Btz","Bt0"],
  "magician": ["EIh","EIi","DGz","DGy","Bt4","Bt1","Bt2","Bt3"],
  "magnet": ["D2l","DG0","Bt9","Bt6","Bt7","Bt8"],
  "magnifying glass": ["BuA","BuB","BuC","BuD","BuE","BuF"],
  "mahjong": ["BuI","BuG","BuH"],
  "maid": ["EIj","EIk","DG2","DG1","BuL","BuJ","BuK"],
  "mail": ["BuU","BuM","BuN"],
  "mail carrier": ["Drv"],
  "mailbox": ["BuS","BuO","BuP","BuQ","BuR"],
  "mailman": ["EIl","EIm","D2m","DG4","DG3","BuT"],
  "main course": ["Drw"],
  "maintain a building": ["EIn"],
  "maize": ["BuX","BuV","BuW"],
  "majority": ["Drx"],
  "make": ["EbE","EbD","EYd","EYc","EYb","Djj","Dje","Djf","Djg","Djh","Dji"],
  "make a cake": ["Dry"],
  "make a model": ["Dje"],
  "make a model plane": ["EYb"],
  "make a sandwich": ["EbD","EIo","Djf"],
  "make a snowman": ["Drz"],
  "make a speech": ["EYc","EIp","Djg"],
  "make a web": ["EYd","Djh"],
  "make a website": ["EIq"],
  "make bread": ["EIr"],
  "make clothes": ["EIs"],
  "make coffee": ["EbE","EIt","Dji"],
  "make computer software": ["EIu"],
  "make drinks": ["EIv"],
  "make friends": ["Dr0"],
  "make made": ["EVa","EWI","EVZ","ES7","Dje","Djf","Djh","Dji","Djj"],
  "make music": ["EIw"],
  "make my bed": ["Dr1","Dr2"],
  "make some food": ["Djj"],
  "make things with wood": ["EIx"],
  "make websites": ["EIy"],
  "making": ["EbE","EbD","Djj","Dje","Djf","Djg","Djh","Dji"],
  "making a model": ["Dje"],
  "making a sandwich": ["EbD","Djf"],
  "making a speech": ["Djg"],
  "making a web": ["Djh"],
  "making coffee": ["EbE","Dji"],
  "making some food": ["Djj"],
  "Malaysia": ["EIz","Bua","BuY","BuZ"],
  "Malaysia flag": ["DG5"],
  "Mali": ["EI0"],
  "mall": ["Bui","Bub","Buc","Bud","Bue"],
  "mallet": ["Buh","Buf","Bug"],
  "mammal": ["DG6"],
  "mammals": ["EI1","Dr3"],
  "mammoth": ["Bum","Buj","Buk","Bul"],
  "man": ["Dr6"],
  "manage": ["Dr4"],
  "manage a hotel": ["EI2"],
  "manage a sports team": ["EI3"],
  "manager": ["Dr5"],
  "mandolin": ["Buq","Bun","Buo","Bup"],
  "mane": ["DG7","But","Bur","Bus"],
  "mango": ["Egs","DG9","Buz","Buu","Buv","Buw","Bux","Buy"],
  "mangoes": ["D2n","DG8"],
  "mangosteen": ["Bu4","Bu0","Bu1","Bu2","Bu3"],
  "mantis": ["Bu8","Bu5","Bu6","Bu7"],
  "manufacture": ["BvA","Bu9"],
  "many": ["Dr7"],
  "many hands make light work": ["EI4","EI5","EI6"],
  "map": ["D2o","DHA","BvD","BvB","BvC"],
  "marathon": ["BvG","BvE","BvF"],
  "marble": ["BvJ","BvH","BvI"],
  "marbles": ["BvN","BvK","BvL","BvM"],
  "march": ["BvP","BvO"],
  "March": ["Dr8"],
  "marigold": ["BvS","BvQ","BvR"],
  "marine": ["BvT"],
  "marker": ["D2p","DHB","BvW","BvU","BvV"],
  "markers": ["BvY","BvX"],
  "market": ["Bvd","BvZ","Bva","Bvb","Bvc"],
  "marriage": ["Bvh","Bve","Bvf","Bvg"],
  "married": ["Bvi"],
  "marry": ["Bvl","Bvj","Bvk"],
  "mars": ["Bvs","Bvm","Bvn"],
  "marshmallow": ["Bvr","Bvo","Bvp","Bvq"],
  "martian": ["Bvt"],
  "mascot": ["Bvv","Bvu"],
  "mashed potatoes": ["Bvw","Bvx","Bvy"],
  "mask": ["Bv2","Bvz","Bv0","Bv1"],
  "massage": ["EYe","Djk"],
  "massage massaged": ["Djk"],
  "massage people": ["EI7"],
  "massage someone": ["EYe"],
  "massaging": ["Djk"],
  "masseuse": ["EI8","EI9","D2q","DHD","DHC"],
  "mat": ["BwJ","Bv3","Bv4"],
  "match": ["BwD","Bv5","Bv6","Bv7"],
  "matchbox": ["Bv9","Bv8"],
  "matches": ["BwC","BwA","BwB"],
  "math": ["BwG","BwE"],
  "mathematics": ["BwF"],
  "maths": ["EdF","D2r","DHE","BwI","BwH"],
  "mature": ["BwK"],
  "maximum speed": ["BwL"],
  "May": ["DsA"],
  "mayo": ["BwN"],
  "mayonnaise": ["BwM"],
  "mayor": ["Dr9"],
  "meal": ["BwQ","BwO","BwP"],
  "mean": ["DsB"],
  "measure": ["BwS","BwR"],
  "meat": ["Bwb","BwT","BwU","BwV"],
  "meatball": ["BwW"],
  "meatballs": ["Bwa","BwX","BwY","BwZ"],
  "mechanic": ["EJA","EJD","D2s","DHI","DHF","Bwf","Bwc","Bwd","Bwe"],
  "mechanical engineer": ["EJC","EJB","DHG","DHH"],
  "medal": ["D2t","DHJ","Bwi","Bwg","Bwh"],
  "medals": ["Bwk","Bwj"],
  "media": ["DsC"],
  "medicine": ["D2u","DHK","Bwo","Bwl","Bwm","Bwn"],
  "meerkat": ["Bws","Bwp","Bwq","Bwr"],
  "meet": ["Eda","Djl"],
  "meet each": ["Eda"],
  "meet each other": ["Eda"],
  "meet friends": ["DsD"],
  "meet met": ["EU6","Djl"],
  "meet someone": ["Djl"],
  "meeting": ["Eda","Djl","Bwv","Bwt","Bwu"],
  "meeting room": ["Bww","Bwx","Bwy"],
  "meeting someone": ["Djl"],
  "melancholy": ["Bw3","Bwz","Bw0","Bw1","Bw2"],
  "melon": ["Bw7","Bw4","Bw5","Bw6"],
  "melt": ["BxA","Bw8","Bw9"],
  "memory": ["BxB"],
  "memory stick": ["DsE"],
  "mend": ["BxC"],
  "mental": ["BxD"],
  "menu": ["DsF"],
  "mercury": ["DsH","DsG"],
  "mermaid": ["DHL","BxH","BxE","BxF","BxG"],
  "merry go round": ["DsI"],
  "mess": ["DsK"],
  "message": ["DsJ"],
  "messages": ["DHM"],
  "messier": ["ER5","DHN"],
  "messily": ["ERG"],
  "messy": ["Ehp","EJE","DHO","BxK","BxI","BxJ"],
  "messy bathroom": ["Ehp"],
  "met": ["EU6"],
  "metal": ["BxP","BxL","BxM","BxN"],
  "metal detector": ["BxO"],
  "meteor": ["BxS","BxQ","BxR"],
  "metropolitan": ["BxU","BxT"],
  "Mexican": ["EeR","DHP"],
  "Mexico": ["EJF","D2v","DHR","BxZ","BxV","BxW","BxX","BxY"],
  "Mexico flag": ["DHQ"],
  "mice": ["Bxb","Bxa"],
  "microchip": ["Bxd","Bxc"],
  "microphone": ["D2w","DHS","Bxh","Bxe","Bxf","Bxg"],
  "microscope": ["D2x","DHT","Bxl","Bxi","Bxj","Bxk"],
  "microwave": ["D2y","DHU","Bxp","Bxm","Bxn","Bxo"],
  "microwave oven": ["DsL"],
  "middle": ["DdS"],
  "midnight": ["DsM"],
  "mild": ["DHW","DHV"],
  "milk": ["D2z","DHX","Bxt","Bxq","Bxr","Bxs"],
  "milkshake": ["D20","Bxw","Bxu","Bxv"],
  "milkshakes": ["Bxy","Bxx"],
  "milky way": ["Bxz"],
  "millipede": ["Bx3","Bx0","Bx1","Bx2"],
  "mime": ["Bx4"],
  "minecraft": ["Bx5"],
  "miner": ["ByA"],
  "mineral water": ["Bx6","Bx7","Bx8","Bx9"],
  "mini": ["ByC"],
  "mini car": ["ByB"],
  "minivan": ["ByD"],
  "mints": ["DHY"],
  "minus": ["ByE"],
  "mirror": ["D21","D22","DHa","DHZ","ByI","ByF","ByG","ByH"],
  "miserable": ["ByJ"],
  "mistake": ["DsN"],
  "mistletoe": ["EJG","ByL","ByK"],
  "mittens": ["D23","DHb","ByO","ByM","ByN"],
  "mix": ["ByQ","ByP"],
  "mixer": ["D24","DHc"],
  "mixture": ["DsO"],
  "mobile": ["DsP"],
  "mobile game": ["DHd"],
  "mobile phone": ["ByR","ByS","ByT"],
  "model": ["EYf","EJH","EJJ","Djm","DHg","DHe","ByV","ByU"],
  "model clothes": ["EYf","EJI","Djm"],
  "model modeled": ["Djm"],
  "model plane": ["DHf"],
  "modeling": ["Djm"],
  "modeling clothes": ["Djm"],
  "modern": ["ByX","ByW"],
  "moisture": ["Bya","ByY","ByZ"],
  "mole": ["Byd","Byb","Byc"],
  "mollusca": ["DHh"],
  "molten": ["Byh","Bye","Byf","Byg"],
  "mom": ["Byj","Byi"],
  "mona lisa": ["Byn"],
  "Monaco": ["Bym","Byk","Byl"],
  "Monday": ["DHk","DHi","DHj"],
  "money": ["D25","DHl","Byp","Byo"],
  "Mongolia": ["EJK"],
  "Mongolia flag": ["DHm"],
  "monitor": ["D26","Byt","Byq","Byr","Bys"],
  "monkey": ["D27","DHn","Byw","Byu","Byv"],
  "monkeys": ["Byx"],
  "monster": ["DsQ"],
  "Montenegro": ["EJL"],
  "monument": ["By0","Byy","Byz"],
  "moon": ["D6r","DOj","By9","By1","By2","By3","By4"],
  "moon cake": ["DsR"],
  "mooncake": ["By8","By5","By6","By7"],
  "moose": ["DsS"],
  "mop": ["EYg","D29","Djn","DHp","BzI","BzA","BzB","BzC"],
  "mop mopped": ["Djn"],
  "mop the floor": ["EYg","Djn","BzJ"],
  "moped": ["D28","DHo","BzH","BzD","BzE","BzF","BzG"],
  "mopping": ["Djn"],
  "mopping the floor": ["Djn"],
  "more beautiful": ["ERa","DHq","DHr"],
  "more boring": ["ERc","DHs"],
  "more casual": ["ERf","DHt"],
  "more colorful": ["ERj","DHu","DHv"],
  "more colourful": ["ERj","DHu","DHv"],
  "more dangerous": ["ERk","DHw"],
  "more difficult": ["ERn","DHx"],
  "more exciting": ["ERr","DHy"],
  "more expensive": ["ERs","DHz","DH0"],
  "more formal": ["ERv","DH1"],
  "morning": ["DYR","BzM"],
  "morning glory": ["BzK","BzL"],
  "Morocco": ["EJM","BzP","BzN","BzO"],
  "mortgage": ["BzQ"],
  "mosque": ["BzR"],
  "mosquito": ["BzV","BzS","BzT","BzU"],
  "motel": ["BzY","BzW","BzX"],
  "moth": ["Bzd","BzZ","Bza"],
  "mother": ["EJO","DZa","Bzc","Bzb"],
  "mother in law": ["EJN","DZZ"],
  "motherinlaw": ["EJN"],
  "motorbike": ["D3A","DH2","Bzi","Bze","Bzf","Bzg","Bzh"],
  "motorboat": ["Bzm","Bzj","Bzk","Bzl"],
  "motorcycle": ["Bzp","Bzn","Bzo"],
  "motorhome": ["Bzt","Bzq","Bzr","Bzs"],
  "mountain": ["EdA","D3B","DH3","B0A","Bzu","Bzv","Bzw","Bzx","Bzy"],
  "mountain bike": ["Bzz","Bz0","Bz1","Bz2","Bz3"],
  "mountain biking": ["Bz4","Bz5","Bz6"],
  "mountainous": ["Bz9","Bz7","Bz8"],
  "mountains": ["B0D","B0B","B0C"],
  "mouse": ["EdB","D3C","D3D","DH5","DH4","B0I","B0E","B0F","B0G","B0H"],
  "mousetrap": ["B0K","B0J"],
  "moustache": ["D3E","DH6","B0M","B0L"],
  "mouth": ["D3F","DH7","B0Q","B0N","B0O","B0P"],
  "move": ["Edb","EcR","EYh","Djo","Djp","Djq","B0R"],
  "move a chair": ["Edb","Djo"],
  "move a sofa": ["EYh"],
  "move luggage": ["EJP"],
  "move moved": ["EU7","Djo","Djp","Djq"],
  "move the mouse": ["EcR","Djp"],
  "move the sofa": ["Djq"],
  "moved": ["EU7"],
  "moved an armchair": ["EU7"],
  "movie": ["B0T","B0S"],
  "movie theater": ["D3G","DH8","B0U"],
  "movies": ["DsT"],
  "moving": ["Edb","EcR","Djq","Djo","Djp"],
  "moving a chair": ["Edb","Djo"],
  "moving the mouse": ["EcR","Djp"],
  "moving the sofa": ["Djq"],
  "Mozambique": ["EJQ"],
  "mp player": ["B0V","B0W"],
  "mud": ["B0b","B0X","B0Y","B0Z","B0a"],
  "muffin": ["D3H","DH9","B0h","B0c","B0d","B0e","B0f","B0g"],
  "muffins": ["DsU"],
  "mug": ["D3I","DIA","B0n","B0i","B0j","B0k","B0l","B0m"],
  "mule": ["B0p","B0o"],
  "multiply": ["B0q"],
  "mum": ["EJT","B0s","B0r"],
  "mummies": ["EJR"],
  "mummy": ["EJS","DsV"],
  "muscle": ["B0u","B0t"],
  "muscles": ["DsW"],
  "muscular": ["B0w","B0v"],
  "museum": ["B0z","B0x","B0y"],
  "mushroom": ["Egt","B04","B00","B01","B02","B03"],
  "mushrooms": ["D3J","DIB","B08","B05","B06","B07"],
  "music": ["D3L","DIE","B1I","B09","B1A","B1B","B1C","B1D"],
  "music room": ["DsY"],
  "musical": ["DsX"],
  "musician": ["EJU","EJV","D3K","DID","DIC","B1H","B1E","B1F","B1G"],
  "musketeer": ["B1J"],
  "musketeers": ["B1K"],
  "mustache": ["D3E","DH6","B0M","B0L"],
  "mustard": ["DIF","B1O","B1L","B1M","B1N"],
  "mute": ["B1Q","B1P"],
  "my aunt": ["D85","DZK"],
  "my boyfriend": ["D9l","DZL"],
  "my brother": ["D9r","DZM"],
  "my cousin": ["EBV","DZN"],
  "my cousins": ["DZO"],
  "my daughter": ["EBt","DZQ"],
  "my daughter in law": ["EBu","DZP"],
  "my family": ["DZR"],
  "my father": ["EDb","DZT"],
  "my father in law": ["EDa","DZS"],
  "my granddaughter": ["EEr","DZU"],
  "my grandfather": ["EEs","DZV"],
  "my grandmother": ["EEt","DZW"],
  "my grandson": ["EEu","DZX"],
  "my husband": ["EGi","DZY"],
  "my mother": ["EJO","DZa"],
  "my mother in law": ["EJN","DZZ"],
  "my nephew": ["EJb","DZb"],
  "my niece": ["EJk","DZc"],
  "my parents": ["EKN","DZd"],
  "my sister": ["EM2","DZe"],
  "my son": ["ENV","DZg"],
  "my son in law": ["ENW","DZf"],
  "my twin sister": ["EPW","DZh"],
  "my uncle": ["EPZ","DZi"],
  "my wife": ["EQo","DZj"],
  "Myanmar": ["EJW","B1U","B1R","B1S"],
  "Myanmar flag": ["B1T"],
  "mysterious": ["B1W","B1V"],
  "n": ["DaC","DaB"],
  "nail": ["D3N","DIH","B1Z","B1X"],
  "nail clippers": ["D3M","DIG","B1Y"],
  "nail polish": ["B1a","B1b","B1c","B1d"],
  "nails": ["B1g","B1e","B1f"],
  "Namibia": ["EJX"],
  "nanny": ["EJY","EJZ","DIJ","DII","B1h"],
  "nap": ["B1n","B1i","B1j"],
  "napkin": ["B1m","B1k","B1l"],
  "napkins": ["DsZ"],
  "narrow": ["B1o"],
  "nationality": ["Dsa"],
  "natural": ["B1r","B1p","B1q"],
  "nature": ["B1u","B1s","B1t"],
  "naughty": ["B1v"],
  "navigate": ["B1x","B1w"],
  "neat": ["B1y"],
  "neck": ["D3P","DIM","B15","B1z","B10"],
  "necklace": ["D3O","DIL","DIK","B14","B11","B12","B13"],
  "necktie": ["B17","B16"],
  "nectarine": ["B2A","B18","B19"],
  "needle": ["D3Q","DIO","B2D","B2B","B2C"],
  "needle and thread": ["DIN"],
  "neighbor": ["Dsc","Dsb"],
  "neighborhood": ["B2G","B2E","B2F"],
  "neighbour": ["Dsc","Dsb"],
  "neon sign": ["B2H","B2I","B2J"],
  "Nepal": ["EJa"],
  "nephew": ["EJb","DZb"],
  "neptune": ["B2K"],
  "nervous": ["EJc","EJd","DIP"],
  "nest": ["B2O","B2L","B2M","B2N"],
  "net": ["B2S","B2P","B2Q","B2R"],
  "Netherlands": ["EJe"],
  "Netherlands flag": ["DIQ"],
  "new": ["EJf"],
  "new year party": ["B2b"],
  "New York": ["EJg","Dsf"],
  "New zealand": ["EJh","B2c","B2d","B2e","B2f"],
  "newer": ["ER6","DIR"],
  "news": ["Dse"],
  "news reporter": ["B2W","B2X"],
  "newsagents": ["Dsd"],
  "newspaper": ["D3R","DIS","B2V","B2T","B2U"],
  "newt": ["B2a","B2Y","B2Z"],
  "next": ["Dsg"],
  "next to": ["Efv","Efu","DdT","DdU","DdV"],
  "next to the bookcase": ["Efu"],
  "next to the stove": ["Efv"],
  "Nicaragua": ["EJj"],
  "niece": ["EJk","DZc"],
  "Nigeria": ["EJl","B2i","B2g","B2h"],
  "Nigeria flag": ["DIT"],
  "night": ["B2p","B2j","B2k"],
  "night market": ["B2n","B2o"],
  "nightmare": ["B2m","B2l"],
  "nine": ["DbY","DbW"],
  "nine hundred": ["DbX"],
  "nine o'clock": ["EfW","DeJ"],
  "nine thousand": ["Dbb"],
  "nineteen": ["Dba","DbZ"],
  "ninety": ["Dbi","Dbc"],
  "ninety eight": ["Dbd"],
  "ninety five": ["Dbe"],
  "ninety four": ["Dbf"],
  "ninety nine": ["Dbg"],
  "ninety one": ["Dbh"],
  "ninety seven": ["Dbj"],
  "ninety six": ["Dbk"],
  "ninety thousand": ["Dbl"],
  "ninety three": ["Dbm"],
  "ninety two": ["Dbn"],
  "no entry": ["B2q"],
  "no parking": ["Dsi"],
  "noisier": ["ER7","DIU"],
  "noisily": ["ERT"],
  "noisy": ["Ehq","EJm","B2r"],
  "noodle soup": ["B2w","B2x","B2y","B2z"],
  "noodles": ["D3S","DIV","B20","B2s","B2t","B2u","B2v"],
  "noon": ["Dsh"],
  "North america": ["B21"],
  "North Korea": ["EJn"],
  "northern lights": ["B22","B23"],
  "Norway": ["EJo","B28","B24","B25","B26","B27"],
  "nose": ["D3U","DIX","B3A","B29"],
  "nose bleed": ["D3T","DIW"],
  "note": ["B3E"],
  "notebook": ["B3D","B3B","B3C"],
  "notepad": ["D3V","DIY"],
  "notes": ["B3G","B3F"],
  "nothing": ["Dsj"],
  "notice": ["Dsk"],
  "novel": ["B3K","B3H","B3I","B3J"],
  "November": ["Dsl"],
  "now": ["Dsm"],
  "nuclear engineer": ["EJq","EJp","DIZ","DIa"],
  "nuggets": ["B3M","B3L"],
  "numbers": ["B3P","B3N","B3O"],
  "nurse": ["EJr","EJs","D3W","DIc","DIb","B3S","B3Q","B3R"],
  "nut": ["B3T"],
  "nuts": ["DId","B3X","B3U","B3V","B3W"],
  "o": ["DaE","DaD"],
  "oar": ["B3Z","B3Y"],
  "oasis": ["B3c","B3a","B3b"],
  "oats": ["B3g","B3d","B3e","B3f"],
  "obedient": ["B3h"],
  "obelisk": ["B3k","B3i","B3j"],
  "oboe": ["B3n","B3l","B3m"],
  "observation": ["B3p","B3o"],
  "observatory": ["B3q"],
  "observe": ["B3s","B3r"],
  "obsidian": ["B3v","B3t","B3u"],
  "obstacle": ["B3y","B3w","B3x"],
  "ocean": ["B31","B3z","B30"],
  "octagon": ["B33","B32"],
  "October": ["Dsn"],
  "octopus": ["D3X","DIe","B39","B34","B35","B36","B37","B38"],
  "odd": ["Dso"],
  "offer": ["B4B","B4A"],
  "office": ["DIf","B4H","B4C","B4D","B4E","B4F","B4G"],
  "office worker": ["EJu","EJt","DIg","DIh","B4I","B4J"],
  "office workers": ["B4K"],
  "often": ["DYS"],
  "oil": ["B4P","B4L","B4M","B4N","B4O"],
  "oil rig": ["B4Q","B4R","B4S","B4T"],
  "oil tanker": ["B4U"],
  "oil well": ["B4V"],
  "ok": ["Dsp"],
  "okay": ["B4W"],
  "old": ["Ehs","Ehr","Eht","EJv","DIm","DIi","DIj","B4j","B4X","B4Y","B4Z","B4a"],
  "old city": ["B4b"],
  "old fashioned": ["B4c","B4d","B4e","B4f"],
  "old man": ["B4g","B4h","B4i"],
  "old woman": ["B4k","B4l"],
  "older": ["ER8","DIl","DIk"],
  "olive": ["Egu","DIn","B4p","B4m"],
  "olive oil": ["B4n","B4o"],
  "olives": ["D3Y","DIo","B4t","B4q","B4r","B4s"],
  "olympic": ["B4v","B4u"],
  "olympics": ["B4x","B4w"],
  "omelette": ["B40","B4y","B4z"],
  "on": ["Ef1","Ef0","DdY","DdW","DdX"],
  "on fire": ["Ehv","Ehu","DIp"],
  "on the fence": ["EJz","EJ0","EJ1"],
  "on the left": ["Efx","Efw","DdZ","Dda","Ddb"],
  "on the left of the building": ["Efw"],
  "on the left of the sofa": ["Efx"],
  "on the right": ["Efz","Efy","Ddc","Ddd","Dde"],
  "on the right of the classroom": ["Efy"],
  "on the right of the flag": ["Efz"],
  "on the roof": ["Ef0"],
  "on the table": ["Ef1"],
  "on top": ["DYU"],
  "one": ["Dbs","Dbo"],
  "one hundred": ["Dbp"],
  "one hundred thousand": ["Dbq"],
  "one million": ["Dbr"],
  "one thousand": ["Dbt"],
  "onfire": ["EJw"],
  "onion": ["Egv","DIq","B45","B41","B42","B43","B44"],
  "onions": ["D3Z","DIr","B49","B46","B47","B48"],
  "online": ["B5D"],
  "online class": ["B5A","B5B","B5C"],
  "only": ["DYT"],
  "opal": ["B5E"],
  "open": ["Ehw","Ehx","EcT","EcS","EYj","EYi","EJ4","Djr","Djs","Djt","Dju","Djv","DIs","DYX"],
  "open a bottle": ["EcS","Djr"],
  "open a window": ["EcT","Djs"],
  "open door": ["Ehx","Ehw"],
  "open in the morning": ["EYi"],
  "open minded": ["DYW"],
  "open opened": ["EWG","EUA","Djr","Djs","Djt","Dju","Djv"],
  "open the book": ["Dsq"],
  "open the door": ["EYj","Djt"],
  "open the store": ["Dju"],
  "open the window": ["Djv"],
  "open window": ["DYY"],
  "open your book": ["Dsr"],
  "opened": ["EWG","EUA"],
  "opened the window": ["EUA"],
  "opening": ["EcT","EcS","Djv","Djr","Djs","Djt","Dju"],
  "opening a bottle": ["EcS","Djr"],
  "opening a window": ["EcT","Djs"],
  "opening presents": ["DYV"],
  "opening the door": ["Djt"],
  "opening the store": ["Dju"],
  "opening the window": ["Djv"],
  "opera": ["DYZ","B5F"],
  "oppose": ["DYa","B5G"],
  "opposite": ["B5J","B5H","B5I"],
  "opposition": ["DYb"],
  "optician": ["EJ5","EJ6","DIu","DIt","B5M","B5K","B5L"],
  "optics": ["DYc"],
  "optometrist": ["B5P","B5N","B5O"],
  "orange": ["Egw","DIz","DIv","B5X","B5Q","B5R"],
  "orange hats": ["EgJ","DIw"],
  "orange juice": ["D3a","DIx","DIy","B5S","B5T","B5U","B5V","B5W"],
  "orange shirt": ["Ef9","DI0"],
  "oranges": ["D3b","DI1","B5Z","B5Y"],
  "orbit": ["DYd"],
  "orc": ["EJ8","EJ7"],
  "orchard": ["B5e","B5a","B5b","B5c","B5d"],
  "orchid": ["B5g","B5f"],
  "order": ["EbF","EYk","Djw","Djx","B5i","B5h"],
  "order a pizza": ["EYk","EJ9","Djw"],
  "order food": ["EbF","Djx"],
  "order ordered": ["EVf","ES8","Djw","Djx"],
  "ordered": ["EVf","ES8"],
  "ordered a pizza": ["EVf"],
  "ordered some food": ["ES8"],
  "ordering": ["EbF","Djx","Djw"],
  "ordering a pizza": ["Djw"],
  "ordering food": ["EbF","Djx"],
  "organize holidays": ["EKA"],
  "ornaments": ["Dss"],
  "ostrich": ["B5m","B5j","B5k","B5l"],
  "otter": ["B5p","B5n","B5o"],
  "outlet": ["B5q"],
  "outside": ["B5r"],
  "outskirts": ["B5s"],
  "outstanding": ["B5t"],
  "oval": ["B5x","B5u","B5v","B5w"],
  "oven": ["B51","B5y","B5z","B50"],
  "over the moon": ["EKB","EKC","EKD"],
  "overcast": ["EhO","DI2","B55","B52","B53","B54"],
  "overpopulation": ["B57","B56"],
  "oversleep": ["B58"],
  "overtake": ["B59"],
  "overweight": ["B6C","B6A","B6B"],
  "owl": ["EKE","D3c","DI3","B6H","B6D","B6E","B6F","B6G"],
  "owner": ["B6J","B6I"],
  "ox": ["B6M","B6K","B6L"],
  "oyster": ["B6P","B6N","B6O"],
  "ozone layer": ["B6Q","B6R"],
  "p": ["DaG","DaF"],
  "pack": ["EYl","Djy"],
  "pack a bag": ["EYl","Djy"],
  "pack packed": ["Djy"],
  "package": ["B6W","B6S","B6T","B6U","B6V"],
  "packaging": ["B6X"],
  "packing": ["Djy"],
  "packing a bag": ["Djy"],
  "pad": ["B6c","B6Y"],
  "paddle": ["B6b","B6Z","B6a"],
  "paddles": ["DI4"],
  "padlock": ["D3d","DI5"],
  "page": ["B6d"],
  "pagoda": ["Dst"],
  "paid": ["ETe","Dsu"],
  "paid some money": ["ETe"],
  "pail": ["B6f","B6e"],
  "pain": ["B6i","B6g","B6h"],
  "paint": ["EbG","EYn","EYm","Dj2","Djz","Dj0","Dj1","Dj3","B62","B6j","B6k","B6l"],
  "paint a picture": ["EbG","EYm","EKF","Djz","Dj0","Dj1","B6m","B6n"],
  "paint beautifully": ["ERK"],
  "paint brush": ["Dsv"],
  "paint painted": ["EUB","Djz","Dj0","Dj1","Dj2","Dj3"],
  "paint pictures": ["EKG","Dsw"],
  "paint roller": ["B63","B64","B65"],
  "paint the wall": ["EYn","EKH","Dj3"],
  "paintbrush": ["D3e","DI6","B6s","B6o","B6p","B6q","B6r"],
  "painted": ["EUB"],
  "painted a picture": ["EUB"],
  "painter": ["B6v","B6t","B6u"],
  "painting": ["EbG","Dj2","Djz","Dj0","Dj1","Dj3","B60","B6w","B6x"],
  "painting a picture": ["EbG","Djz","Dj0","Dj1","B6y","B6z"],
  "painting the wall": ["Dj3"],
  "paintings": ["B61"],
  "paints": ["B67","B66"],
  "pajamas": ["B68","CI1"],
  "Pakistan": ["EKI"],
  "Pakistan flag": ["DI7"],
  "palace": ["B7E","B69","B7A","B7B","B7C","B7D"],
  "pale": ["B7H","B7F","B7G"],
  "palm tree": ["B7I","B7J","B7K"],
  "pan": ["B7e","B7L","B7M"],
  "Panama": ["EKJ","B7Q","B7N","B7O","B7P"],
  "pancake": ["B7S","B7R"],
  "pancakes": ["DI8","B7W","B7T","B7U","B7V"],
  "pancreas": ["B7X"],
  "panda": ["D3f","DI9","B7b","B7Y","B7Z","B7a"],
  "pandas": ["B7c"],
  "pangolin": ["B7d"],
  "panini": ["DJA"],
  "pants": ["D3g","DJC","DJB","B7j","B7f","B7g","B7h","B7i"],
  "papaya": ["B7o","B7k","B7l","B7m","B7n"],
  "papaya salad": ["B7p","B7q"],
  "paper": ["D3i","DJE","B70","B7r"],
  "paper clip": ["B7u","B7v","B7w"],
  "paper clips": ["D3h","DJD","B7x","B7y","B7z"],
  "paper towel": ["B71","B72"],
  "paper towels": ["D3j","DJF","B73"],
  "paperbag": ["B7t","B7s"],
  "Papua New Guinea": ["EKK"],
  "parachute": ["B75","B74"],
  "parade": ["B76"],
  "paradise": ["B78","B77"],
  "paragraph": ["B79"],
  "parallel": ["B8A"],
  "paramedic": ["EKL","EKM","DJH","DJG","B8C","B8B"],
  "parasol": ["B8F","B8D","B8E"],
  "parcel": ["B8G"],
  "parent": ["B8H"],
  "parents": ["EKN","DZd","B8J","B8I"],
  "Paris": ["Dsx"],
  "park": ["DJI","B8S","B8K","B8L","B8M"],
  "parking garage": ["B8N","B8O","B8P"],
  "parking lot": ["B8Q","B8R"],
  "parrot": ["D3k","DJJ","B8W","B8T","B8U","B8V"],
  "partly cloudy": ["Dsy"],
  "partner": ["Dsz"],
  "party": ["B8Y","B8X"],
  "party hat": ["Ds0"],
  "pass": ["Dj4"],
  "pass a test": ["Dj4"],
  "pass passed": ["EV5","Dj4"],
  "passed": ["EV5"],
  "passed the test": ["EV5"],
  "passenger": ["B8a","B8Z"],
  "passengers": ["B8c","B8b"],
  "passing": ["Dj4"],
  "passing a test": ["Dj4"],
  "passion fruit": ["B8d","B8e","B8f","B8g"],
  "passport": ["B8j","B8h","B8i"],
  "password": ["Ds1"],
  "pasta": ["D3l","DJK","B8n","B8k","B8l","B8m"],
  "pastries": ["B8q","B8o","B8p"],
  "pastry": ["B8s","B8r"],
  "pasture": ["B8w","B8t","B8u","B8v"],
  "pat": ["B84"],
  "path": ["B8z","B8x","B8y"],
  "patient": ["B83","B80","B81","B82"],
  "patriot": ["B88","B85","B86","B87"],
  "pattern": ["B9B","B89","B9A"],
  "pavement": ["B9F","B9C","B9D","B9E"],
  "paw": ["B9J","B9G","B9H","B9I"],
  "paws": ["B9L","B9K"],
  "pay": ["EcU","EYo","Dj6","Dj5","B9P","B9M","B9N","B9O"],
  "pay attention": ["Ds2"],
  "pay money": ["EcU","EYo","Dj5"],
  "pay paid": ["ETe","Dj5","Dj6"],
  "paying": ["EcU","Dj6","Dj5"],
  "paying money": ["EcU","Dj5"],
  "pc": ["B9Q"],
  "pea": ["B9o"],
  "peace": ["B9V","B9R","B9S"],
  "peaceful": ["B9U","B9T"],
  "peach": ["Egx","DJN","DJL","B9c","B9W"],
  "peach blossom": ["B9X"],
  "peaches": ["D3m","DJM","B9b","B9Y","B9Z","B9a"],
  "peacock": ["D3n","DJO","B9f","B9d","B9e"],
  "peanut": ["B9n","B9g"],
  "peanut butter": ["DJP","B9h","B9i","B9j","B9k","B9l","B9m"],
  "peanuts": ["D3o","Ds3"],
  "pear": ["Egy","DJQ","B9v","B9p","B9q","B9r"],
  "pearl": ["B9s"],
  "pearls": ["B9u","B9t"],
  "pears": ["D3p","DJR","B9y","B9w","B9x"],
  "peas": ["D3q","DJT","DJS","B91","B9z","B90"],
  "pebbles": ["B95","B92","B93","B94"],
  "pedal": ["B96"],
  "pedals": ["B98","B97"],
  "peddler": ["B99"],
  "pedestal": ["CAB","CAA"],
  "pedestrian": ["CAH","CAC"],
  "pedestrian crossing": ["CAD","CAE","CAF","CAG"],
  "pedestrians": ["CAJ","CAI"],
  "peel": ["EcV","Dj7","CAN","CAK","CAL","CAM"],
  "peel a banana": ["EcV","Dj7"],
  "peel peeled": ["Dj7"],
  "peeler": ["D3r","DJU"],
  "peeling": ["EcV","Dj7"],
  "peeling a banana": ["EcV","Dj7"],
  "peg": ["D3s","DJV","CAQ","CAO","CAP"],
  "pegs": ["CAR"],
  "pelican": ["CAU","CAS","CAT"],
  "pen": ["D3t","D3x","DJa","DJW","CAv","CAV","CAW","CAX"],
  "pencil": ["D3v","DJY","CAd","CAY","CAZ","CAa"],
  "pencil box": ["CAb"],
  "pencil case": ["D3u","DJX","CAc"],
  "pencil sharpener": ["CAg","CAh","CAi"],
  "pencils": ["CAj","CAe","CAf"],
  "pendant": ["CAm","CAk","CAl"],
  "penguin": ["D3w","DJZ","CAp","CAn","CAo"],
  "penguins": ["CAr","CAq"],
  "peninsula": ["CAu","CAs","CAt"],
  "pens": ["CAy","CAw","CAx"],
  "pentagon": ["CAz"],
  "people": ["CA0"],
  "pepper": ["Egz","CA9","CA1","CA2","CA3","CA4"],
  "peppermint": ["CA7","CA5","CA6"],
  "pepperoni": ["CA8"],
  "peppers": ["D3y","CBD","CBA","CBB","CBC"],
  "perfect": ["CBE"],
  "perform": ["CBJ","CBF"],
  "perform on stage": ["EKO"],
  "performance": ["CBI","CBG","CBH"],
  "perfume": ["CBM","CBK","CBL"],
  "personal trainer": ["EKQ","EKP","DJb","DJc"],
  "Peru": ["EKR","CBQ","CBN","CBO","CBP"],
  "pet": ["CBY","CBR","CBS","CBT"],
  "pet food": ["DJd","CBU","CBV","CBW","CBX"],
  "pet store": ["D3z","DJe"],
  "petrol": ["CBc","CBZ","CBa","CBb"],
  "petrol station": ["CBd","CBe","CBf"],
  "pets": ["CBh","CBg"],
  "pharmacist": ["EKS","EKT","D30","DJg","DJf","CBk","CBi","CBj"],
  "pharmacy": ["DJh","CBl"],
  "Philippines": ["EKU","CBp","CBm","CBn","CBo"],
  "Philippines flag": ["DJi"],
  "phone": ["ETd","D31","D33","DJl","DJj","CBt","CBq","CBr","CBs"],
  "phone charger": ["D32","DJk"],
  "phone rang": ["ETd"],
  "photo": ["CB2"],
  "photo album": ["CBu"],
  "photocopier": ["CBx","CBv","CBw"],
  "photographer": ["EKV","EKW","D34","DJn","DJm","CB0","CBy","CBz"],
  "photography": ["CB1"],
  "phrase": ["CB3"],
  "physical education": ["D35","DJo"],
  "physical therapy": ["CB4"],
  "physics": ["D36","DJp","CB6","CB5"],
  "physiotherapy": ["CB7"],
  "piano": ["D37","DJq","CCC","CB8","CB9","CCA","CCB"],
  "pick": ["EcW","EbH","Dj8","Dj9","CCE","CCD"],
  "pick apples": ["EbH","Dj8"],
  "pick flowers": ["EcW","Dj9"],
  "pick picked": ["ES9","Dj8","Dj9"],
  "pick up": ["EbI","EKX","DkA"],
  "pick up litter": ["EbI"],
  "pick up picked up": ["DkA"],
  "picked": ["ES9"],
  "picked apples": ["ES9"],
  "picking": ["EcW","EbH","Dj9","Dj8"],
  "picking apples": ["EbH","Dj8"],
  "picking flowers": ["EcW","Dj9"],
  "picking up": ["EbI","DkA"],
  "picnic": ["CCI","CCF","CCG","CCH"],
  "picture": ["D38","DJr","CCL","CCJ","CCK"],
  "pictures": ["CCM"],
  "picturesque": ["CCP","CCN","CCO"],
  "pie": ["D39","DJt","DJs","CCZ","CCQ","CCR","CCS"],
  "piece": ["CCY"],
  "piece of cake": ["CCT","CCU","CCV","CCW","CCX"],
  "pier": ["CCd","CCa","CCb","CCc"],
  "pig": ["D4A","DJu","CCr","CCe","CCf","CCg","CCh"],
  "pig pen": ["CCq"],
  "pigeon": ["CCl","CCi","CCj","CCk"],
  "piglet": ["CCp","CCm","CCn","CCo"],
  "pile": ["CCu","CCs","CCt"],
  "pill": ["CC4","CCv","CCw"],
  "pillow": ["D4B","DJv","CCz","CCx","CCy"],
  "pillows": ["CC3","CC0","CC1","CC2"],
  "pills": ["CC7","CC5","CC6"],
  "pilot": ["EKY","EKZ","D4C","DJx","DJw","CDB","CC8","CC9","CDA"],
  "pin": ["CDS","CDC"],
  "pinball": ["CDD"],
  "pine": ["CDM"],
  "pineapple": ["D4D","DJy","CDJ","CDE","CDF","CDG"],
  "pineapple juice": ["CDH","CDI"],
  "pineapples": ["CDL","CDK"],
  "pinecone": ["Ds4"],
  "ping pong": ["CDN","CDO","CDP","CDQ"],
  "pink": ["DJz"],
  "pink shirt": ["EgA"],
  "pink tshirt": ["DJ0"],
  "pinocchio": ["CDR"],
  "pins": ["D4E","DJ1"],
  "pipe": ["Ds5"],
  "piranha": ["CDT"],
  "pirate": ["EKa","CDW","CDU","CDV"],
  "pirate ship": ["CDX","CDY"],
  "pitch": ["Ds6"],
  "pitcher": ["CDa","CDZ"],
  "pizza": ["D4F","DJ3","DJ2","CDg","CDb","CDc","CDd","CDe","CDf"],
  "plaid": ["CDh"],
  "plain": ["CDi"],
  "plane": ["D4G","DJ4","CDo","CDj","CDk","CDl","CDm","CDn"],
  "planet": ["D4H","DJ5","CDp"],
  "planets": ["CDs","CDq","CDr"],
  "plant": ["EYp","D4I","DkB","DJ6","CDy","CDt","CDu","CDv","CDw","CDx"],
  "plant a tree": ["EYp","EKb","DkB"],
  "plant planted": ["EVb","DkB"],
  "planted": ["EVb"],
  "planted a tree": ["EVb"],
  "planting": ["DkB"],
  "planting a tree": ["DkB"],
  "plants": ["CD1","CDz","CD0"],
  "plastic": ["CD7","CD2","CD3"],
  "plastic bag": ["CD4","CD5","CD6"],
  "plastic straw": ["CD8","CD9","CEA"],
  "plate": ["D4J","DJ7","CED","CEB","CEC"],
  "plates": ["CEF","CEE"],
  "platform": ["CEH","CEG"],
  "platypus": ["Ds7"],
  "play": ["Edf","Ede","Edd","Edc","EbL","EbK","EbJ","EYx","EYw","EYv","EYu","EYt","EYs","EYr","EYq","DkC","DkD","DkE","DkF","DkG","DkH","DkI","DkJ","DkK","DkL","DkM","DkN","DkP","DkQ","DkR","DkS","DkT"],
  "play a boardgame": ["DkC"],
  "play a game": ["DkD"],
  "play a guitar": ["DkE"],
  "play a video game": ["DkF"],
  "play baseball": ["EKc"],
  "play basketball": ["EYq","DkG"],
  "play board games": ["EYr","EKd"],
  "play cards": ["Edc","DkH","DkI"],
  "play cards played cards": ["DkH"],
  "play chess": ["EbJ","DkJ"],
  "play computer games": ["EYs"],
  "play football": ["Edd","DkK"],
  "play games on your phone": ["EYt"],
  "play hockey": ["Ds8"],
  "play music": ["EYu","DkL"],
  "play on a swing": ["EYv","EKe","DkM"],
  "play played": ["EV6","EWR","EU8","DkT","DkC","DkD","DkE","DkF","DkG","DkI","DkJ","DkK","DkL","DkN"],
  "play pool": ["EbK","DkN"],
  "play saxophone": ["DkO"],
  "play soccer": ["EYw","DkP"],
  "play sport": ["EKf"],
  "play table tennis": ["EKg"],
  "play tennis": ["Ede","EKh","DkQ"],
  "play tennis badly": ["ERL"],
  "play the drums": ["Ds9"],
  "play the flute": ["EKi"],
  "play the flute well": ["ERM"],
  "play the guitar": ["EbL","EYx","EKj","DkR"],
  "play the guitar badly": ["ERN"],
  "play the piano": ["DtA"],
  "play the trumpet": ["DkS"],
  "play the violin": ["EKk"],
  "play video games": ["Edf","DkT"],
  "play volleyball": ["EKl"],
  "play with friend": ["DtB"],
  "play with friends": ["DtC"],
  "played": ["EV6","EWR","EU8"],
  "played a board game": ["EWR"],
  "played soccer": ["EU8"],
  "played the trumpet": ["EV6"],
  "playful": ["CEJ","CEI"],
  "playground": ["DJ8","CEL","CEK"],
  "playing": ["Edf","Ede","Edd","Edc","EbL","EbK","EbJ","DkT","DkC","DkD","DkE","DkF","DkG","DkH","DkI","DkJ","DkK","DkL","DkM","DkN","DkP","DkQ","DkR","DkS"],
  "playing a boardgame": ["DkC"],
  "playing a game": ["DkD"],
  "playing a guitar": ["DkE"],
  "playing a video game": ["DkF"],
  "playing basketball": ["DkG"],
  "playing cards": ["Edc","DkH","DkI"],
  "playing chess": ["EbJ","DkJ"],
  "playing football": ["Edd","DkK"],
  "playing music": ["DkL"],
  "playing on a swing": ["DkM"],
  "playing pool": ["EbK","DkN"],
  "playing saxophone": ["DkO"],
  "playing soccer": ["DkP"],
  "playing tennis": ["Ede","DkQ"],
  "playing the guitar": ["EbL","DkR"],
  "playing the trumpet": ["DkS"],
  "playing video games": ["Edf","DkT"],
  "pleasant": ["CEM"],
  "please": ["DtD"],
  "pleased": ["EKm"],
  "plenty of fish in the sea": ["EKn","EKo","EKp"],
  "pliers": ["CEP","CEN","CEO"],
  "plough": ["CEV","CEQ","CER","CES","CET","CEU"],
  "plow": ["CEV","CEQ","CER","CES","CET","CEU"],
  "plug": ["D4K","D4M","DKB","DJ9","CEa","CEW","CEX","CEY"],
  "plug hole": ["D4L","DKA"],
  "plug in": ["EYy","EKq","Dkh","DkU","CEZ"],
  "plug in a laptop": ["EYy","DkU"],
  "plug in plugged in": ["Dkh"],
  "plug plugged": ["DkU"],
  "plugging in": ["Dkh","DkU"],
  "plugging in a laptop": ["DkU"],
  "plum": ["Eg0","DKE","CEh","CEb","CEc"],
  "plumber": ["EKr","EKs","D4N","DKD","DKC","CEf","CEd","CEe"],
  "plump": ["CEi","CEg"],
  "plums": ["D4O","DKF","CEm","CEj","CEk","CEl"],
  "plunger": ["CEo","CEn"],
  "plus": ["CEq","CEp"],
  "pluto": ["CEr"],
  "poached egg": ["CEs"],
  "poached eggs": ["CEt"],
  "pocket": ["CEw","CEu","CEv"],
  "poem": ["CEz","CEx","CEy"],
  "poet": ["CE0"],
  "point": ["EbM","DkW","CE2","CE1"],
  "point at": ["DkV"],
  "point at a clock": ["DkV"],
  "point at the clock": ["EbM"],
  "point at the tv": ["DkW"],
  "point pointed": ["ETA","DkV","DkW"],
  "pointed": ["ETA"],
  "pointed at a tv": ["ETA"],
  "pointing": ["EbM","DkW"],
  "pointing at": ["DkV"],
  "pointing at a clock": ["DkV"],
  "pointing at the tv": ["DkW"],
  "poison": ["DtE"],
  "poisonous": ["CE5","CE3","CE4"],
  "Poland": ["EKt","CE9","CE6","CE7","CE8"],
  "Poland flag": ["DKG"],
  "polar bear": ["CFA","CFB","CFC"],
  "pole": ["DtF"],
  "police": ["CFK"],
  "police car": ["CFD","CFE","CFF"],
  "police man": ["D4P"],
  "police officer": ["EKv","EKu","DKH","DKI","CFG","CFH","CFI","CFJ"],
  "police station": ["CFL"],
  "police woman": ["DtG"],
  "policeman": ["D4P"],
  "policewoman": ["DtG"],
  "polish": ["CFM"],
  "politician": ["EKw","EKx","D4Q","DKK","DKJ","CFN"],
  "polka dot": ["CFO"],
  "pollute": ["CFS","CFP","CFQ"],
  "polluted": ["CFR"],
  "pollution": ["CFV","CFT","CFU"],
  "polo shirt": ["D4R","DKL"],
  "pomegranate": ["CFa","CFW","CFX","CFY","CFZ"],
  "pomelo": ["CFd","CFb","CFc"],
  "pond": ["CFj","CFe","CFf","CFg","CFh","CFi"],
  "pony": ["CFo","CFk","CFl","CFm","CFn"],
  "ponytail": ["CFq","CFp"],
  "ponytails": ["CFr","CFs"],
  "pool": ["D4S","DKN","DKM","CFw","CFt","CFu","CFv"],
  "poor": ["EKy","CFx"],
  "pop music": ["CF2"],
  "pop star": ["CF9"],
  "popcorn": ["D4T","DKO","CF1","CFy","CFz","CF0"],
  "poppy": ["CF6","CF3","CF4","CF5"],
  "popsicle": ["CF8","CF7"],
  "population": ["CGB","CGA"],
  "porch": ["CGE","CGC","CGD"],
  "porcupine": ["CGH","CGF","CGG"],
  "pork": ["Eg2","D4U","DKQ","CGM","CGI","CGJ","CGK"],
  "pork belly": ["CGL"],
  "pork chop": ["Eg1","DKP"],
  "porridge": ["CGQ","CGN","CGO","CGP"],
  "port": ["CGV","CGR","CGS","CGT","CGU"],
  "portrait": ["DtH"],
  "Portugal": ["EKz","CGZ","CGW","CGX","CGY"],
  "Portugual flag": ["DKR"],
  "positive": ["CGb","CGa"],
  "post office": ["DKS"],
  "postcard": ["CGe","CGc","CGd"],
  "poster": ["CGi","CGf","CGg","CGh"],
  "postman": ["CGj"],
  "pot": ["CG0","CGk","CGl","CGm"],
  "pot calling the kettle black": ["EK0","EK1","EK2"],
  "potato": ["Eg3","CGy","CGn","CGo","CGp"],
  "potato chips": ["DKT","CGq","CGr","CGs","CGt"],
  "potatoes": ["D4V","DKU","CGx","CGu","CGv","CGw"],
  "potion": ["CGz"],
  "potted plant": ["CG1","CG2"],
  "pottery": ["DtI"],
  "poultry": ["CG4","CG3"],
  "pour": ["EcX","EYz","DkY","DkX","CG8","CG5","CG6","CG7"],
  "pour a drink": ["EYz"],
  "pour coffee": ["EcX","DkX"],
  "pour poured": ["EUC","DkX","DkY"],
  "poured": ["EUC"],
  "poured coffee": ["EUC"],
  "pouring": ["EcX","DkY","DkX"],
  "pouring coffee": ["EcX","DkX"],
  "poverty": ["CG9"],
  "power": ["CHD"],
  "power socket": ["CHE"],
  "powerful": ["CHC","CHA","CHB"],
  "practice the piano": ["DtJ"],
  "practice the saxophone": ["EK3"],
  "prawn": ["CHH","CHF","CHG"],
  "prawns": ["CHL","CHI","CHJ","CHK"],
  "pray": ["CHP","CHM","CHN","CHO"],
  "predator": ["CHT","CHQ","CHR","CHS"],
  "preparation": ["CHU"],
  "prepare": ["DtK"],
  "present": ["Ehg","EY0","DkZ","CHZ","CHV","CHW"],
  "present a TV show": ["EK4"],
  "present information": ["EY0"],
  "present presented": ["DkZ"],
  "presenter": ["CHY","CHX"],
  "presenting": ["DkZ"],
  "presents": ["Ehh","EK5","CHd","CHa","CHb","CHc"],
  "preserve": ["CHf","CHe"],
  "president": ["CHg"],
  "press": ["EcY","Dka","Dkb","CHh"],
  "press a button": ["EcY","Dka"],
  "press pressed": ["ETf","Dka","Dkb"],
  "press the button": ["Dkb"],
  "pressed": ["ETf"],
  "pressed a button": ["ETf"],
  "pressing": ["EcY","Dkb","Dka"],
  "pressing a button": ["EcY","Dka"],
  "pressing the button": ["Dkb"],
  "pretty": ["CHi"],
  "pretzel": ["Eg4","DKV","CHn","CHj","CHk","CHl","CHm"],
  "prey": ["CHq","CHo","CHp"],
  "price": ["CHs","CHr"],
  "prickly": ["DtL"],
  "priest": ["DtM"],
  "primitive": ["CHu","CHt"],
  "prince": ["CHv"],
  "princess": ["CHx","CHw"],
  "principal": ["CHz","CHy"],
  "principal's office": ["CH0"],
  "print": ["Dkc","CH5","CH1"],
  "print printed": ["Dkc"],
  "printer": ["D4W","DKW","CH4","CH2","CH3"],
  "printing": ["Dkc"],
  "prison": ["DtN"],
  "prize": ["CH8","CH6","CH7"],
  "problem": ["DtO"],
  "product": ["DtP"],
  "professional": ["CIA","CH9"],
  "professor": ["CIC","CIB"],
  "profitable": ["CID"],
  "program": ["DtQ"],
  "programmer": ["CIE"],
  "progress": ["CIF"],
  "projector": ["CII","CIG","CIH"],
  "promise": ["CIJ"],
  "protect": ["CIK"],
  "proud": ["EK6","DKX","CIL"],
  "prune": ["CIM"],
  "pub": ["CIR","CIN","CIO"],
  "public restroom": ["CIP"],
  "public transport": ["CIQ"],
  "pudding": ["CIT","CIS"],
  "puddle": ["DtR"],
  "pull": ["EbN","Dkd"],
  "pull a rope": ["EbN","Dkd"],
  "pull pulled": ["ETB","Dkd"],
  "pull ups": ["CIU"],
  "pulled": ["ETB"],
  "pulled a rope": ["ETB"],
  "pulling": ["EbN","Dkd"],
  "pulling a rope": ["EbN","Dkd"],
  "pulling your hair out": ["EK7","EK8","EK9"],
  "pump": ["Dke","CId","CIV"],
  "pump gas": ["Dke"],
  "pump pumped": ["Dke"],
  "pumping": ["Dke"],
  "pumping gas": ["Dke"],
  "pumpkin": ["ELA","D4X","DKY","CIc","CIW","CIX","CIY","CIZ"],
  "pumpkin pie": ["CIa","CIb"],
  "punch": ["Dkf","CIe"],
  "punch a monster": ["Dkf"],
  "punch punched": ["Dkf"],
  "punching": ["Dkf"],
  "punching a monster": ["Dkf"],
  "pup": ["CIn"],
  "pupil": ["CIh","CIf","CIg"],
  "puppet": ["CIk","CIi"],
  "puppeteer": ["CIj"],
  "puppies": ["CIm","CIl"],
  "puppy": ["CIr","CIo","CIp","CIq"],
  "purple": ["DKZ"],
  "purple socks": ["EgK","DKa"],
  "purse": ["D4Y","DKb","CIw","CIs","CIt","CIu","CIv"],
  "push": ["EbO","Dkg","CIx"],
  "push a car": ["EbO","Dkg"],
  "push pushed": ["ETC","Dkg"],
  "push ups": ["CIy","CIz"],
  "pushed": ["ETC"],
  "pushed a car": ["ETC"],
  "pushing": ["EbO","Dkg"],
  "pushing a car": ["EbO","Dkg"],
  "put": ["EbP","EY4","EY3","EY2","Dki","Dkk","Dkl","Dkm"],
  "put a bottle in the bin": ["EY2","Dki"],
  "put away": ["EcZ","ELB","Dkj"],
  "put away groceries": ["EcZ"],
  "put away put away": ["Dkj"],
  "put books in a bag": ["Dkk"],
  "put books in bag": ["EbP"],
  "put food in a microwave": ["Dkl"],
  "put food in the microwave": ["EY3"],
  "put ketchup on a burger": ["EY4","Dkm"],
  "put on": ["EbR","EbQ","ETD","ELC","Dko","Dkn","Dkp"],
  "put on a coat": ["EbQ","Dkn"],
  "put on a hat": ["ETD"],
  "put on put on": ["Dko"],
  "put on shoes": ["EbR","Dkp"],
  "put out": ["EbS","EY5","ELE","Dkr","Dkq"],
  "put out a fire": ["EbS","EY5","Dkq"],
  "put out fires": ["ELD"],
  "put out put out": ["Dkr"],
  "put put": ["Dkl","Dki","Dkk","Dkm"],
  "put up": ["Edg","ELF","Dks"],
  "put up decorations": ["Edg"],
  "put up put up": ["Dks"],
  "putting": ["EbP","Dki","Dkk","Dkl","Dkm"],
  "putting a bottle in the bin": ["Dki"],
  "putting away": ["EcZ","Dkj"],
  "putting books in a bag": ["Dkk"],
  "putting food in a microwave": ["Dkl"],
  "putting ketchup on a burger": ["Dkm"],
  "putting on": ["EbR","EbQ","Dko","Dkn","Dkp"],
  "putting on a coat": ["EbQ","Dkn"],
  "putting on shoes": ["EbR","Dkp"],
  "putting out": ["EbS","Dkr","Dkq"],
  "putting out a fire": ["EbS","Dkq"],
  "putting up": ["Edg","Dks"],
  "puzzle": ["CI0"],
  "puzzles": ["DtS"],
  "pyjamas": ["B68","CI1"],
  "pyramid": ["CI5","CI2","CI3","CI4"],
  "python": ["CI6"],
  "q": ["DaI","DaH"],
  "q tips": ["CI7"],
  "quail": ["CJA","CI8","CI9"],
  "quarter past 1": ["DeL"],
  "quarter past 10": ["DeM"],
  "quarter past 11": ["DeK"],
  "quarter past 2": ["DeN"],
  "quarter past eleven": ["EfX","DeK"],
  "quarter past one": ["EfY","DeL"],
  "quarter past six": ["EfZ"],
  "quarter past ten": ["DeM"],
  "quarter past twelve": ["Efa"],
  "quarter past two": ["DeN"],
  "quarter to 1": ["DeR"],
  "quarter to 10": ["DeS"],
  "quarter to 12": ["DeT"],
  "quarter to 4": ["DeQ"],
  "quarter to 5": ["DeP"],
  "quarter to 8": ["DeO"],
  "quarter to eight": ["Efb","DeO"],
  "quarter to five": ["Efc","DeP"],
  "quarter to four": ["Efd","DeQ"],
  "quarter to one": ["DeR"],
  "quarter to ten": ["DeS"],
  "quarter to twelve": ["DeT"],
  "queen": ["CJB"],
  "question": ["CJD","CJC"],
  "queue": ["CJE"],
  "quick": ["ELG","CJF"],
  "quickly": ["ERC","DtT"],
  "quiet": ["Ehy","ELH","DKd","CJG"],
  "quieter": ["ER9","DKc"],
  "quietly": ["ERY"],
  "quilt": ["DtU"],
  "quit": ["CJI","CJH"],
  "quiz": ["CJJ"],
  "r": ["DaK","DaJ"],
  "rabbit": ["D4Z","DKe","CJO","CJK","CJL","CJM","CJN"],
  "rabbits": ["DtV"],
  "raccoon": ["CJS","CJP","CJQ","CJR"],
  "race": ["CJU","CJT"],
  "rack": ["CJa","CJV","CJW"],
  "racket": ["CJZ","CJX","CJY"],
  "radiate": ["CJd","CJb","CJc"],
  "radio": ["CJf","CJe"],
  "radish": ["CJj","CJg","CJh","CJi"],
  "rafting": ["DtW"],
  "rag": ["CJk"],
  "railroad": ["CJn","CJl","CJm"],
  "railway": ["DtX"],
  "railway station": ["CJo","CJp"],
  "rain": ["D4c","Dkt","DKj","DKf","CJ6","CJq","CJr","CJs"],
  "rain boots": ["CJt"],
  "rain rained": ["Dkt"],
  "rainbow": ["D4a","DKh","DKg","CJx","CJu","CJv","CJw"],
  "raincoat": ["D4b","DKi","CJz","CJy"],
  "rained": ["ETZ"],
  "rainforest": ["CJ3","CJ0","CJ1","CJ2"],
  "raining": ["Dkt","CJ5","CJ4"],
  "raining cats and dogs": ["ELI","ELJ","ELK"],
  "rainy": ["ELL","CJ8","CJ7"],
  "raisin": ["CKB","CJ9","CKA"],
  "raisins": ["CKE","CKC","CKD"],
  "rake": ["CKI","CKF","CKG","CKH"],
  "ram": ["CKL","CKJ","CKK"],
  "ran": ["EUD"],
  "ranch": ["CKP","CKM","CKN","CKO"],
  "random": ["CKQ"],
  "ranger": ["CKR"],
  "rarely": ["DtY"],
  "rash": ["D4d","DKk","CKS"],
  "raspberries": ["CKV","CKT","CKU"],
  "raspberry": ["CKZ","CKW","CKX"],
  "raspberry juice": ["CKY"],
  "rat": ["D4e","DKl","CKe","CKa","CKb","CKc","CKd"],
  "rattlesnake": ["CKf"],
  "ray": ["DtZ"],
  "razor": ["D4f","DKm"],
  "reach": ["CKi","CKg"],
  "reaching": ["CKh"],
  "react": ["CKj"],
  "read": ["Eca","EbU","EbT","EY6","EVi","ETE","Dkz","Dku","Dkv","Dkw","Dkx","Dky","CKo","CKk","CKl"],
  "read a book": ["Eca","EY6","ETE","ELM","Dku","Dkv","Dkw"],
  "read a newspaper": ["EbU","Dky"],
  "read aloud": ["EbT","Dkx"],
  "read aloud read aloud": ["Dkx"],
  "read books": ["Dta"],
  "read comics": ["Dtb"],
  "read out": ["ELN"],
  "read read": ["EVi","ETE","Dky","Dku","Dkv","Dkw","Dkz"],
  "read the book": ["EVi"],
  "reading": ["Eca","EbU","EbT","Dkz","Dku","Dkv","Dkw","Dkx","Dky","CKn","CKm"],
  "reading a book": ["Eca","Dku","Dkv","Dkw"],
  "reading a newspaper": ["EbU","Dky"],
  "reading aloud": ["EbT","Dkx"],
  "reading books": ["Dtc"],
  "ready": ["CKp"],
  "real estate agent": ["ELP","ELO","DKn","DKo"],
  "realize": ["CKq"],
  "receipt": ["CKs","CKr"],
  "receive": ["EY7","Dk0","Dk1","CKt"],
  "receive a package": ["EY7","Dk1"],
  "receive an email": ["Dk0"],
  "receive received": ["ETh","Dk0","Dk1"],
  "received": ["ETh"],
  "received an email": ["ETh"],
  "receiving": ["Dk1","Dk0"],
  "receiving a package": ["Dk1"],
  "receiving an email": ["Dk0"],
  "reception": ["CKz","CKu"],
  "reception desk": ["CKv","CKw"],
  "receptionist": ["ELQ","ELR","D4g","DKq","DKp","CKy","CKx"],
  "recipie": ["DYe"],
  "recliner": ["D4h","DKr"],
  "recommend": ["DYf"],
  "record": ["Dtd"],
  "recorder": ["CK0"],
  "rectangle": ["CK1"],
  "rectangular": ["CK2"],
  "recycle": ["CK5","CK3","CK4"],
  "recycling": ["CK9"],
  "recycling bank": ["CK6"],
  "recycling bin": ["CK7","CK8"],
  "red": ["DKy"],
  "red and blue": ["DKs"],
  "red and green": ["DKt"],
  "red and white": ["DKu"],
  "red and yellow": ["DKv"],
  "red apple": ["CLA"],
  "red glasses": ["EgL","DKw"],
  "red hair": ["CLB","CLC","CLD","CLE"],
  "red jacket": ["EgB","DKx"],
  "red pepper": ["CLF","CLG","CLH"],
  "red shoes": ["EgM"],
  "red socks": ["DKz"],
  "reel": ["CLI"],
  "referee": ["ELS","ELT","DK1","DK0","CLL","CLJ","CLK"],
  "reflect": ["EY8","Dk3","Dk2","CLP","CLM"],
  "reflect reflected": ["EUs","Dk3","Dk2"],
  "reflect the light": ["EY8"],
  "reflected": ["EUs"],
  "reflected the light": ["EUs"],
  "reflecting": ["Dk3","Dk2"],
  "reflective vest": ["CLN","CLO"],
  "refrigerator": ["CLS","CLQ","CLR"],
  "refuse": ["EbV","Dk4","CLU","CLT"],
  "refuse money": ["EbV","Dk4"],
  "refuse refused": ["ETF","Dk4"],
  "refused": ["ETF"],
  "refused money": ["ETF"],
  "refusing": ["EbV","Dk4"],
  "refusing money": ["EbV","Dk4"],
  "region": ["CLV"],
  "regions": ["CLW"],
  "regret": ["CLX"],
  "rehearse": ["CLY"],
  "reindeer": ["Eh0","ELU","CLb","CLZ","CLa"],
  "relationship": ["CLd","CLc"],
  "relatives": ["CLf","CLe"],
  "relax": ["EbW","EY9","Dk6","Dk5","CLp","CLg","CLh"],
  "relax on the beach": ["EY9","ELV"],
  "relax on the sofa": ["ELW"],
  "relax relaxed": ["ETG","Dk6","Dk5"],
  "relaxed": ["ETG","CLk","CLi","CLj"],
  "relaxing": ["EbW","Dk6","Dk5","CLo","CLl","CLm","CLn"],
  "religious": ["CLq"],
  "remote": ["D4i","DK2","CLx","CLr","CLs"],
  "remote control": ["CLt","CLu","CLv","CLw"],
  "renewable": ["CLz","CLy"],
  "renminbi": ["CL0"],
  "repair": ["EbX","EZA","Dk7","Dk8","Dk9","CL2","CL1"],
  "repair a phone": ["EbX","Dk7","Dk8"],
  "repair repaired": ["ETH","Dk7","Dk8","Dk9"],
  "repair the AC": ["EZA","Dk9"],
  "repair things": ["ELX"],
  "repaired": ["ETH"],
  "repaired a phone": ["ETH"],
  "repairing": ["EbX","Dk9","Dk7","Dk8"],
  "repairing a phone": ["EbX","Dk7","Dk8"],
  "repairing the AC": ["Dk9"],
  "repeat": ["Dte"],
  "reply": ["CL3"],
  "report": ["Dtf"],
  "report the news": ["ELa"],
  "reporter": ["ELY","ELZ","D4j","DK4","DK3","CL4"],
  "reptile": ["DK5","CL7","CL5","CL6"],
  "reptiles": ["ELb"],
  "rescue": ["EbY","EZB","DlA","DlB","CL9","CL8"],
  "rescue people": ["ELc"],
  "rescue rescued": ["ETI","DlA","DlB"],
  "rescue someone": ["EbY","EZB","DlB"],
  "rescued": ["ETI"],
  "rescued someone": ["ETI"],
  "rescuing": ["EbY","DlA","DlB"],
  "rescuing someone": ["EbY","DlB"],
  "reservation": ["Dtg"],
  "resign": ["CMB","CMA"],
  "respect": ["CMC"],
  "responsible": ["Dth"],
  "rest": ["EZC","DlC","CMI"],
  "rest on the sofa": ["EZC"],
  "rest rested": ["DlC"],
  "restaurant": ["DK6","CMG","CMD","CME","CMF"],
  "resting": ["DlC","CMH"],
  "restroom": ["CMK","CMJ"],
  "resume": ["CML"],
  "rhino": ["D4k","DK7","CMP","CMM","CMN","CMO"],
  "rhinoceros": ["Dti"],
  "rhubarb": ["CMT","CMQ","CMR","CMS"],
  "rib": ["CMa"],
  "rib cage": ["CMY","CMZ"],
  "ribbon": ["CMX","CMU","CMV","CMW"],
  "ribs": ["CMe","CMb","CMc","CMd"],
  "rice": ["D4l","DK9","CMk","CMf","CMg","CMh","CMi","CMj"],
  "rice and vegetables": ["Eg5","DK8"],
  "rice pudding": ["CMl"],
  "rich": ["ELd","CMm"],
  "rickshaw": ["CMq","CMn","CMo","CMp"],
  "ridden": ["EV7"],
  "ridden a scooter": ["EV7"],
  "ride": ["Ecb","Eba","EbZ","EZE","EZD","DlD","DlE","DlF","DlG","CMw"],
  "ride a bicycle": ["Dtj"],
  "ride a bike": ["EbZ","EZD","ELe","DlD","CMr","CMs"],
  "ride a horse": ["Ecb","DlE","CMt"],
  "ride a motorbike": ["Eba","ELf","DlF","CMu"],
  "ride a motorbike dangerously": ["ERO"],
  "ride a scooter": ["EZE","DlG"],
  "ride a skateboard": ["ELg","CMv"],
  "ride a skateboard safely": ["ERP"],
  "ride my bike": ["Dtk"],
  "ride ridden": ["EV7"],
  "ride rode": ["ETJ","DlD","DlE","DlF","DlG"],
  "riding": ["Ecb","Eba","EbZ","DlD","DlE","DlF","DlG"],
  "riding a bike": ["EbZ","DlD"],
  "riding a horse": ["Ecb","DlE"],
  "riding a motorbike": ["Eba","DlF"],
  "riding a scooter": ["DlG","CMx"],
  "right": ["ELh","Dtl"],
  "ring": ["EdH","D4m","DlI","DlH","CM2","CMy","CMz","CM0","CM1"],
  "ring rang": ["DlH","DlI"],
  "ringing": ["EdH","DlI","DlH"],
  "rinse": ["CM3"],
  "riot": ["CM6","CM4","CM5"],
  "rip": ["CNB","CM7"],
  "ripe": ["CNA","CM8","CM9"],
  "riper": ["ESA","DLA"],
  "rise": ["EdI","EZG","DlJ","CNC"],
  "rise in the morning": ["EZG"],
  "rise rose": ["EUo","DlJ"],
  "rising": ["EdI","DlJ"],
  "rival": ["CND"],
  "river": ["D4n","DLB","CNK","CNE","CNF","CNG","CNH"],
  "river bank": ["CNI","CNJ"],
  "river rapids": ["CNL","CNM","CNN"],
  "road": ["D4o","DLC","CNQ","CNO","CNP"],
  "road rage": ["CNR"],
  "roadworks": ["CNS"],
  "roar": ["CNU","CNT"],
  "roast": ["CNX"],
  "roast beef": ["DLD"],
  "roast chicken": ["CNV","CNW"],
  "roast vegetables": ["CNY"],
  "robe": ["Dtm"],
  "robin": ["CNb","CNZ","CNa"],
  "robot": ["CNf","CNc","CNd","CNe"],
  "rock": ["CNu","CNg"],
  "rock climbing": ["CNh","CNi","CNj","CNk","CNl"],
  "rock pool": ["CNv"],
  "rocket": ["D4p","DLE","CNq","CNm","CNn","CNo","CNp"],
  "rocking horse": ["CNr","CNs","CNt"],
  "rocks": ["CN2","CNw","CNx","CNy","CNz","CN0","CN1"],
  "rod": ["Dtn"],
  "rode": ["ETJ"],
  "rode a motorbike": ["ETJ"],
  "roll": ["COP","CN3","CN4"],
  "roll out the red carpet": ["ELi","ELj","ELk"],
  "roller blades": ["CN5","CN6","CN7"],
  "roller blading": ["CN8","CN9","COA"],
  "roller coaster": ["COB","COC","COD","COE","COF","COG","COH"],
  "roller skate": ["COI"],
  "roller skates": ["Dtq"],
  "roller skating": ["COJ"],
  "rollerblading": ["Dto"],
  "rollerblads": ["Dtp"],
  "rolling pin": ["COK","COL","COM","CON","COO"],
  "romance": ["COV","COQ","COR","COS","COT","COU"],
  "Romania": ["ELl","COZ","COW","COX","COY"],
  "romantic": ["ELm","COd","COa","COb","COc"],
  "roof": ["COi","COe","COf","COg","COh"],
  "room": ["COk"],
  "roommates": ["COj"],
  "roomservice": ["COl"],
  "rooster": ["COp","COm","COn","COo"],
  "roots": ["COt","COq","COr","COs"],
  "rope": ["COy","COu","COv","COw","COx"],
  "rosary": ["CO1","COz","CO0"],
  "rose": ["EUo","CO5","CO2","CO3","CO4"],
  "roses": ["CO8","CO6","CO7"],
  "rotate": ["CPA","CO9"],
  "rough": ["Dtr"],
  "round": ["Dtt","Dts"],
  "roundabout": ["CPC","CPB"],
  "route": ["Dtu"],
  "row": ["EZH","DlK"],
  "row a boat": ["EZH","DlK","CPD"],
  "row rowed": ["DlK"],
  "rowing": ["DlK"],
  "rowing a boat": ["DlK"],
  "royal": ["CPE"],
  "rubber": ["CPF"],
  "rubbish": ["CPI","CPG","CPH"],
  "rucksack": ["D4q","DLF"],
  "rug": ["D4s","DLH","CPO","CPJ"],
  "rugby": ["D4r","DLG","CPN","CPK","CPL","CPM"],
  "ruler": ["D4t","DLI","CPR","CPP","CPQ"],
  "run": ["Ecc","EVs","ELs","DlP","DlL","DlM","DlN","CPV","CPS"],
  "run a marathon": ["EVs","DlN"],
  "run in the park": ["ELn"],
  "run like the wind": ["ELo","ELp","ELq"],
  "run out": ["ELr","DlO"],
  "run out ran out": ["DlO"],
  "run quickly": ["ERQ"],
  "run ran": ["EUD","DlL","DlM","DlN","DlP"],
  "run run": ["EVs"],
  "running": ["Ecc","D4u","DlP","DlL","DlM","DlN","DLJ","CPU","CPT"],
  "running a marathon": ["DlN"],
  "running out": ["DlO"],
  "rural": ["CPa","CPW","CPX","CPY"],
  "rural area": ["CPZ"],
  "rush": ["CPe"],
  "rush hour": ["CPb","CPc","CPd"],
  "Russia": ["ELt","D4v","DLM","CPi","CPf","CPg","CPh"],
  "Russia flag": ["DLK"],
  "Russian": ["EeS","DLL"],
  "s": ["DaM","DaL"],
  "sack": ["Dtv"],
  "sacred": ["CPk","CPj"],
  "sad": ["Eh1","Eh2","ELu","DLO","CPr","CPl","CPm"],
  "sadder": ["ESB","DLN"],
  "saddle": ["CPp","CPn","CPo"],
  "sadness": ["CPq"],
  "safari": ["DYg"],
  "safe": ["ELv","CPu","CPs","CPt"],
  "safely": ["ERP"],
  "safer": ["ESC","DLP"],
  "safety": ["DYh","CPv"],
  "said": ["EUE"],
  "said hello": ["EUE"],
  "sail": ["EZJ","DlQ","CP5","CPw"],
  "sail a boat": ["EZJ","ELw","DlQ","CPx"],
  "sail sailed": ["DlQ"],
  "sailboat": ["CPy"],
  "sailing": ["DlQ","DYi","CP1","CPz"],
  "sailing a boat": ["DlQ"],
  "sailing boat": ["CP0"],
  "sailor": ["ELx","ELy","DLR","DLQ","CP4","CP2","CP3"],
  "saint": ["CP7","CP6"],
  "salad": ["D4w","DLS","CQC","CP8","CP9","CQA","CQB"],
  "salami": ["CQG","CQD","CQE","CQF"],
  "sales clerk": ["CQH"],
  "salesperson": ["Dtw"],
  "salmon": ["DLT","CQM","CQI","CQJ","CQK","CQL"],
  "salsa": ["CQP","CQN","CQO"],
  "salt": ["DLU","CQU","CQQ","CQR"],
  "salt and pepper": ["D4x","CQS","CQT"],
  "salty": ["CQV"],
  "salute": ["CQZ","CQW","CQX","CQY"],
  "same": ["CQb","CQa"],
  "Samoa": ["ELz"],
  "samosas": ["DLV"],
  "sand": ["CQx","CQc","CQd","CQe","CQf"],
  "sand castle": ["CQk","CQl","CQm","CQn","CQo"],
  "sand dunes": ["CQp","CQq","CQr","CQs","CQt"],
  "sandals": ["D4y","DLW","CQj","CQg","CQh","CQi"],
  "sandcastle": ["Dtx"],
  "sandpaper": ["CQu"],
  "sandpit": ["CQw","CQv"],
  "sandstorm": ["CQ2","CQy","CQz","CQ0","CQ1"],
  "sandwich": ["D4z","DLX","CRB","CQ3","CQ4","CQ5","CQ6"],
  "sandwiches": ["CRA","CQ7","CQ8","CQ9"],
  "sang": ["EUF"],
  "sang a song": ["EUF"],
  "santa": ["Eh3","EL0","CRK","CRC","CRD","CRE","CRF"],
  "santa claus": ["CRG","CRH","CRI","CRJ"],
  "Santa Claus": ["Eh3"],
  "Santa's sleigh": ["Eh4"],
  "sapling": ["CRQ","CRL","CRM","CRN","CRO","CRP"],
  "sapphire": ["CRV","CRR","CRS","CRT","CRU"],
  "sarcophagus": ["CRZ","CRW","CRX","CRY"],
  "sardines": ["CRe","CRa","CRb","CRc","CRd"],
  "sat": ["EUG"],
  "sat down": ["EUG"],
  "satchel": ["D40","DLY"],
  "satellite": ["CRk","CRf","CRg","CRh","CRi","CRj"],
  "satellite dish": ["D41","DLZ"],
  "satsumas": ["CRm","CRl"],
  "Saturday": ["DLc","DLa","DLb"],
  "saturn": ["CRs","CRn","CRo","CRp","CRq","CRr"],
  "sauce": ["CRx","CRt","CRu","CRv","CRw"],
  "saucepan": ["D42","DLd"],
  "Saudi Arabia": ["EL1"],
  "sausage": ["Eg6","DLe","CRz","CRy"],
  "sausages": ["D43","DLf","CR2","CR0","CR1"],
  "savannah": ["CR6","CR3","CR4","CR5"],
  "save injured people": ["EL2"],
  "save money": ["CR7"],
  "savoury": ["CR9","CR8"],
  "saw": ["EUH","D44","DLg","CSC","CSA","CSB"],
  "saw an elephant": ["EUH"],
  "saxophone": ["D45","DLh","CSI","CSD","CSE","CSF","CSG","CSH"],
  "say": ["EZK","DlR","DlS"],
  "say hello": ["EZK","DlR","DlS"],
  "say said": ["EUE","DlR","DlS"],
  "saying": ["DlS","DlR"],
  "saying hello": ["DlR","DlS"],
  "says": ["Ecd"],
  "says 'hello'": ["Ecd"],
  "scale": ["Dty"],
  "scales": ["CSJ"],
  "scan": ["CSL"],
  "scanner": ["CSK"],
  "scar": ["D47","DLk"],
  "scarecrow": ["EL3","EL4","CSR","CSM","CSN","CSO","CSP","CSQ"],
  "scared": ["EL5","DLi","CST","CSS"],
  "scarf": ["D46","DLj","CSX","CSU","CSV","CSW"],
  "scary": ["CSZ","CSY"],
  "scenery": ["CSc","CSa","CSb"],
  "scent": ["CSf","CSd","CSe"],
  "schedule": ["Dtz"],
  "scholar": ["CSj","CSg","CSh","CSi"],
  "school": ["CSv","CSk","CSl"],
  "school bag": ["CSm","CSn","CSo","CSp","CSq"],
  "school bus": ["DLl","CSr","CSs","CSt","CSu"],
  "school schedule": ["CSw","CSx","CSy"],
  "school trip": ["CSz","CS0"],
  "schoolbag": ["Dt0"],
  "science": ["DYj","CS5"],
  "science fiction": ["CS1","CS2","CS3","CS4"],
  "science lab": ["Dt1"],
  "scientist": ["EL6","EL7","D48","DLn","DLm","CTA","CS6","CS7","CS8","CS9"],
  "scientists": ["DYk","CTB","CTC"],
  "scissors": ["D49","DLo","CTF","CTD","CTE"],
  "scoop": ["CTI","CTG","CTH"],
  "scooter": ["D5A","DLp","CTN","CTJ","CTK","CTL","CTM"],
  "scorch": ["CTQ","CTO","CTP"],
  "score": ["DlT"],
  "score a goal": ["DlT"],
  "score scored": ["EVY","DlT"],
  "scored": ["EVY"],
  "scored a goal": ["EVY"],
  "scoring": ["DlT"],
  "scoring a goal": ["DlT"],
  "scorpion": ["D5B","DLq","CTV","CTR","CTS","CTT","CTU"],
  "Scotland": ["EL8"],
  "scrambled egg on toast": ["Eg7","DLr"],
  "scrambled eggs": ["CTW","CTX","CTY","CTZ"],
  "scream": ["DlU","CTc","CTa","CTb"],
  "scream screamed": ["EUI","DlU"],
  "screamed": ["EUI"],
  "screaming": ["DlU"],
  "screen": ["ETK","CTg","CTd","CTe","CTf"],
  "screen cracked": ["ETK"],
  "screw": ["D5D","DLt","CTn","CTh","CTi"],
  "screwdriver": ["D5C","DLs","CTm","CTj","CTk","CTl"],
  "script": ["Dt2"],
  "scuba diver": ["CTo","CTp"],
  "scuba diving": ["CTq"],
  "sculpture": ["CTt","CTr","CTs"],
  "sea": ["CUJ","CTu","CTv","CTw","DvP"],
  "sea horse": ["Dt3"],
  "sea lion": ["CT8","CT9","CUA","CUB"],
  "sea turtle": ["CUW","CUX","CUY","CUZ","CUa"],
  "sea weed": ["CUb","CUc"],
  "seafood": ["CTx"],
  "seagull": ["CT1","CTy","CTz","CT0"],
  "seahorse": ["CT4","CT2","CT3"],
  "seal": ["CUC","CT5","CT6","CT7"],
  "seals": ["CUF","CUD","CUE"],
  "seam": ["CUI","CUG","CUH"],
  "search": ["Dt4"],
  "seaside": ["CUN","CUK","CUL","CUM"],
  "seat": ["CUV","CUO","CUP","CUQ","CUR","CUS"],
  "seat belt": ["CUT","CUU"],
  "seaweed": ["Dt5"],
  "second": ["Dt6"],
  "secret": ["Dt7"],
  "secretary": ["EL9","EMA","DLv","DLu","CUe","CUd"],
  "security guard": ["EMC","EMB","D5E","DLw","DLx","CUf","CUg","CUh","CUi"],
  "see": ["DlV","DlW","DlX","DlY"],
  "see a ghost": ["DlV"],
  "see an elephant": ["DlW","DlX"],
  "see saw": ["EUH","DlV","DlW","DlX","DlY"],
  "see seen": ["EVj"],
  "see the Eiffel Tower": ["DlY"],
  "seed": ["CUo","CUj","CUk","CUl","CUm","CUn"],
  "seeds": ["CUp"],
  "seeing": ["DlY","DlV","DlW","DlX"],
  "seeing a ghost": ["DlV"],
  "seeing an elephant": ["DlW","DlX"],
  "seeing the Eiffel Tower": ["DlY"],
  "seen": ["EVj"],
  "seen an elephant": ["EVj"],
  "seesaw": ["CUt","CUq","CUr","CUs"],
  "selfish": ["Dt8"],
  "sell": ["Ece","EZN","EZM","EZL","DlZ","Dla","Dlb","Dlc","CUu"],
  "sell apples": ["Ece","DlZ"],
  "sell cars": ["EZL","EMD","Dla"],
  "sell drinks": ["EZM","Dlb"],
  "sell homes": ["EME"],
  "sell medicine": ["EZN","EMF","Dlc"],
  "sell sold": ["EUP","DlZ","Dla","Dlb","Dlc"],
  "sell things": ["EMG"],
  "selling": ["Ece","Dlc","DlZ","Dla","Dlb"],
  "selling apples": ["Ece","DlZ"],
  "selling cars": ["Dla"],
  "selling drinks": ["Dlb"],
  "selling medicine": ["Dlc"],
  "send": ["EZP","EZO","Dld","Dle","Dlf","CUw","CUv"],
  "send a message": ["EZO","Dld"],
  "send an email": ["EZP","Dle","Dlf"],
  "send sent": ["ETi","Dld","Dle","Dlf"],
  "sending": ["Dlf","Dld","Dle"],
  "sending a message": ["Dld"],
  "sending an email": ["Dle","Dlf"],
  "sent": ["ETi"],
  "sent an email": ["ETi"],
  "September": ["Dt9"],
  "Serbia": ["EMH"],
  "serious": ["DuA"],
  "servant": ["CUx"],
  "servants": ["CUy"],
  "serve": ["Ecf","EZQ","Dlh","Dlg"],
  "serve a country": ["EMI"],
  "serve food": ["Ecf","EZQ","EMJ","Dlg"],
  "serve served": ["EUJ","Dlg","Dlh"],
  "served": ["EUJ"],
  "served some food": ["EUJ"],
  "serving": ["Ecf","Dlh","Dlg"],
  "serving food": ["Ecf","Dlg"],
  "set the table": ["DuB"],
  "seven": ["Dbw","Dbu"],
  "seven hundred": ["Dbv"],
  "seven o'clock": ["DeU"],
  "seven thousand": ["Dbz"],
  "seventeen": ["Dby","Dbx"],
  "seventy": ["Db6","Db0"],
  "seventy eight": ["Db1"],
  "seventy five": ["Db2"],
  "seventy four": ["Db3"],
  "seventy nine": ["Db4"],
  "seventy one": ["Db5"],
  "seventy seven": ["Db7"],
  "seventy six": ["Db8"],
  "seventy thousand": ["Db9"],
  "seventy three": ["DcA"],
  "seventy two": ["DcB"],
  "sew": ["EZR","Dli","CU6","CUz","CU0"],
  "sew clothes": ["EZR","Dli"],
  "sew sewed": ["Dli"],
  "sew some clothes": ["EMK"],
  "sewing": ["Dli","CU5"],
  "sewing clothes": ["Dli"],
  "sewing machine": ["CU1","CU2","CU3","CU4"],
  "shade": ["CU8","CU7"],
  "shades": ["CVC","CU9","CVA","CVB"],
  "shadow": ["CVF","CVD","CVE"],
  "shake": ["Dlj","Dlk","CVL","CVG","CVH"],
  "shake hands": ["Edh","Dlj","Dlk","CVI","CVJ","CVK"],
  "shake shook": ["EU9","Dlj","Dlk"],
  "shaker": ["CVN","CVM"],
  "shaking": ["Dlk","Dlj"],
  "shaking hands": ["Edh","Dlj","Dlk"],
  "shallow": ["DuC"],
  "shampoo": ["D5F","DLy","CVQ","CVO","CVP"],
  "shapes": ["CVR"],
  "share": ["Dll"],
  "share a pizza": ["Dll"],
  "share pizza#": ["CVS"],
  "share shared": ["Dll"],
  "sharing": ["Dll"],
  "sharing a pizza": ["Dll"],
  "shark": ["D5G","DLz","CVV","CVT","CVU"],
  "sharp": ["DL2","CVc","CVW","CVX"],
  "sharpener": ["D5H","DL0","CVb","CVY","CVZ","CVa"],
  "sharper": ["ESD","DL1"],
  "shave": ["Ebb","EZT","Dlm","Dln"],
  "shave shaved": ["EVc","Dlm","Dln"],
  "shave your head": ["EZT","Dln"],
  "shaved": ["EVc"],
  "shaved his head": ["EVc"],
  "shaving": ["Ebb","Dlm","Dln","CVe","CVd"],
  "shaving your head": ["Dln"],
  "shawl": ["DuD"],
  "she asks a question": ["Ebw"],
  "she blows her nose": ["Ebx"],
  "she brushes her hair": ["Eby"],
  "she carries a box": ["Ebz"],
  "she closes her laptop": ["Eb0"],
  "she combs her hair": ["Eb1"],
  "she concentrates": ["Eb2"],
  "she cooks": ["Eb3"],
  "she coughs": ["Eb4"],
  "she cries": ["Eb5"],
  "she cuts paper": ["Eb6"],
  "she designs clothes": ["Eb7"],
  "she dives into the water": ["Eb8"],
  "she does homework": ["Eb9"],
  "she draws on the board": ["EcA"],
  "she drinks water": ["EcB"],
  "she drives a car": ["EcC"],
  "she drops a ball": ["EcD"],
  "she eats pizza": ["EcE"],
  "she feeds a dog": ["EcF"],
  "she fills a glass with water": ["EcG"],
  "she fills out a form": ["EcH"],
  "she gets a book": ["EcI"],
  "she gets a haircut": ["EcJ"],
  "she hands out fliers": ["EcK"],
  "she hangs up clothes": ["EcL"],
  "she highlights lines": ["EcM"],
  "she holds a baby": ["EcN"],
  "she ignores him": ["EcO"],
  "she irons a shirt": ["EcP"],
  "she is asking a question": ["Ebw"],
  "she is blowing her nose": ["Ebx"],
  "she is brushing her hair": ["Eby"],
  "she is carrying a box": ["Ebz"],
  "she is closing her laptop": ["Eb0"],
  "she is combing her hair": ["Eb1"],
  "she is concentrating": ["Eb2"],
  "she is cooking": ["Eb3"],
  "she is coughing": ["Eb4"],
  "she is crying": ["Eb5"],
  "she is cutting paper": ["Eb6"],
  "she is designing clothes": ["Eb7"],
  "she is diving into the water": ["Eb8"],
  "she is doing homework": ["Eb9"],
  "she is drawing on the board": ["EcA"],
  "she is drinking water": ["EcB"],
  "she is driving a car": ["EcC"],
  "she is dropping a ball": ["EcD"],
  "she is eating pizza": ["EcE"],
  "she is feeding a dog": ["EcF"],
  "she is filling a glass with water": ["EcG"],
  "she is filling out a form": ["EcH"],
  "she is getting a book": ["EcI"],
  "she is getting a haircut": ["EcJ"],
  "she is handing out fliers": ["EcK"],
  "she is hanging up clothes": ["EcL"],
  "she is highlighting lines": ["EcM"],
  "she is holding a baby": ["EcN"],
  "she is hot": ["Ehm"],
  "she is ignoring him": ["EcO"],
  "she is ironing a shirt": ["EcP"],
  "she is looking after children": ["EcQ"],
  "she is moving the mouse": ["EcR"],
  "she is opening a bottle": ["EcS"],
  "she is opening a window": ["EcT"],
  "she is paying money": ["EcU"],
  "she is peeling a banana": ["EcV"],
  "she is picking flowers": ["EcW"],
  "she is pouring coffee": ["EcX"],
  "she is pressing a button": ["EcY"],
  "she is putting away the groceries": ["EcZ"],
  "she is reading a book": ["Eca"],
  "she is riding a horse": ["Ecb"],
  "she is running": ["Ecc"],
  "she is saying 'hello'": ["Ecd"],
  "she is selling apples": ["Ece"],
  "she is serving food": ["Ecf"],
  "she is shouting": ["Ecg"],
  "she is showing her id": ["Ech"],
  "she is singing": ["Eci"],
  "she is sitting": ["Ecj"],
  "she is skating": ["Eck"],
  "she is skiing": ["Ecl"],
  "she is sleeping": ["Ecm"],
  "she is smelling a flower": ["Ecn"],
  "she is smiling": ["Eco"],
  "she is speaking English": ["Ecp"],
  "she is studying": ["Ecq"],
  "she is taking a photo": ["Ecr"],
  "she is taking a shower": ["Ecs"],
  "she is taking some pizza": ["Ect"],
  "she is talking on the phone": ["Ecu"],
  "she is tall": ["EiD"],
  "she is telling off the boy": ["Ecv"],
  "she is thinking": ["Ecw"],
  "she is tired": ["EiF"],
  "she is trying on a dress": ["Ecx"],
  "she is turning down some cake": ["Ecy"],
  "she is turning on the light": ["Ecz"],
  "she is tying her shoes": ["Ec0"],
  "she is using a computer": ["Ec1"],
  "she is visiting her grandparents": ["Ec2"],
  "she is waking up": ["Ec3"],
  "she is walking the dog": ["Ec4"],
  "she is waving her hand": ["Ec5"],
  "she is wearing glasses": ["Ehz"],
  "she is wiping the table": ["Ec6"],
  "she is withdrawing money": ["Ec7"],
  "she is writing": ["Ec8"],
  "she looks after children": ["EcQ"],
  "she moves the mouse": ["EcR"],
  "she opens a bottle": ["EcS"],
  "she opens a window": ["EcT"],
  "she pays money": ["EcU"],
  "she peels a banana": ["EcV"],
  "she picks flowers": ["EcW"],
  "she pours coffee": ["EcX"],
  "she presses a button": ["EcY"],
  "she puts away the groceries": ["EcZ"],
  "she reads a book": ["Eca"],
  "she rides a horse": ["Ecb"],
  "she runs": ["Ecc"],
  "she says 'hello'": ["Ecd"],
  "she sells apples": ["Ece"],
  "she serves food": ["Ecf"],
  "she shouts": ["Ecg"],
  "she shows her id": ["Ech"],
  "she sings": ["Eci"],
  "she sits": ["Ecj"],
  "she skates": ["Eck"],
  "she skis": ["Ecl"],
  "she sleeps": ["Ecm"],
  "she smells a flower": ["Ecn"],
  "she smiles": ["Eco"],
  "she speaks english": ["Ecp"],
  "she studies": ["Ecq"],
  "she takes a photo": ["Ecr"],
  "she takes a shower": ["Ecs"],
  "she takes some pizza": ["Ect"],
  "she talks on the phone": ["Ecu"],
  "she tells off the boy": ["Ecv"],
  "she thinks": ["Ecw"],
  "she ties her shoes": ["Ec0"],
  "she tries on a dress": ["Ecx"],
  "she turns down some cake": ["Ecy"],
  "she turns on the light": ["Ecz"],
  "she uses a computer": ["Ec1"],
  "she visits her grandparents": ["Ec2"],
  "she wakes up": ["Ec3"],
  "she walks the dog": ["Ec4"],
  "she waves her hand": ["Ec5"],
  "she wipes the table": ["Ec6"],
  "she withdraws money": ["Ec7"],
  "she writes": ["Ec8"],
  "shed": ["D5I","DL3","CVi","CVf","CVg","CVh"],
  "sheep": ["D5J","DL4","CVo","CVj","CVk","CVl","CVm"],
  "sheepdog": ["DYl","CVn"],
  "sheet": ["CVr","CVp","CVq"],
  "sheets": ["CVs"],
  "shelf": ["CVx","CVt","CVu","CVv","CVw"],
  "shell": ["DL5","CV1","CVy","CVz","CV0"],
  "shells": ["CV4","CV2","CV3"],
  "shelter": ["CV8","CV5","CV6","CV7"],
  "shelves": ["D5K","DL6","CWC","CV9","CWA","CWB"],
  "shepherd": ["CWF","CWD","CWE"],
  "shield": ["D5L","DL7","CWK","CWG","CWH","CWI","CWJ"],
  "shine": ["CWM","CWL"],
  "shiny": ["CWN"],
  "ship": ["CWQ","CWO","CWP"],
  "shirt": ["D5M","DL9","DL8","CWS","CWR"],
  "shitzu": ["CWU","CWT"],
  "shock": ["CWZ","CWV"],
  "shocked": ["CWY","CWW","CWX"],
  "shoe": ["CWc","CWa","CWb"],
  "shoe shop": ["CWh","CWi"],
  "shoe store": ["CWk","CWl"],
  "shoes": ["D5N","DMC","DMA","DMB","CWj","CWd","CWe","CWf","CWg"],
  "shook": ["EU9"],
  "shook hands": ["EU9"],
  "shop": ["Edi","Dlo"],
  "shop assistant": ["EMr","EMq","D5O","DMD","DME"],
  "shop shopped": ["Dlo"],
  "shopping": ["Edi","Dlo","CWu","CWm"],
  "shopping cart": ["D5P","DMF"],
  "shopping center": ["DMG","DuE","CWn","CWo"],
  "shopping centre": ["DMG","DuE","CWn","CWo"],
  "shopping list": ["CWp"],
  "shopping mall": ["CWq","CWr","CWs","CWt"],
  "shops": ["CWv"],
  "shore": ["DuF"],
  "short": ["EMs","EMt","DuH","DuG"],
  "short hair": ["CWw","CWx"],
  "shorter": ["ESE","DMJ","DMH","DMI"],
  "shorts": ["D5Q","DMK","CW1","CWy","CWz","CW0"],
  "shoulder": ["D5R","DML","CW2"],
  "shoulders": ["CW4","CW3"],
  "shout": ["Ecg","EMu","Dlp","CW7"],
  "shout angrily": ["ERR"],
  "shout shouted": ["Dlp"],
  "shouting": ["Ecg","Dlp","CW6","CW5"],
  "shovel": ["CXB","CW8","CW9","CXA"],
  "show": ["Ech","EZU","Dlq","Dlr"],
  "show a phone": ["EZU","Dlq"],
  "show id": ["Ech"],
  "show showed": ["EUK","Dlq","Dlr"],
  "show your ID": ["Dlr"],
  "showed": ["EUK"],
  "showed her id": ["EUK"],
  "shower": ["D5S","DMM","CXG","CXC","CXD","CXE","CXF"],
  "showing": ["Ech","Dlr","Dlq"],
  "showing a phone": ["Dlq"],
  "showing your ID": ["Dlr"],
  "shrimp": ["Eg8","D5T","DMN","CXL","CXH","CXI","CXJ","CXK"],
  "shrugged": ["CXO","CXM","CXN"],
  "shut": ["Ebc","EZV","ETL","Dls"],
  "shut shut": ["ETL","Dls"],
  "shut the door": ["Ebc","EZV","ETL","Dls"],
  "shutting": ["Ebc","Dls"],
  "shutting the door": ["Ebc","Dls"],
  "shuttlecock": ["DuI"],
  "shy": ["EMv","CXP"],
  "sibling": ["CXQ"],
  "siblings": ["CXR"],
  "sick": ["EMw","DMO","CXU","CXS","CXT"],
  "side dish": ["CXV","CXW","CXX"],
  "sidewalk": ["DuJ"],
  "sight": ["DuK"],
  "sightseeing": ["CXa","CXY","CXZ"],
  "sign": ["Ebd","Dlt","Dlu","CXc","CXb"],
  "sign his name": ["Dlt"],
  "sign name": ["Ebd"],
  "sign signed": ["EUe","Dlt","Dlu","Dlv"],
  "sign your name": ["Dlu"],
  "signed": ["EUe"],
  "signed my name": ["EUe"],
  "significant": ["DuL"],
  "signing": ["Ebd","Dlu","Dlt"],
  "signing his name": ["Dlt"],
  "signing your name": ["Dlu"],
  "signpost": ["CXg","CXd","CXe","CXf"],
  "silence": ["CXi","CXh"],
  "silent": ["CXj"],
  "silk": ["CXk"],
  "silly": ["CXm","CXl"],
  "silver": ["DMP","CXo","CXn"],
  "sing": ["Eci","EZW","Dlx","Dlv","Dlw","CX3","CXp","CXq"],
  "sing a song": ["EZW","CXv"],
  "sing karaoke": ["Dlw"],
  "sing sang": ["EUF","Dlw","Dlx"],
  "sing songs": ["EM0"],
  "sing sung": ["EWA"],
  "Singapore": ["EMx","CXu","CXr","CXs","CXt"],
  "Singapore flag": ["DMQ"],
  "singer": ["EMy","EMz","D5U","DMS","DMR","CXz","CXw","CXx","CXy"],
  "singing": ["Eci","Dlx","Dlv","Dlw","CX2","CX0","CX1"],
  "singing karaoke": ["Dlw"],
  "sink": ["D5V","DMT","CX8","CX4","CX5","CX6","CX7"],
  "sip": ["CX9"],
  "sister": ["EM2","EM1","EM5","DZe","CYA"],
  "sister in law": ["EM3","EM4"],
  "sisterinlaw": ["EM3","EM4"],
  "sit": ["Ecj","EZX","CYI","CYB","CYC","CYD","CYE"],
  "sit down": ["EM7","EM6","Dly","CYF","CYG"],
  "sit down comfortably": ["ERS"],
  "sit down sat down": ["Dly"],
  "sit on": ["Dlz"],
  "sit on a sofa": ["Dlz"],
  "sit on the sofa": ["EZX","CYH"],
  "sit sat": ["EUG","Dlz"],
  "sit up": ["CYK"],
  "sitcom": ["DuM"],
  "sitting": ["Ecj"],
  "sitting down": ["Dly"],
  "sitting on": ["Dlz"],
  "sitting on a sofa": ["Dlz"],
  "sitting room": ["CYJ"],
  "six": ["DcE","DcC"],
  "six hundred": ["DcD"],
  "six o'clock": ["DeV"],
  "six thousand": ["DcH"],
  "sixteen": ["DcG","DcF"],
  "sixty": ["DcO","DcI"],
  "sixty eight": ["DcJ"],
  "sixty five": ["DcK"],
  "sixty four": ["DcL"],
  "sixty nine": ["DcM"],
  "sixty one": ["DcN"],
  "sixty seven": ["DcP"],
  "sixty six": ["DcQ"],
  "sixty thousand": ["DcR"],
  "sixty three": ["DcS"],
  "sixty two": ["DcT"],
  "skate": ["Eck","Dl1","Dl0","CYQ"],
  "skate park": ["DuN"],
  "skate skated": ["EUL","Dl0","Dl1"],
  "skateboard": ["D5X","DMV","CYP","CYL","CYM"],
  "skateboarding": ["D5W","DMU","CYO","CYN"],
  "skated": ["EUL"],
  "skates": ["CYR"],
  "skating": ["Eck","Dl1","Dl0","CYS"],
  "skating rink": ["CYT"],
  "skeleton": ["EM8","CYW","CYU","CYV"],
  "skeletons": ["EM9"],
  "sketch": ["CYX"],
  "ski": ["Ecl","Dl2","CYf","CYY","CYZ"],
  "ski jacket": ["CYc"],
  "ski skied": ["Dl2"],
  "skiing": ["Ecl","D5Y","Dl2","DMW","CYb","CYa"],
  "skin": ["CYd"],
  "skinny": ["DuO"],
  "skip": ["CYi","CYe"],
  "skipping": ["CYg"],
  "skipping rope": ["CYh"],
  "skirt": ["D5Z","DMX","CYo","CYj","CYk","CYl","CYm","CYn"],
  "skis": ["DMY","CYp"],
  "skull": ["CYt","CYq","CYr","CYs"],
  "skunk": ["D5a","DMZ","CYx","CYu","CYv","CYw"],
  "sky": ["CY1","CYy","CYz","CY0","DvQ"],
  "skydiving": ["DuP"],
  "skyscraper": ["CY4","CY2","CY3"],
  "skyscrapers": ["D5b","CY7","CY5","CY6"],
  "skyscrappers": ["DMa"],
  "sled": ["CZG","CY8","CY9","CZA"],
  "sledge": ["CZF","CZB","CZC","CZD","CZE"],
  "sleep": ["Ecm","EZY","END","Dl6","Dl3","Dl4","Dl5","CZP","CZH","CZI"],
  "sleep in class": ["EZY","Dl5"],
  "sleep like a log": ["ENA","ENB","ENC"],
  "sleep slept": ["EVw","ETM","Dl3","Dl4","Dl5","Dl6"],
  "sleeping": ["Ecm","Dl6","Dl3","Dl4","Dl5","CZN","CZJ","CZK"],
  "sleeping bag": ["CZL","CZM"],
  "sleeping in class": ["Dl5"],
  "sleepover": ["CZO"],
  "sleepy": ["CZS","CZQ","CZR"],
  "sleigh": ["Eh4","ENE","CZX","CZT","CZU","CZV","CZW"],
  "slept": ["EVw","ETM"],
  "slept in class": ["EVw"],
  "slice": ["CZe","CZY","CZZ","CZa","CZb"],
  "slice of cake": ["CZc"],
  "slice of pie": ["CZd"],
  "slide": ["D5c","DMb","CZh","CZf","CZg"],
  "slim": ["CZi"],
  "slip": ["DuQ"],
  "slippers": ["D5d","DMc","CZm","CZj","CZk","CZl"],
  "slope": ["CZn"],
  "sloth": ["DuR"],
  "Slovakia": ["ENF","CZr","CZo","CZp","CZq"],
  "Slovenia": ["ENG"],
  "slow": ["ENH","DMe","CZt","CZs"],
  "slower": ["ESF","DMd"],
  "slowly": ["ERV","DuS"],
  "small": ["Eh5","Eh6","ENI","DMj","DMf"],
  "smaller": ["ESG","DMi","DMg","DMh"],
  "smart": ["CZw"],
  "smart watch": ["D5e","DMk"],
  "smartphone": ["CZv","CZu"],
  "smash": ["CZy","CZx"],
  "smell": ["Ecn","EZb","EZa","Dl7","Dl8","Dl9","DmA"],
  "smell a flower": ["Ecn","Dl7"],
  "smell bad": ["Eh7","EZa","Dl8","Dl9"],
  "smell flowers": ["DmA"],
  "smell nice": ["EZb"],
  "smell smelled": ["EUM","Dl7","Dl8","Dl9","DmA"],
  "smelled": ["EUM"],
  "smelled a flower": ["EUM"],
  "smelling": ["Ecn","DmA","Dl7","Dl8","Dl9"],
  "smelling a flower": ["Ecn","Dl7"],
  "smelling bad": ["Dl8","Dl9"],
  "smelling flowers": ["DmA"],
  "smelly": ["Eh7","ENJ","DMl"],
  "smile": ["Eco","DmC","DmB","CZ0","CZz"],
  "smile smiled": ["EUN","DmB","DmC"],
  "smiled": ["EUN"],
  "smiling": ["Eco","DmC","DmB","CZ3","CZ1","CZ2"],
  "smoke": ["CZ5","CZ4"],
  "smooth": ["DuT"],
  "smoothie": ["CaA","CZ6","CZ7","CZ8","CZ9"],
  "snack": ["DuV","DuU"],
  "snacks": ["DuW"],
  "snail": ["D5f","DMm","CaE","CaB","CaC","CaD"],
  "snake": ["D5g","DMn","CaK","CaF","CaG","CaH","CaI","CaJ"],
  "snakes": ["CaM","CaL"],
  "sneaker": ["CaO","CaN"],
  "sneakers": ["D5h","DMo","CaR","CaP","CaQ"],
  "sneaky": ["CaS"],
  "sneeze": ["DmD","CaU","CaT"],
  "sneeze sneezed": ["EUO","DmD"],
  "sneezed": ["EUO"],
  "sneezing": ["DmD","CaV"],
  "sniff": ["CaW"],
  "sniper": ["CaX"],
  "snooker": ["CaZ","CaY"],
  "snore": ["ENK","Caa"],
  "snore noisily": ["ERT"],
  "snorkel": ["D5i","DMp","Cag","Cab","Cac","Cad"],
  "snorkeling": ["Caf","Cae"],
  "snow": ["D5j","DmE","DMr","DMq","CbR","Cah","Cai","Caj","Cak"],
  "snow globe": ["Ca5","Ca6","Ca7","Ca8"],
  "snow leopard": ["CbC","CbD","CbE","CbF","CbG","CbH"],
  "snow shoes": ["CbS","CbT"],
  "snow snowed": ["ETa","DmE"],
  "snowball": ["Can","Cal"],
  "snowball fight": ["Cam"],
  "snowboard": ["Caw","Cao"],
  "snowboarder": ["Car","Cap","Caq"],
  "snowboarding": ["Cav","Cas","Cat","Cau"],
  "snowed": ["ETa"],
  "snowflake": ["ENL","Ca0","Cax","Cay","Caz"],
  "snowflakes": ["Ca4","Ca1","Ca2","Ca3"],
  "snowing": ["DmE","CbB","Ca9","CbA"],
  "snowman": ["Eh8","ENM","CbO","CbI","CbJ","CbK","CbL","CbM","CbN"],
  "snowmen": ["CbQ","CbP"],
  "snowstorm": ["CbW","CbU","CbV"],
  "snowy": ["ENN","CbZ","CbX","CbY"],
  "soap": ["D5k","DMs","Cbe","Cba","Cbb","Cbc","Cbd"],
  "soccer": ["D5l","DMt","Cbs","Cbf","Cbg","Cbh","Cbi"],
  "soccer ball": ["Cbj","Cbk","Cbl","Cbm"],
  "soccer field": ["Cbn","Cbo"],
  "soccer player": ["Cbp","Cbq","Cbr"],
  "sociable": ["DuX"],
  "social media": ["Cbt"],
  "sock": ["Cbx","Cbu","Cbv","Cbw"],
  "socket": ["D5m","DMu"],
  "socks": ["D5n","DMw","DMv","Cb1","Cby","Cbz","Cb0"],
  "soda": ["DMx","Cb6","Cb2","Cb3","Cb4","Cb5"],
  "sofa": ["D5o","DMy","CcA","Cb7","Cb8","Cb9"],
  "soft": ["ENO","CcC","CcB"],
  "software developer": ["ENQ","ENP","DMz","DM0"],
  "software engineer": ["ENS","ENR","DM1","DM2"],
  "soil": ["CcH","CcD","CcE","CcF","CcG"],
  "solar eclipse": ["CcI","CcJ","CcK","CcL"],
  "solar system": ["CcM","CcN"],
  "sold": ["EUP","DuY"],
  "sold apples": ["EUP"],
  "soldier": ["ENT","ENU","D5p","DM4","DM3","CcR","CcO","CcP","CcQ"],
  "soldiers": ["CcV","CcS","CcT","CcU"],
  "solid": ["CcW"],
  "solitary": ["CcY","CcX"],
  "solve": ["CcZ"],
  "son": ["ENV","ENX","DZg","Ccc","Cca"],
  "son in law": ["ENW","DZf"],
  "song": ["Ccb"],
  "soninlaw": ["ENW"],
  "sore throat": ["D5q","DM5","Ccd"],
  "sorry": ["DuZ"],
  "soul": ["Ccf","Cce"],
  "soup": ["D5r","DM6","Ccj","Ccg","Cch","Cci"],
  "soup spoon": ["Cck","Ccl","Ccm"],
  "South Africa": ["ENY","D5s","DM9","Ccn","Cco","Ccp","Ccq"],
  "South Africa flag": ["DM7"],
  "South African": ["EeT","DM8"],
  "South America": ["Ccr","Ccs"],
  "South Korea": ["Cct","Ccu","Ccv"],
  "souvenir": ["Ccw"],
  "soy sauce": ["Ccx","Ccy","Ccz"],
  "space": ["Cc3","Cc0","Cc1","Cc2"],
  "space shuttle": ["Cc7","Cc8","Cc9"],
  "space station": ["CdA","CdB"],
  "space suit": ["CdC","CdD","CdE"],
  "spacecraft": ["Dua"],
  "spaceship": ["Cc6","Cc4","Cc5"],
  "spacious": ["CdG","CdF"],
  "spade": ["D5t","DNA","CdJ","CdH","CdI"],
  "spaghetti": ["D5v","DNC","CdO","CdK","CdL","CdM","CdN"],
  "spaghetti bolognese": ["D5u","DNB"],
  "Spain": ["ENZ","D5w","DNE","CdS","CdP","CdQ","CdR"],
  "Spain flag": ["DND"],
  "Spanish": ["EeU","D5x","DNG","DNF"],
  "spare ribs": ["CdT","CdU"],
  "spark": ["CdY"],
  "sparkler": ["CdV"],
  "sparkling water": ["CdW","CdX"],
  "sparrow": ["Cdb","CdZ","Cda"],
  "spatula": ["D5y","DNH","Cdd","Cdc"],
  "speak": ["Ecp","EZd","DmH","DmF","DmG","DmI"],
  "speak about politics": ["ENa"],
  "speak Chinese": ["DmF"],
  "speak different languages": ["ENb"],
  "speak English": ["Ecp","DmG"],
  "speak Spanish": ["EZd","DmI"],
  "speak spoke": ["ETN","DmF","DmG","DmH","DmI"],
  "speak spoken": ["EV8"],
  "speakers": ["D5z","DNI","Cdf","Cde"],
  "speaking": ["Ecp","DmH","DmF","DmG","DmI"],
  "speaking Chinese": ["DmF"],
  "speaking English": ["DmG"],
  "speaking Spanish": ["DmI"],
  "spear": ["Cdj","Cdg","Cdh","Cdi"],
  "special": ["Dub"],
  "species": ["Duc"],
  "speed camera": ["Cdk","Cdl"],
  "speed limit": ["Cdm","Cdn"],
  "spell": ["Cdo"],
  "sphere": ["Dud"],
  "sphinx": ["Cdr","Cdp","Cdq"],
  "spicy": ["Cdu","Cds","Cdt"],
  "spider": ["ENc","D50","DNJ","Cdy","Cdv","Cdw","Cdx"],
  "spider web": ["Cd1","Cd2","Cd3","Cd4"],
  "spiders": ["Cd0","Cdz"],
  "spike": ["Cd5"],
  "spiky": ["Cd9","Cd6","Cd7"],
  "spiky hair": ["Cd8"],
  "spill": ["DmJ","CeC","CeA","CeB"],
  "spill spilt": ["EUt","DmJ"],
  "spill water": ["DmJ"],
  "spilling": ["DmJ"],
  "spilling water": ["DmJ"],
  "spilt": ["EUt"],
  "spin": ["Duf"],
  "spinach": ["CeH","CeD","CeE","CeF","CeG"],
  "spine": ["CeJ","CeI"],
  "spinkle": ["Due"],
  "spit": ["CeK"],
  "splash": ["CeN","CeL","CeM"],
  "split": ["CeO"],
  "spoil": ["CeQ","CeP"],
  "spoke": ["ETN"],
  "spoken": ["EV8"],
  "spoken chinese": ["EV8"],
  "sponge": ["CeT","CeR","CeS"],
  "spoon": ["D51","DNK","CeX","CeU","CeV","CeW"],
  "sports": ["Duj"],
  "sports car": ["CeY","CeZ","Cea"],
  "sports center": ["Dug","Duh"],
  "sports centre": ["Dug","Duh"],
  "sports field": ["Dui"],
  "sporty": ["Duk"],
  "spots": ["Dul"],
  "spray": ["EZe","DmK"],
  "spray sprayed": ["DmK"],
  "spray water": ["EZe"],
  "spraying": ["DmK"],
  "spread": ["EZf","DmL"],
  "spread butter": ["EZf","DmL"],
  "spread spread": ["DmL"],
  "spreading": ["DmL"],
  "spreading butter": ["DmL"],
  "spring": ["Dum"],
  "spring onion": ["Ceb","Cec"],
  "spring onions": ["Ced","Cee"],
  "spring roll": ["Cef","Ceg"],
  "spring rolls": ["DNL"],
  "sprinkler": ["Ceh"],
  "spy": ["Cej","Cei"],
  "square": ["Cek"],
  "squash": ["Cen","Cel","Cem"],
  "squats": ["Cep","Ceo"],
  "squeeze": ["Ebe","DmM","Ces","Ceq","Cer"],
  "squeeze an orange": ["Ebe","DmM"],
  "squeeze squeezed": ["DmM"],
  "squeezing": ["Ebe","DmM"],
  "squeezing an orange": ["Ebe","DmM"],
  "squid": ["Cew","Cet","Ceu","Cev"],
  "squirrel": ["D52","DNM","Ce0","Cex","Cey","Cez"],
  "Sri Lanka": ["ENd","Ce1","Ce2","Ce3"],
  "stable": ["Ce6","Ce4","Ce5"],
  "stack of books": ["Ce7"],
  "stadium": ["D53","DNN","CfB","Ce8","Ce9","CfA"],
  "stage": ["CfD","CfC"],
  "stair": ["CfG","CfE","CfF"],
  "stairs": ["DNO","CfM","CfH","CfI","CfJ","CfK","CfL"],
  "stamp": ["CfQ","CfN","CfO","CfP"],
  "stamps": ["CfR"],
  "stand": ["DmN"],
  "stand stood": ["EUQ","DmN"],
  "stand up": ["ENe","DmO"],
  "stand up stood up": ["DmO"],
  "standing": ["DmN"],
  "standing in line": ["Dun"],
  "standing up": ["DmO"],
  "stapler": ["D54","DNP","CfU","CfS","CfT"],
  "star": ["Cfh","CfV","CfW"],
  "star fish": ["CfX","CfY","CfZ"],
  "star fruit": ["Cfa","Cfb","Cfc","Cfd"],
  "stare": ["EZh","DmP"],
  "stare out the window": ["EZh","DmP"],
  "stare stared": ["DmP"],
  "starfish": ["Duo"],
  "staring": ["DmP"],
  "staring out the window": ["DmP"],
  "starling": ["Cfg","Cfe","Cff"],
  "starry night": ["Cfi"],
  "stars": ["D55","DNQ","Cfm","Cfj","Cfk","Cfl"],
  "start": ["EZi","DmQ","DmR","Cfo","Cfn"],
  "start a race": ["DmQ"],
  "start school": ["EZi","DmR"],
  "start started": ["EWQ","DmQ","DmR"],
  "started": ["EWQ"],
  "started the race": ["EWQ"],
  "starting": ["DmR","DmQ"],
  "starting a race": ["DmQ"],
  "starting school": ["DmR"],
  "station": ["Cft","Cfp","Cfq","Cfr","Cfs"],
  "statue": ["D56","DNR","Cfy","Cfu","Cfv","Cfw","Cfx"],
  "stay": ["EZj"],
  "stay at home": ["Dup"],
  "stay in": ["DmS"],
  "stay in bed": ["EZj","DmS"],
  "stay stayed": ["DmS"],
  "staying in": ["DmS"],
  "staying in bed": ["DmS"],
  "steak": ["D57","DNT","Cf4","Cfz","Cf0","Cf1","Cf2","Cf3"],
  "steak and chips": ["DNS"],
  "steal": ["Ebf","DmT"],
  "steal a wallet": ["Ebf","DmT"],
  "steal stole": ["ETO","DmT"],
  "stealing": ["Ebf","DmT"],
  "stealing a wallet": ["Ebf","DmT"],
  "steam": ["Duq"],
  "steam engine": ["Cf5","Cf6"],
  "steep": ["Cf9","Cf7","Cf8"],
  "stem": ["Dur"],
  "step ladder": ["CgA","CgB","CgC","CgD"],
  "steps": ["CgH","CgE","CgF","CgG"],
  "stereo": ["D58","DNU"],
  "stethoscope": ["D59","DNV","CgK","CgI","CgJ"],
  "stew": ["CgM","CgL"],
  "stick": ["CgU","CgN","CgO","CgP"],
  "stick insect": ["CgQ","CgR","CgS","CgT"],
  "stick out like a sore thumb": ["ENf","ENg","ENh"],
  "stickers": ["Dus"],
  "sticks": ["Dut"],
  "sticky": ["CgV"],
  "sticky rice": ["Duu"],
  "sticky tape": ["CgW"],
  "stilt house": ["CgX"],
  "sting": ["DmU","Cga","CgY","CgZ"],
  "sting stung": ["ESU","DmU"],
  "stinging": ["DmU"],
  "stingray": ["Duv"],
  "stir": ["DmV","Cgc","Cgb"],
  "stir stirred": ["DmV"],
  "stiring": ["DmV"],
  "stocking": ["Eh9","ENi","Cgf","Cgd","Cge"],
  "stole": ["ETO"],
  "stole a wallet": ["ETO"],
  "stomach": ["Cgg"],
  "stomach ache": ["D6A","DNW"],
  "stomp": ["Duw"],
  "stone": ["Cgi","Cgh"],
  "stood": ["EUQ"],
  "stood up": ["EUQ"],
  "stool": ["D6B","DNX"],
  "stop": ["EZk","DmX","DmW","Cgk","Cgj"],
  "stop at the lights": ["DmW"],
  "stop at the red light": ["EZk"],
  "stop sign": ["D6C","DNY"],
  "stop stopped": ["EUh","DmW","DmX"],
  "stopped": ["EUh"],
  "stopping": ["DmX","DmW"],
  "stopping at the lights": ["DmW"],
  "store": ["DNZ","Cgl"],
  "stork": ["Cgq","Cgm","Cgn","Cgo","Cgp"],
  "storm": ["DNb","DNa","DYm","Cgt","Cgr","Cgs"],
  "stormy": ["Cgw","Cgu","Cgv"],
  "story": ["Cgz"],
  "storybook": ["Cgy","Cgx"],
  "storyteller": ["Cg0"],
  "stove": ["D6D","DNc","Cg4","Cg1","Cg2","Cg3"],
  "straight": ["Cg8","Cg5","Cg6"],
  "straight hair": ["Cg7"],
  "strange": ["ChB","Cg9","ChA"],
  "straw": ["D6F","DNf","ChV","ChC","ChD","ChE","ChF","ChG"],
  "straw hat": ["ChQ","ChR","ChS","ChT","ChU"],
  "strawberries": ["D6E","DNd","ChL","ChH","ChI","ChJ","ChK"],
  "strawberry": ["Eg9","DNe","ChP","ChM","ChN"],
  "strawberry juice": ["ChO"],
  "stream": ["ChZ","ChW","ChX","ChY"],
  "street": ["Che","Cha","Chb","Chc","Chd"],
  "street light": ["D6G","DNg"],
  "strength": ["Chf"],
  "stressed": ["Chh","Chg"],
  "stretch": ["DmY","Cho","Chi","Chj","Chk"],
  "stretch stretched": ["DmY"],
  "stretcher": ["D6H","DNh"],
  "stretching": ["DmY","Chn","Chl","Chm"],
  "strict": ["Chq","Chp"],
  "strike": ["Chs","Chr"],
  "string": ["Chw","Cht","Chu","Chv"],
  "striped": ["Chy","Chx"],
  "stripes": ["Ch0","Chz"],
  "stripy": ["Ch1"],
  "strong": ["EiA","ENm","DNj","Ch2"],
  "strong as an ox": ["ENj","ENk","ENl"],
  "stronger": ["ESH","DNi"],
  "stubborn": ["Dux"],
  "student": ["Ch7","Ch3","Ch4","Ch5","Ch6"],
  "students": ["CiB","Ch8","Ch9","CiA"],
  "studied": ["EV9","EVA"],
  "studied maths": ["EV9"],
  "studio": ["CiC"],
  "study": ["Ecq","ENp","Dmb","DmZ","Dma","DNk","DYn","CiF","CiD","CiE"],
  "study at college": ["ENn"],
  "study hard": ["ERU"],
  "study in the library": ["ENo"],
  "study Spanish": ["ENq"],
  "study studied": ["EV9","EVA","DmZ","Dma","Dmb"],
  "studying": ["Ecq","Dmb","DmZ","Dma"],
  "stung": ["ESU"],
  "stung me": ["ESU"],
  "stuntman": ["CiH","CiG"],
  "subjects": ["DYo"],
  "submarine": ["DYp","CiM","CiI","CiJ","CiK","CiL"],
  "submersible": ["DYq"],
  "subtract": ["CiN"],
  "suburban": ["CiO"],
  "subway": ["CiT","CiP","CiQ","CiR","CiS"],
  "successful": ["Duy"],
  "Sudan": ["ENr"],
  "sugar": ["DNl","CiW","CiU","CiV"],
  "sugary food": ["DYr"],
  "suggestions": ["DYs"],
  "suit": ["D6J","DNn","Cij","CiX","CiY","CiZ","Cia"],
  "suit and tie": ["Cib","Cic","Cid","Cie"],
  "suitcase": ["D6I","DNm","Cii","Cif","Cig","Cih"],
  "sulk": ["Cik"],
  "summer": ["Duz"],
  "sun": ["D6t","DOn","CjE","Cil","Cim"],
  "sun cream": ["Du1"],
  "sun hat": ["Ci1","Ci2","Ci3","Ci4"],
  "sunbathe": ["Dmc","Cip","Cin","Cio"],
  "sunbathe sunbathed": ["Dmc"],
  "sunbathing": ["Dmc"],
  "sunburn": ["Du0"],
  "suncream": ["Ciq"],
  "Sunday": ["DNq","DNo","DNp"],
  "Sunday roast": ["Cir"],
  "sunflower": ["Cit","Cis"],
  "sunflowers": ["Ciw","Ciu","Civ"],
  "sung": ["EWA"],
  "sung the song": ["EWA"],
  "sunglasses": ["D6K","DNr","Ci0","Cix","Ciy","Ciz"],
  "sunlight": ["Ci8","Ci5","Ci6","Ci7"],
  "sunnier": ["ESI","DNs"],
  "sunny": ["EiB","ENs","DNu","DNt","DYt","CjD","Ci9","CjA","CjB","CjC"],
  "sunrise": ["CjI","CjF","CjG","CjH"],
  "sunscreen": ["DNv","DYu","CjL","CjJ","CjK"],
  "sunset": ["CjQ","CjM","CjN","CjO","CjP"],
  "sunshine": ["CjU","CjR","CjS","CjT"],
  "superhero": ["DNw","CjX","CjV","CjW"],
  "superman": ["Du2"],
  "supermarket": ["DNx","Cja","CjY","CjZ"],
  "supernova": ["Cjc","Cjb"],
  "support": ["EZn","Dmd"],
  "support a team": ["Dmd"],
  "support liverpool": ["EZn"],
  "support supported": ["EVk","Dmd"],
  "supported": ["EVk"],
  "supported liverpool": ["EVk"],
  "supporting": ["Dmd"],
  "supporting a team": ["Dmd"],
  "surf": ["Cjl","Cjd","Cje"],
  "surf board": ["Cjf","Cjg"],
  "surf the internet": ["Du4"],
  "surfboard": ["Du3"],
  "surfing": ["D6L","DNy","Cjk","Cjh","Cji","Cjj"],
  "surgeon": ["ENt","ENu","D6M","DN0","DNz","Cjo","Cjm","Cjn"],
  "surgery": ["Cjr","Cjp","Cjq"],
  "surprise": ["Du5"],
  "surprised": ["ENv","DN1","Cju","Cjs","Cjt"],
  "sushi": ["D6N","DN2","Cjx","Cjv","Cjw"],
  "suspension": ["DYv"],
  "suspicious": ["Cjy"],
  "swam": ["ETP"],
  "swamp": ["Cj3","Cjz","Cj0","Cj1","Cj2"],
  "swan": ["D6O","DN3","Cj6","Cj4","Cj5"],
  "sweat": ["CkD","Cj7","Cj8"],
  "sweater": ["D6P","DN4","CkC","Cj9","CkA","CkB"],
  "sweatshirt": ["CkH","CkE","CkF","CkG"],
  "Sweden": ["ENw","CkL","CkI","CkJ","CkK"],
  "sweep": ["Ebg","EZo","Dme","Dmf","CkP","CkM","CkN","CkO"],
  "sweep swept": ["ETQ","Dme","Dmf"],
  "sweep the floor": ["Ebg","EZo","Dmf"],
  "sweeping": ["Ebg","Dme","Dmf"],
  "sweeping the floor": ["Ebg","Dmf"],
  "sweet": ["Du6"],
  "sweet potato": ["CkV","CkW","CkX","CkZ"],
  "sweet potatoes": ["CkY"],
  "sweet shop": ["Ckd","Cke"],
  "sweetcorn": ["DN5","CkR","CkQ"],
  "sweetheart": ["CkU","CkS","CkT"],
  "sweets": ["Ckf","Cka","Ckb","Ckc"],
  "swept": ["ETQ"],
  "swept the floor": ["ETQ"],
  "swim": ["Ebh","EZp","Dmh","Dmg","Ckr","Ckg"],
  "swim in the sea": ["Du7"],
  "swim in the water": ["EZp"],
  "swim swam": ["ETP","Dmg","Dmh"],
  "swimmer": ["Cki","Ckh"],
  "swimming": ["Ebh","D6Q","Dmh","Dmg","DN7","Ckl","Ckj","Ckk"],
  "swimming cap": ["DN6"],
  "swimming pool": ["Ckm","Ckn","Cko","Ckp"],
  "swimming trunks": ["D6R","DN8","Ckq"],
  "swimsuit": ["D6S","DN9","Cks"],
  "swing": ["D6T","Dmi","DOA","Ckx","Ckt","Cku","Ckv","Ckw"],
  "swing swung": ["Dmi"],
  "swinging": ["Dmi"],
  "swings": ["Cky"],
  "switch": ["D6U","DOB"],
  "Switzerland": ["ENx","Ck2","Ckz","Ck0","Ck1"],
  "swivel chair": ["D6V","DOC"],
  "sword": ["D6W","DOD"],
  "swordfish": ["Ck5","Ck3","Ck4"],
  "syringe": ["D6X","DOE"],
  "syrup": ["Ck7","Ck6"],
  "t": ["DaO","DaN"],
  "t rex": ["Cst","Csu"],
  "t shirt": ["Cth","Ctj","Ctl","Ctn"],
  "table": ["D6Y","DOF","ClG","Ck8","Ck9","ClA","ClB","ClC"],
  "table tennis": ["D6Z","DOG","ClK","ClL","ClM","ClN","ClO"],
  "tablecloth": ["ClF","ClD","ClE"],
  "tablespoon": ["ClH"],
  "tablet": ["D6a","DOH","ClP","ClI","ClJ"],
  "taco": ["D6b","DOI"],
  "tacos": ["ClT","ClQ","ClR","ClS"],
  "tadpole": ["ClW","ClU","ClV"],
  "taekwondo": ["ClY","ClX"],
  "tail": ["D6c","DOL","Cla","ClZ"],
  "tailor": ["ENy","ENz","DOK","DOJ"],
  "Taiwan": ["EN0","Cld","Clb","Clc"],
  "Taiwan flag": ["DOM"],
  "Taj mahal": ["Cle","Clf","Clg"],
  "take": ["Ecs","Edj","EZx","EZw","EZv","EZu","EZt","EZs","EZr","EZq","Dmu","Dmv","Dm0","Dm1","Dm2"],
  "take a bath": ["EZq","EN1","Dmj"],
  "take a cookie": ["EZr","Dmk"],
  "take a nap": ["Clh"],
  "take a photo": ["Edj","EZt","Dml","Dmm","Dmn","Dmo","Cli","Clj","Clk"],
  "take a picture": ["EZu","Du8"],
  "take a shower": ["Ecs","EZv","EN2","Dmp","Dmq","Dmr"],
  "take a test": ["Dms"],
  "take an exam": ["EZs"],
  "take away": ["Du9"],
  "take care": ["EN4","Dmt"],
  "take care of": ["DvA"],
  "take care of a garden": ["EN3"],
  "take care took care": ["Dmt"],
  "take medicine": ["EZw","Dmu"],
  "take money": ["EZx","EN5","Dmv"],
  "take off": ["Ebi","EN7","EN6","Dmw","Dmx"],
  "take off a coat": ["EN7","Ebi"],
  "take off took off": ["Dmw"],
  "take out": ["Ebj","EN9","EN8","Dmy","Dmz"],
  "take out the trash": ["EN8","Ebj","Dmz"],
  "take out took out": ["Dmy","Dmz"],
  "take photos": ["EOA"],
  "take pictures": ["DvB"],
  "take some pizza": ["Dm0","Dm1"],
  "take taken": ["EWB","EWC"],
  "take the bus": ["EOB","Dm2"],
  "take took": ["EVH","Dm0","Dmj","Dmk","Dml","Dmo","Dmp","Dmu","Dmv"],
  "taken": ["EWB","EWC"],
  "taken a bath": ["EWB"],
  "taken a shower": ["EWC"],
  "takes": ["Ect"],
  "takes some pizza": ["Ect"],
  "taking": ["Ecs","Edj","Dmu","Dmv","Dm0","Dm1","Dm2"],
  "taking a bath": ["Dmj"],
  "taking a cookie": ["Dmk"],
  "taking a photo": ["Dml","Dmm","Dmn","Dmo"],
  "taking a shower": ["Ecs","Dmp","Dmq","Dmr"],
  "taking a test": ["Dms"],
  "taking care": ["Dmt"],
  "taking medicine": ["Dmu"],
  "taking money": ["Dmv"],
  "taking off": ["Ebi","Dmw","Dmx"],
  "taking out": ["Ebj","Dmy","Dmz"],
  "taking out the trash": ["Ebj","Dmz"],
  "taking photos": ["DvC"],
  "taking some pizza": ["Ect","Dm0","Dm1"],
  "taking the bus": ["Dm2"],
  "talent show": ["DvE"],
  "talented": ["DvD"],
  "talk": ["Edl","EZz","EZy","Dm7","Dm3","Dm4","Dm5","Dm6","Cll"],
  "talk on a headset": ["EZy"],
  "talk on the phone": ["Edk","Dm5","Dm6"],
  "talk talked": ["EVB","Dm3","Dm4","Dm5","Dm7"],
  "talk to": ["Dm8"],
  "talk to a friend": ["EZz","Dm8"],
  "talk together": ["EOF"],
  "talked": ["EVB"],
  "talked to each other": ["EVB"],
  "talking": ["Edl","Dm7","Dm3","Dm4","Dm5","Dm6"],
  "talking on the phone": ["Edk","Dm5","Dm6"],
  "talking to": ["Dm8"],
  "talking to a brick wall": ["EOC","EOD","EOE"],
  "talking to a friend": ["Dm8"],
  "tall": ["EiC","EiD","EOG","DOO"],
  "tall buildings": ["EiC"],
  "taller": ["ESJ","DON"],
  "tambourine": ["D6d","DOP","Cln","Clm"],
  "tangerine": ["EhA","D6e","DOQ","Clq","Clo","Clp"],
  "tangerines": ["DOR","Clt","Clr","Cls"],
  "tangle": ["Clv"],
  "tangled": ["Clu"],
  "tank": ["Clz","Clw","Clx","Cly"],
  "tanktop": ["Cl0"],
  "Tanzania": ["EOH","Cl3","Cl1","Cl2"],
  "tap": ["CmD","Cl4","Cl5","Cl6"],
  "tape": ["D6g","DOT","CmC","Cl7","Cl8","Cl9"],
  "tape measure": ["D6f","DOS","CmA","CmB"],
  "tarantula": ["CmI","CmE","CmF","CmG","CmH"],
  "taste": ["EZ1","EZ0","Dm9","DnA"],
  "taste bad": ["EZ0","Dm9"],
  "taste good": ["EZ1","DnA"],
  "taste tasted": ["Dm9","DnA"],
  "tasting": ["DnA","Dm9"],
  "tasting bad": ["Dm9"],
  "tasting good": ["DnA"],
  "taught": ["EUR"],
  "taught english": ["EUR"],
  "taxi": ["CmM","CmJ","CmK","CmL"],
  "taxi rank": ["CmN"],
  "tea": ["D6i","DOX","Cmc","CmO","CmP","CmQ"],
  "tea set": ["Cmi","Cmj","Cmk"],
  "tea towel": ["D6k","DOZ"],
  "teach": ["EZ2","DnC","DnB"],
  "teach a student": ["EOI"],
  "teach class": ["EZ2","EOJ"],
  "teach English": ["DnB"],
  "teach students": ["EOM"],
  "teach taught": ["EUR","DnB","DnC"],
  "teacher": ["EOK","EOL","D6h","DOV","DOU","CmV","CmR","CmS","CmT","CmU"],
  "teachers": ["DvF"],
  "teaching": ["DnC","DnB"],
  "teaching English": ["DnB"],
  "teacup": ["CmW"],
  "teacups": ["CmX"],
  "teal": ["DOW"],
  "team": ["Cmb","CmY","CmZ","Cma"],
  "teapot": ["D6j","DOY","Cmg","Cmd","Cme","Cmf"],
  "tear": ["DnD","Cmh"],
  "tear tore": ["EVI","DnD"],
  "tear up": ["EON","DnE"],
  "tear up tore up": ["DnE"],
  "tearing": ["DnD"],
  "tearing up": ["DnE"],
  "teaspoon": ["Cmm","Cml"],
  "technician": ["Cmo","Cmn"],
  "technology": ["DvG"],
  "teddy": ["Cmy","Cmp","Cmq","Cmr","Cms"],
  "teddy bear": ["Cmt","Cmu","Cmv","Cmw","Cmx"],
  "teenagers": ["Cm0","Cmz"],
  "teepee": ["Cm4","Cm1","Cm2","Cm3"],
  "teeth": ["D6l","DOa","Cm7","Cm5","Cm6"],
  "telephone": ["DvH"],
  "telescope": ["D6m","DOb","CnA","Cm8","Cm9"],
  "television": ["DOc","CnF","CnB","CnC","CnD","CnE"],
  "tell": ["Ebk","DnH","DnF","DnG"],
  "tell a secret": ["Ebk","DnF"],
  "tell off": ["Ecv","EOO"],
  "tell off a boy": ["DnG"],
  "tell off someone": ["Ecv"],
  "tell told": ["ETS","DnF","DnG","DnH"],
  "telling": ["Ebk","DnH","DnF","DnG"],
  "telling a secret": ["Ebk","DnF"],
  "telling off": ["Ecv"],
  "telling off a boy": ["DnG"],
  "temple": ["CnH","CnG"],
  "ten": ["DcV","DcU"],
  "ten o'clock": ["DeW"],
  "ten past eight": ["Efe","DeX"],
  "ten thousand": ["DcW"],
  "ten to five": ["Eff","DeY"],
  "tennis": ["D6n","DOd","CnP","CnI","CnJ","CnK","CnL"],
  "tennis ball": ["CnM"],
  "tennis court": ["CnN","CnO"],
  "tennis racket": ["CnQ","CnR"],
  "tent": ["D6o","DOe","CnX","CnS","CnT","CnU","CnV","CnW"],
  "terrible": ["DvI"],
  "Texas": ["EOP"],
  "text": ["CnY"],
  "text message": ["DvK"],
  "textbook": ["DvJ"],
  "Thai": ["EeV","DOh"],
  "Thailand": ["EOQ","D6p","DOg","Cnd","CnZ","Cna","Cnb","Cnc"],
  "Thailand flag": ["DOf"],
  "thanksgiving": ["DvL"],
  "Thanksgiving dinner": ["Cne"],
  "the bathroom is messy": ["Ehp"],
  "the beach": ["C5x","DvN","AT2","ATm","ATn","ATo","ATp","ATq"],
  "the bikes are fast": ["Ehd"],
  "the birds are flying over the mountain": ["Ec9"],
  "the black sheep of the family": ["EOR","EOS","EOT"],
  "the book is old": ["Ehr"],
  "the book is worn out": ["Ehr"],
  "the boots smell bad": ["Eh7"],
  "the buildings are high": ["EiC"],
  "the buildings are tall": ["EiC"],
  "the car is waiting at the lights": ["EdA"],
  "the cat chases a mouse": ["EdB"],
  "the cat is chasing a mouse": ["EdB"],
  "the chair is big": ["EhF"],
  "the chair is on fire": ["Ehu"],
  "the chairs are on fire": ["Ehv"],
  "the clocks are upside down": ["EiI"],
  "the clothes are drying": ["EdC"],
  "the dishes are dirty": ["EhZ"],
  "the dog is biting his hand": ["EdD"],
  "the dog is wet": ["EiJ"],
  "the door is open": ["Ehx"],
  "the doors are open": ["Ehw"],
  "the early bird catches the worm": ["EOU","EOV","EOW"],
  "the earth": ["D6q","BFW","BFV","DOi"],
  "the fan blows air": ["EdE"],
  "the fan is blowing air": ["EdE"],
  "the girl is learning maths": ["EdF"],
  "the girl learns maths": ["EdF"],
  "the grass is always greener on the other side": ["EOX","EOY","EOZ"],
  "the library is quiet": ["Ehy"],
  "the lights are bright": ["EhI"],
  "the moon": ["D6r","DOj","By9","By1","By2","By3","By4"],
  "the pencils are broken": ["EhJ"],
  "the phone charges": ["EdG"],
  "the phone is charging": ["EdG"],
  "the phone is ringing": ["EdH"],
  "the phone rings": ["EdH"],
  "the plant is dead": ["EhV"],
  "the plants are dead": ["EhW"],
  "the ring is expensive": ["Ehc"],
  "the room is messy": ["Ehp"],
  "the screen is cracked": ["EhT"],
  "the sea": ["CUJ","CTu","CTv","CTw","DvP"],
  "the sky": ["CY1","CYy","CYz","CY0","DvQ"],
  "the store hasn't opened yet": ["EOc"],
  "the sun": ["D6t","DOn","CjE","Cil","Cim"],
  "the sun is rising": ["EdI"],
  "the sun rises": ["EdI"],
  "the tires are flat": ["Ehf"],
  "the train hasn't arrived yet": ["EOd"],
  "the tyres are flat": ["Ehf"],
  "the UK": ["DvR"],
  "the water boils": ["EdJ"],
  "the water is boiling": ["EdJ"],
  "theater": ["Cni","DvM","Cnf","Cng","Cnh"],
  "theatre": ["Cni","DvM","Cnf","Cng","Cnh"],
  "their hair is blue": ["EhG"],
  "their hair is long": ["Eho"],
  "their shirts are colorful": ["EhS"],
  "their sweaters are small": ["Eh5"],
  "theme park": ["DvO"],
  "therapist": ["EOa","EOb","DOl","DOk"],
  "thermometer": ["D6s","DOm","Cnn","Cnj","Cnk","Cnl","Cnm"],
  "they are arguing": ["EdK"],
  "they are climbing a mountain": ["EdL"],
  "they are cold": ["EhP"],
  "they are dancing": ["EdM"],
  "they are debating": ["EdN"],
  "they are drinking coffee": ["EdO"],
  "they are eating cake": ["EdP"],
  "they are exchanging money": ["EdQ"],
  "they are exercising": ["EdR"],
  "they are fighting": ["EdS"],
  "they are going to school": ["EdT"],
  "they are guarding the door": ["EdU"],
  "they are happy": ["Ehj"],
  "they are holding hands": ["EdV"],
  "they are hugging": ["EdW"],
  "they are jumping": ["EdX"],
  "they are listening to music": ["EdY"],
  "they are looking at each other": ["EdZ"],
  "they are meeting each other": ["Eda"],
  "they are moving a chair": ["Edb"],
  "they are old": ["Ehs"],
  "they are playing cards": ["Edc"],
  "they are playing football": ["Edd"],
  "they are playing tennis": ["Ede"],
  "they are playing video games": ["Edf"],
  "they are putting up decorations": ["Edg"],
  "they are sad": ["Eh2"],
  "they are shaking hands": ["Edh"],
  "they are shopping": ["Edi"],
  "they are taking a photo": ["Edj"],
  "they are talking": ["Edl"],
  "they are talking on the phone": ["Edk"],
  "they are tired": ["EiE"],
  "they are unhappy": ["Eh2"],
  "they are waiting for a bus": ["Edm"],
  "they are watching tv": ["Edn"],
  "they argue": ["EdK"],
  "they climb a mountain": ["EdL"],
  "they dance": ["EdM"],
  "they debate": ["EdN"],
  "they drink coffee": ["EdO"],
  "they eat cake": ["EdP"],
  "they exchange money": ["EdQ"],
  "they exercise": ["EdR"],
  "they fight": ["EdS"],
  "they go to school": ["EdT"],
  "they guard the door": ["EdU"],
  "they hold hands": ["EdV"],
  "they hug": ["EdW"],
  "they jump": ["EdX"],
  "they listen to music": ["EdY"],
  "they look at each other": ["EdZ"],
  "they meet each other": ["Eda"],
  "they move a chair": ["Edb"],
  "they play cards": ["Edc"],
  "they play football": ["Edd"],
  "they play tennis": ["Ede"],
  "they play video games": ["Edf"],
  "they put up decorations": ["Edg"],
  "they shake hands": ["Edh"],
  "they shop": ["Edi"],
  "they take a photo": ["Edj"],
  "they talk": ["Edl"],
  "they talking on the phone": ["Edk"],
  "they wait for a bus": ["Edm"],
  "they watch tv": ["Edn"],
  "thief": ["Cnq","Cno","Cnp"],
  "thigh": ["Cnr"],
  "thimble": ["Cnu","Cns","Cnt"],
  "thin": ["EOv","DOp","Cn1","Cnv","Cnw","Cnx"],
  "thin as a rake": ["EOr","EOs","EOt"],
  "think": ["Ecw","EZ3","DnJ","Cn0","Cny","Cnz"],
  "think about": ["EOu","DnI"],
  "think about money": ["EZ3","DnI"],
  "think about thought about": ["DnI"],
  "think thought": ["EUS","DnJ"],
  "thinking": ["Ecw","DnJ"],
  "thinking about": ["DnI"],
  "thinking about money": ["DnI"],
  "thinner": ["ESK","DOo"],
  "third": ["DvS"],
  "thirsty": ["EOw","Cn3","Cn2"],
  "thirteen": ["DcY","DcX"],
  "thirty": ["Dcf","DcZ"],
  "thirty eight": ["Dca"],
  "thirty five": ["Dcb"],
  "thirty four": ["Dcc"],
  "thirty nine": ["Dcd"],
  "thirty one": ["Dce"],
  "thirty seven": ["Dcg"],
  "thirty six": ["Dch"],
  "thirty thousand": ["Dci"],
  "thirty three": ["Dcj"],
  "thirty two": ["Dck"],
  "thorn": ["Cn5","Cn4"],
  "thorns": ["Cn6"],
  "thought": ["EUS"],
  "thoughtful": ["DvT"],
  "three": ["Dcn","Dcl"],
  "three hundred": ["Dcm"],
  "three o'clock": ["Efg","DeZ"],
  "three thousand": ["Dco"],
  "threw away": ["ETR"],
  "threw away a bottle": ["ETR"],
  "throat": ["DvU"],
  "throne": ["Cn9","Cn7","Cn8"],
  "throw": ["Ebl","DnK","CoC","CoA"],
  "throw a ball": ["Ebl","DnK","CoB"],
  "throw away": ["Ebm","EZ4","EOx","DnL","DnM"],
  "throw away a bottle": ["Ebm","DnL"],
  "throw away threw away": ["DnM"],
  "throw away trash": ["EZ4","DnM"],
  "throw threw": ["DnK","DnL"],
  "throwing": ["Ebl","DnK"],
  "throwing a ball": ["Ebl","DnK"],
  "throwing away": ["Ebm","DnL","DnM"],
  "throwing away a bottle": ["Ebm","DnL"],
  "throwing away trash": ["DnM"],
  "thumb": ["D6u","DOq","CoF","CoD","CoE"],
  "thunder": ["CoH"],
  "thunder and lightning": ["CoG"],
  "thunderstorm": ["DvV"],
  "Thursday": ["DOt","DOr","DOs"],
  "tic tac toe": ["CoQ","CoR"],
  "tick": ["CoP","CoI","CoJ"],
  "ticket": ["D6v","DOu","CoO","CoK","CoL","CoM","CoN"],
  "tickets": ["DvW"],
  "tidier": ["ESL","DOv"],
  "tidy": ["EZ5","EOz","DnN","DnO","CoU","CoS","CoT"],
  "tidy hotel rooms": ["EOy"],
  "tidy my room": ["DvX"],
  "tidy the bed": ["EZ5","DnN"],
  "tidy the room": ["DnO"],
  "tidy tidied": ["DnN","DnO"],
  "tidy up": ["EO0","DnP"],
  "tidy up tidied up": ["DnP"],
  "tidying": ["DnO","DnN"],
  "tidying the bed": ["DnN"],
  "tidying the room": ["DnO"],
  "tidying up": ["DnP"],
  "tie": ["Ec0","EZ6","D6w","DnR","DnQ","DnS","DOw","CoY","CoV","CoW","CoX"],
  "tie her shoes": ["DnQ"],
  "tie shoes": ["Ec0"],
  "tie tied": ["EVG","DnQ","DnR","DnS"],
  "tie your shoe": ["EZ6","DnS"],
  "tie your shoes": ["CoZ"],
  "tied": ["EVG"],
  "tied my laces": ["EVG"],
  "tiger": ["D6x","DOx","Coe","Coa","Cob","Coc","Cod"],
  "tigers": ["Cog","Cof"],
  "tigers are dangerous": ["EhU"],
  "tight": ["DOz"],
  "tighter": ["ESM","DOy"],
  "timber": ["Coj","Coh","Coi"],
  "time is money": ["EO1","EO2","EO3"],
  "timetable": ["Cok"],
  "tin": ["Col"],
  "tiny": ["EO4"],
  "tire": ["DvY","Cuu","Cur","Cus","Cut"],
  "tired": ["EiE","EiF","EO5","DO0","Con","Com"],
  "tissue": ["Coo"],
  "tissues": ["D6y","DO1"],
  "titanic": ["Coq","Cop"],
  "toad": ["Cou","Cor","Cos","Cot"],
  "toads": ["Cow","Cov"],
  "toast": ["EhB","DO3","Co5","Cox","Coy","Coz"],
  "toaster": ["D6z","DO2","Co4","Co0","Co1","Co2","Co3"],
  "toe": ["DO6"],
  "toenail": ["DO4"],
  "toenails": ["DO5"],
  "toes": ["D60","DO7","Co9","Co6","Co7","Co8"],
  "tofu": ["CpC","CpA","CpB"],
  "together": ["CpE","CpD"],
  "toil": ["CpO"],
  "toilet": ["D62","DO9","CpN","CpF","CpG","CpH"],
  "toilet paper": ["D61","DO8","CpI","CpJ","CpK","CpL","CpM"],
  "told": ["ETS"],
  "told her something": ["ETS"],
  "tomato": ["EhC","DPB","CpY","CpP","CpQ"],
  "tomato pasta": ["CpW","CpX"],
  "tomato sauce": ["CpZ","Cpa","Cpb"],
  "tomato soup": ["Cpc","Cpd","Cpe"],
  "tomatoes": ["D63","DPA","CpV","CpR","CpS","CpT","CpU"],
  "tomb": ["Cpg","Cpf"],
  "tongue": ["D64","DPC","Cpk","Cph","Cpi","Cpj"],
  "too big": ["EhE"],
  "too bright": ["EhI"],
  "too cold": ["EhP","EhQ"],
  "too fast": ["Ehd"],
  "too fat": ["Ehe"],
  "too heavy": ["Ehl"],
  "too large": ["EhE"],
  "too small": ["Eh5","Eh6"],
  "too tall": ["EiD"],
  "took": ["EVH"],
  "took a pizza slice": ["EVH"],
  "tool": ["Cpo"],
  "toolbox": ["Cpn","Cpl","Cpm"],
  "tools": ["Cps","Cpp","Cpq","Cpr"],
  "tooth": ["Cp4","Cpt","Cpu"],
  "toothache": ["Cpw","Cpv"],
  "toothbrush": ["D65","DPD","Cp0","Cpx","Cpy","Cpz"],
  "toothpaste": ["D66","DPE","Cp3","Cp1","Cp2"],
  "top": ["Ddf"],
  "torch": ["Cp8","Cp5","Cp6","Cp7"],
  "tore": ["EVI"],
  "tore some money": ["EVI"],
  "tornado": ["D67","DPF","CqB","Cp9","CqA"],
  "tortoise": ["D68","DPG","CqG","CqC","CqD","CqE","CqF"],
  "toucan": ["CqJ","CqH","CqI"],
  "touch": ["EZ7","DnT","CqM","CqK","CqL"],
  "touch touched": ["DnT"],
  "touch your toes": ["EZ7","DnT"],
  "touching": ["DnT"],
  "touching your toes": ["DnT"],
  "tour": ["DvZ"],
  "tour bus": ["CqN","CqO","CqP"],
  "tour guide": ["EPB","EPA","D69","DPH","DPI","CqQ"],
  "tourist": ["CqS","CqR"],
  "towel": ["D7A","DPK","DPJ","CqV","CqT","CqU"],
  "towels": ["CqZ","CqW","CqX","CqY"],
  "tower": ["Cqc","Cqa","Cqb"],
  "town": ["Cqi","Cqd","Cqe"],
  "town hall": ["Cqf","Cqg","Cqh"],
  "town house": ["Dva"],
  "town square": ["Cqj","Cqk","Cql"],
  "toxic waste": ["Cqm","Cqn"],
  "toy": ["Cqu","Cqo","Cqp"],
  "toy box": ["Cqq","Cqr"],
  "toy car": ["Cqs","Cqt"],
  "toy shop": ["Cqx","Cqy"],
  "toy soldier": ["Cqz","Cq0"],
  "toy soldiers": ["Cq1","Cq2","Cq3","Cq4"],
  "toy store": ["Cq6","Cq7","Cq8"],
  "toy train": ["Cq9","CrA","CrB"],
  "toys": ["Cq5","Cqv","Cqw"],
  "trachea": ["CrC"],
  "track": ["CrE","CrD"],
  "tracks": ["CrG","CrF"],
  "tracksuit": ["D7B","DPL","CrJ","CrH","CrI"],
  "tractor": ["D7C","DPM","CrO","CrK","CrL","CrM","CrN"],
  "tradition": ["Dvb"],
  "traffic": ["Dvc"],
  "traffic cone": ["D7D","DPN"],
  "traffic jam": ["CrP","CrQ","CrR"],
  "traffic light": ["D7E","DPO","CrS","CrT","CrU","CrV"],
  "traffic lights": ["CrW","CrX","CrY","CrZ","Cra","Crb"],
  "trail": ["Dvd"],
  "train": ["D7F","DPP","Cri","Crc","Crd","Cre"],
  "train people": ["EPC"],
  "train station": ["D7G","DPQ","Crj","Crk","Crl","Crm","Crn"],
  "trainer": ["Crf"],
  "trainers": ["Crh","Crg"],
  "tram": ["Crq","Cro","Crp"],
  "trampoline": ["Cru","Crr","Crs","Crt"],
  "transform": ["DYw"],
  "translate": ["EZ8","DnU"],
  "translate chinese to english": ["EZ8"],
  "translate translated": ["DnU"],
  "translating": ["DnU"],
  "translator": ["EPD","EPE","DPS","DPR"],
  "trap": ["Crx","Crv"],
  "trapezium": ["Crw"],
  "trash": ["Cr7","Cry","Crz","Cr0"],
  "trash can": ["D7H","DPT","Cr1","Cr2","Cr3","Cr4","Cr5"],
  "trash collection": ["Cr6"],
  "travel": ["CsA"],
  "travel agent": ["EPG","EPF","DPU","DPV"],
  "traveling": ["Cr9","Cr8"],
  "travelling": ["Cr9","Cr8"],
  "travels": ["CsC","CsB"],
  "tray": ["D7I","DPW","CsH","CsD","CsE","CsF","CsG"],
  "treadmill": ["CsL","CsI","CsJ","CsK"],
  "treasure": ["CsP","CsM","CsN","CsO"],
  "tree": ["EiG","D7J","DPX","Csa","CsQ","CsR","CsS","CsT","CsU","CsV"],
  "tree house": ["CsW","CsX","CsY","CsZ"],
  "trees": ["Csi","Csb","Csc","Csd","Cse","Csf","Csg","Csh"],
  "trekking": ["Csl","Csj","Csk"],
  "trench": ["Css","Csm","Csn"],
  "trench coat": ["Cso","Csp","Csq","Csr"],
  "triangle": ["Csw","Csv"],
  "tribe": ["Csz","Csx","Csy"],
  "trick or treat": ["Dve"],
  "trickortreaters": ["EPH"],
  "tried": ["EUT"],
  "tried on a dress": ["EUT"],
  "Trinidad and Tobago": ["Cs0","Cs1","Cs2"],
  "trio": ["Cs4","Cs3"],
  "trip": ["Cs7","Cs5","Cs6"],
  "troll": ["CtD","Cs8","Cs9"],
  "troll face": ["CtC"],
  "trolley": ["CtB","CtA"],
  "trophy": ["CtI","CtE","CtF","CtG","CtH"],
  "tropical": ["CtN","CtJ","CtK","CtL"],
  "tropical fish": ["CtM"],
  "trousers": ["DPZ","DPY","CtS","CtO","CtP","CtQ","CtR"],
  "truck": ["D7L","DPc","CtY","CtT","CtU","CtV","CtW","CtX"],
  "truck driver": ["EPJ","EPI","D7K","DPa","DPb"],
  "trumpet": ["D7M","DPd","Ctd","CtZ","Cta","Ctb","Ctc"],
  "trunk": ["DPe","Ctf","Cte"],
  "trust": ["Ctg"],
  "try": ["Ecx"],
  "try on": ["EPK","DnV"],
  "try on a dress": ["Ecx"],
  "try on tried on": ["DnV"],
  "try tried": ["EUT"],
  "trying": ["Ecx"],
  "trying on": ["DnV"],
  "tshirt": ["D7N","DPg","DPf","Cto","Cti","Ctk","Ctm"],
  "tsunami": ["Cts","Ctp","Ctq","Ctr"],
  "tub": ["Ctz","Ctt","Ctu"],
  "tuba": ["Cty","Ctv","Ctw","Ctx"],
  "tube": ["Dvf"],
  "Tuesday": ["DPj","DPh","DPi"],
  "tulip": ["Ct2","Ct0","Ct1"],
  "tulips": ["Ct5","Ct3","Ct4"],
  "tuna": ["DPk","Ct9","Ct6","Ct7","Ct8"],
  "tune": ["CuA"],
  "tunnel": ["D7O","DPl","CuE","CuB","CuC","CuD"],
  "Turkey": ["EPM","D7P","DPn","CuK","CuF","CuG"],
  "turkey": ["EiH","EPL","CuH","CuI","CuJ"],
  "Turkey flag": ["DPm"],
  "Turkish": ["EeW","DPo"],
  "turn down": ["Ecy","EPN","DnW"],
  "turn down cake": ["Ecy","DnW"],
  "turn down turned down": ["DnW"],
  "turn into": ["EPO","DnX"],
  "turn into turned into": ["DnX"],
  "turn off": ["EZ9","EPP","DnY"],
  "turn off the light": ["EZ9","DnY"],
  "turn off turned off": ["DnY"],
  "turn on": ["Ecz","Ebn","EaA","EPQ","Dna","DnZ","Dnb"],
  "turn on a TV": ["DnZ"],
  "turn on the AC": ["EaA","Dnb"],
  "turn on the light": ["Ecz"],
  "turn on the tv": ["Ebn"],
  "turn on turned on": ["DnZ","Dna","Dnb"],
  "turn over": ["EPR","Dnc"],
  "turn over turned over": ["Dnc"],
  "turned on": ["EUU"],
  "turned on a light": ["EUU"],
  "turning down": ["Ecy","DnW"],
  "turning down cake": ["Ecy","DnW"],
  "turning into": ["DnX"],
  "turning off": ["DnY"],
  "turning off the light": ["DnY"],
  "turning on": ["Ecz","Ebn","Dna","DnZ","Dnb"],
  "turning on a TV": ["DnZ"],
  "turning on the AC": ["Dnb"],
  "turning over": ["Dnc"],
  "turquoise": ["DPp"],
  "turtle": ["D7Q","DPq","CuQ","CuL","CuM","CuN"],
  "turtleneck": ["CuP"],
  "turtlenecked": ["CuO"],
  "turtles": ["CuR"],
  "tusk": ["CuT","CuS"],
  "tutor": ["EaB","EPS","EPT","D7R","Dnd","DPs","DPr"],
  "tutor a student": ["EaB"],
  "tutor tutored": ["Dnd"],
  "tutoring": ["Dnd"],
  "Tuvalu": ["CuW","CuU","CuV"],
  "tv": ["D7S","DPt"],
  "TV presenter": ["DPu","DPv","EPU","EPV"],
  "twelve": ["Dcr","Dcp"],
  "twelve hundred": ["Dcq"],
  "twenty": ["Dcy","Dcs"],
  "twenty eight": ["Dct"],
  "twenty five": ["Dcu"],
  "twenty five past eleven": ["Efh","Dea"],
  "twenty five past six": ["Deb"],
  "twenty five past ten": ["Dec"],
  "twenty five to ten": ["Efi","Ded"],
  "twenty four": ["Dcv"],
  "twenty nine": ["Dcw"],
  "twenty one": ["Dcx"],
  "twenty past two": ["Efj","Dee"],
  "twenty seven": ["Dcz"],
  "twenty six": ["Dc0"],
  "twenty thousand": ["Dc1"],
  "twenty three": ["Dc2"],
  "twenty to four": ["Efk","Def"],
  "twenty two": ["Dc3"],
  "twig": ["Cua","CuX","CuY","CuZ"],
  "twin": ["Cuc"],
  "twin bed": ["Cub"],
  "twin room": ["Cud"],
  "twin sister": ["EPW","DZh"],
  "twins": ["Cui","Cue","Cuf","Cug","Cuh"],
  "twinsister": ["EPW"],
  "two": ["Dc6","Dc4"],
  "two hundred": ["Dc5"],
  "two o'clock": ["Deg"],
  "two thousand": ["Dc7"],
  "tying": ["DnR","DnQ","DnS"],
  "tying her shoes": ["DnQ"],
  "tying your shoe": ["DnS"],
  "type": ["Ebo","EaC","Dng","Dne","Dnf","Cul","Cuj","Cuk"],
  "type on a keyboard": ["EaC"],
  "type typed": ["EVJ","Dne","Dnf","Dng"],
  "typed": ["EVJ"],
  "typewriter": ["Cun","Cum"],
  "typhoon": ["Cup","Cuo"],
  "typing": ["Ebo","Dng","Dne","Dnf"],
  "typist": ["Cuq"],
  "tyre": ["DvY","Cuu","Cur","Cus","Cut"],
  "u": ["DaQ","DaP"],
  "ufo": ["Cuw","Cuv"],
  "uglier": ["ESN","DPw"],
  "ugly": ["EPX","DPx","Cuz","Cux","Cuy"],
  "ukelele": ["Cu3","Cu0","Cu1","Cu2"],
  "Ukraine": ["EPY","Cu6","Cu4","Cu5"],
  "uluru": ["Cu8","Cu7"],
  "umbrella": ["D7T","DPz","DPy","CvA","Cu9"],
  "umpire": ["CvB"],
  "uncle": ["EPZ","DZi"],
  "under": ["Ef3","Ef2","Ddi","Ddg","Ddh"],
  "under the chair": ["Ef2"],
  "under the sofa": ["Ef3"],
  "under the weather": ["EPa","EPb","EPc"],
  "underground": ["Dvg"],
  "understand": ["Dvh"],
  "underwater": ["CvC"],
  "unfriendly": ["EPd"],
  "unhappy": ["Eh2","Eh1","EPe","Dvi"],
  "unhealthy": ["EPf","CvE","CvD"],
  "unicorn": ["CvI","CvF","CvG","CvH"],
  "uniform": ["CvM","CvJ","CvK","CvL"],
  "United Kingdom": ["EPg","CvN","CvO","CvP","CvQ"],
  "United States": ["EPk","DwN","CvR","CvS","CvT","CvU"],
  "universe": ["CvX","CvV","CvW"],
  "university": ["Cva","CvY","CvZ"],
  "university lecturer": ["EPi","EPh","DP0","DP1"],
  "unload": ["Cvb"],
  "untidy": ["Cvc"],
  "unusual": ["Dvj"],
  "up": ["Dvl","Dvk"],
  "upload": ["Cve","Cvd"],
  "upset": ["EPj","Cvf"],
  "upside down": ["EiI","DP2","Cvg","Cvh"],
  "upstairs": ["Cvi"],
  "uranus": ["Cvj"],
  "USA": ["EPk","DwN","C4p","AEp","AEV","AEW","AEX","AEY","AEZ"],
  "usa dollar": ["Cvk","Cvl"],
  "USA flag": ["DP3"],
  "usb stick": ["D7U","DP4","Cvm","Cvn"],
  "use": ["Ec1","Ebq","Ebp","EaG","EaF","EaE","EaD","Dnm","Dnh","Dni","Dnj","Dnl"],
  "use a computer": ["Ec1","EPl","Dnh"],
  "use a hairdryer": ["EaD","DP5"],
  "use a key": ["DP6"],
  "use a laptop": ["EPm"],
  "use a microwave": ["DP7"],
  "use a mirror": ["DP8"],
  "use a pen": ["DP9"],
  "use a phone": ["Ebq","EaE","Dni","DQA"],
  "use a ruler": ["DQB"],
  "use a spoon": ["DQC"],
  "use a tablet": ["Ebp","Dnj"],
  "use a tissue": ["DQD"],
  "use a wheelchair": ["EaF","Dnk"],
  "use chopsticks": ["EaG","Dnl","DQE"],
  "use scissors": ["DQF"],
  "use the Internet": ["Dnn"],
  "use used": ["EVx","ETT","Dnh","Dni","Dnj","Dnm"],
  "used": ["EVx","ETT"],
  "used chopsticks": ["EVx"],
  "used his phone": ["ETT"],
  "useful": ["Dvm"],
  "using": ["Ec1","Ebq","Ebp","Dnm","Dnh","Dni","Dnj","Dnl"],
  "using a computer": ["Ec1","Dnh"],
  "using a phone": ["Ebq","Dni"],
  "using a tablet": ["Ebp","Dnj"],
  "using a wheelchair": ["Dnk"],
  "using chopsticks": ["Dnl"],
  "using the Internet": ["Dnn"],
  "v": ["DaS","DaR"],
  "vacation": ["Cvo"],
  "vacuum": ["Cvq"],
  "vacuum cleaner": ["D7V","DQG","Cvp"],
  "valley": ["DYx","Cvt","Cvr","Cvs"],
  "valuable": ["DYy","Cvu"],
  "valve": ["DYz","Cvw","Cvv"],
  "vampire": ["EPn","EPo","Cvz","Cvx","Cvy"],
  "van": ["D7W","DQH","Cv3","Cv0"],
  "vandalism": ["Cv2","Cv1"],
  "vanilla": ["Dvn"],
  "vase": ["D7X","DQI","Cv8","Cv4","Cv5","Cv6","Cv7"],
  "vast": ["CwA","Cv9"],
  "Vatican city": ["CwB"],
  "vegetable": ["CwF","CwC"],
  "vegetable garden": ["CwD","CwE"],
  "vegetables": ["EPp","DQJ","CwK","CwG","CwH","CwI","CwJ"],
  "veins": ["CwL"],
  "velocity": ["CwM"],
  "vendor": ["CwO","CwN"],
  "Venezuela": ["EPq","CwR","CwP","CwQ"],
  "venus": ["CwS"],
  "vermillion": ["DQK"],
  "vertical": ["CwT"],
  "vessel": ["CwW","CwU","CwV"],
  "vest": ["D7Y","DQL","CwZ","CwX","CwY"],
  "vet": ["EPr","EPs","D7Z","DQN","DQM","Cwc","Cwa"],
  "veterinarian": ["Cwb"],
  "video": ["Cwd"],
  "Vietnam": ["EPt","Cwj","Cwe","Cwf","Cwg","Cwh","Cwi"],
  "Vietnam flag": ["DQO"],
  "view": ["Cwk"],
  "village": ["Cwn","Cwl","Cwm"],
  "villain": ["Cwo"],
  "vinegar": ["Cwp"],
  "violet": ["DQP"],
  "violin": ["D7a","DQQ","Cww","Cwq","Cwr","Cws","Cwt"],
  "violinist": ["Cwv","Cwu"],
  "visit": ["Ec2","Dno"],
  "visit grandparents": ["Ec2","Dno"],
  "visit visited": ["EWD","EUV","Dno"],
  "visited": ["EWD","EUV"],
  "visited france": ["EWD"],
  "visited her grandparents": ["EUV"],
  "visiting": ["Ec2","Dno"],
  "visiting grandparents": ["Ec2","Dno"],
  "volcano": ["D7b","DQT","DQR","DQS","Cw2","Cwx","Cwy","Cwz","Cw0","Cw1"],
  "volleyball": ["D7c","DQU","Cw7","Cw3","Cw4","Cw5","Cw6"],
  "volunteer": ["Dvo"],
  "voting": ["Dvp"],
  "voucher": ["Cw8"],
  "voyage": ["Dvq"],
  "vulture": ["CxC","Cw9","CxA","CxB"],
  "w": ["DaU","DaT"],
  "waffle": ["EhD"],
  "waffles": ["D7d","DQV","CxF","CxD","CxE"],
  "wagon": ["CxI","CxG","CxH"],
  "wait": ["Edm","EaH","Dns","Dnp","Dnr","CxQ","CxJ","CxK","CxL"],
  "wait at the lights": ["Dnp"],
  "wait for": ["Dnq"],
  "wait for a bus": ["Edm","EaH","Dnq"],
  "wait for a train": ["Dnr"],
  "wait in line": ["CxP"],
  "wait waited": ["EWS","EVC","Dnp","Dnq","Dnr","Dns"],
  "waited": ["EWS","EVC"],
  "waited for a bus": ["EVC"],
  "waiter": ["EPu","EPv","D7e","DQX","DQW","CxO","CxM","CxN"],
  "waiting": ["Edm","Dns","Dnp","Dnr"],
  "waiting at the lights": ["Dnp"],
  "waiting for": ["Dnq"],
  "waiting for a bus": ["Edm","Dnq"],
  "waiting for a train": ["Dnr"],
  "waitress": ["CxT","CxR","CxS"],
  "wake up": ["Ec3","EPx","EPw","Dnt","Dnu","CxU","CxV"],
  "wake up woke up": ["Dnt","Dnu"],
  "waking up": ["Ec3","Dnt","Dnu"],
  "Wales": ["EPy"],
  "walk": ["Ec4","EaK","EP0","Dnx","Dnv","Dnw","Dny","Cxc","CxW","CxX"],
  "walk a dog": ["Dnv"],
  "walk in the countryside": ["EPz"],
  "walk in the park": ["Dnw"],
  "walk slowly": ["ERV"],
  "walk the": ["Ec4"],
  "walk the dog": ["Ec4","EaK","Cxd","Cxe","Cxf","Cxg"],
  "walk to class": ["EP1","Dny"],
  "walk to school": ["Dvr"],
  "walk walked": ["ETU","Dnv","Dnw","Dnx","Dny"],
  "walked": ["ETU"],
  "walking": ["Ec4","Dnx","Dnv","Dnw","Dny","Cxb","CxY","CxZ","Cxa"],
  "walking a dog": ["Dnv"],
  "walking in the park": ["Dnw"],
  "walking stick": ["D7f","DQY"],
  "walking to class": ["Dny"],
  "wall": ["D7h","DQa","Cxo","Cxh","Cxi"],
  "wallet": ["D7g","DQZ","Cxn","Cxj","Cxk","Cxl","Cxm"],
  "walnut": ["D7i"],
  "walnuts": ["Cxs","Cxp","Cxq","Cxr"],
  "walrus": ["Cxv","Cxt","Cxu"],
  "waltz": ["Cxw"],
  "wand": ["Cxx"],
  "war": ["Dvs"],
  "wardrobe": ["Cx0","Cxy","Cxz"],
  "warm": ["EP2","Cx2","Cx1"],
  "warmer": ["ESO","DQb"],
  "was": ["EUW"],
  "was sad": ["EUW"],
  "wash": ["Ebt","Ebs","Ebr","EaN","EaM","EaL","Dn2","Dnz","Dn0","Dn1","Dn3","Dn4","Dn5","Dn6","Dn7","Cx8","Cx3"],
  "wash dishes": ["Dnz","Dn0"],
  "wash face": ["Ebr","Dvt"],
  "wash hands": ["Ebs"],
  "wash his face": ["Dn1"],
  "wash the car": ["CyB"],
  "wash the dishes": ["Ebt","EaL","Dn3","CyC","CyD"],
  "wash up": ["Dvu"],
  "wash washed": ["EVO","EVN","EWE","ETV","Dnz","Dn0","Dn1","Dn2"],
  "wash your car": ["Dn4"],
  "wash your face": ["EaM","EP4","Dn5"],
  "wash your hair": ["EaN","EP5","Dn6"],
  "wash your hands": ["Dn7"],
  "washbasin": ["Cx5","Cx4"],
  "washed": ["EVO","EVN","EWE","ETV"],
  "washed her hair": ["EWE"],
  "washed his car": ["EVN"],
  "washed his hands": ["ETV"],
  "washed the dishes": ["EVO"],
  "washing": ["Ebt","Ebs","Ebr","Dn2","Dnz","Dn0","Dn1","Dn3","Dn4","Dn5","Dn6","Dn7"],
  "washing dishes": ["Dnz","Dn0"],
  "washing his face": ["Dn1"],
  "washing machine": ["D7j","DQc","Cx6","Cx7"],
  "washing the dishes": ["Ebt","Dn3"],
  "washing your car": ["Dn4"],
  "washing your face": ["Dn5"],
  "washing your hair": ["Dn6"],
  "washing your hands": ["Dn7"],
  "Washington": ["EP3"],
  "washroom": ["CyA","Cx9"],
  "wasp": ["CyH","CyE","CyF","CyG"],
  "waste": ["CyM","CyI","CyJ"],
  "waste basket": ["CyK","CyL"],
  "watch": ["Edn","EaO","D7k","D7l","Dn8","Dn9","DoA","DQe","DQd","CyU","CyN","CyO","CyP"],
  "watch movies": ["Dvv"],
  "watch strap": ["CyV","CyW"],
  "watch TV": ["Edn","EaO","CyX","CyY","EP6","Dn9","DoA"],
  "watch tv": ["Edn","EaO","CyX","CyY","EP6","Dn9","DoA"],
  "watch watched": ["EVh","EVD","Dn8","Dn9","DoA"],
  "watched": ["EVh","EVD"],
  "watched tv": ["EVh","EVD"],
  "watches": ["CyR","CyQ"],
  "watching": ["Edn","Dn8","Dn9","DoA"],
  "watching TV": ["Edn","CyS","CyT","Dn9","DoA"],
  "watching tv": ["Edn","CyS","CyT","Dn9","DoA"],
  "water": ["EaP","D7o","DoB","DQh","CzA","CyZ","Cya"],
  "water balloon": ["Cyb"],
  "water bottle": ["Cyc","Cyd","Cye"],
  "water bucket": ["Cyf"],
  "water cycle": ["DY0","Cyg","Cyh"],
  "water dispenser": ["D7m","DQf"],
  "water lily": ["Cyu","Cyv"],
  "water park": ["DY1","Cy3","Cy5","Cy8"],
  "water plants": ["EaP"],
  "water shortage": ["DY2","CzB","CzC","CzD"],
  "water ski": ["Dvw"],
  "water skiing": ["CzE","CzF","CzG","CzH"],
  "water slide": ["CzI","CzJ","CzK"],
  "water the lawn": ["CzL","CzM"],
  "water vegetables": ["DoB"],
  "water watered": ["DoB"],
  "waterfall": ["Cym","Cyi","Cyj","Cyk","Cyl"],
  "waterfalls": ["Cyo","Cyn"],
  "watering": ["DoB","Cyt"],
  "watering can": ["Cyp","Cyq","Cyr","Cys"],
  "watering vegetables": ["DoB"],
  "watermelon": ["D7n","DQg","Cy1","Cyw","Cyx","Cyy","Cyz","Cy0"],
  "watermelons": ["Cy2"],
  "waterpark": ["Cy9","Cy4","Cy6","Cy7"],
  "waterwheel": ["Dvx"],
  "wave": ["Ec5","EaQ","DoE","DoC","DoD","CzQ","CzN","CzO","CzP"],
  "wave her hand": ["DoD"],
  "wave to a friend": ["EaQ"],
  "wave waved": ["ETW","DoC","DoD","DoE"],
  "waved": ["ETW"],
  "waves": ["CzR"],
  "waving": ["Ec5","DoE","DoC","DoD"],
  "waving her hand": ["DoD"],
  "wavy": ["Dvy"],
  "wavy hair": ["CzS","CzT"],
  "wax": ["CzU"],
  "weak": ["EP7","CzW","CzV"],
  "weaker": ["ESP","DQi"],
  "wear": ["EaS","EaR","DoF","DoG","DoH","DoI","DoJ"],
  "wear a black dress": ["Ef4"],
  "wear a blue hat": ["Ef5"],
  "wear a brown belt": ["Ef6"],
  "wear a brown coat": ["Ef7"],
  "wear a coat": ["DoF"],
  "wear a costume": ["EP8"],
  "wear a green scarf": ["Ef8"],
  "wear a mask": ["EaR","DoG","DoH"],
  "wear a pink shirt": ["EgA"],
  "wear a raincoat": ["EaS","DoI"],
  "wear a red jacket": ["EgB"],
  "wear a yellow skirt": ["EgC"],
  "wear a yellow tie": ["EgD"],
  "wear an orange shirt": ["Ef9"],
  "wear black gloves": ["EgE"],
  "wear blue coats": ["EgF"],
  "wear blue pants": ["EgG"],
  "wear brown pants": ["EgH"],
  "wear glasses": ["DoJ"],
  "wear green shorts": ["EgI"],
  "wear orange hats": ["EgJ"],
  "wear purple socks": ["EgK"],
  "wear red glasses": ["EgL"],
  "wear red shoes": ["EgM"],
  "wear wore": ["EUb","DoF","DoG","DoI","DoJ"],
  "wear worn": ["EWU","EWF"],
  "wear yellow shorts": ["EgN"],
  "wearing": ["DoF","DoG","DoH","DoI","DoJ"],
  "wearing a coat": ["DoF"],
  "wearing a mask": ["DoG","DoH"],
  "wearing a raincoat": ["DoI"],
  "wearing glasses": ["DoJ"],
  "weather": ["DY3","CzY","CzX"],
  "weather vane": ["CzZ"],
  "web": ["Czg","Cza"],
  "web designer": ["Czd","Cze","Czf"],
  "web developer": ["EQA","EP9","DQj","DQk"],
  "webcam": ["Czc","Czb"],
  "wedding": ["Czm","Czh","Czi","Czj","Czk","Czl"],
  "Wednesday": ["DQn","DQl","DQm"],
  "weed": ["Czo","Czn"],
  "weeds": ["Czs","Czp","Czq","Czr"],
  "weep": ["Czt"],
  "weigh": ["Czu"],
  "weight": ["Dvz"],
  "weight lifting": ["Czv","Czw"],
  "weight scale": ["Czx","Czy"],
  "weightlifting": ["D7p","DQo"],
  "weights": ["DQp"],
  "welcome": ["DY4"],
  "well": ["ERE","DY6","Cz0","Czz"],
  "well built": ["DY5"],
  "went": ["EVE"],
  "went to school": ["EVE"],
  "were": ["EVF"],
  "were happy": ["EVF"],
  "werewolf": ["EQB","EQC","Cz4","Cz1","Cz2","Cz3"],
  "western": ["Cz7","Cz5","Cz6"],
  "wet": ["EiJ","EQD","DQs","DQq","DQr","C0E","Cz8"],
  "wet dog": ["EiJ"],
  "wetland": ["C0D","Cz9","C0A","C0B","C0C"],
  "wetter": ["ESQ","DQt"],
  "whale": ["D7q","DQu","C0L","C0F","C0G","C0H","C0I","C0J","C0K"],
  "what": ["Ddr","Dds","Ddt"],
  "what color": ["Ddq"],
  "what color is the bike": ["EQE","Ddq"],
  "what colour": ["Ddq"],
  "what colour is the bike": ["EQE","Ddq"],
  "what do you like to drink": ["EQF"],
  "what do you like to eat": ["EQG"],
  "what is the time": ["Ddr"],
  "what is the weather like": ["EQH"],
  "what is your favorite country": ["EQI"],
  "what is your favourite country": ["EQI"],
  "what is your phone number": ["EQJ","Dds"],
  "what phone do you have": ["EQK","Ddt"],
  "what sport do you like": ["EQL"],
  "what time": ["Ddv"],
  "what time do you go to bed": ["EQM"],
  "what time do you wake up": ["Ddv"],
  "what's the weather like": ["Ddu"],
  "wheat": ["C0Q","C0M","C0N","C0O","C0P"],
  "wheel": ["C0g","C0R","C0S","C0T","C0U","C0V"],
  "wheelbarrow": ["D7r","DQv","C0a","C0W","C0X","C0Y","C0Z"],
  "wheelchair": ["D7s","DQw","C0f","C0b","C0c","C0d","C0e"],
  "when": ["Ddw"],
  "when do you brush your teeth": ["EQN"],
  "When do you go to bed": ["Ddw"],
  "when do you study": ["EQO"],
  "when do you take a shower": ["EQP"],
  "when do you wake up": ["EQQ"],
  "when is Christmas": ["EQR"],
  "when is lunch": ["EQS"],
  "when is the meeting": ["EQT"],
  "when is your exam": ["EQU"],
  "where": ["Ddx","Ddy","Ddz","Dd3"],
  "where are you from": ["EQV","Ddx"],
  "where are you going": ["EQW","Ddy"],
  "where do you live": ["EQY","Ddz"],
  "where does she come from": ["EQX"],
  "where is he from": ["EQZ"],
  "where is italy": ["EQa"],
  "where is she from": ["Dd0"],
  "where is the bus stop": ["EQb","Dd1"],
  "where is the hospital": ["EQc"],
  "where is the remote": ["EQd","Dd2"],
  "where is the WC": ["Dd3"],
  "which": ["Dd4"],
  "which donut would you like": ["EQe"],
  "which ice cream would you like": ["EQf"],
  "which team do you like": ["EQg","Dd4"],
  "whip": ["C0h"],
  "whisk": ["Dv0"],
  "whiskers": ["C0j","C0i"],
  "whisper": ["DoK","C0l","C0k"],
  "whisper whispered": ["ETX","DoK"],
  "whispered": ["ETX"],
  "whispering": ["DoK"],
  "whistle": ["D7t","DQx","C0o","C0m","C0n"],
  "white": ["DQz"],
  "whiteboard": ["D7u","DQy","C0t","C0p","C0q","C0r","C0s"],
  "who": ["Dd5","Dd6"],
  "who do you love": ["EQh","Dd5"],
  "who is playing the violin": ["EQi"],
  "who is she": ["Dd6"],
  "who is the manager": ["EQj"],
  "who is the oldest": ["EQk"],
  "who is the president": ["EQl"],
  "who is your favorite singer": ["EQm"],
  "who is your favourite singer": ["EQm"],
  "who is your friend": ["EQn"],
  "wide": ["Dv1"],
  "wider": ["ESR","DQ0"],
  "wife": ["EQo","EQp","DZj","C0x","C0u","C0v","C0w"],
  "wifi": ["C01","C0y","C0z","C00"],
  "wig": ["C03","C02"],
  "wild": ["C1C","C04","C05"],
  "wild animals": ["C06","C07","C08","C09"],
  "wildlife": ["C1B","C1A"],
  "win": ["DoL","DoM","C2F","C1D","C1E"],
  "win the cup": ["DoM"],
  "win win won": ["DoM"],
  "win won": ["EWT","EUa","DoL"],
  "wind": ["D7y","DQ5","C1e","C1F","C1G"],
  "wind farm": ["DY7","C1H","C1I"],
  "wind vane": ["DY8"],
  "windmill": ["D7v","DQ1","C1M","C1J","C1K","C1L"],
  "window": ["D7x","DQ4","C1W","C1N","C1O","C1P","C1Q"],
  "window blind": ["C1R","C1S","C1T"],
  "window blinds": ["C1U","C1V"],
  "window cleaner": ["EQr","EQq","D7w","DQ2","DQ3"],
  "windows": ["C1d","C1X","C1Y","C1Z","C1a","C1b","C1c"],
  "windsurf": ["C1k","C1f","C1g"],
  "windsurfing": ["C1j","C1h","C1i"],
  "windy": ["EQs","DQ7","DQ6","C1p","C1l","C1m","C1n","C1o"],
  "wine": ["D70","C1v","C1q","C1r","C1s","C1t","C1u"],
  "wine glass": ["D7z","DQ8"],
  "wing": ["C10","C1w","C1x","C1y","C1z"],
  "wings": ["D71","DQ9","C16","C11","C12","C13","C14","C15"],
  "wink": ["DY9","C2B","C17","C18","C19","C2A"],
  "winner": ["DZA","C2D","C2C"],
  "winnie the pooh": ["C2E"],
  "winning": ["DoL","DoM"],
  "winning the cup": ["DoM"],
  "winter": ["C2J","C2G","C2H","C2I","Dv2"],
  "wipe": ["Ec6","DoN"],
  "wipe the table": ["Ec6","DoN"],
  "wipe wiped": ["EUX"],
  "wipe wipes": ["DoN"],
  "wiped": ["EUX"],
  "wiped the table": ["EUX"],
  "wiping": ["Ec6","DoN"],
  "wiping the table": ["Ec6","DoN"],
  "wire": ["C2M","C2K","C2L"],
  "wire stripper": ["C2N"],
  "wise": ["Dv3"],
  "witch": ["EQu","C2R","C2O","C2P","C2Q"],
  "witches": ["EQt"],
  "with": ["Dv4"],
  "withdraw": ["Ec7","DoO","C2S"],
  "withdraw money": ["Ec7","DoO"],
  "withdraw withdrew": ["EUY","DoO"],
  "withdrawing": ["Ec7","DoO"],
  "withdrawing money": ["Ec7","DoO"],
  "withdrew": ["EUY"],
  "withdrew money": ["EUY"],
  "wither": ["DZB"],
  "wizard": ["EQv","EQw","DZC","C2W","C2T","C2U","C2V"],
  "woke up": ["EUZ"],
  "wolf": ["EQx","D72","DRA","C2b","C2X","C2Y","C2Z","C2a"],
  "wolly jumper": ["DZD"],
  "wolves": ["C2f","C2c","C2d","C2e"],
  "woman": ["C2m","C2g","C2h","C2i","C2j","C2k","C2l"],
  "women": ["C2q","C2n","C2o","C2p"],
  "won": ["EWT","EUa"],
  "won a prize": ["EUa"],
  "won the cup": ["EWT"],
  "wonderful": ["Dv5"],
  "wood": ["C21","C2r","C2s","C2t","C2u"],
  "wood screw": ["C22","C23","C24"],
  "wooden": ["C2y","C2v","C2w"],
  "wooden paddle": ["C2x"],
  "woodlouse": ["C20","C2z"],
  "woods": ["Dv6"],
  "wool": ["C27","C25","C26"],
  "words": ["C28"],
  "wordsheet": ["DZE"],
  "wore": ["EUb"],
  "wore a coat": ["EUb"],
  "work": ["EaV","EaU","EaT","EQy","EQ2","DoT","DoP","DoQ","DoR","C3C","C29","C3A","C3B"],
  "work ": ["EQz"],
  "work happily": ["ERW"],
  "work hard": ["ERX"],
  "work in a clothes store": ["EaT","DoR"],
  "work in an office": ["EaU","EQ0"],
  "work on a computer": ["EaV"],
  "work out": ["EQ1","DoS"],
  "work out worked out": ["DoS"],
  "work quietly": ["ERY"],
  "work worked": ["DoT","DoP","DoQ","DoR"],
  "working": ["DoT","DoP","DoQ","DoR"],
  "working in a clothes store": ["DoR"],
  "working out": ["DoS"],
  "world": ["DZF","C3D"],
  "worm": ["C3G","C3E","C3F"],
  "worn": ["EWU","EWF"],
  "worn a costume": ["EWU"],
  "worn glasses": ["EWF"],
  "worn out": ["Ehr"],
  "worried": ["C3J","C3H","C3I"],
  "worry": ["C3L","C3K"],
  "worse": ["ERZ","DRB"],
  "would you like some fruit": ["EQ3"],
  "wrap": ["DRC"],
  "wrappers": ["DZG"],
  "wreath": ["EiK","EQ4","DZH","C3P","C3M","C3N","C3O"],
  "wrench": ["DZI","C3T","C3Q","C3R","C3S"],
  "wrench set": ["C3U","C3V"],
  "wrestling": ["D73","DRD","C3Y","C3W","C3X"],
  "wrist": ["D74","DRE"],
  "write": ["Ec8","EaY","EaX","DoW","DoU","DoV","DoX","C3b","C3Z","C3a"],
  "write an email": ["Dv7"],
  "write books": ["EQ5"],
  "write computer software": ["EaX"],
  "write different languages": ["EQ6"],
  "write on the board": ["EaY","DoV"],
  "write software": ["DoX"],
  "write wrote": ["EUc","DoU","DoV","DoW"],
  "writer": ["Dv8"],
  "writing": ["Ec8","DoW","DoU","DoV","DoX","C3e","C3c","C3d"],
  "writing on the board": ["DoV"],
  "writing software": ["DoX"],
  "wrong": ["EQ7"],
  "wrote": ["EUc"],
  "x": ["DaW","DaV"],
  "x ray": ["D75","DRF","C3f","C3g"],
  "xylophone": ["C3i","C3h"],
  "y": ["DaY","DaX"],
  "yacht": ["C3m","C3j","C3k","C3l"],
  "yak": ["C3r","C3n","C3o","C3p","C3q"],
  "yam": ["C3t","C3s"],
  "yard": ["C3w","C3u","C3v"],
  "yarn": ["C3z","C3x","C3y"],
  "yawn": ["Ebv","DoZ","DoY","C33","C30","C31","C32"],
  "yawn yawned": ["EUd","DoY","DoZ"],
  "yawned": ["EUd"],
  "yawning": ["Ebv","DoZ","DoY"],
  "yell": ["C34"],
  "yellow": ["DRG"],
  "yellow shorts": ["EgN","DRH"],
  "yellow skirt": ["EgC","DRI"],
  "yellow tie": ["EgD","DRJ"],
  "yes": ["Dv9"],
  "yin and yang": ["C35"],
  "yo yo": ["DwC"],
  "yoga": ["C4A","C36","C37","C38","C39"],
  "yoghurt": ["DwA"],
  "yogurt": ["DRK","C4B"],
  "yorkshire pudding": ["C4C"],
  "young": ["C4D"],
  "younger": ["ESS","DRL"],
  "youtube": ["DwB"],
  "yoyo": ["DwD"],
  "z": ["Daa","DaZ"],
  "zebra": ["D76","DRM","C4J","C4E","C4F","C4G"],
  "zebra crossing": ["C4H","C4I"],
  "zebras": ["C4L","C4K"],
  "zero": ["Dc9","Dc8"],
  "zigzag": ["DwE"],
  "zip": ["D77","DRN","C4Q","C4M","C4N"],
  "zipper": ["C4P","C4O"],
  "zombie": ["EQ8","EQ9","C4T","C4R","C4S"],
  "zoo": ["D78","DRP"],
  "zookeeper": ["DwF"],
  "zoom call": ["DRO"],
  "zucchini": ["C4Y","C4U","C4V","C4W","C4X"]
}